export const SVG_ACCESSIBILITY = 'ACCESSIBILITY';
import { default as ACCESSIBILITY_rebranded } from './deprecated/js/accessibility.js';
export const SVG_ACTION_ITEM_ACTIVE = 'ACTION_ITEM_ACTIVE';
import { default as ACTION_ITEM_ACTIVE_rebranded } from './deprecated/js/action-item-active.js';
export const SVG_ACTION_ITEM_INACTIVE = 'ACTION_ITEM_INACTIVE';
import { default as ACTION_ITEM_INACTIVE_rebranded } from './deprecated/js/action-item-inactive.js';
export const SVG_ADD_ACTIVE = 'ADD_ACTIVE';
import { default as ADD_ACTIVE_rebranded } from './deprecated/js/add-active.js';
export const SVG_ADD_CIRCLE_ACTIVE = 'ADD_CIRCLE_ACTIVE';
import { default as ADD_CIRCLE_ACTIVE_rebranded } from './deprecated/js/add-circle-active.js';
export const SVG_ADD_INACTIVE = 'ADD_INACTIVE';
import { default as ADD_INACTIVE_rebranded } from './deprecated/js/add-inactive.js';
export const SVG_ADD_CIRCLE_INACTIVE = 'ADD_CIRCLE_INACTIVE';
import { default as ADD_CIRCLE_INACTIVE_rebranded } from './deprecated/js/add-circle-inactive.js';
export const SVG_ADD_PERSON_ACTIVE = 'ADD_PERSON_ACTIVE';
import { default as ADD_PERSON_ACTIVE_rebranded } from './deprecated/js/add-person-active.js';
export const SVG_ADD_PERSON_INACTIVE = 'ADD_PERSON_INACTIVE';
import { default as ADD_PERSON_INACTIVE_rebranded } from './deprecated/js/add-person-inactive.js';
export const SVG_ADD = 'ADD';
import { default as ADD_rebranded } from './deprecated/js/add.js';
export const SVG_ADDRESS_BOOK_CONTACTS_ACTIVE = 'ADDRESS_BOOK_CONTACTS_ACTIVE';
import { default as ADDRESS_BOOK_CONTACTS_ACTIVE_rebranded } from './deprecated/js/address-book-contacts-active.js';
export const SVG_ADDRESS_BOOK_CONTACTS_INACTIVE = 'ADDRESS_BOOK_CONTACTS_INACTIVE';
import { default as ADDRESS_BOOK_CONTACTS_INACTIVE_rebranded } from './deprecated/js/address-book-contacts-inactive.js';
export const SVG_ADDRESSES_ACTIVE = 'ADDRESSES_ACTIVE';
import { default as ADDRESSES_ACTIVE_rebranded } from './deprecated/js/addresses-active.js';
export const SVG_ADDRESSES_INACTIVE = 'ADDRESSES_INACTIVE';
import { default as ADDRESSES_INACTIVE_rebranded } from './deprecated/js/addresses-inactive.js';
export const SVG_ADJUST_CAMERA = 'ADJUST_CAMERA';
import { default as ADJUST_CAMERA_rebranded } from './deprecated/js/adjust-camera.js';
export const SVG_ADJUST_CAMERA_INACTIVE = 'ADJUST_CAMERA_INACTIVE';
import { default as ADJUST_CAMERA_INACTIVE_rebranded } from './deprecated/js/adjust-camera-inactive.js';
export const SVG_ADJUSTMENTS_ACTIVE = 'ADJUSTMENTS_ACTIVE';
import { default as ADJUSTMENTS_ACTIVE_rebranded } from './deprecated/js/adjustments-active.js';
export const SVG_ADJUSTMENTS = 'ADJUSTMENTS';
import { default as ADJUSTMENTS_rebranded } from './deprecated/js/adjustments.js';
export const SVG_ADMIN_ACTIVE = 'ADMIN_ACTIVE';
import { default as ADMIN_ACTIVE_rebranded } from './deprecated/js/admin-active.js';
export const SVG_ADMIN_INACTIVE = 'ADMIN_INACTIVE';
import { default as ADMIN_INACTIVE_rebranded } from './deprecated/js/admin-inactive.js';
export const SVG_ADOBE = 'ADOBE';
import { default as ADOBE_rebranded } from './deprecated/js/adobe.js';
export const SVG_ALERT_ACTIVE = 'ALERT_ACTIVE';
import { default as ALERT_ACTIVE_rebranded } from './deprecated/js/alert-active.js';
export const SVG_ALERT_INACTIVE = 'ALERT_INACTIVE';
import { default as ALERT_INACTIVE_rebranded } from './deprecated/js/alert-inactive.js';
export const SVG_AMEX_ACTIVE = 'AMEX_ACTIVE';
import { default as AMEX_ACTIVE_rebranded } from './deprecated/js/amex-active.js';
export const SVG_AMEX = 'AMEX';
import { default as AMEX_rebranded } from './deprecated/js/amex.js';
export const SVG_ANDROID = 'ANDROID';
import { default as ANDROID_rebranded } from './deprecated/js/android.js';
export const SVG_ANNOTATION_INACTIVE = 'ANNOTATION_INACTIVE';
import { default as ANNOTATION_INACTIVE_rebranded } from './deprecated/js/annotation-inactive.js';
export const SVG_APP_SWITCHER = 'APP_SWITCHER';
import { default as APP_SWITCHER_rebranded } from './deprecated/js/app-switcher.js';
export const SVG_APPLE_MONOCHROMATIC = 'APPLE_MONOCHROMATIC';
import { default as APPLE_MONOCHROMATIC_rebranded } from './deprecated/js/apple-monochromatic.js';
export const SVG_ANNOTATION_ACTIVE = 'ANNOTATION_ACTIVE';
import { default as ANNOTATION_ACTIVE_rebranded } from './deprecated/js/annotation-active.js';
export const SVG_ARCHIVE_INACTIVE = 'ARCHIVE_INACTIVE';
import { default as ARCHIVE_INACTIVE_rebranded } from './deprecated/js/archive-inactive.js';
export const SVG_ARCHIVE_ACTIVE = 'ARCHIVE_ACTIVE';
import { default as ARCHIVE_ACTIVE_rebranded } from './deprecated/js/archive-active.js';
export const SVG_ARROW_DOWN = 'ARROW_DOWN';
import { default as ARROW_DOWN_rebranded } from './deprecated/js/arrow-down.js';
export const SVG_ARROW_LEFT = 'ARROW_LEFT';
import { default as ARROW_LEFT_rebranded } from './deprecated/js/arrow-left.js';
export const SVG_ARROW_RIGHT = 'ARROW_RIGHT';
import { default as ARROW_RIGHT_rebranded } from './deprecated/js/arrow-right.js';
export const SVG_ARROW_UP = 'ARROW_UP';
import { default as ARROW_UP_rebranded } from './deprecated/js/arrow-up.js';
export const SVG_ASSISTANCE_ACTIVE = 'ASSISTANCE_ACTIVE';
import { default as ASSISTANCE_ACTIVE_rebranded } from './deprecated/js/assistance-active.js';
export const SVG_ASSISTANCE_INACTIVE = 'ASSISTANCE_INACTIVE';
import { default as ASSISTANCE_INACTIVE_rebranded } from './deprecated/js/assistance-inactive.js';
export const SVG_AUDIO_OFF_20_PX_ACTIVE = 'AUDIO_OFF_20_PX_ACTIVE';
import { default as AUDIO_OFF_20_PX_ACTIVE_rebranded } from './deprecated/js/audio-off-20-px-active.js';
export const SVG_AUDIO_OFF_20_PX = 'AUDIO_OFF_20_PX';
import { default as AUDIO_OFF_20_PX_rebranded } from './deprecated/js/audio-off-20-px.js';
export const SVG_BACKSPACE_INACTIVE = 'BACKSPACE_INACTIVE';
import { default as BACKSPACE_INACTIVE_rebranded } from './deprecated/js/backspace-inactive.js';
export const SVG_BACKSPACE = 'BACKSPACE';
import { default as BACKSPACE_rebranded } from './deprecated/js/backspace.js';
export const SVG_BADGE_ACTIVE = 'BADGE_ACTIVE';
import { default as BADGE_ACTIVE_rebranded } from './deprecated/js/badge-active.js';
export const SVG_BADGE_INACTIVE = 'BADGE_INACTIVE';
import { default as BADGE_INACTIVE_rebranded } from './deprecated/js/badge-inactive.js';
export const SVG_BATTERY_FULL_ACTIVE = 'BATTERY_FULL_ACTIVE';
import { default as BATTERY_FULL_ACTIVE_rebranded } from './deprecated/js/battery-full-active.js';
export const SVG_BATTERY_FULL = 'BATTERY_FULL';
import { default as BATTERY_FULL_rebranded } from './deprecated/js/battery-full.js';
export const SVG_BATTERY_LOW_ACTIVE = 'BATTERY_LOW_ACTIVE';
import { default as BATTERY_LOW_ACTIVE_rebranded } from './deprecated/js/battery-low-active.js';
export const SVG_BATTERY_LOW = 'BATTERY_LOW';
import { default as BATTERY_LOW_rebranded } from './deprecated/js/battery-low.js';
export const SVG_BATTERY_MID_ACTIVE = 'BATTERY_MID_ACTIVE';
import { default as BATTERY_MID_ACTIVE_rebranded } from './deprecated/js/battery-mid-active.js';
export const SVG_BATTERY_MID = 'BATTERY_MID';
import { default as BATTERY_MID_rebranded } from './deprecated/js/battery-mid.js';
export const SVG_BELL_DISABLED_ACTIVE = 'BELL_DISABLED_ACTIVE';
import { default as BELL_DISABLED_ACTIVE_rebranded } from './deprecated/js/bell-disabled-active.js';
export const SVG_BELL_ACTIVE = 'BELL_ACTIVE';
import { default as BELL_ACTIVE_rebranded } from './deprecated/js/bell-active.js';
export const SVG_BLOCK = 'BLOCK';
import { default as BLOCK_rebranded } from './deprecated/js/block.js';
export const SVG_BELL_DISABLED_INACTIVE = 'BELL_DISABLED_INACTIVE';
import { default as BELL_DISABLED_INACTIVE_rebranded } from './deprecated/js/bell-disabled-inactive.js';
export const SVG_BELL_INACTIVE = 'BELL_INACTIVE';
import { default as BELL_INACTIVE_rebranded } from './deprecated/js/bell-inactive.js';
export const SVG_BLUETOOTH = 'BLUETOOTH';
import { default as BLUETOOTH_rebranded } from './deprecated/js/bluetooth.js';
export const SVG_BLUETOOTH_CONNECTED = 'BLUETOOTH_CONNECTED';
import { default as BLUETOOTH_CONNECTED_rebranded } from './deprecated/js/bluetooth-connected.js';
export const SVG_BOLD_ACTIVE = 'BOLD_ACTIVE';
import { default as BOLD_ACTIVE_rebranded } from './deprecated/js/bold-active.js';
export const SVG_BOLD_INACTIVE = 'BOLD_INACTIVE';
import { default as BOLD_INACTIVE_rebranded } from './deprecated/js/bold-inactive.js';
export const SVG_BOOKMARK_ACTIVE = 'BOOKMARK_ACTIVE';
import { default as BOOKMARK_ACTIVE_rebranded } from './deprecated/js/bookmark-active.js';
export const SVG_BOOKMARK_INACTIVE = 'BOOKMARK_INACTIVE';
import { default as BOOKMARK_INACTIVE_rebranded } from './deprecated/js/bookmark-inactive.js';
export const SVG_BRAVE = 'BRAVE';
import { default as BRAVE_rebranded } from './deprecated/js/brave.js';
export const SVG_BREAKOUT_ROOM_ACTIVE = 'BREAKOUT_ROOM_ACTIVE';
import { default as BREAKOUT_ROOM_ACTIVE_rebranded } from './deprecated/js/breakout-room-active.js';
export const SVG_BREAKOUT_ROOM = 'BREAKOUT_ROOM';
import { default as BREAKOUT_ROOM_rebranded } from './deprecated/js/breakout-room.js';
export const SVG_BRIGHTNESS_INACTIVE = 'BRIGHTNESS_INACTIVE';
import { default as BRIGHTNESS_INACTIVE_rebranded } from './deprecated/js/brightness-inactive.js';
export const SVG_BUG_ACTIVE = 'BUG_ACTIVE';
import { default as BUG_ACTIVE_rebranded } from './deprecated/js/bug-active.js';
export const SVG_BRIGHTNESS = 'BRIGHTNESS';
import { default as BRIGHTNESS_rebranded } from './deprecated/js/brightness.js';
export const SVG_BUG_INACTIVE = 'BUG_INACTIVE';
import { default as BUG_INACTIVE_rebranded } from './deprecated/js/bug-inactive.js';
export const SVG_BULB_ACTIVE = 'BULB_ACTIVE';
import { default as BULB_ACTIVE_rebranded } from './deprecated/js/bulb-active.js';
export const SVG_BULB_INACTIVE = 'BULB_INACTIVE';
import { default as BULB_INACTIVE_rebranded } from './deprecated/js/bulb-inactive.js';
export const SVG_BUSINESS_ACTIVE = 'BUSINESS_ACTIVE';
import { default as BUSINESS_ACTIVE_rebranded } from './deprecated/js/business-active.js';
export const SVG_BUSINESS_INACTIVE = 'BUSINESS_INACTIVE';
import { default as BUSINESS_INACTIVE_rebranded } from './deprecated/js/business-inactive.js';
export const SVG_CALCULATOR_ACTIVE = 'CALCULATOR_ACTIVE';
import { default as CALCULATOR_ACTIVE_rebranded } from './deprecated/js/calculator-active.js';
export const SVG_CALCULATOR_INACTIVE = 'CALCULATOR_INACTIVE';
import { default as CALCULATOR_INACTIVE_rebranded } from './deprecated/js/calculator-inactive.js';
export const SVG_CALENDAR_ACTIVE = 'CALENDAR_ACTIVE';
import { default as CALENDAR_ACTIVE_rebranded } from './deprecated/js/calendar-active.js';
export const SVG_CALENDAR_INACTIVE = 'CALENDAR_INACTIVE';
import { default as CALENDAR_INACTIVE_rebranded } from './deprecated/js/calendar-inactive.js';
export const SVG_CALL_FAILED_ACTIVE = 'CALL_FAILED_ACTIVE';
import { default as CALL_FAILED_ACTIVE_rebranded } from './deprecated/js/call-failed-active.js';
export const SVG_CALL_FAILED_INACTIVE = 'CALL_FAILED_INACTIVE';
import { default as CALL_FAILED_INACTIVE_rebranded } from './deprecated/js/call-failed-inactive.js';
export const SVG_CALL_MADE = 'CALL_MADE';
import { default as CALL_MADE_rebranded } from './deprecated/js/call-made.js';
export const SVG_CALL_ME_UP_ACTIVE = 'CALL_ME_UP_ACTIVE';
import { default as CALL_ME_UP_ACTIVE_rebranded } from './deprecated/js/call-me-up-active.js';
export const SVG_CALL_ME_UP_INACTIVE = 'CALL_ME_UP_INACTIVE';
import { default as CALL_ME_UP_INACTIVE_rebranded } from './deprecated/js/call-me-up-inactive.js';
export const SVG_CALL_MESSAGE_ACTIVE = 'CALL_MESSAGE_ACTIVE';
import { default as CALL_MESSAGE_ACTIVE_rebranded } from './deprecated/js/call-message-active.js';
export const SVG_CALL_MERGE = 'CALL_MERGE';
import { default as CALL_MERGE_rebranded } from './deprecated/js/call-merge.js';
export const SVG_CALL_MESSAGE_INACTIVE = 'CALL_MESSAGE_INACTIVE';
import { default as CALL_MESSAGE_INACTIVE_rebranded } from './deprecated/js/call-message-inactive.js';
export const SVG_CALL_MISSED = 'CALL_MISSED';
import { default as CALL_MISSED_rebranded } from './deprecated/js/call-missed.js';
export const SVG_CALL_ON_HOLD_ACTIVE = 'CALL_ON_HOLD_ACTIVE';
import { default as CALL_ON_HOLD_ACTIVE_rebranded } from './deprecated/js/call-on-hold-active.js';
export const SVG_CALL_ON_HOLD_INACTIVE = 'CALL_ON_HOLD_INACTIVE';
import { default as CALL_ON_HOLD_INACTIVE_rebranded } from './deprecated/js/call-on-hold-inactive.js';
export const SVG_CALL_PARK_ACTIVE = 'CALL_PARK_ACTIVE';
import { default as CALL_PARK_ACTIVE_rebranded } from './deprecated/js/call-park-active.js';
export const SVG_CALL_RECEIVED = 'CALL_RECEIVED';
import { default as CALL_RECEIVED_rebranded } from './deprecated/js/call-received.js';
export const SVG_CALL_PARK_INACTIVE = 'CALL_PARK_INACTIVE';
import { default as CALL_PARK_INACTIVE_rebranded } from './deprecated/js/call-park-inactive.js';
export const SVG_CALL_SPLIT = 'CALL_SPLIT';
import { default as CALL_SPLIT_rebranded } from './deprecated/js/call-split.js';
export const SVG_CALL_TRANSFER_ACTIVE = 'CALL_TRANSFER_ACTIVE';
import { default as CALL_TRANSFER_ACTIVE_rebranded } from './deprecated/js/call-transfer-active.js';
export const SVG_CALL_TRANSFER_INACTIVE = 'CALL_TRANSFER_INACTIVE';
import { default as CALL_TRANSFER_INACTIVE_rebranded } from './deprecated/js/call-transfer-inactive.js';
export const SVG_CAMERA_ACTIVE = 'CAMERA_ACTIVE';
import { default as CAMERA_ACTIVE_rebranded } from './deprecated/js/camera-active.js';
export const SVG_CAMERA_AUTO_INACTIVE = 'CAMERA_AUTO_INACTIVE';
import { default as CAMERA_AUTO_INACTIVE_rebranded } from './deprecated/js/camera-auto-inactive.js';
export const SVG_CAMERA_FLIP_ACTIVE = 'CAMERA_FLIP_ACTIVE';
import { default as CAMERA_FLIP_ACTIVE_rebranded } from './deprecated/js/camera-flip-active.js';
export const SVG_CAMERA_FLIP = 'CAMERA_FLIP';
import { default as CAMERA_FLIP_rebranded } from './deprecated/js/camera-flip.js';
export const SVG_CAMERA_AUTO = 'CAMERA_AUTO';
import { default as CAMERA_AUTO_rebranded } from './deprecated/js/camera-auto.js';
export const SVG_CAMERA_INACTIVE = 'CAMERA_INACTIVE';
import { default as CAMERA_INACTIVE_rebranded } from './deprecated/js/camera-inactive.js';
export const SVG_CAMERA_POSITION_BOTTOM = 'CAMERA_POSITION_BOTTOM';
import { default as CAMERA_POSITION_BOTTOM_rebranded } from './deprecated/js/camera-position-bottom.js';
export const SVG_CAMERA_POSITION_LEFT = 'CAMERA_POSITION_LEFT';
import { default as CAMERA_POSITION_LEFT_rebranded } from './deprecated/js/camera-position-left.js';
export const SVG_CAMERA_POSITION_RIGHT = 'CAMERA_POSITION_RIGHT';
import { default as CAMERA_POSITION_RIGHT_rebranded } from './deprecated/js/camera-position-right.js';
export const SVG_CAMERA_POSITION_TOP = 'CAMERA_POSITION_TOP';
import { default as CAMERA_POSITION_TOP_rebranded } from './deprecated/js/camera-position-top.js';
export const SVG_CAMERA_PRESETS_ACTIVE = 'CAMERA_PRESETS_ACTIVE';
import { default as CAMERA_PRESETS_ACTIVE_rebranded } from './deprecated/js/camera-presets-active.js';
export const SVG_CAMERA_PRESETS_INACTIVE = 'CAMERA_PRESETS_INACTIVE';
import { default as CAMERA_PRESETS_INACTIVE_rebranded } from './deprecated/js/camera-presets-inactive.js';
export const SVG_CAMERA_SHARE_ACTIVE = 'CAMERA_SHARE_ACTIVE';
import { default as CAMERA_SHARE_ACTIVE_rebranded } from './deprecated/js/camera-share-active.js';
export const SVG_CAMERA_SHARE = 'CAMERA_SHARE';
import { default as CAMERA_SHARE_rebranded } from './deprecated/js/camera-share.js';
export const SVG_CARD_ACTIVE = 'CARD_ACTIVE';
import { default as CARD_ACTIVE_rebranded } from './deprecated/js/card-active.js';
export const SVG_CARD = 'CARD';
import { default as CARD_rebranded } from './deprecated/js/card.js';
export const SVG_CART_ACTIVE = 'CART_ACTIVE';
import { default as CART_ACTIVE_rebranded } from './deprecated/js/cart-active.js';
export const SVG_CART_INACTIVE = 'CART_INACTIVE';
import { default as CART_INACTIVE_rebranded } from './deprecated/js/cart-inactive.js';
export const SVG_CASH_ACTIVE = 'CASH_ACTIVE';
import { default as CASH_ACTIVE_rebranded } from './deprecated/js/cash-active.js';
export const SVG_CASH = 'CASH';
import { default as CASH_rebranded } from './deprecated/js/cash.js';
export const SVG_CHAT_ACTIVE = 'CHAT_ACTIVE';
import { default as CHAT_ACTIVE_rebranded } from './deprecated/js/chat-active.js';
export const SVG_CHAT_DOTS_ACTIVE = 'CHAT_DOTS_ACTIVE';
import { default as CHAT_DOTS_ACTIVE_rebranded } from './deprecated/js/chat-dots-active.js';
export const SVG_CHAT_DOTS_INACTIVE = 'CHAT_DOTS_INACTIVE';
import { default as CHAT_DOTS_INACTIVE_rebranded } from './deprecated/js/chat-dots-inactive.js';
export const SVG_CHAT_FEEDBACK_ACTIVE = 'CHAT_FEEDBACK_ACTIVE';
import { default as CHAT_FEEDBACK_ACTIVE_rebranded } from './deprecated/js/chat-feedback-active.js';
export const SVG_CHAT_FEEDBACK_INACTIVE = 'CHAT_FEEDBACK_INACTIVE';
import { default as CHAT_FEEDBACK_INACTIVE_rebranded } from './deprecated/js/chat-feedback-inactive.js';
export const SVG_CHAT_INACTIVE = 'CHAT_INACTIVE';
import { default as CHAT_INACTIVE_rebranded } from './deprecated/js/chat-inactive.js';
export const SVG_CHAT_QUESTION_ACTIVE = 'CHAT_QUESTION_ACTIVE';
import { default as CHAT_QUESTION_ACTIVE_rebranded } from './deprecated/js/chat-question-active.js';
export const SVG_CHAT_QUESTION_INACTIVE = 'CHAT_QUESTION_INACTIVE';
import { default as CHAT_QUESTION_INACTIVE_rebranded } from './deprecated/js/chat-question-inactive.js';
export const SVG_CHECK = 'CHECK';
import { default as CHECK_rebranded } from './deprecated/js/check.js';
export const SVG_CHECKBOX_ACTIVE = 'CHECKBOX_ACTIVE';
import { default as CHECKBOX_ACTIVE_rebranded } from './deprecated/js/checkbox-active.js';
export const SVG_CHECKBOX_ACTIVE_ANDROID = 'CHECKBOX_ACTIVE_ANDROID';
import { default as CHECKBOX_ACTIVE_ANDROID_rebranded } from './deprecated/js/checkbox-active-android.js';
export const SVG_CHECKBOX_ANDROID_INDETERMINATE = 'CHECKBOX_ANDROID_INDETERMINATE';
import { default as CHECKBOX_ANDROID_INDETERMINATE_rebranded } from './deprecated/js/checkbox-android-indeterminate.js';
export const SVG_CHECKBOX_ANDROID = 'CHECKBOX_ANDROID';
import { default as CHECKBOX_ANDROID_rebranded } from './deprecated/js/checkbox-android.js';
export const SVG_CHECKBOX_CHECK = 'CHECKBOX_CHECK';
import { default as CHECKBOX_CHECK_rebranded } from './deprecated/js/checkbox-check.js';
export const SVG_CHECKBOX_INDETERMINATE = 'CHECKBOX_INDETERMINATE';
import { default as CHECKBOX_INDETERMINATE_rebranded } from './deprecated/js/checkbox-indeterminate.js';
export const SVG_CHECKBOX = 'CHECKBOX';
import { default as CHECKBOX_rebranded } from './deprecated/js/checkbox.js';
export const SVG_CHECKBOX_LINE = 'CHECKBOX_LINE';
import { default as CHECKBOX_LINE_rebranded } from './deprecated/js/checkbox-line.js';
export const SVG_CHECKMARK_CIRCLE_ACTIVE = 'CHECKMARK_CIRCLE_ACTIVE';
import { default as CHECKMARK_CIRCLE_ACTIVE_rebranded } from './deprecated/js/checkmark-circle-active.js';
export const SVG_CHEVRON_COMBO = 'CHEVRON_COMBO';
import { default as CHEVRON_COMBO_rebranded } from './deprecated/js/chevron-combo.js';
export const SVG_CHECKMARK_CIRCLE_INACTIVE = 'CHECKMARK_CIRCLE_INACTIVE';
import { default as CHECKMARK_CIRCLE_INACTIVE_rebranded } from './deprecated/js/checkmark-circle-inactive.js';
export const SVG_CHEVRON_DOWN_20_PX = 'CHEVRON_DOWN_20_PX';
import { default as CHEVRON_DOWN_20_PX_rebranded } from './deprecated/js/chevron-down-20-px.js';
export const SVG_CHEVRON_DOWN = 'CHEVRON_DOWN';
import { default as CHEVRON_DOWN_rebranded } from './deprecated/js/chevron-down.js';
export const SVG_CHEVRON_LEFT = 'CHEVRON_LEFT';
import { default as CHEVRON_LEFT_rebranded } from './deprecated/js/chevron-left.js';
export const SVG_CHEVRON_LEFT_COLLAPSE = 'CHEVRON_LEFT_COLLAPSE';
import { default as CHEVRON_LEFT_COLLAPSE_rebranded } from './deprecated/js/chevron-left-collapse.js';
export const SVG_CHEVRON_RIGHT_EXPAND = 'CHEVRON_RIGHT_EXPAND';
import { default as CHEVRON_RIGHT_EXPAND_rebranded } from './deprecated/js/chevron-right-expand.js';
export const SVG_CHEVRON_RIGHT = 'CHEVRON_RIGHT';
import { default as CHEVRON_RIGHT_rebranded } from './deprecated/js/chevron-right.js';
export const SVG_CHEVRON_UP_20_PX = 'CHEVRON_UP_20_PX';
import { default as CHEVRON_UP_20_PX_rebranded } from './deprecated/js/chevron-up-20-px.js';
export const SVG_CHEVRON_UP = 'CHEVRON_UP';
import { default as CHEVRON_UP_rebranded } from './deprecated/js/chevron-up.js';
export const SVG_CLEAR_ALL = 'CLEAR_ALL';
import { default as CLEAR_ALL_rebranded } from './deprecated/js/clear-all.js';
export const SVG_CLIP = 'CLIP';
import { default as CLIP_rebranded } from './deprecated/js/clip.js';
export const SVG_CLIPBOARD_ACTIVE = 'CLIPBOARD_ACTIVE';
import { default as CLIPBOARD_ACTIVE_rebranded } from './deprecated/js/clipboard-active.js';
export const SVG_CLIPBOARD_INACTIVE = 'CLIPBOARD_INACTIVE';
import { default as CLIPBOARD_INACTIVE_rebranded } from './deprecated/js/clipboard-inactive.js';
export const SVG_CLOSE_CIRCLE_ACTIVE = 'CLOSE_CIRCLE_ACTIVE';
import { default as CLOSE_CIRCLE_ACTIVE_rebranded } from './deprecated/js/close-circle-active.js';
export const SVG_CLOCK_ACTIVE = 'CLOCK_ACTIVE';
import { default as CLOCK_ACTIVE_rebranded } from './deprecated/js/clock-active.js';
export const SVG_CLOCK_INACTIVE = 'CLOCK_INACTIVE';
import { default as CLOCK_INACTIVE_rebranded } from './deprecated/js/clock-inactive.js';
export const SVG_CLOSE = 'CLOSE';
import { default as CLOSE_rebranded } from './deprecated/js/close.js';
export const SVG_CLOSE_CIRCLE_INACTIVE = 'CLOSE_CIRCLE_INACTIVE';
import { default as CLOSE_CIRCLE_INACTIVE_rebranded } from './deprecated/js/close-circle-inactive.js';
export const SVG_CLOUD_ACTIVE = 'CLOUD_ACTIVE';
import { default as CLOUD_ACTIVE_rebranded } from './deprecated/js/cloud-active.js';
export const SVG_CLOUD_OFF_ACTIVE = 'CLOUD_OFF_ACTIVE';
import { default as CLOUD_OFF_ACTIVE_rebranded } from './deprecated/js/cloud-off-active.js';
export const SVG_CLOUD_OFF = 'CLOUD_OFF';
import { default as CLOUD_OFF_rebranded } from './deprecated/js/cloud-off.js';
export const SVG_CLOUD_UPLOAD_ACTIVE = 'CLOUD_UPLOAD_ACTIVE';
import { default as CLOUD_UPLOAD_ACTIVE_rebranded } from './deprecated/js/cloud-upload-active.js';
export const SVG_CLOUD_UPLOAD_INACTIVE = 'CLOUD_UPLOAD_INACTIVE';
import { default as CLOUD_UPLOAD_INACTIVE_rebranded } from './deprecated/js/cloud-upload-inactive.js';
export const SVG_CLOUD = 'CLOUD';
import { default as CLOUD_rebranded } from './deprecated/js/cloud.js';
export const SVG_COBY_ACTIVE = 'COBY_ACTIVE';
import { default as COBY_ACTIVE_rebranded } from './deprecated/js/coby-active.js';
export const SVG_COBY_INACTIVE = 'COBY_INACTIVE';
import { default as COBY_INACTIVE_rebranded } from './deprecated/js/coby-inactive.js';
export const SVG_AD = 'AD';
import { default as AD_rebranded } from './deprecated/js/ad.js';
export const SVG_AE = 'AE';
import { default as AE_rebranded } from './deprecated/js/ae.js';
export const SVG_CODE = 'CODE';
import { default as CODE_rebranded } from './deprecated/js/code.js';
export const SVG_AG = 'AG';
import { default as AG_rebranded } from './deprecated/js/ag.js';
export const SVG_AF = 'AF';
import { default as AF_rebranded } from './deprecated/js/af.js';
export const SVG_AL = 'AL';
import { default as AL_rebranded } from './deprecated/js/al.js';
export const SVG_AM = 'AM';
import { default as AM_rebranded } from './deprecated/js/am.js';
export const SVG_AN = 'AN';
import { default as AN_rebranded } from './deprecated/js/an.js';
export const SVG_AO = 'AO';
import { default as AO_rebranded } from './deprecated/js/ao.js';
export const SVG_APPLE = 'APPLE';
import { default as APPLE_rebranded } from './deprecated/js/apple.js';
export const SVG_AR = 'AR';
import { default as AR_rebranded } from './deprecated/js/ar.js';
export const SVG_AT = 'AT';
import { default as AT_rebranded } from './deprecated/js/at.js';
export const SVG_AU = 'AU';
import { default as AU_rebranded } from './deprecated/js/au.js';
export const SVG_AW = 'AW';
import { default as AW_rebranded } from './deprecated/js/aw.js';
export const SVG_AZ = 'AZ';
import { default as AZ_rebranded } from './deprecated/js/az.js';
export const SVG_BA = 'BA';
import { default as BA_rebranded } from './deprecated/js/ba.js';
export const SVG_BD = 'BD';
import { default as BD_rebranded } from './deprecated/js/bd.js';
export const SVG_BB = 'BB';
import { default as BB_rebranded } from './deprecated/js/bb.js';
export const SVG_BE = 'BE';
import { default as BE_rebranded } from './deprecated/js/be.js';
export const SVG_BF = 'BF';
import { default as BF_rebranded } from './deprecated/js/bf.js';
export const SVG_BG = 'BG';
import { default as BG_rebranded } from './deprecated/js/bg.js';
export const SVG_BI = 'BI';
import { default as BI_rebranded } from './deprecated/js/bi.js';
export const SVG_BH = 'BH';
import { default as BH_rebranded } from './deprecated/js/bh.js';
export const SVG_BJ = 'BJ';
import { default as BJ_rebranded } from './deprecated/js/bj.js';
export const SVG_BN = 'BN';
import { default as BN_rebranded } from './deprecated/js/bn.js';
export const SVG_BO = 'BO';
import { default as BO_rebranded } from './deprecated/js/bo.js';
export const SVG_BS = 'BS';
import { default as BS_rebranded } from './deprecated/js/bs.js';
export const SVG_BR = 'BR';
import { default as BR_rebranded } from './deprecated/js/br.js';
export const SVG_BT = 'BT';
import { default as BT_rebranded } from './deprecated/js/bt.js';
export const SVG_BV = 'BV';
import { default as BV_rebranded } from './deprecated/js/bv.js';
export const SVG_BW = 'BW';
import { default as BW_rebranded } from './deprecated/js/bw.js';
export const SVG_BY = 'BY';
import { default as BY_rebranded } from './deprecated/js/by.js';
export const SVG_BZ = 'BZ';
import { default as BZ_rebranded } from './deprecated/js/bz.js';
export const SVG_CA = 'CA';
import { default as CA_rebranded } from './deprecated/js/ca.js';
export const SVG_CD = 'CD';
import { default as CD_rebranded } from './deprecated/js/cd.js';
export const SVG_CF = 'CF';
import { default as CF_rebranded } from './deprecated/js/cf.js';
export const SVG_CG = 'CG';
import { default as CG_rebranded } from './deprecated/js/cg.js';
export const SVG_CH = 'CH';
import { default as CH_rebranded } from './deprecated/js/ch.js';
export const SVG_CI = 'CI';
import { default as CI_rebranded } from './deprecated/js/ci.js';
export const SVG_CL = 'CL';
import { default as CL_rebranded } from './deprecated/js/cl.js';
export const SVG_CM = 'CM';
import { default as CM_rebranded } from './deprecated/js/cm.js';
export const SVG_CN = 'CN';
import { default as CN_rebranded } from './deprecated/js/cn.js';
export const SVG_CO = 'CO';
import { default as CO_rebranded } from './deprecated/js/co.js';
export const SVG_CR = 'CR';
import { default as CR_rebranded } from './deprecated/js/cr.js';
export const SVG_CU = 'CU';
import { default as CU_rebranded } from './deprecated/js/cu.js';
export const SVG_CV = 'CV';
import { default as CV_rebranded } from './deprecated/js/cv.js';
export const SVG_CONNECT_WISE = 'CONNECT_WISE';
import { default as CONNECT_WISE_rebranded } from './deprecated/js/connect-wise.js';
export const SVG_CW = 'CW';
import { default as CW_rebranded } from './deprecated/js/cw.js';
export const SVG_CY = 'CY';
import { default as CY_rebranded } from './deprecated/js/cy.js';
export const SVG_DE = 'DE';
import { default as DE_rebranded } from './deprecated/js/de.js';
export const SVG_DATTO = 'DATTO';
import { default as DATTO_rebranded } from './deprecated/js/datto.js';
export const SVG_CZ = 'CZ';
import { default as CZ_rebranded } from './deprecated/js/cz.js';
export const SVG_DJ = 'DJ';
import { default as DJ_rebranded } from './deprecated/js/dj.js';
export const SVG_DM = 'DM';
import { default as DM_rebranded } from './deprecated/js/dm.js';
export const SVG_DK = 'DK';
import { default as DK_rebranded } from './deprecated/js/dk.js';
export const SVG_DO = 'DO';
import { default as DO_rebranded } from './deprecated/js/do.js';
export const SVG_DZ = 'DZ';
import { default as DZ_rebranded } from './deprecated/js/dz.js';
export const SVG_EC = 'EC';
import { default as EC_rebranded } from './deprecated/js/ec.js';
export const SVG_EG = 'EG';
import { default as EG_rebranded } from './deprecated/js/eg.js';
export const SVG_EE = 'EE';
import { default as EE_rebranded } from './deprecated/js/ee.js';
export const SVG_ER = 'ER';
import { default as ER_rebranded } from './deprecated/js/er.js';
export const SVG_ES = 'ES';
import { default as ES_rebranded } from './deprecated/js/es.js';
export const SVG_FACEBOOK = 'FACEBOOK';
import { default as FACEBOOK_rebranded } from './deprecated/js/facebook.js';
export const SVG_ET = 'ET';
import { default as ET_rebranded } from './deprecated/js/et.js';
export const SVG_FI = 'FI';
import { default as FI_rebranded } from './deprecated/js/fi.js';
export const SVG_FILE = 'FILE';
import { default as FILE_rebranded } from './deprecated/js/file.js';
export const SVG_FJ = 'FJ';
import { default as FJ_rebranded } from './deprecated/js/fj.js';
export const SVG_GA = 'GA';
import { default as GA_rebranded } from './deprecated/js/ga.js';
export const SVG_FR = 'FR';
import { default as FR_rebranded } from './deprecated/js/fr.js';
export const SVG_FM = 'FM';
import { default as FM_rebranded } from './deprecated/js/fm.js';
export const SVG_GB = 'GB';
import { default as GB_rebranded } from './deprecated/js/gb.js';
export const SVG_GD = 'GD';
import { default as GD_rebranded } from './deprecated/js/gd.js';
export const SVG_GH = 'GH';
import { default as GH_rebranded } from './deprecated/js/gh.js';
export const SVG_GE = 'GE';
import { default as GE_rebranded } from './deprecated/js/ge.js';
export const SVG_GM = 'GM';
import { default as GM_rebranded } from './deprecated/js/gm.js';
export const SVG_GN = 'GN';
import { default as GN_rebranded } from './deprecated/js/gn.js';
export const SVG_GOOGLE_DRIVE_DOC = 'GOOGLE_DRIVE_DOC';
import { default as GOOGLE_DRIVE_DOC_rebranded } from './deprecated/js/google-drive-doc.js';
export const SVG_GOOGLE_CALENDAR = 'GOOGLE_CALENDAR';
import { default as GOOGLE_CALENDAR_rebranded } from './deprecated/js/google-calendar.js';
export const SVG_GOOGLE_DRIVE_DRAWINGS = 'GOOGLE_DRIVE_DRAWINGS';
import { default as GOOGLE_DRIVE_DRAWINGS_rebranded } from './deprecated/js/google-drive-drawings.js';
export const SVG_GOOGLE_DRIVE_FOLDER = 'GOOGLE_DRIVE_FOLDER';
import { default as GOOGLE_DRIVE_FOLDER_rebranded } from './deprecated/js/google-drive-folder.js';
export const SVG_GOOGLE_DRIVE_SHEET = 'GOOGLE_DRIVE_SHEET';
import { default as GOOGLE_DRIVE_SHEET_rebranded } from './deprecated/js/google-drive-sheet.js';
export const SVG_GOOGLE_DRIVE_SLIDE = 'GOOGLE_DRIVE_SLIDE';
import { default as GOOGLE_DRIVE_SLIDE_rebranded } from './deprecated/js/google-drive-slide.js';
export const SVG_GOOGLE_DRIVE = 'GOOGLE_DRIVE';
import { default as GOOGLE_DRIVE_rebranded } from './deprecated/js/google-drive.js';
export const SVG_GOOGLE_GMAIL = 'GOOGLE_GMAIL';
import { default as GOOGLE_GMAIL_rebranded } from './deprecated/js/google-gmail.js';
export const SVG_GOOGLE = 'GOOGLE';
import { default as GOOGLE_rebranded } from './deprecated/js/google.js';
export const SVG_GOTO_ADMIN_BLACK_YELLOW = 'GOTO_ADMIN_BLACK_YELLOW';
import { default as GOTO_ADMIN_BLACK_YELLOW_rebranded } from './deprecated/js/goto-admin-black-yellow.js';
export const SVG_GOTO_ADMIN_PARTNER_APP_ICON_DARK_MODE = 'GOTO_ADMIN_PARTNER_APP_ICON_DARK_MODE';
import { default as GOTO_ADMIN_PARTNER_APP_ICON_DARK_MODE_rebranded } from './deprecated/js/goto-admin-partner-app-icon-dark-mode.js';
export const SVG_GOTO_ADMIN_PARTNER_FAVICON_DARK_MODE = 'GOTO_ADMIN_PARTNER_FAVICON_DARK_MODE';
import { default as GOTO_ADMIN_PARTNER_FAVICON_DARK_MODE_rebranded } from './deprecated/js/goto-admin-partner-favicon-dark-mode.js';
export const SVG_GOTO_ADMIN_PARTNER_FAVICON = 'GOTO_ADMIN_PARTNER_FAVICON';
import { default as GOTO_ADMIN_PARTNER_FAVICON_rebranded } from './deprecated/js/goto-admin-partner-favicon.js';
export const SVG_GOTO_ADMIN_WHITE_YELLOW = 'GOTO_ADMIN_WHITE_YELLOW';
import { default as GOTO_ADMIN_WHITE_YELLOW_rebranded } from './deprecated/js/goto-admin-white-yellow.js';
export const SVG_GOTO_ADMIN_PARTNER_APP_ICON = 'GOTO_ADMIN_PARTNER_APP_ICON';
import { default as GOTO_ADMIN_PARTNER_APP_ICON_rebranded } from './deprecated/js/goto-admin-partner-app-icon.js';
export const SVG_GOTO_APP_ICON_DARK_MODE = 'GOTO_APP_ICON_DARK_MODE';
import { default as GOTO_APP_ICON_DARK_MODE_rebranded } from './deprecated/js/goto-app-icon-dark-mode.js';
export const SVG_GOTO_APP_ICON = 'GOTO_APP_ICON';
import { default as GOTO_APP_ICON_rebranded } from './deprecated/js/goto-app-icon.js';
export const SVG_GOTO_BLACK_FAVICON = 'GOTO_BLACK_FAVICON';
import { default as GOTO_BLACK_FAVICON_rebranded } from './deprecated/js/goto-black-favicon.js';
export const SVG_GOTO_BLACK_MONOCHROME_FAVICON = 'GOTO_BLACK_MONOCHROME_FAVICON';
import { default as GOTO_BLACK_MONOCHROME_FAVICON_rebranded } from './deprecated/js/goto-black-monochrome-favicon.js';
export const SVG_GOTO_BLACK_YELLOW_FAVICON_LEGACY = 'GOTO_BLACK_YELLOW_FAVICON_LEGACY';
import { default as GOTO_BLACK_YELLOW_FAVICON_LEGACY_rebranded } from './deprecated/js/goto-black-yellow-favicon-legacy.js';
export const SVG_GOTO_BLACK_YELLOW_FAVICON = 'GOTO_BLACK_YELLOW_FAVICON';
import { default as GOTO_BLACK_YELLOW_FAVICON_rebranded } from './deprecated/js/goto-black-yellow-favicon.js';
export const SVG_GOTO_BLACK_WHITE = 'GOTO_BLACK_WHITE';
import { default as GOTO_BLACK_WHITE_rebranded } from './deprecated/js/goto-black-white.js';
export const SVG_GOTO_BLACK_YELLOW = 'GOTO_BLACK_YELLOW';
import { default as GOTO_BLACK_YELLOW_rebranded } from './deprecated/js/goto-black-yellow.js';
export const SVG_GOTO_BLACK = 'GOTO_BLACK';
import { default as GOTO_BLACK_rebranded } from './deprecated/js/goto-black.js';
export const SVG_GOTO_GIVES_BLACK_YELLOW = 'GOTO_GIVES_BLACK_YELLOW';
import { default as GOTO_GIVES_BLACK_YELLOW_rebranded } from './deprecated/js/goto-gives-black-yellow.js';
export const SVG_GOTO_GIVES_BLACK = 'GOTO_GIVES_BLACK';
import { default as GOTO_GIVES_BLACK_rebranded } from './deprecated/js/goto-gives-black.js';
export const SVG_GOTO_GIVES_GREY = 'GOTO_GIVES_GREY';
import { default as GOTO_GIVES_GREY_rebranded } from './deprecated/js/goto-gives-grey.js';
export const SVG_GOTO_GIVES_WHITE_YELLOW = 'GOTO_GIVES_WHITE_YELLOW';
import { default as GOTO_GIVES_WHITE_YELLOW_rebranded } from './deprecated/js/goto-gives-white-yellow.js';
export const SVG_GOTO_GIVES_WHITE = 'GOTO_GIVES_WHITE';
import { default as GOTO_GIVES_WHITE_rebranded } from './deprecated/js/goto-gives-white.js';
export const SVG_GOTO_GREY = 'GOTO_GREY';
import { default as GOTO_GREY_rebranded } from './deprecated/js/goto-grey.js';
export const SVG_GOTO_INTEGRATIONS_APP_ICON_DARK_MODE = 'GOTO_INTEGRATIONS_APP_ICON_DARK_MODE';
import { default as GOTO_INTEGRATIONS_APP_ICON_DARK_MODE_rebranded } from './deprecated/js/goto-integrations-app-icon-dark-mode.js';
export const SVG_GOTO_INTEGRATIONS_APP_ICON = 'GOTO_INTEGRATIONS_APP_ICON';
import { default as GOTO_INTEGRATIONS_APP_ICON_rebranded } from './deprecated/js/goto-integrations-app-icon.js';
export const SVG_GOTO_MARK = 'GOTO_MARK';
import { default as GOTO_MARK_rebranded } from './deprecated/js/goto-mark.js';
export const SVG_GOTO_PARTNER_BLACK_YELLOW = 'GOTO_PARTNER_BLACK_YELLOW';
import { default as GOTO_PARTNER_BLACK_YELLOW_rebranded } from './deprecated/js/goto-partner-black-yellow.js';
export const SVG_GOTO_WHITE_FAVICON = 'GOTO_WHITE_FAVICON';
import { default as GOTO_WHITE_FAVICON_rebranded } from './deprecated/js/goto-white-favicon.js';
export const SVG_GOTO_PARTNER_WHITE_YELLOW = 'GOTO_PARTNER_WHITE_YELLOW';
import { default as GOTO_PARTNER_WHITE_YELLOW_rebranded } from './deprecated/js/goto-partner-white-yellow.js';
export const SVG_GOTO_WHITE_MONOCHROME_FAVICON = 'GOTO_WHITE_MONOCHROME_FAVICON';
import { default as GOTO_WHITE_MONOCHROME_FAVICON_rebranded } from './deprecated/js/goto-white-monochrome-favicon.js';
export const SVG_GOTO_WHITE_YELLOW_FAVICON_DARK_MODE = 'GOTO_WHITE_YELLOW_FAVICON_DARK_MODE';
import { default as GOTO_WHITE_YELLOW_FAVICON_DARK_MODE_rebranded } from './deprecated/js/goto-white-yellow-favicon-dark-mode.js';
export const SVG_GOTO_WHITE = 'GOTO_WHITE';
import { default as GOTO_WHITE_rebranded } from './deprecated/js/goto-white.js';
export const SVG_GOTO_WHITE_YELLOW = 'GOTO_WHITE_YELLOW';
import { default as GOTO_WHITE_YELLOW_rebranded } from './deprecated/js/goto-white-yellow.js';
export const SVG_GQ = 'GQ';
import { default as GQ_rebranded } from './deprecated/js/gq.js';
export const SVG_GR = 'GR';
import { default as GR_rebranded } from './deprecated/js/gr.js';
export const SVG_GRASSHOPPER_MARK = 'GRASSHOPPER_MARK';
import { default as GRASSHOPPER_MARK_rebranded } from './deprecated/js/grasshopper-mark.js';
export const SVG_GTR_BLACK_HORIZONTAL = 'GTR_BLACK_HORIZONTAL';
import { default as GTR_BLACK_HORIZONTAL_rebranded } from './deprecated/js/gtr-black-horizontal.js';
export const SVG_GT = 'GT';
import { default as GT_rebranded } from './deprecated/js/gt.js';
export const SVG_GTR_BLACK_VERTICAL = 'GTR_BLACK_VERTICAL';
import { default as GTR_BLACK_VERTICAL_rebranded } from './deprecated/js/gtr-black-vertical.js';
export const SVG_GTR_BLACK_YELLOW_PURPLE_HORIZONTAL = 'GTR_BLACK_YELLOW_PURPLE_HORIZONTAL';
import { default as GTR_BLACK_YELLOW_PURPLE_HORIZONTAL_rebranded } from './deprecated/js/gtr-black-yellow-purple-horizontal.js';
export const SVG_GTR_BLACK_YELLOW_PURPLE_VERTICAL = 'GTR_BLACK_YELLOW_PURPLE_VERTICAL';
import { default as GTR_BLACK_YELLOW_PURPLE_VERTICAL_rebranded } from './deprecated/js/gtr-black-yellow-purple-vertical.js';
export const SVG_GTR_DEFAULT_APP_ICON_DARK_MODE = 'GTR_DEFAULT_APP_ICON_DARK_MODE';
import { default as GTR_DEFAULT_APP_ICON_DARK_MODE_rebranded } from './deprecated/js/gtr-default-app-icon-dark-mode.js';
export const SVG_GTR_DEFAULT_APP_ICON = 'GTR_DEFAULT_APP_ICON';
import { default as GTR_DEFAULT_APP_ICON_rebranded } from './deprecated/js/gtr-default-app-icon.js';
export const SVG_GTR_FAVICON_DARK_MODE = 'GTR_FAVICON_DARK_MODE';
import { default as GTR_FAVICON_DARK_MODE_rebranded } from './deprecated/js/gtr-favicon-dark-mode.js';
export const SVG_GTR_FAVICON_LEGACY = 'GTR_FAVICON_LEGACY';
import { default as GTR_FAVICON_LEGACY_rebranded } from './deprecated/js/gtr-favicon-legacy.js';
export const SVG_GTR_FAVICON = 'GTR_FAVICON';
import { default as GTR_FAVICON_rebranded } from './deprecated/js/gtr-favicon.js';
export const SVG_GTR_GREY_HORIZONTAL = 'GTR_GREY_HORIZONTAL';
import { default as GTR_GREY_HORIZONTAL_rebranded } from './deprecated/js/gtr-grey-horizontal.js';
export const SVG_GTR_GREY_VERTICAL = 'GTR_GREY_VERTICAL';
import { default as GTR_GREY_VERTICAL_rebranded } from './deprecated/js/gtr-grey-vertical.js';
export const SVG_GTR_PURPLE_APP_ICON_DARK_MODE = 'GTR_PURPLE_APP_ICON_DARK_MODE';
import { default as GTR_PURPLE_APP_ICON_DARK_MODE_rebranded } from './deprecated/js/gtr-purple-app-icon-dark-mode.js';
export const SVG_GTR_PURPLE_APP_ICON = 'GTR_PURPLE_APP_ICON';
import { default as GTR_PURPLE_APP_ICON_rebranded } from './deprecated/js/gtr-purple-app-icon.js';
export const SVG_GTR_WHITE_HORIZONTAL = 'GTR_WHITE_HORIZONTAL';
import { default as GTR_WHITE_HORIZONTAL_rebranded } from './deprecated/js/gtr-white-horizontal.js';
export const SVG_GTR_WHITE_VERTICAL = 'GTR_WHITE_VERTICAL';
import { default as GTR_WHITE_VERTICAL_rebranded } from './deprecated/js/gtr-white-vertical.js';
export const SVG_GTR_WHITE_YELLOW_HORIZONTAL = 'GTR_WHITE_YELLOW_HORIZONTAL';
import { default as GTR_WHITE_YELLOW_HORIZONTAL_rebranded } from './deprecated/js/gtr-white-yellow-horizontal.js';
export const SVG_GTR_WHITE_YELLOW_VERTICAL = 'GTR_WHITE_YELLOW_VERTICAL';
import { default as GTR_WHITE_YELLOW_VERTICAL_rebranded } from './deprecated/js/gtr-white-yellow-vertical.js';
export const SVG_GW = 'GW';
import { default as GW_rebranded } from './deprecated/js/gw.js';
export const SVG_GY = 'GY';
import { default as GY_rebranded } from './deprecated/js/gy.js';
export const SVG_HK = 'HK';
import { default as HK_rebranded } from './deprecated/js/hk.js';
export const SVG_HR = 'HR';
import { default as HR_rebranded } from './deprecated/js/hr.js';
export const SVG_HN = 'HN';
import { default as HN_rebranded } from './deprecated/js/hn.js';
export const SVG_HT = 'HT';
import { default as HT_rebranded } from './deprecated/js/ht.js';
export const SVG_HU = 'HU';
import { default as HU_rebranded } from './deprecated/js/hu.js';
export const SVG_ID = 'ID';
import { default as ID_rebranded } from './deprecated/js/id.js';
export const SVG_IE = 'IE';
import { default as IE_rebranded } from './deprecated/js/ie.js';
export const SVG_IL = 'IL';
import { default as IL_rebranded } from './deprecated/js/il.js';
export const SVG_IN = 'IN';
import { default as IN_rebranded } from './deprecated/js/in.js';
export const SVG_IQ = 'IQ';
import { default as IQ_rebranded } from './deprecated/js/iq.js';
export const SVG_INSTAGRAM = 'INSTAGRAM';
import { default as INSTAGRAM_rebranded } from './deprecated/js/instagram.js';
export const SVG_IR = 'IR';
import { default as IR_rebranded } from './deprecated/js/ir.js';
export const SVG_IS = 'IS';
import { default as IS_rebranded } from './deprecated/js/is.js';
export const SVG_IT = 'IT';
import { default as IT_rebranded } from './deprecated/js/it.js';
export const SVG_JM = 'JM';
import { default as JM_rebranded } from './deprecated/js/jm.js';
export const SVG_JO = 'JO';
import { default as JO_rebranded } from './deprecated/js/jo.js';
export const SVG_JP = 'JP';
import { default as JP_rebranded } from './deprecated/js/jp.js';
export const SVG_KE = 'KE';
import { default as KE_rebranded } from './deprecated/js/ke.js';
export const SVG_KG = 'KG';
import { default as KG_rebranded } from './deprecated/js/kg.js';
export const SVG_KH = 'KH';
import { default as KH_rebranded } from './deprecated/js/kh.js';
export const SVG_KI = 'KI';
import { default as KI_rebranded } from './deprecated/js/ki.js';
export const SVG_KP = 'KP';
import { default as KP_rebranded } from './deprecated/js/kp.js';
export const SVG_KR = 'KR';
import { default as KR_rebranded } from './deprecated/js/kr.js';
export const SVG_KW = 'KW';
import { default as KW_rebranded } from './deprecated/js/kw.js';
export const SVG_KM = 'KM';
import { default as KM_rebranded } from './deprecated/js/km.js';
export const SVG_KZ = 'KZ';
import { default as KZ_rebranded } from './deprecated/js/kz.js';
export const SVG_LA = 'LA';
import { default as LA_rebranded } from './deprecated/js/la.js';
export const SVG_LB = 'LB';
import { default as LB_rebranded } from './deprecated/js/lb.js';
export const SVG_LI = 'LI';
import { default as LI_rebranded } from './deprecated/js/li.js';
export const SVG_LC = 'LC';
import { default as LC_rebranded } from './deprecated/js/lc.js';
export const SVG_LINKEDIN = 'LINKEDIN';
import { default as LINKEDIN_rebranded } from './deprecated/js/linkedin.js';
export const SVG_LK = 'LK';
import { default as LK_rebranded } from './deprecated/js/lk.js';
export const SVG_LP_BY_GO_TO_BLACK_HORIZONTAL = 'LP_BY_GO_TO_BLACK_HORIZONTAL';
import { default as LP_BY_GO_TO_BLACK_HORIZONTAL_rebranded } from './deprecated/js/lp-by-go-to-black-horizontal.js';
export const SVG_LP_BY_GO_TO_BLACK_RED_HORIZONTAL = 'LP_BY_GO_TO_BLACK_RED_HORIZONTAL';
import { default as LP_BY_GO_TO_BLACK_RED_HORIZONTAL_rebranded } from './deprecated/js/lp-by-go-to-black-red-horizontal.js';
export const SVG_LP_BY_GO_TO_BLACK_RED_VERTICAL = 'LP_BY_GO_TO_BLACK_RED_VERTICAL';
import { default as LP_BY_GO_TO_BLACK_RED_VERTICAL_rebranded } from './deprecated/js/lp-by-go-to-black-red-vertical.js';
export const SVG_LP_BY_GO_TO_BLACK_VERTICAL = 'LP_BY_GO_TO_BLACK_VERTICAL';
import { default as LP_BY_GO_TO_BLACK_VERTICAL_rebranded } from './deprecated/js/lp-by-go-to-black-vertical.js';
export const SVG_LP_BY_GO_TO_GREY_HORIZONTAL = 'LP_BY_GO_TO_GREY_HORIZONTAL';
import { default as LP_BY_GO_TO_GREY_HORIZONTAL_rebranded } from './deprecated/js/lp-by-go-to-grey-horizontal.js';
export const SVG_LP_BY_GO_TO_GREY_VERTICAL = 'LP_BY_GO_TO_GREY_VERTICAL';
import { default as LP_BY_GO_TO_GREY_VERTICAL_rebranded } from './deprecated/js/lp-by-go-to-grey-vertical.js';
export const SVG_LP_BY_GO_TO_WHITE_HORIZONTAL = 'LP_BY_GO_TO_WHITE_HORIZONTAL';
import { default as LP_BY_GO_TO_WHITE_HORIZONTAL_rebranded } from './deprecated/js/lp-by-go-to-white-horizontal.js';
export const SVG_LP_BY_GO_TO_WHITE_RED_HORIZONTAL = 'LP_BY_GO_TO_WHITE_RED_HORIZONTAL';
import { default as LP_BY_GO_TO_WHITE_RED_HORIZONTAL_rebranded } from './deprecated/js/lp-by-go-to-white-red-horizontal.js';
export const SVG_LP_BY_GO_TO_WHITE_RED_VERTICAL = 'LP_BY_GO_TO_WHITE_RED_VERTICAL';
import { default as LP_BY_GO_TO_WHITE_RED_VERTICAL_rebranded } from './deprecated/js/lp-by-go-to-white-red-vertical.js';
export const SVG_LP_BY_GO_TO_WHITE_VERTICAL = 'LP_BY_GO_TO_WHITE_VERTICAL';
import { default as LP_BY_GO_TO_WHITE_VERTICAL_rebranded } from './deprecated/js/lp-by-go-to-white-vertical.js';
export const SVG_LR = 'LR';
import { default as LR_rebranded } from './deprecated/js/lr.js';
export const SVG_LS = 'LS';
import { default as LS_rebranded } from './deprecated/js/ls.js';
export const SVG_LU = 'LU';
import { default as LU_rebranded } from './deprecated/js/lu.js';
export const SVG_LY = 'LY';
import { default as LY_rebranded } from './deprecated/js/ly.js';
export const SVG_LT = 'LT';
import { default as LT_rebranded } from './deprecated/js/lt.js';
export const SVG_LV = 'LV';
import { default as LV_rebranded } from './deprecated/js/lv.js';
export const SVG_MA = 'MA';
import { default as MA_rebranded } from './deprecated/js/ma.js';
export const SVG_MC = 'MC';
import { default as MC_rebranded } from './deprecated/js/mc.js';
export const SVG_MD = 'MD';
import { default as MD_rebranded } from './deprecated/js/md.js';
export const SVG_ME = 'ME';
import { default as ME_rebranded } from './deprecated/js/me.js';
export const SVG_MG = 'MG';
import { default as MG_rebranded } from './deprecated/js/mg.js';
export const SVG_MH = 'MH';
import { default as MH_rebranded } from './deprecated/js/mh.js';
export const SVG_MICROSOFT = 'MICROSOFT';
import { default as MICROSOFT_rebranded } from './deprecated/js/microsoft.js';
export const SVG_MICROSOFT_TEAMS = 'MICROSOFT_TEAMS';
import { default as MICROSOFT_TEAMS_rebranded } from './deprecated/js/microsoft-teams.js';
export const SVG_MIRO = 'MIRO';
import { default as MIRO_rebranded } from './deprecated/js/miro.js';
export const SVG_MK = 'MK';
import { default as MK_rebranded } from './deprecated/js/mk.js';
export const SVG_MM = 'MM';
import { default as MM_rebranded } from './deprecated/js/mm.js';
export const SVG_ML = 'ML';
import { default as ML_rebranded } from './deprecated/js/ml.js';
export const SVG_MN = 'MN';
import { default as MN_rebranded } from './deprecated/js/mn.js';
export const SVG_MR = 'MR';
import { default as MR_rebranded } from './deprecated/js/mr.js';
export const SVG_MT = 'MT';
import { default as MT_rebranded } from './deprecated/js/mt.js';
export const SVG_MU = 'MU';
import { default as MU_rebranded } from './deprecated/js/mu.js';
export const SVG_MV = 'MV';
import { default as MV_rebranded } from './deprecated/js/mv.js';
export const SVG_MW = 'MW';
import { default as MW_rebranded } from './deprecated/js/mw.js';
export const SVG_MX = 'MX';
import { default as MX_rebranded } from './deprecated/js/mx.js';
export const SVG_MZ = 'MZ';
import { default as MZ_rebranded } from './deprecated/js/mz.js';
export const SVG_MY = 'MY';
import { default as MY_rebranded } from './deprecated/js/my.js';
export const SVG_NA = 'NA';
import { default as NA_rebranded } from './deprecated/js/na.js';
export const SVG_NE = 'NE';
import { default as NE_rebranded } from './deprecated/js/ne.js';
export const SVG_NG = 'NG';
import { default as NG_rebranded } from './deprecated/js/ng.js';
export const SVG_NI = 'NI';
import { default as NI_rebranded } from './deprecated/js/ni.js';
export const SVG_NL = 'NL';
import { default as NL_rebranded } from './deprecated/js/nl.js';
export const SVG_NP = 'NP';
import { default as NP_rebranded } from './deprecated/js/np.js';
export const SVG_NO = 'NO';
import { default as NO_rebranded } from './deprecated/js/no.js';
export const SVG_NR = 'NR';
import { default as NR_rebranded } from './deprecated/js/nr.js';
export const SVG_NZ = 'NZ';
import { default as NZ_rebranded } from './deprecated/js/nz.js';
export const SVG_OFFICE_365 = 'OFFICE_365';
import { default as OFFICE_365_rebranded } from './deprecated/js/office-365.js';
export const SVG_OM = 'OM';
import { default as OM_rebranded } from './deprecated/js/om.js';
export const SVG_OUTLOOK = 'OUTLOOK';
import { default as OUTLOOK_rebranded } from './deprecated/js/outlook.js';
export const SVG_PA = 'PA';
import { default as PA_rebranded } from './deprecated/js/pa.js';
export const SVG_PE = 'PE';
import { default as PE_rebranded } from './deprecated/js/pe.js';
export const SVG_PG = 'PG';
import { default as PG_rebranded } from './deprecated/js/pg.js';
export const SVG_PH = 'PH';
import { default as PH_rebranded } from './deprecated/js/ph.js';
export const SVG_PK = 'PK';
import { default as PK_rebranded } from './deprecated/js/pk.js';
export const SVG_PL = 'PL';
import { default as PL_rebranded } from './deprecated/js/pl.js';
export const SVG_PS = 'PS';
import { default as PS_rebranded } from './deprecated/js/ps.js';
export const SVG_PT = 'PT';
import { default as PT_rebranded } from './deprecated/js/pt.js';
export const SVG_PW = 'PW';
import { default as PW_rebranded } from './deprecated/js/pw.js';
export const SVG_PY = 'PY';
import { default as PY_rebranded } from './deprecated/js/py.js';
export const SVG_QA = 'QA';
import { default as QA_rebranded } from './deprecated/js/qa.js';
export const SVG_RO = 'RO';
import { default as RO_rebranded } from './deprecated/js/ro.js';
export const SVG_RS = 'RS';
import { default as RS_rebranded } from './deprecated/js/rs.js';
export const SVG_RU = 'RU';
import { default as RU_rebranded } from './deprecated/js/ru.js';
export const SVG_RW = 'RW';
import { default as RW_rebranded } from './deprecated/js/rw.js';
export const SVG_SB = 'SB';
import { default as SB_rebranded } from './deprecated/js/sb.js';
export const SVG_SC = 'SC';
import { default as SC_rebranded } from './deprecated/js/sc.js';
export const SVG_SA = 'SA';
import { default as SA_rebranded } from './deprecated/js/sa.js';
export const SVG_SD = 'SD';
import { default as SD_rebranded } from './deprecated/js/sd.js';
export const SVG_SE = 'SE';
import { default as SE_rebranded } from './deprecated/js/se.js';
export const SVG_SG = 'SG';
import { default as SG_rebranded } from './deprecated/js/sg.js';
export const SVG_SI = 'SI';
import { default as SI_rebranded } from './deprecated/js/si.js';
export const SVG_SK = 'SK';
import { default as SK_rebranded } from './deprecated/js/sk.js';
export const SVG_SL = 'SL';
import { default as SL_rebranded } from './deprecated/js/sl.js';
export const SVG_SLACK = 'SLACK';
import { default as SLACK_rebranded } from './deprecated/js/slack.js';
export const SVG_SN = 'SN';
import { default as SN_rebranded } from './deprecated/js/sn.js';
export const SVG_SM = 'SM';
import { default as SM_rebranded } from './deprecated/js/sm.js';
export const SVG_SO = 'SO';
import { default as SO_rebranded } from './deprecated/js/so.js';
export const SVG_SR = 'SR';
import { default as SR_rebranded } from './deprecated/js/sr.js';
export const SVG_SS = 'SS';
import { default as SS_rebranded } from './deprecated/js/ss.js';
export const SVG_ST = 'ST';
import { default as ST_rebranded } from './deprecated/js/st.js';
export const SVG_SV = 'SV';
import { default as SV_rebranded } from './deprecated/js/sv.js';
export const SVG_SX = 'SX';
import { default as SX_rebranded } from './deprecated/js/sx.js';
export const SVG_SY = 'SY';
import { default as SY_rebranded } from './deprecated/js/sy.js';
export const SVG_SZ = 'SZ';
import { default as SZ_rebranded } from './deprecated/js/sz.js';
export const SVG_TD = 'TD';
import { default as TD_rebranded } from './deprecated/js/td.js';
export const SVG_TH = 'TH';
import { default as TH_rebranded } from './deprecated/js/th.js';
export const SVG_TJ = 'TJ';
import { default as TJ_rebranded } from './deprecated/js/tj.js';
export const SVG_TG = 'TG';
import { default as TG_rebranded } from './deprecated/js/tg.js';
export const SVG_TL = 'TL';
import { default as TL_rebranded } from './deprecated/js/tl.js';
export const SVG_TM = 'TM';
import { default as TM_rebranded } from './deprecated/js/tm.js';
export const SVG_TN = 'TN';
import { default as TN_rebranded } from './deprecated/js/tn.js';
export const SVG_TO = 'TO';
import { default as TO_rebranded } from './deprecated/js/to.js';
export const SVG_TV = 'TV';
import { default as TV_rebranded } from './deprecated/js/tv.js';
export const SVG_TT = 'TT';
import { default as TT_rebranded } from './deprecated/js/tt.js';
export const SVG_TR = 'TR';
import { default as TR_rebranded } from './deprecated/js/tr.js';
export const SVG_TWITTER = 'TWITTER';
import { default as TWITTER_rebranded } from './deprecated/js/twitter.js';
export const SVG_TZ = 'TZ';
import { default as TZ_rebranded } from './deprecated/js/tz.js';
export const SVG_UA = 'UA';
import { default as UA_rebranded } from './deprecated/js/ua.js';
export const SVG_UG = 'UG';
import { default as UG_rebranded } from './deprecated/js/ug.js';
export const SVG_US = 'US';
import { default as US_rebranded } from './deprecated/js/us.js';
export const SVG_UY = 'UY';
import { default as UY_rebranded } from './deprecated/js/uy.js';
export const SVG_UZ = 'UZ';
import { default as UZ_rebranded } from './deprecated/js/uz.js';
export const SVG_VA = 'VA';
import { default as VA_rebranded } from './deprecated/js/va.js';
export const SVG_VC = 'VC';
import { default as VC_rebranded } from './deprecated/js/vc.js';
export const SVG_VE = 'VE';
import { default as VE_rebranded } from './deprecated/js/ve.js';
export const SVG_VI = 'VI';
import { default as VI_rebranded } from './deprecated/js/vi.js';
export const SVG_VN = 'VN';
import { default as VN_rebranded } from './deprecated/js/vn.js';
export const SVG_VU = 'VU';
import { default as VU_rebranded } from './deprecated/js/vu.js';
export const SVG_WS = 'WS';
import { default as WS_rebranded } from './deprecated/js/ws.js';
export const SVG_YE = 'YE';
import { default as YE_rebranded } from './deprecated/js/ye.js';
export const SVG_YOUTUBE = 'YOUTUBE';
import { default as YOUTUBE_rebranded } from './deprecated/js/youtube.js';
export const SVG_ZA = 'ZA';
import { default as ZA_rebranded } from './deprecated/js/za.js';
export const SVG_ZM = 'ZM';
import { default as ZM_rebranded } from './deprecated/js/zm.js';
export const SVG_ZW = 'ZW';
import { default as ZW_rebranded } from './deprecated/js/zw.js';
export const SVG_COMMUTER_MODE_ACTIVE = 'COMMUTER_MODE_ACTIVE';
import { default as COMMUTER_MODE_ACTIVE_rebranded } from './deprecated/js/commuter-mode-active.js';
export const SVG_COMMUTER_MODE = 'COMMUTER_MODE';
import { default as COMMUTER_MODE_rebranded } from './deprecated/js/commuter-mode.js';
export const SVG_CONFERENCE_PHONE_INACTIVE = 'CONFERENCE_PHONE_INACTIVE';
import { default as CONFERENCE_PHONE_INACTIVE_rebranded } from './deprecated/js/conference-phone-inactive.js';
export const SVG_CONFERENCE_PHONE = 'CONFERENCE_PHONE';
import { default as CONFERENCE_PHONE_rebranded } from './deprecated/js/conference-phone.js';
export const SVG_CONNECT_ACTIVE = 'CONNECT_ACTIVE';
import { default as CONNECT_ACTIVE_rebranded } from './deprecated/js/connect-active.js';
export const SVG_CONNECT_INACTIVE = 'CONNECT_INACTIVE';
import { default as CONNECT_INACTIVE_rebranded } from './deprecated/js/connect-inactive.js';
export const SVG_CONNECTED_VIA_PHONE_ACTIVE = 'CONNECTED_VIA_PHONE_ACTIVE';
import { default as CONNECTED_VIA_PHONE_ACTIVE_rebranded } from './deprecated/js/connected-via-phone-active.js';
export const SVG_CONNECTED_VIA_PHONE_INACTIVE = 'CONNECTED_VIA_PHONE_INACTIVE';
import { default as CONNECTED_VIA_PHONE_INACTIVE_rebranded } from './deprecated/js/connected-via-phone-inactive.js';
export const SVG_CONTINUE_20_PX_INACTIVE = 'CONTINUE_20_PX_INACTIVE';
import { default as CONTINUE_20_PX_INACTIVE_rebranded } from './deprecated/js/continue-20-px-inactive.js';
export const SVG_CONTROLS_ACTIVE = 'CONTROLS_ACTIVE';
import { default as CONTROLS_ACTIVE_rebranded } from './deprecated/js/controls-active.js';
export const SVG_CONTROLS_INACTIVE = 'CONTROLS_INACTIVE';
import { default as CONTROLS_INACTIVE_rebranded } from './deprecated/js/controls-inactive.js';
export const SVG_CONVERSATION_ACTIVE = 'CONVERSATION_ACTIVE';
import { default as CONVERSATION_ACTIVE_rebranded } from './deprecated/js/conversation-active.js';
export const SVG_CONTINUE_20_PX = 'CONTINUE_20_PX';
import { default as CONTINUE_20_PX_rebranded } from './deprecated/js/continue-20-px.js';
export const SVG_CONVERSATION_INACTIVE = 'CONVERSATION_INACTIVE';
import { default as CONVERSATION_INACTIVE_rebranded } from './deprecated/js/conversation-inactive.js';
export const SVG_COPY_ACTIVE = 'COPY_ACTIVE';
import { default as COPY_ACTIVE_rebranded } from './deprecated/js/copy-active.js';
export const SVG_COPY_INACTIVE = 'COPY_INACTIVE';
import { default as COPY_INACTIVE_rebranded } from './deprecated/js/copy-inactive.js';
export const SVG_CPU_ACTIVE = 'CPU_ACTIVE';
import { default as CPU_ACTIVE_rebranded } from './deprecated/js/cpu-active.js';
export const SVG_CPU = 'CPU';
import { default as CPU_rebranded } from './deprecated/js/cpu.js';
export const SVG_CREATE_CONVERSATION_ACTIVE = 'CREATE_CONVERSATION_ACTIVE';
import { default as CREATE_CONVERSATION_ACTIVE_rebranded } from './deprecated/js/create-conversation-active.js';
export const SVG_CREATE_CONVERSATION_INACTIVE = 'CREATE_CONVERSATION_INACTIVE';
import { default as CREATE_CONVERSATION_INACTIVE_rebranded } from './deprecated/js/create-conversation-inactive.js';
export const SVG_CREATE_GROUP_ACTIVE = 'CREATE_GROUP_ACTIVE';
import { default as CREATE_GROUP_ACTIVE_rebranded } from './deprecated/js/create-group-active.js';
export const SVG_CREATE_GROUP_INACTIVE = 'CREATE_GROUP_INACTIVE';
import { default as CREATE_GROUP_INACTIVE_rebranded } from './deprecated/js/create-group-inactive.js';
export const SVG_CROWD_ACTIVE = 'CROWD_ACTIVE';
import { default as CROWD_ACTIVE_rebranded } from './deprecated/js/crowd-active.js';
export const SVG_CROWD_INACTIVE = 'CROWD_INACTIVE';
import { default as CROWD_INACTIVE_rebranded } from './deprecated/js/crowd-inactive.js';
export const SVG_CTRL_ALT_DEL_ACTIVE = 'CTRL_ALT_DEL_ACTIVE';
import { default as CTRL_ALT_DEL_ACTIVE_rebranded } from './deprecated/js/ctrl-alt-del-active.js';
export const SVG_CTRL_ALT_DEL_INACTIVE = 'CTRL_ALT_DEL_INACTIVE';
import { default as CTRL_ALT_DEL_INACTIVE_rebranded } from './deprecated/js/ctrl-alt-del-inactive.js';
export const SVG_CVS_ACTIVE = 'CVS_ACTIVE';
import { default as CVS_ACTIVE_rebranded } from './deprecated/js/cvs-active.js';
export const SVG_CVS_INACTIVE = 'CVS_INACTIVE';
import { default as CVS_INACTIVE_rebranded } from './deprecated/js/cvs-inactive.js';
export const SVG_DARK_MODE_INACTIVE = 'DARK_MODE_INACTIVE';
import { default as DARK_MODE_INACTIVE_rebranded } from './deprecated/js/dark-mode-inactive.js';
export const SVG_DARK_MODE = 'DARK_MODE';
import { default as DARK_MODE_rebranded } from './deprecated/js/dark-mode.js';
export const SVG_DASHBOARD_ACTIVE = 'DASHBOARD_ACTIVE';
import { default as DASHBOARD_ACTIVE_rebranded } from './deprecated/js/dashboard-active.js';
export const SVG_DASHBOARD_INACTIVE = 'DASHBOARD_INACTIVE';
import { default as DASHBOARD_INACTIVE_rebranded } from './deprecated/js/dashboard-inactive.js';
export const SVG_DATA_MASKING_ACTIVE = 'DATA_MASKING_ACTIVE';
import { default as DATA_MASKING_ACTIVE_rebranded } from './deprecated/js/data-masking-active.js';
export const SVG_DATA_MASKING_INACTIVE = 'DATA_MASKING_INACTIVE';
import { default as DATA_MASKING_INACTIVE_rebranded } from './deprecated/js/data-masking-inactive.js';
export const SVG_DATA = 'DATA';
import { default as DATA_rebranded } from './deprecated/js/data.js';
export const SVG_DECISION_ACTIVE = 'DECISION_ACTIVE';
import { default as DECISION_ACTIVE_rebranded } from './deprecated/js/decision-active.js';
export const SVG_DECISION_INACTIVE = 'DECISION_INACTIVE';
import { default as DECISION_INACTIVE_rebranded } from './deprecated/js/decision-inactive.js';
export const SVG_DESKTOP_ACTIVE = 'DESKTOP_ACTIVE';
import { default as DESKTOP_ACTIVE_rebranded } from './deprecated/js/desktop-active.js';
export const SVG_DELETE_CONVERSATION_ACTIVE = 'DELETE_CONVERSATION_ACTIVE';
import { default as DELETE_CONVERSATION_ACTIVE_rebranded } from './deprecated/js/delete-conversation-active.js';
export const SVG_DELETE_CONVERSATION_INACTIVE = 'DELETE_CONVERSATION_INACTIVE';
import { default as DELETE_CONVERSATION_INACTIVE_rebranded } from './deprecated/js/delete-conversation-inactive.js';
export const SVG_DEVICES_ACTIVE = 'DEVICES_ACTIVE';
import { default as DEVICES_ACTIVE_rebranded } from './deprecated/js/devices-active.js';
export const SVG_DESKTOP = 'DESKTOP';
import { default as DESKTOP_rebranded } from './deprecated/js/desktop.js';
export const SVG_DEVICES_INACTIVE = 'DEVICES_INACTIVE';
import { default as DEVICES_INACTIVE_rebranded } from './deprecated/js/devices-inactive.js';
export const SVG_DIAL_IN_ACTIVE = 'DIAL_IN_ACTIVE';
import { default as DIAL_IN_ACTIVE_rebranded } from './deprecated/js/dial-in-active.js';
export const SVG_DIAL_IN_INACTIVE = 'DIAL_IN_INACTIVE';
import { default as DIAL_IN_INACTIVE_rebranded } from './deprecated/js/dial-in-inactive.js';
export const SVG_DIAL_OUT_ACTIVE = 'DIAL_OUT_ACTIVE';
import { default as DIAL_OUT_ACTIVE_rebranded } from './deprecated/js/dial-out-active.js';
export const SVG_DIAL_OUT_INACTIVE = 'DIAL_OUT_INACTIVE';
import { default as DIAL_OUT_INACTIVE_rebranded } from './deprecated/js/dial-out-inactive.js';
export const SVG_DIAL_PAD = 'DIAL_PAD';
import { default as DIAL_PAD_rebranded } from './deprecated/js/dial-pad.js';
export const SVG_DISCOVER = 'DISCOVER';
import { default as DISCOVER_rebranded } from './deprecated/js/discover.js';
export const SVG_DISCOVER_ACTIVE = 'DISCOVER_ACTIVE';
import { default as DISCOVER_ACTIVE_rebranded } from './deprecated/js/discover-active.js';
export const SVG_DOCUMENT_ACTIVE = 'DOCUMENT_ACTIVE';
import { default as DOCUMENT_ACTIVE_rebranded } from './deprecated/js/document-active.js';
export const SVG_DOCUMENT_INACTIVE = 'DOCUMENT_INACTIVE';
import { default as DOCUMENT_INACTIVE_rebranded } from './deprecated/js/document-inactive.js';
export const SVG_DOLBY = 'DOLBY';
import { default as DOLBY_rebranded } from './deprecated/js/dolby.js';
export const SVG_DOLLAR_ACTIVE = 'DOLLAR_ACTIVE';
import { default as DOLLAR_ACTIVE_rebranded } from './deprecated/js/dollar-active.js';
export const SVG_DOLLAR = 'DOLLAR';
import { default as DOLLAR_rebranded } from './deprecated/js/dollar.js';
export const SVG_DOWNLOAD_DESKTOP_APP_FILLED = 'DOWNLOAD_DESKTOP_APP_FILLED';
import { default as DOWNLOAD_DESKTOP_APP_FILLED_rebranded } from './deprecated/js/download-desktop-app-filled.js';
export const SVG_DOWNLOAD_DESKTOP_APP = 'DOWNLOAD_DESKTOP_APP';
import { default as DOWNLOAD_DESKTOP_APP_rebranded } from './deprecated/js/download-desktop-app.js';
export const SVG_DOWNLOAD_MOBILE_APP_FILLED = 'DOWNLOAD_MOBILE_APP_FILLED';
import { default as DOWNLOAD_MOBILE_APP_FILLED_rebranded } from './deprecated/js/download-mobile-app-filled.js';
export const SVG_DOWNLOAD_MOBILE_APP = 'DOWNLOAD_MOBILE_APP';
import { default as DOWNLOAD_MOBILE_APP_rebranded } from './deprecated/js/download-mobile-app.js';
export const SVG_DRAG_DROP_ACTIVE = 'DRAG_DROP_ACTIVE';
import { default as DRAG_DROP_ACTIVE_rebranded } from './deprecated/js/drag-drop-active.js';
export const SVG_DRAG_CURSOR = 'DRAG_CURSOR';
import { default as DRAG_CURSOR_rebranded } from './deprecated/js/drag-cursor.js';
export const SVG_DRAG_DROP = 'DRAG_DROP';
import { default as DRAG_DROP_rebranded } from './deprecated/js/drag-drop.js';
export const SVG_DRAG_FREE = 'DRAG_FREE';
import { default as DRAG_FREE_rebranded } from './deprecated/js/drag-free.js';
export const SVG_DOWNLOAD = 'DOWNLOAD';
import { default as DOWNLOAD_rebranded } from './deprecated/js/download.js';
export const SVG_DRAG_LINEAR = 'DRAG_LINEAR';
import { default as DRAG_LINEAR_rebranded } from './deprecated/js/drag-linear.js';
export const SVG_DRAWER_LEFT_ACTIVE = 'DRAWER_LEFT_ACTIVE';
import { default as DRAWER_LEFT_ACTIVE_rebranded } from './deprecated/js/drawer-left-active.js';
export const SVG_DRAWER_LEFT_INACTIVE = 'DRAWER_LEFT_INACTIVE';
import { default as DRAWER_LEFT_INACTIVE_rebranded } from './deprecated/js/drawer-left-inactive.js';
export const SVG_DRAWER_RIGHT_INACTIVE = 'DRAWER_RIGHT_INACTIVE';
import { default as DRAWER_RIGHT_INACTIVE_rebranded } from './deprecated/js/drawer-right-inactive.js';
export const SVG_DRIVE_ACTIVE = 'DRIVE_ACTIVE';
import { default as DRIVE_ACTIVE_rebranded } from './deprecated/js/drive-active.js';
export const SVG_DRIVE_INACTIVE = 'DRIVE_INACTIVE';
import { default as DRIVE_INACTIVE_rebranded } from './deprecated/js/drive-inactive.js';
export const SVG_DRAWER_RIGHT_ACTIVE = 'DRAWER_RIGHT_ACTIVE';
import { default as DRAWER_RIGHT_ACTIVE_rebranded } from './deprecated/js/drawer-right-active.js';
export const SVG_DUAL_DISPLAY_ACTIVE = 'DUAL_DISPLAY_ACTIVE';
import { default as DUAL_DISPLAY_ACTIVE_rebranded } from './deprecated/js/dual-display-active.js';
export const SVG_ECHO = 'ECHO';
import { default as ECHO_rebranded } from './deprecated/js/echo.js';
export const SVG_EDGE = 'EDGE';
import { default as EDGE_rebranded } from './deprecated/js/edge.js';
export const SVG_DUAL_DISPLAY = 'DUAL_DISPLAY';
import { default as DUAL_DISPLAY_rebranded } from './deprecated/js/dual-display.js';
export const SVG_EDIT_INACTIVE = 'EDIT_INACTIVE';
import { default as EDIT_INACTIVE_rebranded } from './deprecated/js/edit-inactive.js';
export const SVG_EDIT = 'EDIT';
import { default as EDIT_rebranded } from './deprecated/js/edit.js';
export const SVG_EDUCATION_ACTIVE = 'EDUCATION_ACTIVE';
import { default as EDUCATION_ACTIVE_rebranded } from './deprecated/js/education-active.js';
export const SVG_EDUCATION_INACTIVE = 'EDUCATION_INACTIVE';
import { default as EDUCATION_INACTIVE_rebranded } from './deprecated/js/education-inactive.js';
export const SVG_EMAIL_ACTIVE = 'EMAIL_ACTIVE';
import { default as EMAIL_ACTIVE_rebranded } from './deprecated/js/email-active.js';
export const SVG_EMAIL_INACTIVE = 'EMAIL_INACTIVE';
import { default as EMAIL_INACTIVE_rebranded } from './deprecated/js/email-inactive.js';
export const SVG_EMOJI_ACTIVE = 'EMOJI_ACTIVE';
import { default as EMOJI_ACTIVE_rebranded } from './deprecated/js/emoji-active.js';
export const SVG_EMOJI_SAD_ACTIVE = 'EMOJI_SAD_ACTIVE';
import { default as EMOJI_SAD_ACTIVE_rebranded } from './deprecated/js/emoji-sad-active.js';
export const SVG_EMOJI_SAD = 'EMOJI_SAD';
import { default as EMOJI_SAD_rebranded } from './deprecated/js/emoji-sad.js';
export const SVG_EMOJI = 'EMOJI';
import { default as EMOJI_rebranded } from './deprecated/js/emoji.js';
export const SVG_ENCRYPTION_ACTIVE = 'ENCRYPTION_ACTIVE';
import { default as ENCRYPTION_ACTIVE_rebranded } from './deprecated/js/encryption-active.js';
export const SVG_ENLARGE_MEETING_ACTIVE = 'ENLARGE_MEETING_ACTIVE';
import { default as ENLARGE_MEETING_ACTIVE_rebranded } from './deprecated/js/enlarge-meeting-active.js';
export const SVG_ENCRYPTION_INACTIVE = 'ENCRYPTION_INACTIVE';
import { default as ENCRYPTION_INACTIVE_rebranded } from './deprecated/js/encryption-inactive.js';
export const SVG_ENLARGE_MEETING = 'ENLARGE_MEETING';
import { default as ENLARGE_MEETING_rebranded } from './deprecated/js/enlarge-meeting.js';
export const SVG_ENTER_ACTIVE = 'ENTER_ACTIVE';
import { default as ENTER_ACTIVE_rebranded } from './deprecated/js/enter-active.js';
export const SVG_ENTER_INACTIVE = 'ENTER_INACTIVE';
import { default as ENTER_INACTIVE_rebranded } from './deprecated/js/enter-inactive.js';
export const SVG_EURO_ACTIVE = 'EURO_ACTIVE';
import { default as EURO_ACTIVE_rebranded } from './deprecated/js/euro-active.js';
export const SVG_EURO = 'EURO';
import { default as EURO_rebranded } from './deprecated/js/euro.js';
export const SVG_EVENT_INACTIVE = 'EVENT_INACTIVE';
import { default as EVENT_INACTIVE_rebranded } from './deprecated/js/event-inactive.js';
export const SVG_EVENT_ACTIVE = 'EVENT_ACTIVE';
import { default as EVENT_ACTIVE_rebranded } from './deprecated/js/event-active.js';
export const SVG_EVENT_PHONE_ACTIVE = 'EVENT_PHONE_ACTIVE';
import { default as EVENT_PHONE_ACTIVE_rebranded } from './deprecated/js/event-phone-active.js';
export const SVG_EXECUTABLE_ACTIVE = 'EXECUTABLE_ACTIVE';
import { default as EXECUTABLE_ACTIVE_rebranded } from './deprecated/js/executable-active.js';
export const SVG_EVENT_PHONE_INACTIVE = 'EVENT_PHONE_INACTIVE';
import { default as EVENT_PHONE_INACTIVE_rebranded } from './deprecated/js/event-phone-inactive.js';
export const SVG_EXECUTABLE_INACTIVE = 'EXECUTABLE_INACTIVE';
import { default as EXECUTABLE_INACTIVE_rebranded } from './deprecated/js/executable-inactive.js';
export const SVG_EXTERNAL_LINK_ACTIVE = 'EXTERNAL_LINK_ACTIVE';
import { default as EXTERNAL_LINK_ACTIVE_rebranded } from './deprecated/js/external-link-active.js';
export const SVG_EXTERNAL_LINK = 'EXTERNAL_LINK';
import { default as EXTERNAL_LINK_rebranded } from './deprecated/js/external-link.js';
export const SVG_FADE_OUT = 'FADE_OUT';
import { default as FADE_OUT_rebranded } from './deprecated/js/fade-out.js';
export const SVG_FAST_FORWARD_ACTIVE = 'FAST_FORWARD_ACTIVE';
import { default as FAST_FORWARD_ACTIVE_rebranded } from './deprecated/js/fast-forward-active.js';
export const SVG_FAX_ACTIVE = 'FAX_ACTIVE';
import { default as FAX_ACTIVE_rebranded } from './deprecated/js/fax-active.js';
export const SVG_FAST_FORWARD_INACTIVE = 'FAST_FORWARD_INACTIVE';
import { default as FAST_FORWARD_INACTIVE_rebranded } from './deprecated/js/fast-forward-inactive.js';
export const SVG_FAX = 'FAX';
import { default as FAX_rebranded } from './deprecated/js/fax.js';
export const SVG_FILE_ACTIVE = 'FILE_ACTIVE';
import { default as FILE_ACTIVE_rebranded } from './deprecated/js/file-active.js';
export const SVG_FILE_BROWSER_ACTIVE = 'FILE_BROWSER_ACTIVE';
import { default as FILE_BROWSER_ACTIVE_rebranded } from './deprecated/js/file-browser-active.js';
export const SVG_FILE_BROWSER_INACTIVE = 'FILE_BROWSER_INACTIVE';
import { default as FILE_BROWSER_INACTIVE_rebranded } from './deprecated/js/file-browser-inactive.js';
export const SVG_FILE_CODE_ACTIVE = 'FILE_CODE_ACTIVE';
import { default as FILE_CODE_ACTIVE_rebranded } from './deprecated/js/file-code-active.js';
export const SVG_FILE_CODE_INACTIVE = 'FILE_CODE_INACTIVE';
import { default as FILE_CODE_INACTIVE_rebranded } from './deprecated/js/file-code-inactive.js';
export const SVG_FILE_INACTIVE = 'FILE_INACTIVE';
import { default as FILE_INACTIVE_rebranded } from './deprecated/js/file-inactive.js';
export const SVG_FILE_PDF_ACTIVE = 'FILE_PDF_ACTIVE';
import { default as FILE_PDF_ACTIVE_rebranded } from './deprecated/js/file-pdf-active.js';
export const SVG_FILE_PDF_INACTIVE = 'FILE_PDF_INACTIVE';
import { default as FILE_PDF_INACTIVE_rebranded } from './deprecated/js/file-pdf-inactive.js';
export const SVG_FILE_PRESENTATION_ACTIVE = 'FILE_PRESENTATION_ACTIVE';
import { default as FILE_PRESENTATION_ACTIVE_rebranded } from './deprecated/js/file-presentation-active.js';
export const SVG_FILE_PRESENTATION_INACTIVE = 'FILE_PRESENTATION_INACTIVE';
import { default as FILE_PRESENTATION_INACTIVE_rebranded } from './deprecated/js/file-presentation-inactive.js';
export const SVG_FILE_SOUND_ACTIVE = 'FILE_SOUND_ACTIVE';
import { default as FILE_SOUND_ACTIVE_rebranded } from './deprecated/js/file-sound-active.js';
export const SVG_FILE_SOUND_INACTIVE = 'FILE_SOUND_INACTIVE';
import { default as FILE_SOUND_INACTIVE_rebranded } from './deprecated/js/file-sound-inactive.js';
export const SVG_FILE_SPREADSHEET_INACTIVE = 'FILE_SPREADSHEET_INACTIVE';
import { default as FILE_SPREADSHEET_INACTIVE_rebranded } from './deprecated/js/file-spreadsheet-inactive.js';
export const SVG_FILE_SPREADSHEET_ACTIVE = 'FILE_SPREADSHEET_ACTIVE';
import { default as FILE_SPREADSHEET_ACTIVE_rebranded } from './deprecated/js/file-spreadsheet-active.js';
export const SVG_FILE_TRANSFER_ACTIVE = 'FILE_TRANSFER_ACTIVE';
import { default as FILE_TRANSFER_ACTIVE_rebranded } from './deprecated/js/file-transfer-active.js';
export const SVG_FILE_TRANSFER_INACTIVE = 'FILE_TRANSFER_INACTIVE';
import { default as FILE_TRANSFER_INACTIVE_rebranded } from './deprecated/js/file-transfer-inactive.js';
export const SVG_FILE_VIDEO_INACTIVE = 'FILE_VIDEO_INACTIVE';
import { default as FILE_VIDEO_INACTIVE_rebranded } from './deprecated/js/file-video-inactive.js';
export const SVG_FILE_VIDEO_ACTIVE = 'FILE_VIDEO_ACTIVE';
import { default as FILE_VIDEO_ACTIVE_rebranded } from './deprecated/js/file-video-active.js';
export const SVG_FILTER_ACTIVE = 'FILTER_ACTIVE';
import { default as FILTER_ACTIVE_rebranded } from './deprecated/js/filter-active.js';
export const SVG_FILTER_INACTIVE = 'FILTER_INACTIVE';
import { default as FILTER_INACTIVE_rebranded } from './deprecated/js/filter-inactive.js';
export const SVG_FINGERPRINT = 'FINGERPRINT';
import { default as FINGERPRINT_rebranded } from './deprecated/js/fingerprint.js';
export const SVG_FIT_HEIGHT_ACTIVE = 'FIT_HEIGHT_ACTIVE';
import { default as FIT_HEIGHT_ACTIVE_rebranded } from './deprecated/js/fit-height-active.js';
export const SVG_FIT_HEIGHT = 'FIT_HEIGHT';
import { default as FIT_HEIGHT_rebranded } from './deprecated/js/fit-height.js';
export const SVG_FIT_WIDTH_ACTIVE = 'FIT_WIDTH_ACTIVE';
import { default as FIT_WIDTH_ACTIVE_rebranded } from './deprecated/js/fit-width-active.js';
export const SVG_FIREFOX = 'FIREFOX';
import { default as FIREFOX_rebranded } from './deprecated/js/firefox.js';
export const SVG_FIT_WIDTH = 'FIT_WIDTH';
import { default as FIT_WIDTH_rebranded } from './deprecated/js/fit-width.js';
export const SVG_FITNESS = 'FITNESS';
import { default as FITNESS_rebranded } from './deprecated/js/fitness.js';
export const SVG_FLASLIGHT_OFF_ACTIVE = 'FLASLIGHT_OFF_ACTIVE';
import { default as FLASLIGHT_OFF_ACTIVE_rebranded } from './deprecated/js/flaslight-off-active.js';
export const SVG_FLASLIGHT_OFF_INACTIVE = 'FLASLIGHT_OFF_INACTIVE';
import { default as FLASLIGHT_OFF_INACTIVE_rebranded } from './deprecated/js/flaslight-off-inactive.js';
export const SVG_FLASLIGHT_ON_ACTIVE = 'FLASLIGHT_ON_ACTIVE';
import { default as FLASLIGHT_ON_ACTIVE_rebranded } from './deprecated/js/flaslight-on-active.js';
export const SVG_FLASLIGHT_ON_INACTIVE = 'FLASLIGHT_ON_INACTIVE';
import { default as FLASLIGHT_ON_INACTIVE_rebranded } from './deprecated/js/flaslight-on-inactive.js';
export const SVG_FLOWCHART_ACTIVE = 'FLOWCHART_ACTIVE';
import { default as FLOWCHART_ACTIVE_rebranded } from './deprecated/js/flowchart-active.js';
export const SVG_FLOWCHART = 'FLOWCHART';
import { default as FLOWCHART_rebranded } from './deprecated/js/flowchart.js';
export const SVG_FOLDER_ACTIVE = 'FOLDER_ACTIVE';
import { default as FOLDER_ACTIVE_rebranded } from './deprecated/js/folder-active.js';
export const SVG_FOLDER_ARCHIVE_ACTIVE = 'FOLDER_ARCHIVE_ACTIVE';
import { default as FOLDER_ARCHIVE_ACTIVE_rebranded } from './deprecated/js/folder-archive-active.js';
export const SVG_FOLDER_ARCHIVE_INACTIVE = 'FOLDER_ARCHIVE_INACTIVE';
import { default as FOLDER_ARCHIVE_INACTIVE_rebranded } from './deprecated/js/folder-archive-inactive.js';
export const SVG_FOLDER_CREATE_ACTIVE = 'FOLDER_CREATE_ACTIVE';
import { default as FOLDER_CREATE_ACTIVE_rebranded } from './deprecated/js/folder-create-active.js';
export const SVG_FOLDER_CREATE_INACTIVE = 'FOLDER_CREATE_INACTIVE';
import { default as FOLDER_CREATE_INACTIVE_rebranded } from './deprecated/js/folder-create-inactive.js';
export const SVG_FOLDER_INACTIVE = 'FOLDER_INACTIVE';
import { default as FOLDER_INACTIVE_rebranded } from './deprecated/js/folder-inactive.js';
export const SVG_FOLDER_UP = 'FOLDER_UP';
import { default as FOLDER_UP_rebranded } from './deprecated/js/folder-up.js';
export const SVG_FONT = 'FONT';
import { default as FONT_rebranded } from './deprecated/js/font.js';
export const SVG_GEO_PIN_ACTIVE = 'GEO_PIN_ACTIVE';
import { default as GEO_PIN_ACTIVE_rebranded } from './deprecated/js/geo-pin-active.js';
export const SVG_GEO_PIN_INACTIVE = 'GEO_PIN_INACTIVE';
import { default as GEO_PIN_INACTIVE_rebranded } from './deprecated/js/geo-pin-inactive.js';
export const SVG_GIFT_ACTIVE = 'GIFT_ACTIVE';
import { default as GIFT_ACTIVE_rebranded } from './deprecated/js/gift-active.js';
export const SVG_GIFT = 'GIFT';
import { default as GIFT_rebranded } from './deprecated/js/gift.js';
export const SVG_GLOBAL_SESSION_LIST_ACTIVE = 'GLOBAL_SESSION_LIST_ACTIVE';
import { default as GLOBAL_SESSION_LIST_ACTIVE_rebranded } from './deprecated/js/global-session-list-active.js';
export const SVG_GLOBAL_SESSION_LIST_INACTIVE = 'GLOBAL_SESSION_LIST_INACTIVE';
import { default as GLOBAL_SESSION_LIST_INACTIVE_rebranded } from './deprecated/js/global-session-list-inactive.js';
export const SVG_GLOBE_ACTIVE = 'GLOBE_ACTIVE';
import { default as GLOBE_ACTIVE_rebranded } from './deprecated/js/globe-active.js';
export const SVG_GLOBE = 'GLOBE';
import { default as GLOBE_rebranded } from './deprecated/js/globe.js';
export const SVG_GOOGLE_MONOCHROMATIC = 'GOOGLE_MONOCHROMATIC';
import { default as GOOGLE_MONOCHROMATIC_rebranded } from './deprecated/js/google-monochromatic.js';
export const SVG_GOOGLE_CHROME = 'GOOGLE_CHROME';
import { default as GOOGLE_CHROME_rebranded } from './deprecated/js/google-chrome.js';
export const SVG_GOTO = 'GOTO';
import { default as GOTO_rebranded } from './deprecated/js/goto.js';
export const SVG_GOTO_ASSIST = 'GOTO_ASSIST';
import { default as GOTO_ASSIST_rebranded } from './deprecated/js/goto-assist.js';
export const SVG_GRIP_20_PX = 'GRIP_20_PX';
import { default as GRIP_20_PX_rebranded } from './deprecated/js/grip-20-px.js';
export const SVG_GTC_CONTACT_CENTER_PICTO = 'GTC_CONTACT_CENTER_PICTO';
import { default as GTC_CONTACT_CENTER_PICTO_rebranded } from './deprecated/js/gtc-contact-center-picto.js';
export const SVG_GTC_MEETING_PICTO = 'GTC_MEETING_PICTO';
import { default as GTC_MEETING_PICTO_rebranded } from './deprecated/js/gtc-meeting-picto.js';
export const SVG_GTC_MESSAGING_PICTO = 'GTC_MESSAGING_PICTO';
import { default as GTC_MESSAGING_PICTO_rebranded } from './deprecated/js/gtc-messaging-picto.js';
export const SVG_GTC_PHONE_MTG_BUNDLE_PICTO = 'GTC_PHONE_MTG_BUNDLE_PICTO';
import { default as GTC_PHONE_MTG_BUNDLE_PICTO_rebranded } from './deprecated/js/gtc-phone-mtg-bundle-picto.js';
export const SVG_GTC_ROOM_PICTO = 'GTC_ROOM_PICTO';
import { default as GTC_ROOM_PICTO_rebranded } from './deprecated/js/gtc-room-picto.js';
export const SVG_GTC_VIRTUAL_EVENTS_PICTO = 'GTC_VIRTUAL_EVENTS_PICTO';
import { default as GTC_VIRTUAL_EVENTS_PICTO_rebranded } from './deprecated/js/gtc-virtual-events-picto.js';
export const SVG_GTC_TRAINING_PICTO = 'GTC_TRAINING_PICTO';
import { default as GTC_TRAINING_PICTO_rebranded } from './deprecated/js/gtc-training-picto.js';
export const SVG_GTC_VOICE_PICTO = 'GTC_VOICE_PICTO';
import { default as GTC_VOICE_PICTO_rebranded } from './deprecated/js/gtc-voice-picto.js';
export const SVG_GTC_WEBINAR_PICTO = 'GTC_WEBINAR_PICTO';
import { default as GTC_WEBINAR_PICTO_rebranded } from './deprecated/js/gtc-webinar-picto.js';
export const SVG_GTR_CONVERSATIONAL_TICKETING_PICTO = 'GTR_CONVERSATIONAL_TICKETING_PICTO';
import { default as GTR_CONVERSATIONAL_TICKETING_PICTO_rebranded } from './deprecated/js/gtr-conversational-ticketing-picto.js';
export const SVG_GTR_DEVICE_MONITORING_PICTO = 'GTR_DEVICE_MONITORING_PICTO';
import { default as GTR_DEVICE_MONITORING_PICTO_rebranded } from './deprecated/js/gtr-device-monitoring-picto.js';
export const SVG_GTR_ENDPOINT_MANAGEMENT_PICTO = 'GTR_ENDPOINT_MANAGEMENT_PICTO';
import { default as GTR_ENDPOINT_MANAGEMENT_PICTO_rebranded } from './deprecated/js/gtr-endpoint-management-picto.js';
export const SVG_GTR_ENDPOINT_SECURITY_PICTO = 'GTR_ENDPOINT_SECURITY_PICTO';
import { default as GTR_ENDPOINT_SECURITY_PICTO_rebranded } from './deprecated/js/gtr-endpoint-security-picto.js';
export const SVG_GTR_FINGERPRINT_PICTO = 'GTR_FINGERPRINT_PICTO';
import { default as GTR_FINGERPRINT_PICTO_rebranded } from './deprecated/js/gtr-fingerprint-picto.js';
export const SVG_GTR_HELP_DESK_PICTO = 'GTR_HELP_DESK_PICTO';
import { default as GTR_HELP_DESK_PICTO_rebranded } from './deprecated/js/gtr-help-desk-picto.js';
export const SVG_GTR_MOBILE_DEVICE_SUPPORT_PICTO = 'GTR_MOBILE_DEVICE_SUPPORT_PICTO';
import { default as GTR_MOBILE_DEVICE_SUPPORT_PICTO_rebranded } from './deprecated/js/gtr-mobile-device-support-picto.js';
export const SVG_GTR_IT_AUTOMATION_PICTO = 'GTR_IT_AUTOMATION_PICTO';
import { default as GTR_IT_AUTOMATION_PICTO_rebranded } from './deprecated/js/gtr-it-automation-picto.js';
export const SVG_GTR_REMOTE_ACCESS_PICTO = 'GTR_REMOTE_ACCESS_PICTO';
import { default as GTR_REMOTE_ACCESS_PICTO_rebranded } from './deprecated/js/gtr-remote-access-picto.js';
export const SVG_GTR_REMOTE_SUPPORT_PICTO = 'GTR_REMOTE_SUPPORT_PICTO';
import { default as GTR_REMOTE_SUPPORT_PICTO_rebranded } from './deprecated/js/gtr-remote-support-picto.js';
export const SVG_GTR_VISUAL_ENGAGEMENT_PICTO = 'GTR_VISUAL_ENGAGEMENT_PICTO';
import { default as GTR_VISUAL_ENGAGEMENT_PICTO_rebranded } from './deprecated/js/gtr-visual-engagement-picto.js';
export const SVG_HAND_LOWER = 'HAND_LOWER';
import { default as HAND_LOWER_rebranded } from './deprecated/js/hand-lower.js';
export const SVG_HAMBURGER_MENU = 'HAMBURGER_MENU';
import { default as HAMBURGER_MENU_rebranded } from './deprecated/js/hamburger-menu.js';
export const SVG_HAND_RAISE = 'HAND_RAISE';
import { default as HAND_RAISE_rebranded } from './deprecated/js/hand-raise.js';
export const SVG_HARDPHONE_INACTIVE = 'HARDPHONE_INACTIVE';
import { default as HARDPHONE_INACTIVE_rebranded } from './deprecated/js/hardphone-inactive.js';
export const SVG_HARDPHONE = 'HARDPHONE';
import { default as HARDPHONE_rebranded } from './deprecated/js/hardphone.js';
export const SVG_HDMI_ACTIVE = 'HDMI_ACTIVE';
import { default as HDMI_ACTIVE_rebranded } from './deprecated/js/hdmi-active.js';
export const SVG_HDMI = 'HDMI';
import { default as HDMI_rebranded } from './deprecated/js/hdmi.js';
export const SVG_HEADPHONES = 'HEADPHONES';
import { default as HEADPHONES_rebranded } from './deprecated/js/headphones.js';
export const SVG_HEALTHCARE_ACTIVE = 'HEALTHCARE_ACTIVE';
import { default as HEALTHCARE_ACTIVE_rebranded } from './deprecated/js/healthcare-active.js';
export const SVG_HEALTHCARE_INACTIVE = 'HEALTHCARE_INACTIVE';
import { default as HEALTHCARE_INACTIVE_rebranded } from './deprecated/js/healthcare-inactive.js';
export const SVG_HEART_ACTIVE = 'HEART_ACTIVE';
import { default as HEART_ACTIVE_rebranded } from './deprecated/js/heart-active.js';
export const SVG_HEART_INACTIVE = 'HEART_INACTIVE';
import { default as HEART_INACTIVE_rebranded } from './deprecated/js/heart-inactive.js';
export const SVG_HELP_CIRCLE_ACTIVE = 'HELP_CIRCLE_ACTIVE';
import { default as HELP_CIRCLE_ACTIVE_rebranded } from './deprecated/js/help-circle-active.js';
export const SVG_HELP_CIRCLE_INACTIVE = 'HELP_CIRCLE_INACTIVE';
import { default as HELP_CIRCLE_INACTIVE_rebranded } from './deprecated/js/help-circle-inactive.js';
export const SVG_HELP_SQUARE_ACTIVE = 'HELP_SQUARE_ACTIVE';
import { default as HELP_SQUARE_ACTIVE_rebranded } from './deprecated/js/help-square-active.js';
export const SVG_HELP_SQUARE_INACTIVE = 'HELP_SQUARE_INACTIVE';
import { default as HELP_SQUARE_INACTIVE_rebranded } from './deprecated/js/help-square-inactive.js';
export const SVG_HELPDESK_ACTIVE = 'HELPDESK_ACTIVE';
import { default as HELPDESK_ACTIVE_rebranded } from './deprecated/js/helpdesk-active.js';
export const SVG_HELPDESK = 'HELPDESK';
import { default as HELPDESK_rebranded } from './deprecated/js/helpdesk.js';
export const SVG_HIGHLIGHTER_ACTIVE = 'HIGHLIGHTER_ACTIVE';
import { default as HIGHLIGHTER_ACTIVE_rebranded } from './deprecated/js/highlighter-active.js';
export const SVG_HIGHLIGHTER = 'HIGHLIGHTER';
import { default as HIGHLIGHTER_rebranded } from './deprecated/js/highlighter.js';
export const SVG_HISTORY = 'HISTORY';
import { default as HISTORY_rebranded } from './deprecated/js/history.js';
export const SVG_HOME_ACTIVE = 'HOME_ACTIVE';
import { default as HOME_ACTIVE_rebranded } from './deprecated/js/home-active.js';
export const SVG_HOME_INACTIVE = 'HOME_INACTIVE';
import { default as HOME_INACTIVE_rebranded } from './deprecated/js/home-inactive.js';
export const SVG_HOUSE_ACTIVE = 'HOUSE_ACTIVE';
import { default as HOUSE_ACTIVE_rebranded } from './deprecated/js/house-active.js';
export const SVG_HOUSE_INACTIVE = 'HOUSE_INACTIVE';
import { default as HOUSE_INACTIVE_rebranded } from './deprecated/js/house-inactive.js';
export const SVG_ID_CARD_ACTIVE = 'ID_CARD_ACTIVE';
import { default as ID_CARD_ACTIVE_rebranded } from './deprecated/js/id-card-active.js';
export const SVG_ID_CARD = 'ID_CARD';
import { default as ID_CARD_rebranded } from './deprecated/js/id-card.js';
export const SVG_INBOX_ACTIVE = 'INBOX_ACTIVE';
import { default as INBOX_ACTIVE_rebranded } from './deprecated/js/inbox-active.js';
export const SVG_INBOX_INACTIVE = 'INBOX_INACTIVE';
import { default as INBOX_INACTIVE_rebranded } from './deprecated/js/inbox-inactive.js';
export const SVG_INFINITY = 'INFINITY';
import { default as INFINITY_rebranded } from './deprecated/js/infinity.js';
export const SVG_INFO_ACTIVE = 'INFO_ACTIVE';
import { default as INFO_ACTIVE_rebranded } from './deprecated/js/info-active.js';
export const SVG_INTEGRATIONS_ACTIVE = 'INTEGRATIONS_ACTIVE';
import { default as INTEGRATIONS_ACTIVE_rebranded } from './deprecated/js/integrations-active.js';
export const SVG_INFO_INACTIVE = 'INFO_INACTIVE';
import { default as INFO_INACTIVE_rebranded } from './deprecated/js/info-inactive.js';
export const SVG_INTEGRATIONS = 'INTEGRATIONS';
import { default as INTEGRATIONS_rebranded } from './deprecated/js/integrations.js';
export const SVG_INTERNET_EXPLORER = 'INTERNET_EXPLORER';
import { default as INTERNET_EXPLORER_rebranded } from './deprecated/js/internet-explorer.js';
export const SVG_ITALICS_INACTIVE = 'ITALICS_INACTIVE';
import { default as ITALICS_INACTIVE_rebranded } from './deprecated/js/italics-inactive.js';
export const SVG_ITALICS_ACTIVE = 'ITALICS_ACTIVE';
import { default as ITALICS_ACTIVE_rebranded } from './deprecated/js/italics-active.js';
export const SVG_KEY_ACTIVE = 'KEY_ACTIVE';
import { default as KEY_ACTIVE_rebranded } from './deprecated/js/key-active.js';
export const SVG_KEY_INACTIVE = 'KEY_INACTIVE';
import { default as KEY_INACTIVE_rebranded } from './deprecated/js/key-inactive.js';
export const SVG_KEYBOARD_ACTIVE = 'KEYBOARD_ACTIVE';
import { default as KEYBOARD_ACTIVE_rebranded } from './deprecated/js/keyboard-active.js';
export const SVG_KEYBOARD_INACTIVE = 'KEYBOARD_INACTIVE';
import { default as KEYBOARD_INACTIVE_rebranded } from './deprecated/js/keyboard-inactive.js';
export const SVG_LAB_ACTIVE = 'LAB_ACTIVE';
import { default as LAB_ACTIVE_rebranded } from './deprecated/js/lab-active.js';
export const SVG_LAB_INACTIVE = 'LAB_INACTIVE';
import { default as LAB_INACTIVE_rebranded } from './deprecated/js/lab-inactive.js';
export const SVG_LAUNCH_ACTIVE = 'LAUNCH_ACTIVE';
import { default as LAUNCH_ACTIVE_rebranded } from './deprecated/js/launch-active.js';
export const SVG_LAUNCH_INACTIVE = 'LAUNCH_INACTIVE';
import { default as LAUNCH_INACTIVE_rebranded } from './deprecated/js/launch-inactive.js';
export const SVG_LEAVE_ACTIVE = 'LEAVE_ACTIVE';
import { default as LEAVE_ACTIVE_rebranded } from './deprecated/js/leave-active.js';
export const SVG_LEAVE = 'LEAVE';
import { default as LEAVE_rebranded } from './deprecated/js/leave.js';
export const SVG_LEGAL_INACTIVE = 'LEGAL_INACTIVE';
import { default as LEGAL_INACTIVE_rebranded } from './deprecated/js/legal-inactive.js';
export const SVG_LEGAL_ACTIVE = 'LEGAL_ACTIVE';
import { default as LEGAL_ACTIVE_rebranded } from './deprecated/js/legal-active.js';
export const SVG_LINK_HORIZONTAL_ACTIVE = 'LINK_HORIZONTAL_ACTIVE';
import { default as LINK_HORIZONTAL_ACTIVE_rebranded } from './deprecated/js/link-horizontal-active.js';
export const SVG_LINK_ACTIVE = 'LINK_ACTIVE';
import { default as LINK_ACTIVE_rebranded } from './deprecated/js/link-active.js';
export const SVG_LINK_HORIZONTAL = 'LINK_HORIZONTAL';
import { default as LINK_HORIZONTAL_rebranded } from './deprecated/js/link-horizontal.js';
export const SVG_LINK_INACTIVE = 'LINK_INACTIVE';
import { default as LINK_INACTIVE_rebranded } from './deprecated/js/link-inactive.js';
export const SVG_LINUX = 'LINUX';
import { default as LINUX_rebranded } from './deprecated/js/linux.js';
export const SVG_LIST_ACTIVE = 'LIST_ACTIVE';
import { default as LIST_ACTIVE_rebranded } from './deprecated/js/list-active.js';
export const SVG_LIST_INACTIVE = 'LIST_INACTIVE';
import { default as LIST_INACTIVE_rebranded } from './deprecated/js/list-inactive.js';
export const SVG_LISTEN = 'LISTEN';
import { default as LISTEN_rebranded } from './deprecated/js/listen.js';
export const SVG_LOADER = 'LOADER';
import { default as LOADER_rebranded } from './deprecated/js/loader.js';
export const SVG_LOCKED_ACTIVE_20_PX = 'LOCKED_ACTIVE_20_PX';
import { default as LOCKED_ACTIVE_20_PX_rebranded } from './deprecated/js/locked-active-20-px.js';
export const SVG_LOCKED_ACTIVE = 'LOCKED_ACTIVE';
import { default as LOCKED_ACTIVE_rebranded } from './deprecated/js/locked-active.js';
export const SVG_LOCKED_INACTIVE_20_PX = 'LOCKED_INACTIVE_20_PX';
import { default as LOCKED_INACTIVE_20_PX_rebranded } from './deprecated/js/locked-inactive-20-px.js';
export const SVG_LOCKED_INACTIVE = 'LOCKED_INACTIVE';
import { default as LOCKED_INACTIVE_rebranded } from './deprecated/js/locked-inactive.js';
export const SVG_LOG_ACTIVE = 'LOG_ACTIVE';
import { default as LOG_ACTIVE_rebranded } from './deprecated/js/log-active.js';
export const SVG_LOG_INACTIVE = 'LOG_INACTIVE';
import { default as LOG_INACTIVE_rebranded } from './deprecated/js/log-inactive.js';
export const SVG_LOGMEIN = 'LOGMEIN';
import { default as LOGMEIN_rebranded } from './deprecated/js/logmein.js';
export const SVG_LOUD_SPEAKER_ACTIVE = 'LOUD_SPEAKER_ACTIVE';
import { default as LOUD_SPEAKER_ACTIVE_rebranded } from './deprecated/js/loud-speaker-active.js';
export const SVG_LOUD_SPEAKER = 'LOUD_SPEAKER';
import { default as LOUD_SPEAKER_rebranded } from './deprecated/js/loud-speaker.js';
export const SVG_MAGIC_WAND_ACTIVE = 'MAGIC_WAND_ACTIVE';
import { default as MAGIC_WAND_ACTIVE_rebranded } from './deprecated/js/magic-wand-active.js';
export const SVG_MAGIC_WAND_INACTIVE = 'MAGIC_WAND_INACTIVE';
import { default as MAGIC_WAND_INACTIVE_rebranded } from './deprecated/js/magic-wand-inactive.js';
export const SVG_MAIN_SWITCH_ACTIVE = 'MAIN_SWITCH_ACTIVE';
import { default as MAIN_SWITCH_ACTIVE_rebranded } from './deprecated/js/main-switch-active.js';
export const SVG_MANAGE_LICENSES_ACTIVE = 'MANAGE_LICENSES_ACTIVE';
import { default as MANAGE_LICENSES_ACTIVE_rebranded } from './deprecated/js/manage-licenses-active.js';
export const SVG_MAIN_SWITCH_INACTIVE = 'MAIN_SWITCH_INACTIVE';
import { default as MAIN_SWITCH_INACTIVE_rebranded } from './deprecated/js/main-switch-inactive.js';
export const SVG_MANAGE_LICENSES_INACTIVE = 'MANAGE_LICENSES_INACTIVE';
import { default as MANAGE_LICENSES_INACTIVE_rebranded } from './deprecated/js/manage-licenses-inactive.js';
export const SVG_MANUFACTURING_ACTIVE = 'MANUFACTURING_ACTIVE';
import { default as MANUFACTURING_ACTIVE_rebranded } from './deprecated/js/manufacturing-active.js';
export const SVG_MANUFACTURING_INACTIVE = 'MANUFACTURING_INACTIVE';
import { default as MANUFACTURING_INACTIVE_rebranded } from './deprecated/js/manufacturing-inactive.js';
export const SVG_MASTER_ACTIVE = 'MASTER_ACTIVE';
import { default as MASTER_ACTIVE_rebranded } from './deprecated/js/master-active.js';
export const SVG_MASTER = 'MASTER';
import { default as MASTER_rebranded } from './deprecated/js/master.js';
export const SVG_MATERIALS_ACTIVE = 'MATERIALS_ACTIVE';
import { default as MATERIALS_ACTIVE_rebranded } from './deprecated/js/materials-active.js';
export const SVG_MATERIALS_INACTIVE = 'MATERIALS_INACTIVE';
import { default as MATERIALS_INACTIVE_rebranded } from './deprecated/js/materials-inactive.js';
export const SVG_MEET_NOW_ACTIVE = 'MEET_NOW_ACTIVE';
import { default as MEET_NOW_ACTIVE_rebranded } from './deprecated/js/meet-now-active.js';
export const SVG_MEET_NOW = 'MEET_NOW';
import { default as MEET_NOW_rebranded } from './deprecated/js/meet-now.js';
export const SVG_MEETING_JOIN_ACTIVE = 'MEETING_JOIN_ACTIVE';
import { default as MEETING_JOIN_ACTIVE_rebranded } from './deprecated/js/meeting-join-active.js';
export const SVG_MEETING_JOIN_INACTIVE = 'MEETING_JOIN_INACTIVE';
import { default as MEETING_JOIN_INACTIVE_rebranded } from './deprecated/js/meeting-join-inactive.js';
export const SVG_MEETING_SYNC_ACTIVE = 'MEETING_SYNC_ACTIVE';
import { default as MEETING_SYNC_ACTIVE_rebranded } from './deprecated/js/meeting-sync-active.js';
export const SVG_MEETING_SYNC = 'MEETING_SYNC';
import { default as MEETING_SYNC_rebranded } from './deprecated/js/meeting-sync.js';
export const SVG_MEETINGS_ACTIVE = 'MEETINGS_ACTIVE';
import { default as MEETINGS_ACTIVE_rebranded } from './deprecated/js/meetings-active.js';
export const SVG_MEETINGS_INACTIVE = 'MEETINGS_INACTIVE';
import { default as MEETINGS_INACTIVE_rebranded } from './deprecated/js/meetings-inactive.js';
export const SVG_MESSENGER = 'MESSENGER';
import { default as MESSENGER_rebranded } from './deprecated/js/messenger.js';
export const SVG_MERGE = 'MERGE';
import { default as MERGE_rebranded } from './deprecated/js/merge.js';
export const SVG_MIC_ON_20_PX = 'MIC_ON_20_PX';
import { default as MIC_ON_20_PX_rebranded } from './deprecated/js/mic-on-20-px.js';
export const SVG_MIC_OFF_20_PX = 'MIC_OFF_20_PX';
import { default as MIC_OFF_20_PX_rebranded } from './deprecated/js/mic-off-20-px.js';
export const SVG_MICROPHONE_ACTIVE = 'MICROPHONE_ACTIVE';
import { default as MICROPHONE_ACTIVE_rebranded } from './deprecated/js/microphone-active.js';
export const SVG_MICROPHONE_INACTIVE_HARDMUTED = 'MICROPHONE_INACTIVE_HARDMUTED';
import { default as MICROPHONE_INACTIVE_HARDMUTED_rebranded } from './deprecated/js/microphone-inactive-hardmuted.js';
export const SVG_MICROPHONE_INACTIVE = 'MICROPHONE_INACTIVE';
import { default as MICROPHONE_INACTIVE_rebranded } from './deprecated/js/microphone-inactive.js';
export const SVG_MICROPHONE_OFF_ACTIVE = 'MICROPHONE_OFF_ACTIVE';
import { default as MICROPHONE_OFF_ACTIVE_rebranded } from './deprecated/js/microphone-off-active.js';
export const SVG_MICROPHONE_ON_HARDMUTED = 'MICROPHONE_ON_HARDMUTED';
import { default as MICROPHONE_ON_HARDMUTED_rebranded } from './deprecated/js/microphone-on-hardmuted.js';
export const SVG_MICROPHONE_ON_INACTIVE = 'MICROPHONE_ON_INACTIVE';
import { default as MICROPHONE_ON_INACTIVE_rebranded } from './deprecated/js/microphone-on-inactive.js';
export const SVG_MINIFY_MEETING = 'MINIFY_MEETING';
import { default as MINIFY_MEETING_rebranded } from './deprecated/js/minify-meeting.js';
export const SVG_MINIFY_MEETING_ACTIVE = 'MINIFY_MEETING_ACTIVE';
import { default as MINIFY_MEETING_ACTIVE_rebranded } from './deprecated/js/minify-meeting-active.js';
export const SVG_MOBILE_SUPPORT_ACTIVE = 'MOBILE_SUPPORT_ACTIVE';
import { default as MOBILE_SUPPORT_ACTIVE_rebranded } from './deprecated/js/mobile-support-active.js';
export const SVG_MOBILE_SUPPORT = 'MOBILE_SUPPORT';
import { default as MOBILE_SUPPORT_rebranded } from './deprecated/js/mobile-support.js';
export const SVG_MORE_HORIZONTAL = 'MORE_HORIZONTAL';
import { default as MORE_HORIZONTAL_rebranded } from './deprecated/js/more-horizontal.js';
export const SVG_MORE_VERTICAL_MOBILE_ONLY = 'MORE_VERTICAL_MOBILE_ONLY';
import { default as MORE_VERTICAL_MOBILE_ONLY_rebranded } from './deprecated/js/more-vertical-mobile-only.js';
export const SVG_MOUSE_ACTIVE = 'MOUSE_ACTIVE';
import { default as MOUSE_ACTIVE_rebranded } from './deprecated/js/mouse-active.js';
export const SVG_MOUSE_INACTIVE = 'MOUSE_INACTIVE';
import { default as MOUSE_INACTIVE_rebranded } from './deprecated/js/mouse-inactive.js';
export const SVG_MUSIC_INACTIVE = 'MUSIC_INACTIVE';
import { default as MUSIC_INACTIVE_rebranded } from './deprecated/js/music-inactive.js';
export const SVG_MUSIC = 'MUSIC';
import { default as MUSIC_rebranded } from './deprecated/js/music.js';
export const SVG_NETWORK_ACTIVE = 'NETWORK_ACTIVE';
import { default as NETWORK_ACTIVE_rebranded } from './deprecated/js/network-active.js';
export const SVG_NETWORK_INACTIVE = 'NETWORK_INACTIVE';
import { default as NETWORK_INACTIVE_rebranded } from './deprecated/js/network-inactive.js';
export const SVG_NOTE_ACTIVE = 'NOTE_ACTIVE';
import { default as NOTE_ACTIVE_rebranded } from './deprecated/js/note-active.js';
export const SVG_NOTE_INACTIVE = 'NOTE_INACTIVE';
import { default as NOTE_INACTIVE_rebranded } from './deprecated/js/note-inactive.js';
export const SVG_NOTE = 'NOTE';
import { default as NOTE_rebranded } from './deprecated/js/note.js';
export const SVG_NOTEPAD_ACTIVE = 'NOTEPAD_ACTIVE';
import { default as NOTEPAD_ACTIVE_rebranded } from './deprecated/js/notepad-active.js';
export const SVG_NOTIFICATIONS_ALERT_INACTIVE = 'NOTIFICATIONS_ALERT_INACTIVE';
import { default as NOTIFICATIONS_ALERT_INACTIVE_rebranded } from './deprecated/js/notifications-alert-inactive.js';
export const SVG_NOTIFICATIONS_ALERT_ACTIVE = 'NOTIFICATIONS_ALERT_ACTIVE';
import { default as NOTIFICATIONS_ALERT_ACTIVE_rebranded } from './deprecated/js/notifications-alert-active.js';
export const SVG_NOTIFICATIONS = 'NOTIFICATIONS';
import { default as NOTIFICATIONS_rebranded } from './deprecated/js/notifications.js';
export const SVG_NOTEPAD_INACTIVE = 'NOTEPAD_INACTIVE';
import { default as NOTEPAD_INACTIVE_rebranded } from './deprecated/js/notepad-inactive.js';
export const SVG_NOTIFICATIONS_INACTIVE = 'NOTIFICATIONS_INACTIVE';
import { default as NOTIFICATIONS_INACTIVE_rebranded } from './deprecated/js/notifications-inactive.js';
export const SVG_NPA_ACTIVE = 'NPA_ACTIVE';
import { default as NPA_ACTIVE_rebranded } from './deprecated/js/npa-active.js';
export const SVG_NPA_INACTIVE = 'NPA_INACTIVE';
import { default as NPA_INACTIVE_rebranded } from './deprecated/js/npa-inactive.js';
export const SVG_NUMBERED_ARROW_INACTIVE = 'NUMBERED_ARROW_INACTIVE';
import { default as NUMBERED_ARROW_INACTIVE_rebranded } from './deprecated/js/numbered-arrow-inactive.js';
export const SVG_NUMBERED_ARROW_ACTIVE = 'NUMBERED_ARROW_ACTIVE';
import { default as NUMBERED_ARROW_ACTIVE_rebranded } from './deprecated/js/numbered-arrow-active.js';
export const SVG_OPEN_VOICE = 'OPEN_VOICE';
import { default as OPEN_VOICE_rebranded } from './deprecated/js/open-voice.js';
export const SVG_OPERA = 'OPERA';
import { default as OPERA_rebranded } from './deprecated/js/opera.js';
export const SVG_ORDERED_LIST_ACTIVE = 'ORDERED_LIST_ACTIVE';
import { default as ORDERED_LIST_ACTIVE_rebranded } from './deprecated/js/ordered-list-active.js';
export const SVG_ORDERED_LIST_INACTIVE = 'ORDERED_LIST_INACTIVE';
import { default as ORDERED_LIST_INACTIVE_rebranded } from './deprecated/js/ordered-list-inactive.js';
export const SVG_PAINT_INACTIVE = 'PAINT_INACTIVE';
import { default as PAINT_INACTIVE_rebranded } from './deprecated/js/paint-inactive.js';
export const SVG_PAINT_ACTIVE = 'PAINT_ACTIVE';
import { default as PAINT_ACTIVE_rebranded } from './deprecated/js/paint-active.js';
export const SVG_PALETTE_ACTIVE = 'PALETTE_ACTIVE';
import { default as PALETTE_ACTIVE_rebranded } from './deprecated/js/palette-active.js';
export const SVG_PALETTE_INACTIVE = 'PALETTE_INACTIVE';
import { default as PALETTE_INACTIVE_rebranded } from './deprecated/js/palette-inactive.js';
export const SVG_PAUSE_20_PX_INACTIVE = 'PAUSE_20_PX_INACTIVE';
import { default as PAUSE_20_PX_INACTIVE_rebranded } from './deprecated/js/pause-20-px-inactive.js';
export const SVG_PAUSE_20_PX = 'PAUSE_20_PX';
import { default as PAUSE_20_PX_rebranded } from './deprecated/js/pause-20-px.js';
export const SVG_PAUSE_ACTIVE = 'PAUSE_ACTIVE';
import { default as PAUSE_ACTIVE_rebranded } from './deprecated/js/pause-active.js';
export const SVG_PAUSE_CIRCLE_ACTIVE = 'PAUSE_CIRCLE_ACTIVE';
import { default as PAUSE_CIRCLE_ACTIVE_rebranded } from './deprecated/js/pause-circle-active.js';
export const SVG_PAUSE_CIRCLE_INACTIVE = 'PAUSE_CIRCLE_INACTIVE';
import { default as PAUSE_CIRCLE_INACTIVE_rebranded } from './deprecated/js/pause-circle-inactive.js';
export const SVG_PAUSE_INACTIVE = 'PAUSE_INACTIVE';
import { default as PAUSE_INACTIVE_rebranded } from './deprecated/js/pause-inactive.js';
export const SVG_PAYMENT_DUE_INACTIVE = 'PAYMENT_DUE_INACTIVE';
import { default as PAYMENT_DUE_INACTIVE_rebranded } from './deprecated/js/payment-due-inactive.js';
export const SVG_PAYMENT_DUE_ACTIVE = 'PAYMENT_DUE_ACTIVE';
import { default as PAYMENT_DUE_ACTIVE_rebranded } from './deprecated/js/payment-due-active.js';
export const SVG_PBX_INACTIVE = 'PBX_INACTIVE';
import { default as PBX_INACTIVE_rebranded } from './deprecated/js/pbx-inactive.js';
export const SVG_PBX = 'PBX';
import { default as PBX_rebranded } from './deprecated/js/pbx.js';
export const SVG_PEOPLE_INACTIVE = 'PEOPLE_INACTIVE';
import { default as PEOPLE_INACTIVE_rebranded } from './deprecated/js/people-inactive.js';
export const SVG_PEOPLE_ACTIVE = 'PEOPLE_ACTIVE';
import { default as PEOPLE_ACTIVE_rebranded } from './deprecated/js/people-active.js';
export const SVG_PERSON_ACTIVE = 'PERSON_ACTIVE';
import { default as PERSON_ACTIVE_rebranded } from './deprecated/js/person-active.js';
export const SVG_PERSON_CHECKMARK_ACTIVE = 'PERSON_CHECKMARK_ACTIVE';
import { default as PERSON_CHECKMARK_ACTIVE_rebranded } from './deprecated/js/person-checkmark-active.js';
export const SVG_PERSON_CHECKMARK_INACTIVE = 'PERSON_CHECKMARK_INACTIVE';
import { default as PERSON_CHECKMARK_INACTIVE_rebranded } from './deprecated/js/person-checkmark-inactive.js';
export const SVG_PERSON_INACTIVE = 'PERSON_INACTIVE';
import { default as PERSON_INACTIVE_rebranded } from './deprecated/js/person-inactive.js';
export const SVG_PERSON_TRANSFER_FROM_ACTIVE = 'PERSON_TRANSFER_FROM_ACTIVE';
import { default as PERSON_TRANSFER_FROM_ACTIVE_rebranded } from './deprecated/js/person-transfer-from-active.js';
export const SVG_PERSON_TRANSFER_FROM_INACTIVE = 'PERSON_TRANSFER_FROM_INACTIVE';
import { default as PERSON_TRANSFER_FROM_INACTIVE_rebranded } from './deprecated/js/person-transfer-from-inactive.js';
export const SVG_PERSON_TRANSFER_TO_ACTIVE = 'PERSON_TRANSFER_TO_ACTIVE';
import { default as PERSON_TRANSFER_TO_ACTIVE_rebranded } from './deprecated/js/person-transfer-to-active.js';
export const SVG_PHONE_DOWN_ACTIVE = 'PHONE_DOWN_ACTIVE';
import { default as PHONE_DOWN_ACTIVE_rebranded } from './deprecated/js/phone-down-active.js';
export const SVG_PERSON_TRANSFER_TO_INACTIVE = 'PERSON_TRANSFER_TO_INACTIVE';
import { default as PERSON_TRANSFER_TO_INACTIVE_rebranded } from './deprecated/js/person-transfer-to-inactive.js';
export const SVG_PHONE_DOWN_INACTIVE = 'PHONE_DOWN_INACTIVE';
import { default as PHONE_DOWN_INACTIVE_rebranded } from './deprecated/js/phone-down-inactive.js';
export const SVG_PHONE_NUMBER_ACTIVE = 'PHONE_NUMBER_ACTIVE';
import { default as PHONE_NUMBER_ACTIVE_rebranded } from './deprecated/js/phone-number-active.js';
export const SVG_PHONE_UP_DISABLED_ACTIVE = 'PHONE_UP_DISABLED_ACTIVE';
import { default as PHONE_UP_DISABLED_ACTIVE_rebranded } from './deprecated/js/phone-up-disabled-active.js';
export const SVG_PHONE_UP_ACTIVE = 'PHONE_UP_ACTIVE';
import { default as PHONE_UP_ACTIVE_rebranded } from './deprecated/js/phone-up-active.js';
export const SVG_PHONE_NUMBER_INACTIVE = 'PHONE_NUMBER_INACTIVE';
import { default as PHONE_NUMBER_INACTIVE_rebranded } from './deprecated/js/phone-number-inactive.js';
export const SVG_PHONE_UP_DISABLED_INACTIVE = 'PHONE_UP_DISABLED_INACTIVE';
import { default as PHONE_UP_DISABLED_INACTIVE_rebranded } from './deprecated/js/phone-up-disabled-inactive.js';
export const SVG_PHONE_UP_INACTIVE = 'PHONE_UP_INACTIVE';
import { default as PHONE_UP_INACTIVE_rebranded } from './deprecated/js/phone-up-inactive.js';
export const SVG_PICTURE_ACTIVE = 'PICTURE_ACTIVE';
import { default as PICTURE_ACTIVE_rebranded } from './deprecated/js/picture-active.js';
export const SVG_PICTURE_DISABLED_ACTIVE = 'PICTURE_DISABLED_ACTIVE';
import { default as PICTURE_DISABLED_ACTIVE_rebranded } from './deprecated/js/picture-disabled-active.js';
export const SVG_PICTURE_DISABLED_INACTIVE = 'PICTURE_DISABLED_INACTIVE';
import { default as PICTURE_DISABLED_INACTIVE_rebranded } from './deprecated/js/picture-disabled-inactive.js';
export const SVG_PICTURE_INACTIVE = 'PICTURE_INACTIVE';
import { default as PICTURE_INACTIVE_rebranded } from './deprecated/js/picture-inactive.js';
export const SVG_PIE_CHART_ACTIVE = 'PIE_CHART_ACTIVE';
import { default as PIE_CHART_ACTIVE_rebranded } from './deprecated/js/pie-chart-active.js';
export const SVG_PIE_CHART_INACTIVE = 'PIE_CHART_INACTIVE';
import { default as PIE_CHART_INACTIVE_rebranded } from './deprecated/js/pie-chart-inactive.js';
export const SVG_PIP_MAXIMIZE_INACTIVE = 'PIP_MAXIMIZE_INACTIVE';
import { default as PIP_MAXIMIZE_INACTIVE_rebranded } from './deprecated/js/pip-maximize-inactive.js';
export const SVG_PIP_MINIMIZE_ACTIVE = 'PIP_MINIMIZE_ACTIVE';
import { default as PIP_MINIMIZE_ACTIVE_rebranded } from './deprecated/js/pip-minimize-active.js';
export const SVG_PIP_MAXIMIZE = 'PIP_MAXIMIZE';
import { default as PIP_MAXIMIZE_rebranded } from './deprecated/js/pip-maximize.js';
export const SVG_PIP_MINIMIZE = 'PIP_MINIMIZE';
import { default as PIP_MINIMIZE_rebranded } from './deprecated/js/pip-minimize.js';
export const SVG_PLAY_ACTIVE = 'PLAY_ACTIVE';
import { default as PLAY_ACTIVE_rebranded } from './deprecated/js/play-active.js';
export const SVG_PLAY_INACTIVE = 'PLAY_INACTIVE';
import { default as PLAY_INACTIVE_rebranded } from './deprecated/js/play-inactive.js';
export const SVG_PLAY_PLAIN_ACTIVE = 'PLAY_PLAIN_ACTIVE';
import { default as PLAY_PLAIN_ACTIVE_rebranded } from './deprecated/js/play-plain-active.js';
export const SVG_PLAY_PLAIN_INACTIVE = 'PLAY_PLAIN_INACTIVE';
import { default as PLAY_PLAIN_INACTIVE_rebranded } from './deprecated/js/play-plain-inactive.js';
export const SVG_POINTER_OFF_ACTIVE = 'POINTER_OFF_ACTIVE';
import { default as POINTER_OFF_ACTIVE_rebranded } from './deprecated/js/pointer-off-active.js';
export const SVG_POINTER_OFF_INACTIVE = 'POINTER_OFF_INACTIVE';
import { default as POINTER_OFF_INACTIVE_rebranded } from './deprecated/js/pointer-off-inactive.js';
export const SVG_POINTER_ON_ACTIVE = 'POINTER_ON_ACTIVE';
import { default as POINTER_ON_ACTIVE_rebranded } from './deprecated/js/pointer-on-active.js';
export const SVG_POINTER_WINDOWS_OFF_ACTIVE = 'POINTER_WINDOWS_OFF_ACTIVE';
import { default as POINTER_WINDOWS_OFF_ACTIVE_rebranded } from './deprecated/js/pointer-windows-off-active.js';
export const SVG_POINTER_ON_INACTIVE = 'POINTER_ON_INACTIVE';
import { default as POINTER_ON_INACTIVE_rebranded } from './deprecated/js/pointer-on-inactive.js';
export const SVG_POINTER_WINDOWS_OFF_INACTIVE = 'POINTER_WINDOWS_OFF_INACTIVE';
import { default as POINTER_WINDOWS_OFF_INACTIVE_rebranded } from './deprecated/js/pointer-windows-off-inactive.js';
export const SVG_POINTER_WINDOWS_ON_ACTIVE = 'POINTER_WINDOWS_ON_ACTIVE';
import { default as POINTER_WINDOWS_ON_ACTIVE_rebranded } from './deprecated/js/pointer-windows-on-active.js';
export const SVG_POINTER_WINDOWS_ON_INACTIVE = 'POINTER_WINDOWS_ON_INACTIVE';
import { default as POINTER_WINDOWS_ON_INACTIVE_rebranded } from './deprecated/js/pointer-windows-on-inactive.js';
export const SVG_POINTER = 'POINTER';
import { default as POINTER_rebranded } from './deprecated/js/pointer.js';
export const SVG_POLLS_ACTIVE = 'POLLS_ACTIVE';
import { default as POLLS_ACTIVE_rebranded } from './deprecated/js/polls-active.js';
export const SVG_POLLS = 'POLLS';
import { default as POLLS_rebranded } from './deprecated/js/polls.js';
export const SVG_POP_IT_BACK_ACTIVE = 'POP_IT_BACK_ACTIVE';
import { default as POP_IT_BACK_ACTIVE_rebranded } from './deprecated/js/pop-it-back-active.js';
export const SVG_POP_IT_BACK = 'POP_IT_BACK';
import { default as POP_IT_BACK_rebranded } from './deprecated/js/pop-it-back.js';
export const SVG_POP_IT_OUT_ACTIVE = 'POP_IT_OUT_ACTIVE';
import { default as POP_IT_OUT_ACTIVE_rebranded } from './deprecated/js/pop-it-out-active.js';
export const SVG_POP_IT_OUT = 'POP_IT_OUT';
import { default as POP_IT_OUT_rebranded } from './deprecated/js/pop-it-out.js';
export const SVG_POP_OUT_CAMERA_ACTIVE = 'POP_OUT_CAMERA_ACTIVE';
import { default as POP_OUT_CAMERA_ACTIVE_rebranded } from './deprecated/js/pop-out-camera-active.js';
export const SVG_POP_OUT_CAMERA = 'POP_OUT_CAMERA';
import { default as POP_OUT_CAMERA_rebranded } from './deprecated/js/pop-out-camera.js';
export const SVG_POP_OUT_WINDOW_ACTIVE = 'POP_OUT_WINDOW_ACTIVE';
import { default as POP_OUT_WINDOW_ACTIVE_rebranded } from './deprecated/js/pop-out-window-active.js';
export const SVG_POP_OUT_WINDOW = 'POP_OUT_WINDOW';
import { default as POP_OUT_WINDOW_rebranded } from './deprecated/js/pop-out-window.js';
export const SVG_POSITION_TV_BOTTOM_ACTIVE = 'POSITION_TV_BOTTOM_ACTIVE';
import { default as POSITION_TV_BOTTOM_ACTIVE_rebranded } from './deprecated/js/position-tv-bottom-active.js';
export const SVG_POSITION_TV_BOTTOM = 'POSITION_TV_BOTTOM';
import { default as POSITION_TV_BOTTOM_rebranded } from './deprecated/js/position-tv-bottom.js';
export const SVG_POSITION_TV_LEFT_ACTIVE = 'POSITION_TV_LEFT_ACTIVE';
import { default as POSITION_TV_LEFT_ACTIVE_rebranded } from './deprecated/js/position-tv-left-active.js';
export const SVG_POSITION_TV_LEFT = 'POSITION_TV_LEFT';
import { default as POSITION_TV_LEFT_rebranded } from './deprecated/js/position-tv-left.js';
export const SVG_POSITION_TV_RIGHT_ACTIVE = 'POSITION_TV_RIGHT_ACTIVE';
import { default as POSITION_TV_RIGHT_ACTIVE_rebranded } from './deprecated/js/position-tv-right-active.js';
export const SVG_POSITION_TV_RIGHT = 'POSITION_TV_RIGHT';
import { default as POSITION_TV_RIGHT_rebranded } from './deprecated/js/position-tv-right.js';
export const SVG_POSITION_TV_TOP_ACTIVE = 'POSITION_TV_TOP_ACTIVE';
import { default as POSITION_TV_TOP_ACTIVE_rebranded } from './deprecated/js/position-tv-top-active.js';
export const SVG_POUND_SIGN = 'POUND_SIGN';
import { default as POUND_SIGN_rebranded } from './deprecated/js/pound-sign.js';
export const SVG_POUND_ACTIVE = 'POUND_ACTIVE';
import { default as POUND_ACTIVE_rebranded } from './deprecated/js/pound-active.js';
export const SVG_POSITION_TV_TOP = 'POSITION_TV_TOP';
import { default as POSITION_TV_TOP_rebranded } from './deprecated/js/position-tv-top.js';
export const SVG_POUND = 'POUND';
import { default as POUND_rebranded } from './deprecated/js/pound.js';
export const SVG_PRESENCE_AVAILABLE = 'PRESENCE_AVAILABLE';
import { default as PRESENCE_AVAILABLE_rebranded } from './deprecated/js/presence-available.js';
export const SVG_PRESENCE_BUSY_ACTIVE = 'PRESENCE_BUSY_ACTIVE';
import { default as PRESENCE_BUSY_ACTIVE_rebranded } from './deprecated/js/presence-busy-active.js';
export const SVG_PRESENCE_BUSY_INACTIVE = 'PRESENCE_BUSY_INACTIVE';
import { default as PRESENCE_BUSY_INACTIVE_rebranded } from './deprecated/js/presence-busy-inactive.js';
export const SVG_PRESENCE_DND = 'PRESENCE_DND';
import { default as PRESENCE_DND_rebranded } from './deprecated/js/presence-dnd.js';
export const SVG_PRESENCE_OFFLINE = 'PRESENCE_OFFLINE';
import { default as PRESENCE_OFFLINE_rebranded } from './deprecated/js/presence-offline.js';
export const SVG_PRESENTATION_ACTIVE = 'PRESENTATION_ACTIVE';
import { default as PRESENTATION_ACTIVE_rebranded } from './deprecated/js/presentation-active.js';
export const SVG_PRESENTATION_INACTIVE = 'PRESENTATION_INACTIVE';
import { default as PRESENTATION_INACTIVE_rebranded } from './deprecated/js/presentation-inactive.js';
export const SVG_PRIVATE_ACTIVE = 'PRIVATE_ACTIVE';
import { default as PRIVATE_ACTIVE_rebranded } from './deprecated/js/private-active.js';
export const SVG_PRIVATE_INACTIVE = 'PRIVATE_INACTIVE';
import { default as PRIVATE_INACTIVE_rebranded } from './deprecated/js/private-inactive.js';
export const SVG_PUSHPIN_ACTIVE = 'PUSHPIN_ACTIVE';
import { default as PUSHPIN_ACTIVE_rebranded } from './deprecated/js/pushpin-active.js';
export const SVG_PUSHPIN_INACTIVE = 'PUSHPIN_INACTIVE';
import { default as PUSHPIN_INACTIVE_rebranded } from './deprecated/js/pushpin-inactive.js';
export const SVG_QUESTION = 'QUESTION';
import { default as QUESTION_rebranded } from './deprecated/js/question.js';
export const SVG_RADIO_BUTTON_ANDROID_SELECTED = 'RADIO_BUTTON_ANDROID_SELECTED';
import { default as RADIO_BUTTON_ANDROID_SELECTED_rebranded } from './deprecated/js/radio-button-android-selected.js';
export const SVG_RADIO_BUTTON_ANDROID_UNSELECTED = 'RADIO_BUTTON_ANDROID_UNSELECTED';
import { default as RADIO_BUTTON_ANDROID_UNSELECTED_rebranded } from './deprecated/js/radio-button-android-unselected.js';
export const SVG_RADIO_BUTTON_SELECTED = 'RADIO_BUTTON_SELECTED';
import { default as RADIO_BUTTON_SELECTED_rebranded } from './deprecated/js/radio-button-selected.js';
export const SVG_RADIO_BUTTON_UNSELECTED = 'RADIO_BUTTON_UNSELECTED';
import { default as RADIO_BUTTON_UNSELECTED_rebranded } from './deprecated/js/radio-button-unselected.js';
export const SVG_READER_ACTIVE = 'READER_ACTIVE';
import { default as READER_ACTIVE_rebranded } from './deprecated/js/reader-active.js';
export const SVG_READER_INACTIVE = 'READER_INACTIVE';
import { default as READER_INACTIVE_rebranded } from './deprecated/js/reader-inactive.js';
export const SVG_RECORD_ACTIVE = 'RECORD_ACTIVE';
import { default as RECORD_ACTIVE_rebranded } from './deprecated/js/record-active.js';
export const SVG_RECORD_INACTIVE = 'RECORD_INACTIVE';
import { default as RECORD_INACTIVE_rebranded } from './deprecated/js/record-inactive.js';
export const SVG_RECORDING_INACTIVE = 'RECORDING_INACTIVE';
import { default as RECORDING_INACTIVE_rebranded } from './deprecated/js/recording-inactive.js';
export const SVG_RECORDING_TAPE_INACTIVE = 'RECORDING_TAPE_INACTIVE';
import { default as RECORDING_TAPE_INACTIVE_rebranded } from './deprecated/js/recording-tape-inactive.js';
export const SVG_RECORDING_TAPE = 'RECORDING_TAPE';
import { default as RECORDING_TAPE_rebranded } from './deprecated/js/recording-tape.js';
export const SVG_RECURRING_ACTIVE = 'RECURRING_ACTIVE';
import { default as RECURRING_ACTIVE_rebranded } from './deprecated/js/recurring-active.js';
export const SVG_RECURRING = 'RECURRING';
import { default as RECURRING_rebranded } from './deprecated/js/recurring.js';
export const SVG_RECORDING = 'RECORDING';
import { default as RECORDING_rebranded } from './deprecated/js/recording.js';
export const SVG_REDO = 'REDO';
import { default as REDO_rebranded } from './deprecated/js/redo.js';
export const SVG_REMOTE_SUPPORT_ACTIVE = 'REMOTE_SUPPORT_ACTIVE';
import { default as REMOTE_SUPPORT_ACTIVE_rebranded } from './deprecated/js/remote-support-active.js';
export const SVG_REFRESH = 'REFRESH';
import { default as REFRESH_rebranded } from './deprecated/js/refresh.js';
export const SVG_REMOTE_SUPPORT = 'REMOTE_SUPPORT';
import { default as REMOTE_SUPPORT_rebranded } from './deprecated/js/remote-support.js';
export const SVG_REPLY_ACTIVE = 'REPLY_ACTIVE';
import { default as REPLY_ACTIVE_rebranded } from './deprecated/js/reply-active.js';
export const SVG_REPLY = 'REPLY';
import { default as REPLY_rebranded } from './deprecated/js/reply.js';
export const SVG_REPORT = 'REPORT';
import { default as REPORT_rebranded } from './deprecated/js/report.js';
export const SVG_RESIZE_HANDLE = 'RESIZE_HANDLE';
import { default as RESIZE_HANDLE_rebranded } from './deprecated/js/resize-handle.js';
export const SVG_RESTORE_ACTIVE = 'RESTORE_ACTIVE';
import { default as RESTORE_ACTIVE_rebranded } from './deprecated/js/restore-active.js';
export const SVG_RESTORE = 'RESTORE';
import { default as RESTORE_rebranded } from './deprecated/js/restore.js';
export const SVG_REWIND_ACTIVE = 'REWIND_ACTIVE';
import { default as REWIND_ACTIVE_rebranded } from './deprecated/js/rewind-active.js';
export const SVG_REWIND_INACTIVE = 'REWIND_INACTIVE';
import { default as REWIND_INACTIVE_rebranded } from './deprecated/js/rewind-inactive.js';
export const SVG_ROOM_PHYSICAL = 'ROOM_PHYSICAL';
import { default as ROOM_PHYSICAL_rebranded } from './deprecated/js/room-physical.js';
export const SVG_ROOM_PHYSICAL_INACTIVE = 'ROOM_PHYSICAL_INACTIVE';
import { default as ROOM_PHYSICAL_INACTIVE_rebranded } from './deprecated/js/room-physical-inactive.js';
export const SVG_ROOM_VIEW = 'ROOM_VIEW';
import { default as ROOM_VIEW_rebranded } from './deprecated/js/room-view.js';
export const SVG_ROTATE_CCW_ACTIVE = 'ROTATE_CCW_ACTIVE';
import { default as ROTATE_CCW_ACTIVE_rebranded } from './deprecated/js/rotate-ccw-active.js';
export const SVG_ROTATE_CCW_INACTIVE = 'ROTATE_CCW_INACTIVE';
import { default as ROTATE_CCW_INACTIVE_rebranded } from './deprecated/js/rotate-ccw-inactive.js';
export const SVG_ROTATE_CW_ACTIVE = 'ROTATE_CW_ACTIVE';
import { default as ROTATE_CW_ACTIVE_rebranded } from './deprecated/js/rotate-cw-active.js';
export const SVG_ROTATE_CW_INACTIVE = 'ROTATE_CW_INACTIVE';
import { default as ROTATE_CW_INACTIVE_rebranded } from './deprecated/js/rotate-cw-inactive.js';
export const SVG_ROUTER_ACTIVE = 'ROUTER_ACTIVE';
import { default as ROUTER_ACTIVE_rebranded } from './deprecated/js/router-active.js';
export const SVG_SAFARI = 'SAFARI';
import { default as SAFARI_rebranded } from './deprecated/js/safari.js';
export const SVG_SALES_QUOTE_INACTIVE = 'SALES_QUOTE_INACTIVE';
import { default as SALES_QUOTE_INACTIVE_rebranded } from './deprecated/js/sales-quote-inactive.js';
export const SVG_ROUTER_INACTIVE = 'ROUTER_INACTIVE';
import { default as ROUTER_INACTIVE_rebranded } from './deprecated/js/router-inactive.js';
export const SVG_SALES_QUOTE_ACTIVE = 'SALES_QUOTE_ACTIVE';
import { default as SALES_QUOTE_ACTIVE_rebranded } from './deprecated/js/sales-quote-active.js';
export const SVG_SAVE_INACTIVE = 'SAVE_INACTIVE';
import { default as SAVE_INACTIVE_rebranded } from './deprecated/js/save-inactive.js';
export const SVG_SAVE_ACTIVE = 'SAVE_ACTIVE';
import { default as SAVE_ACTIVE_rebranded } from './deprecated/js/save-active.js';
export const SVG_SCREEN_ACTIVE = 'SCREEN_ACTIVE';
import { default as SCREEN_ACTIVE_rebranded } from './deprecated/js/screen-active.js';
export const SVG_SCREEN_ADD_DEVICE_ACTIVE = 'SCREEN_ADD_DEVICE_ACTIVE';
import { default as SCREEN_ADD_DEVICE_ACTIVE_rebranded } from './deprecated/js/screen-add-device-active.js';
export const SVG_SCREEN_INACTIVE = 'SCREEN_INACTIVE';
import { default as SCREEN_INACTIVE_rebranded } from './deprecated/js/screen-inactive.js';
export const SVG_SCREEN_MIRRORING_LAPTOP_ACTIVE = 'SCREEN_MIRRORING_LAPTOP_ACTIVE';
import { default as SCREEN_MIRRORING_LAPTOP_ACTIVE_rebranded } from './deprecated/js/screen-mirroring-laptop-active.js';
export const SVG_SCREEN_ADD_DEVICE_INACTIVE = 'SCREEN_ADD_DEVICE_INACTIVE';
import { default as SCREEN_ADD_DEVICE_INACTIVE_rebranded } from './deprecated/js/screen-add-device-inactive.js';
export const SVG_SCREEN_MIRRORING_LAPTOP = 'SCREEN_MIRRORING_LAPTOP';
import { default as SCREEN_MIRRORING_LAPTOP_rebranded } from './deprecated/js/screen-mirroring-laptop.js';
export const SVG_SCREEN_PAUSE_ACTIVE = 'SCREEN_PAUSE_ACTIVE';
import { default as SCREEN_PAUSE_ACTIVE_rebranded } from './deprecated/js/screen-pause-active.js';
export const SVG_SCREEN_PAUSE_INACTIVE = 'SCREEN_PAUSE_INACTIVE';
import { default as SCREEN_PAUSE_INACTIVE_rebranded } from './deprecated/js/screen-pause-inactive.js';
export const SVG_SCREEN_QUALITY_ACTIVE = 'SCREEN_QUALITY_ACTIVE';
import { default as SCREEN_QUALITY_ACTIVE_rebranded } from './deprecated/js/screen-quality-active.js';
export const SVG_SCREEN_QUALITY_INACTIVE = 'SCREEN_QUALITY_INACTIVE';
import { default as SCREEN_QUALITY_INACTIVE_rebranded } from './deprecated/js/screen-quality-inactive.js';
export const SVG_SCREEN_REBOOT_ACTIVE = 'SCREEN_REBOOT_ACTIVE';
import { default as SCREEN_REBOOT_ACTIVE_rebranded } from './deprecated/js/screen-reboot-active.js';
export const SVG_SCREEN_REBOOT_INACTIVE = 'SCREEN_REBOOT_INACTIVE';
import { default as SCREEN_REBOOT_INACTIVE_rebranded } from './deprecated/js/screen-reboot-inactive.js';
export const SVG_SCREEN_RUN_INACTIVE = 'SCREEN_RUN_INACTIVE';
import { default as SCREEN_RUN_INACTIVE_rebranded } from './deprecated/js/screen-run-inactive.js';
export const SVG_SCREEN_RUN_ACTIVE = 'SCREEN_RUN_ACTIVE';
import { default as SCREEN_RUN_ACTIVE_rebranded } from './deprecated/js/screen-run-active.js';
export const SVG_SCREEN_SHARING = 'SCREEN_SHARING';
import { default as SCREEN_SHARING_rebranded } from './deprecated/js/screen-sharing.js';
export const SVG_SCREEN_SHARING_ACTIVE = 'SCREEN_SHARING_ACTIVE';
import { default as SCREEN_SHARING_ACTIVE_rebranded } from './deprecated/js/screen-sharing-active.js';
export const SVG_SCREEN_SNAPSHOT_ACTIVE = 'SCREEN_SNAPSHOT_ACTIVE';
import { default as SCREEN_SNAPSHOT_ACTIVE_rebranded } from './deprecated/js/screen-snapshot-active.js';
export const SVG_SCREEN_SNAPSHOT_INACTIVE = 'SCREEN_SNAPSHOT_INACTIVE';
import { default as SCREEN_SNAPSHOT_INACTIVE_rebranded } from './deprecated/js/screen-snapshot-inactive.js';
export const SVG_SCREEN_STOP_REMOTE_ACTIVE = 'SCREEN_STOP_REMOTE_ACTIVE';
import { default as SCREEN_STOP_REMOTE_ACTIVE_rebranded } from './deprecated/js/screen-stop-remote-active.js';
export const SVG_SCREEN_STOP_REMOTE_INACTIVE = 'SCREEN_STOP_REMOTE_INACTIVE';
import { default as SCREEN_STOP_REMOTE_INACTIVE_rebranded } from './deprecated/js/screen-stop-remote-inactive.js';
export const SVG_SCREEN_SYSTEM_INFO_ACTIVE = 'SCREEN_SYSTEM_INFO_ACTIVE';
import { default as SCREEN_SYSTEM_INFO_ACTIVE_rebranded } from './deprecated/js/screen-system-info-active.js';
export const SVG_SCREEN_SYSTEM_INFO_INACTIVE = 'SCREEN_SYSTEM_INFO_INACTIVE';
import { default as SCREEN_SYSTEM_INFO_INACTIVE_rebranded } from './deprecated/js/screen-system-info-inactive.js';
export const SVG_SCREEN_UNATTENDED_INACTIVE = 'SCREEN_UNATTENDED_INACTIVE';
import { default as SCREEN_UNATTENDED_INACTIVE_rebranded } from './deprecated/js/screen-unattended-inactive.js';
export const SVG_SCREEN_UNATTENDED_ACTIVE = 'SCREEN_UNATTENDED_ACTIVE';
import { default as SCREEN_UNATTENDED_ACTIVE_rebranded } from './deprecated/js/screen-unattended-active.js';
export const SVG_SEARCH_ACTIVE = 'SEARCH_ACTIVE';
import { default as SEARCH_ACTIVE_rebranded } from './deprecated/js/search-active.js';
export const SVG_SEARCH = 'SEARCH';
import { default as SEARCH_rebranded } from './deprecated/js/search.js';
export const SVG_SEE_IT = 'SEE_IT';
import { default as SEE_IT_rebranded } from './deprecated/js/see-it.js';
export const SVG_SEND_LARGE_ACTIVE = 'SEND_LARGE_ACTIVE';
import { default as SEND_LARGE_ACTIVE_rebranded } from './deprecated/js/send-large-active.js';
export const SVG_SEND_LARGE_INACTIVE = 'SEND_LARGE_INACTIVE';
import { default as SEND_LARGE_INACTIVE_rebranded } from './deprecated/js/send-large-inactive.js';
export const SVG_SERVER_ACTIVE = 'SERVER_ACTIVE';
import { default as SERVER_ACTIVE_rebranded } from './deprecated/js/server-active.js';
export const SVG_SERVER_INACTIVE = 'SERVER_INACTIVE';
import { default as SERVER_INACTIVE_rebranded } from './deprecated/js/server-inactive.js';
export const SVG_SETTINGS_ACTIVE = 'SETTINGS_ACTIVE';
import { default as SETTINGS_ACTIVE_rebranded } from './deprecated/js/settings-active.js';
export const SVG_SETTINGS_INACTIVE = 'SETTINGS_INACTIVE';
import { default as SETTINGS_INACTIVE_rebranded } from './deprecated/js/settings-inactive.js';
export const SVG_SHARE_20_PX_INACTIVE = 'SHARE_20_PX_INACTIVE';
import { default as SHARE_20_PX_INACTIVE_rebranded } from './deprecated/js/share-20-px-inactive.js';
export const SVG_SHARE_20_PX = 'SHARE_20_PX';
import { default as SHARE_20_PX_rebranded } from './deprecated/js/share-20-px.js';
export const SVG_SHARE_ACTIVE = 'SHARE_ACTIVE';
import { default as SHARE_ACTIVE_rebranded } from './deprecated/js/share-active.js';
export const SVG_SHARE_ARROW = 'SHARE_ARROW';
import { default as SHARE_ARROW_rebranded } from './deprecated/js/share-arrow.js';
export const SVG_SHARE = 'SHARE';
import { default as SHARE_rebranded } from './deprecated/js/share.js';
export const SVG_SHIELD_ACTIVE = 'SHIELD_ACTIVE';
import { default as SHIELD_ACTIVE_rebranded } from './deprecated/js/shield-active.js';
export const SVG_SHIELD_INACTIVE = 'SHIELD_INACTIVE';
import { default as SHIELD_INACTIVE_rebranded } from './deprecated/js/shield-inactive.js';
export const SVG_SHUFFLE = 'SHUFFLE';
import { default as SHUFFLE_rebranded } from './deprecated/js/shuffle.js';
export const SVG_SIGNAL_0 = 'SIGNAL_0';
import { default as SIGNAL_0_rebranded } from './deprecated/js/signal-0.js';
export const SVG_SIGNAL_2 = 'SIGNAL_2';
import { default as SIGNAL_2_rebranded } from './deprecated/js/signal-2.js';
export const SVG_SIGNAL_1 = 'SIGNAL_1';
import { default as SIGNAL_1_rebranded } from './deprecated/js/signal-1.js';
export const SVG_SIGNAL_3 = 'SIGNAL_3';
import { default as SIGNAL_3_rebranded } from './deprecated/js/signal-3.js';
export const SVG_SIGNAL_STRENGTH_1 = 'SIGNAL_STRENGTH_1';
import { default as SIGNAL_STRENGTH_1_rebranded } from './deprecated/js/signal-strength-1.js';
export const SVG_SIGNAL_STRENGTH_2 = 'SIGNAL_STRENGTH_2';
import { default as SIGNAL_STRENGTH_2_rebranded } from './deprecated/js/signal-strength-2.js';
export const SVG_SIGNAL_STRENGTH_0 = 'SIGNAL_STRENGTH_0';
import { default as SIGNAL_STRENGTH_0_rebranded } from './deprecated/js/signal-strength-0.js';
export const SVG_SIGNAL_STRENGTH_3 = 'SIGNAL_STRENGTH_3';
import { default as SIGNAL_STRENGTH_3_rebranded } from './deprecated/js/signal-strength-3.js';
export const SVG_SIGNAL_STRENGTH_4 = 'SIGNAL_STRENGTH_4';
import { default as SIGNAL_STRENGTH_4_rebranded } from './deprecated/js/signal-strength-4.js';
export const SVG_SIGNOUT_ACTIVE = 'SIGNOUT_ACTIVE';
import { default as SIGNOUT_ACTIVE_rebranded } from './deprecated/js/signout-active.js';
export const SVG_SIGNOUT = 'SIGNOUT';
import { default as SIGNOUT_rebranded } from './deprecated/js/signout.js';
export const SVG_SKETCH = 'SKETCH';
import { default as SKETCH_rebranded } from './deprecated/js/sketch.js';
export const SVG_SKIP_NEXT_ACTIVE = 'SKIP_NEXT_ACTIVE';
import { default as SKIP_NEXT_ACTIVE_rebranded } from './deprecated/js/skip-next-active.js';
export const SVG_SKIP_NEXT_INACTIVE = 'SKIP_NEXT_INACTIVE';
import { default as SKIP_NEXT_INACTIVE_rebranded } from './deprecated/js/skip-next-inactive.js';
export const SVG_SKIP_PREVIOUS_INACTIVE = 'SKIP_PREVIOUS_INACTIVE';
import { default as SKIP_PREVIOUS_INACTIVE_rebranded } from './deprecated/js/skip-previous-inactive.js';
export const SVG_SKIP_PREVIOUS_ACTIVE = 'SKIP_PREVIOUS_ACTIVE';
import { default as SKIP_PREVIOUS_ACTIVE_rebranded } from './deprecated/js/skip-previous-active.js';
export const SVG_SLIDERS_ACTIVE = 'SLIDERS_ACTIVE';
import { default as SLIDERS_ACTIVE_rebranded } from './deprecated/js/sliders-active.js';
export const SVG_SLIDERS_INACTIVE = 'SLIDERS_INACTIVE';
import { default as SLIDERS_INACTIVE_rebranded } from './deprecated/js/sliders-inactive.js';
export const SVG_SMALL_ARROW_DOWN_INACTIVE = 'SMALL_ARROW_DOWN_INACTIVE';
import { default as SMALL_ARROW_DOWN_INACTIVE_rebranded } from './deprecated/js/small-arrow-down-inactive.js';
export const SVG_SMALL_ARROW_DOWN = 'SMALL_ARROW_DOWN';
import { default as SMALL_ARROW_DOWN_rebranded } from './deprecated/js/small-arrow-down.js';
export const SVG_SMALL_ARROW_LEFT_INACTIVE = 'SMALL_ARROW_LEFT_INACTIVE';
import { default as SMALL_ARROW_LEFT_INACTIVE_rebranded } from './deprecated/js/small-arrow-left-inactive.js';
export const SVG_SMALL_ARROW_LEFT = 'SMALL_ARROW_LEFT';
import { default as SMALL_ARROW_LEFT_rebranded } from './deprecated/js/small-arrow-left.js';
export const SVG_SMALL_ARROW_RIGHT_INACTIVE = 'SMALL_ARROW_RIGHT_INACTIVE';
import { default as SMALL_ARROW_RIGHT_INACTIVE_rebranded } from './deprecated/js/small-arrow-right-inactive.js';
export const SVG_SMALL_ARROW_RIGHT = 'SMALL_ARROW_RIGHT';
import { default as SMALL_ARROW_RIGHT_rebranded } from './deprecated/js/small-arrow-right.js';
export const SVG_SMALL_ARROW_UP_INACTIVE = 'SMALL_ARROW_UP_INACTIVE';
import { default as SMALL_ARROW_UP_INACTIVE_rebranded } from './deprecated/js/small-arrow-up-inactive.js';
export const SVG_SMALL_ARROW_UP = 'SMALL_ARROW_UP';
import { default as SMALL_ARROW_UP_rebranded } from './deprecated/js/small-arrow-up.js';
export const SVG_SMARTPHONE_ACTIVE = 'SMARTPHONE_ACTIVE';
import { default as SMARTPHONE_ACTIVE_rebranded } from './deprecated/js/smartphone-active.js';
export const SVG_SMARTPHONE = 'SMARTPHONE';
import { default as SMARTPHONE_rebranded } from './deprecated/js/smartphone.js';
export const SVG_SNOOZE_ACTIVE = 'SNOOZE_ACTIVE';
import { default as SNOOZE_ACTIVE_rebranded } from './deprecated/js/snooze-active.js';
export const SVG_SNOOZE = 'SNOOZE';
import { default as SNOOZE_rebranded } from './deprecated/js/snooze.js';
export const SVG_SPACES_ACTIVE = 'SPACES_ACTIVE';
import { default as SPACES_ACTIVE_rebranded } from './deprecated/js/spaces-active.js';
export const SVG_SPACES_INACTIVE = 'SPACES_INACTIVE';
import { default as SPACES_INACTIVE_rebranded } from './deprecated/js/spaces-inactive.js';
export const SVG_SPEAKER_20_PX_INACTIVE = 'SPEAKER_20_PX_INACTIVE';
import { default as SPEAKER_20_PX_INACTIVE_rebranded } from './deprecated/js/speaker-20-px-inactive.js';
export const SVG_SPEAKER_20_PX = 'SPEAKER_20_PX';
import { default as SPEAKER_20_PX_rebranded } from './deprecated/js/speaker-20-px.js';
export const SVG_SPEAKER_OFF_ACTIVE = 'SPEAKER_OFF_ACTIVE';
import { default as SPEAKER_OFF_ACTIVE_rebranded } from './deprecated/js/speaker-off-active.js';
export const SVG_SPEAKER_OFF_INACTIVE = 'SPEAKER_OFF_INACTIVE';
import { default as SPEAKER_OFF_INACTIVE_rebranded } from './deprecated/js/speaker-off-inactive.js';
export const SVG_SPEAKER_ON_ACTIVE = 'SPEAKER_ON_ACTIVE';
import { default as SPEAKER_ON_ACTIVE_rebranded } from './deprecated/js/speaker-on-active.js';
export const SVG_SPEAKER_ON_INACTIVE = 'SPEAKER_ON_INACTIVE';
import { default as SPEAKER_ON_INACTIVE_rebranded } from './deprecated/js/speaker-on-inactive.js';
export const SVG_SPEAKING_20_PX = 'SPEAKING_20_PX';
import { default as SPEAKING_20_PX_rebranded } from './deprecated/js/speaking-20-px.js';
export const SVG_SPEAKING = 'SPEAKING';
import { default as SPEAKING_rebranded } from './deprecated/js/speaking.js';
export const SVG_STAR_EMPTY = 'STAR_EMPTY';
import { default as STAR_EMPTY_rebranded } from './deprecated/js/star-empty.js';
export const SVG_STAR_FILLED = 'STAR_FILLED';
import { default as STAR_FILLED_rebranded } from './deprecated/js/star-filled.js';
export const SVG_STAR_HALF_FILLED = 'STAR_HALF_FILLED';
import { default as STAR_HALF_FILLED_rebranded } from './deprecated/js/star-half-filled.js';
export const SVG_STAR = 'STAR';
import { default as STAR_rebranded } from './deprecated/js/star.js';
export const SVG_STOP_20_PX_INACTIVE = 'STOP_20_PX_INACTIVE';
import { default as STOP_20_PX_INACTIVE_rebranded } from './deprecated/js/stop-20-px-inactive.js';
export const SVG_STOP_20_PX = 'STOP_20_PX';
import { default as STOP_20_PX_rebranded } from './deprecated/js/stop-20-px.js';
export const SVG_STOP_ACTIVE = 'STOP_ACTIVE';
import { default as STOP_ACTIVE_rebranded } from './deprecated/js/stop-active.js';
export const SVG_STOP_INACTIVE = 'STOP_INACTIVE';
import { default as STOP_INACTIVE_rebranded } from './deprecated/js/stop-inactive.js';
export const SVG_STOP_PLAIN_ACTIVE = 'STOP_PLAIN_ACTIVE';
import { default as STOP_PLAIN_ACTIVE_rebranded } from './deprecated/js/stop-plain-active.js';
export const SVG_STOP_PLAIN_INACTIVE = 'STOP_PLAIN_INACTIVE';
import { default as STOP_PLAIN_INACTIVE_rebranded } from './deprecated/js/stop-plain-inactive.js';
export const SVG_STRETCHING_COLLAPSE = 'STRETCHING_COLLAPSE';
import { default as STRETCHING_COLLAPSE_rebranded } from './deprecated/js/stretching-collapse.js';
export const SVG_STRETCHING_EXIT_FULLSCREEN = 'STRETCHING_EXIT_FULLSCREEN';
import { default as STRETCHING_EXIT_FULLSCREEN_rebranded } from './deprecated/js/stretching-exit-fullscreen.js';
export const SVG_STRETCHING_EXPAND = 'STRETCHING_EXPAND';
import { default as STRETCHING_EXPAND_rebranded } from './deprecated/js/stretching-expand.js';
export const SVG_STRETCHING_FULLSCREEN = 'STRETCHING_FULLSCREEN';
import { default as STRETCHING_FULLSCREEN_rebranded } from './deprecated/js/stretching-fullscreen.js';
export const SVG_STRIKETHROUGH_ACTIVE = 'STRIKETHROUGH_ACTIVE';
import { default as STRIKETHROUGH_ACTIVE_rebranded } from './deprecated/js/strikethrough-active.js';
export const SVG_STRIKETHROUGH_INACTIVE = 'STRIKETHROUGH_INACTIVE';
import { default as STRIKETHROUGH_INACTIVE_rebranded } from './deprecated/js/strikethrough-inactive.js';
export const SVG_SUBTRACT = 'SUBTRACT';
import { default as SUBTRACT_rebranded } from './deprecated/js/subtract.js';
export const SVG_SYNC = 'SYNC';
import { default as SYNC_rebranded } from './deprecated/js/sync.js';
export const SVG_SWAP = 'SWAP';
import { default as SWAP_rebranded } from './deprecated/js/swap.js';
export const SVG_SYNCHRONIZED = 'SYNCHRONIZED';
import { default as SYNCHRONIZED_rebranded } from './deprecated/js/synchronized.js';
export const SVG_TABLET_CHEVRON = 'TABLET_CHEVRON';
import { default as TABLET_CHEVRON_rebranded } from './deprecated/js/tablet-chevron.js';
export const SVG_TAG_ACTIVE = 'TAG_ACTIVE';
import { default as TAG_ACTIVE_rebranded } from './deprecated/js/tag-active.js';
export const SVG_TAG = 'TAG';
import { default as TAG_rebranded } from './deprecated/js/tag.js';
export const SVG_TAX_EXEMPTION_ACTIVE = 'TAX_EXEMPTION_ACTIVE';
import { default as TAX_EXEMPTION_ACTIVE_rebranded } from './deprecated/js/tax-exemption-active.js';
export const SVG_TAX_EXEMPTION_INACTIVE = 'TAX_EXEMPTION_INACTIVE';
import { default as TAX_EXEMPTION_INACTIVE_rebranded } from './deprecated/js/tax-exemption-inactive.js';
export const SVG_TEST_ACTIVE = 'TEST_ACTIVE';
import { default as TEST_ACTIVE_rebranded } from './deprecated/js/test-active.js';
export const SVG_TEST_INACTIVE = 'TEST_INACTIVE';
import { default as TEST_INACTIVE_rebranded } from './deprecated/js/test-inactive.js';
export const SVG_TEXT_FIELD = 'TEXT_FIELD';
import { default as TEXT_FIELD_rebranded } from './deprecated/js/text-field.js';
export const SVG_TEXT_INACTIVE = 'TEXT_INACTIVE';
import { default as TEXT_INACTIVE_rebranded } from './deprecated/js/text-inactive.js';
export const SVG_TEXT = 'TEXT';
import { default as TEXT_rebranded } from './deprecated/js/text.js';
export const SVG_THUMBS_DOWN_ACTIVE = 'THUMBS_DOWN_ACTIVE';
import { default as THUMBS_DOWN_ACTIVE_rebranded } from './deprecated/js/thumbs-down-active.js';
export const SVG_THEMES = 'THEMES';
import { default as THEMES_rebranded } from './deprecated/js/themes.js';
export const SVG_THUMBS_DOWN_INACTIVE = 'THUMBS_DOWN_INACTIVE';
import { default as THUMBS_DOWN_INACTIVE_rebranded } from './deprecated/js/thumbs-down-inactive.js';
export const SVG_THUMBS_UP_INACTIVE = 'THUMBS_UP_INACTIVE';
import { default as THUMBS_UP_INACTIVE_rebranded } from './deprecated/js/thumbs-up-inactive.js';
export const SVG_THUMBS_UP_ACTIVE = 'THUMBS_UP_ACTIVE';
import { default as THUMBS_UP_ACTIVE_rebranded } from './deprecated/js/thumbs-up-active.js';
export const SVG_TIME_LIMITATION = 'TIME_LIMITATION';
import { default as TIME_LIMITATION_rebranded } from './deprecated/js/time-limitation.js';
export const SVG_TRANSFER_CONVERSATION_ACTIVE = 'TRANSFER_CONVERSATION_ACTIVE';
import { default as TRANSFER_CONVERSATION_ACTIVE_rebranded } from './deprecated/js/transfer-conversation-active.js';
export const SVG_TRANSFER_CONVERSATION_INACTIVE = 'TRANSFER_CONVERSATION_INACTIVE';
import { default as TRANSFER_CONVERSATION_INACTIVE_rebranded } from './deprecated/js/transfer-conversation-inactive.js';
export const SVG_TRASH_ACTIVE = 'TRASH_ACTIVE';
import { default as TRASH_ACTIVE_rebranded } from './deprecated/js/trash-active.js';
export const SVG_TRASH_INACTIVE = 'TRASH_INACTIVE';
import { default as TRASH_INACTIVE_rebranded } from './deprecated/js/trash-inactive.js';
export const SVG_TRENDING = 'TRENDING';
import { default as TRENDING_rebranded } from './deprecated/js/trending.js';
export const SVG_UBUNTU = 'UBUNTU';
import { default as UBUNTU_rebranded } from './deprecated/js/ubuntu.js';
export const SVG_UNDO = 'UNDO';
import { default as UNDO_rebranded } from './deprecated/js/undo.js';
export const SVG_UNLOCKED_ACTIVE_20_PX = 'UNLOCKED_ACTIVE_20_PX';
import { default as UNLOCKED_ACTIVE_20_PX_rebranded } from './deprecated/js/unlocked-active-20-px.js';
export const SVG_UNLOCKED_ACTIVE = 'UNLOCKED_ACTIVE';
import { default as UNLOCKED_ACTIVE_rebranded } from './deprecated/js/unlocked-active.js';
export const SVG_UNLOCKED_INACTIVE = 'UNLOCKED_INACTIVE';
import { default as UNLOCKED_INACTIVE_rebranded } from './deprecated/js/unlocked-inactive.js';
export const SVG_UNLOCKED_INACTIVE_20_PX = 'UNLOCKED_INACTIVE_20_PX';
import { default as UNLOCKED_INACTIVE_20_PX_rebranded } from './deprecated/js/unlocked-inactive-20-px.js';
export const SVG_UPLOAD = 'UPLOAD';
import { default as UPLOAD_rebranded } from './deprecated/js/upload.js';
export const SVG_USB_C_ACTIVE = 'USB_C_ACTIVE';
import { default as USB_C_ACTIVE_rebranded } from './deprecated/js/usb-c-active.js';
export const SVG_USB_C = 'USB_C';
import { default as USB_C_rebranded } from './deprecated/js/usb-c.js';
export const SVG_VECTOR = 'VECTOR';
import { default as VECTOR_rebranded } from './deprecated/js/vector.js';
export const SVG_VIEW_GRID_ACTIVE = 'VIEW_GRID_ACTIVE';
import { default as VIEW_GRID_ACTIVE_rebranded } from './deprecated/js/view-grid-active.js';
export const SVG_VIEW_GRID = 'VIEW_GRID';
import { default as VIEW_GRID_rebranded } from './deprecated/js/view-grid.js';
export const SVG_VIEW_SWITCH_ACTIVE_CAMERAS_INACTIVE = 'VIEW_SWITCH_ACTIVE_CAMERAS_INACTIVE';
import { default as VIEW_SWITCH_ACTIVE_CAMERAS_INACTIVE_rebranded } from './deprecated/js/view-switch-active-cameras-inactive.js';
export const SVG_VIEW_SWITCH_ACTIVE_CAMERAS = 'VIEW_SWITCH_ACTIVE_CAMERAS';
import { default as VIEW_SWITCH_ACTIVE_CAMERAS_rebranded } from './deprecated/js/view-switch-active-cameras.js';
export const SVG_VIEW_SWITCH_EVERYONE_INACTIVE = 'VIEW_SWITCH_EVERYONE_INACTIVE';
import { default as VIEW_SWITCH_EVERYONE_INACTIVE_rebranded } from './deprecated/js/view-switch-everyone-inactive.js';
export const SVG_VIEW_SWITCH_EVERYONE = 'VIEW_SWITCH_EVERYONE';
import { default as VIEW_SWITCH_EVERYONE_rebranded } from './deprecated/js/view-switch-everyone.js';
export const SVG_VIEW_SWITCH_FILMSTRIP_INACTIVE = 'VIEW_SWITCH_FILMSTRIP_INACTIVE';
import { default as VIEW_SWITCH_FILMSTRIP_INACTIVE_rebranded } from './deprecated/js/view-switch-filmstrip-inactive.js';
export const SVG_VIEW_SWITCH_FILMSTRIP = 'VIEW_SWITCH_FILMSTRIP';
import { default as VIEW_SWITCH_FILMSTRIP_rebranded } from './deprecated/js/view-switch-filmstrip.js';
export const SVG_VIEW_SWITCH_HIDEALL_INACTIVE = 'VIEW_SWITCH_HIDEALL_INACTIVE';
import { default as VIEW_SWITCH_HIDEALL_INACTIVE_rebranded } from './deprecated/js/view-switch-hideall-inactive.js';
export const SVG_VIEW_SWITCH_HIDEALL = 'VIEW_SWITCH_HIDEALL';
import { default as VIEW_SWITCH_HIDEALL_rebranded } from './deprecated/js/view-switch-hideall.js';
export const SVG_VIEW_SWITCH_PORTRAIT_ACTIVE = 'VIEW_SWITCH_PORTRAIT_ACTIVE';
import { default as VIEW_SWITCH_PORTRAIT_ACTIVE_rebranded } from './deprecated/js/view-switch-portrait-active.js';
export const SVG_VIEW_SWITCH_PORTRAIT_INACTIVE = 'VIEW_SWITCH_PORTRAIT_INACTIVE';
import { default as VIEW_SWITCH_PORTRAIT_INACTIVE_rebranded } from './deprecated/js/view-switch-portrait-inactive.js';
export const SVG_VIEWS_ACTIVE = 'VIEWS_ACTIVE';
import { default as VIEWS_ACTIVE_rebranded } from './deprecated/js/views-active.js';
export const SVG_VIMEO = 'VIMEO';
import { default as VIMEO_rebranded } from './deprecated/js/vimeo.js';
export const SVG_VIEWS_INACTIVE = 'VIEWS_INACTIVE';
import { default as VIEWS_INACTIVE_rebranded } from './deprecated/js/views-inactive.js';
export const SVG_VIRTUAL_BACKGROUND_ACTIVE = 'VIRTUAL_BACKGROUND_ACTIVE';
import { default as VIRTUAL_BACKGROUND_ACTIVE_rebranded } from './deprecated/js/virtual-background-active.js';
export const SVG_VISA_ACTIVE = 'VISA_ACTIVE';
import { default as VISA_ACTIVE_rebranded } from './deprecated/js/visa-active.js';
export const SVG_VIRTUAL_BACKGROUND_INACTIVE = 'VIRTUAL_BACKGROUND_INACTIVE';
import { default as VIRTUAL_BACKGROUND_INACTIVE_rebranded } from './deprecated/js/virtual-background-inactive.js';
export const SVG_VISA = 'VISA';
import { default as VISA_rebranded } from './deprecated/js/visa.js';
export const SVG_VISIBILITY_DISABLED_ACTIVE = 'VISIBILITY_DISABLED_ACTIVE';
import { default as VISIBILITY_DISABLED_ACTIVE_rebranded } from './deprecated/js/visibility-disabled-active.js';
export const SVG_VISIBILITY_DISABLED_INACTIVE = 'VISIBILITY_DISABLED_INACTIVE';
import { default as VISIBILITY_DISABLED_INACTIVE_rebranded } from './deprecated/js/visibility-disabled-inactive.js';
export const SVG_VISIBILITY_ENABLED_ACTIVE = 'VISIBILITY_ENABLED_ACTIVE';
import { default as VISIBILITY_ENABLED_ACTIVE_rebranded } from './deprecated/js/visibility-enabled-active.js';
export const SVG_VISIBILITY_ENABLED_INACTIVE = 'VISIBILITY_ENABLED_INACTIVE';
import { default as VISIBILITY_ENABLED_INACTIVE_rebranded } from './deprecated/js/visibility-enabled-inactive.js';
export const SVG_VOICEMAIL_READ = 'VOICEMAIL_READ';
import { default as VOICEMAIL_READ_rebranded } from './deprecated/js/voicemail-read.js';
export const SVG_VOICEMAIL_UNREAD = 'VOICEMAIL_UNREAD';
import { default as VOICEMAIL_UNREAD_rebranded } from './deprecated/js/voicemail-unread.js';
export const SVG_VOICEMAIL = 'VOICEMAIL';
import { default as VOICEMAIL_rebranded } from './deprecated/js/voicemail.js';
export const SVG_VOIP_PAUSE = 'VOIP_PAUSE';
import { default as VOIP_PAUSE_rebranded } from './deprecated/js/voip-pause.js';
export const SVG_VOIP = 'VOIP';
import { default as VOIP_rebranded } from './deprecated/js/voip.js';
export const SVG_WEB = 'WEB';
import { default as WEB_rebranded } from './deprecated/js/web.js';
export const SVG_WEB_ACTIVE = 'WEB_ACTIVE';
import { default as WEB_ACTIVE_rebranded } from './deprecated/js/web-active.js';
export const SVG_WEBCAM_OFF_ACTIVE = 'WEBCAM_OFF_ACTIVE';
import { default as WEBCAM_OFF_ACTIVE_rebranded } from './deprecated/js/webcam-off-active.js';
export const SVG_WEBCAM_OFF_INACTIVE = 'WEBCAM_OFF_INACTIVE';
import { default as WEBCAM_OFF_INACTIVE_rebranded } from './deprecated/js/webcam-off-inactive.js';
export const SVG_WEBCAM_ON_ACTIVE = 'WEBCAM_ON_ACTIVE';
import { default as WEBCAM_ON_ACTIVE_rebranded } from './deprecated/js/webcam-on-active.js';
export const SVG_WEBCAM_ON_INACTIVE = 'WEBCAM_ON_INACTIVE';
import { default as WEBCAM_ON_INACTIVE_rebranded } from './deprecated/js/webcam-on-inactive.js';
export const SVG_WHISPER_ACTIVE = 'WHISPER_ACTIVE';
import { default as WHISPER_ACTIVE_rebranded } from './deprecated/js/whisper-active.js';
export const SVG_WHISPER = 'WHISPER';
import { default as WHISPER_rebranded } from './deprecated/js/whisper.js';
export const SVG_WHITEBOARD_ACTIVE = 'WHITEBOARD_ACTIVE';
import { default as WHITEBOARD_ACTIVE_rebranded } from './deprecated/js/whiteboard-active.js';
export const SVG_WHITEBOARD_INACTIVE = 'WHITEBOARD_INACTIVE';
import { default as WHITEBOARD_INACTIVE_rebranded } from './deprecated/js/whiteboard-inactive.js';
export const SVG_WIFI_ACTIVE = 'WIFI_ACTIVE';
import { default as WIFI_ACTIVE_rebranded } from './deprecated/js/wifi-active.js';
export const SVG_WIFI_INACTIVE = 'WIFI_INACTIVE';
import { default as WIFI_INACTIVE_rebranded } from './deprecated/js/wifi-inactive.js';
export const SVG_WINDOWS = 'WINDOWS';
import { default as WINDOWS_rebranded } from './deprecated/js/windows.js';
export const SVG_WRENCH_ACTIVE = 'WRENCH_ACTIVE';
import { default as WRENCH_ACTIVE_rebranded } from './deprecated/js/wrench-active.js';
export const SVG_WRENCH_INACTIVE = 'WRENCH_INACTIVE';
import { default as WRENCH_INACTIVE_rebranded } from './deprecated/js/wrench-inactive.js';
export const SVG_YUAN_ACTIVE = 'YUAN_ACTIVE';
import { default as YUAN_ACTIVE_rebranded } from './deprecated/js/yuan-active.js';
export const SVG_YUAN = 'YUAN';
import { default as YUAN_rebranded } from './deprecated/js/yuan.js';
export const SVG_ZIP = 'ZIP';
import { default as ZIP_rebranded } from './deprecated/js/zip.js';
export const SVG_ZOOM_IN_ACTIVE = 'ZOOM_IN_ACTIVE';
import { default as ZOOM_IN_ACTIVE_rebranded } from './deprecated/js/zoom-in-active.js';
export const SVG_ZOOM_IN_INACTIVE = 'ZOOM_IN_INACTIVE';
import { default as ZOOM_IN_INACTIVE_rebranded } from './deprecated/js/zoom-in-inactive.js';
export const SVG_ZOOM_OUT_ACTIVE = 'ZOOM_OUT_ACTIVE';
import { default as ZOOM_OUT_ACTIVE_rebranded } from './deprecated/js/zoom-out-active.js';
export const SVG_ZOOM_OUT_INACTIVE = 'ZOOM_OUT_INACTIVE';
import { default as ZOOM_OUT_INACTIVE_rebranded } from './deprecated/js/zoom-out-inactive.js';
export const SVG_ACCESSIBILITY_FILLED = 'ACCESSIBILITY_FILLED';
import { default as ACCESSIBILITY_FILLED_rebranded } from './rebranded/js/accessibility-filled.js';
export const SVG_ACCESSIBILITY_OUTLINED = 'ACCESSIBILITY_OUTLINED';
import { default as ACCESSIBILITY_OUTLINED_rebranded } from './rebranded/js/accessibility-outlined.js';
export const SVG_ACTION_ITEM_FILLED = 'ACTION_ITEM_FILLED';
import { default as ACTION_ITEM_FILLED_rebranded } from './rebranded/js/action-item-filled.js';
export const SVG_ACTION_ITEM_OUTLINED = 'ACTION_ITEM_OUTLINED';
import { default as ACTION_ITEM_OUTLINED_rebranded } from './rebranded/js/action-item-outlined.js';
export const SVG_ADD_CIRCLE_OUTLINED = 'ADD_CIRCLE_OUTLINED';
import { default as ADD_CIRCLE_OUTLINED_rebranded } from './rebranded/js/add-circle-outlined.js';
export const SVG_ADD_CIRCLE_FILLED = 'ADD_CIRCLE_FILLED';
import { default as ADD_CIRCLE_FILLED_rebranded } from './rebranded/js/add-circle-filled.js';
export const SVG_ADD_FILLED = 'ADD_FILLED';
import { default as ADD_FILLED_rebranded } from './rebranded/js/add-filled.js';
export const SVG_ADD_OUTLINED = 'ADD_OUTLINED';
import { default as ADD_OUTLINED_rebranded } from './rebranded/js/add-outlined.js';
export const SVG_ADD_PERSON_FILLED = 'ADD_PERSON_FILLED';
import { default as ADD_PERSON_FILLED_rebranded } from './rebranded/js/add-person-filled.js';
export const SVG_ADD_PERSON_OUTLINED = 'ADD_PERSON_OUTLINED';
import { default as ADD_PERSON_OUTLINED_rebranded } from './rebranded/js/add-person-outlined.js';
export const SVG_ADDRESS_BOOK_FILLED = 'ADDRESS_BOOK_FILLED';
import { default as ADDRESS_BOOK_FILLED_rebranded } from './rebranded/js/address-book-filled.js';
export const SVG_ADMIN_FILLED = 'ADMIN_FILLED';
import { default as ADMIN_FILLED_rebranded } from './rebranded/js/admin-filled.js';
export const SVG_ADMIN_OUTLINED = 'ADMIN_OUTLINED';
import { default as ADMIN_OUTLINED_rebranded } from './rebranded/js/admin-outlined.js';
export const SVG_ADDRESS_BOOK_OUTLINED = 'ADDRESS_BOOK_OUTLINED';
import { default as ADDRESS_BOOK_OUTLINED_rebranded } from './rebranded/js/address-book-outlined.js';
export const SVG_ALERT_FILLED = 'ALERT_FILLED';
import { default as ALERT_FILLED_rebranded } from './rebranded/js/alert-filled.js';
export const SVG_ALERT_OUTLINED = 'ALERT_OUTLINED';
import { default as ALERT_OUTLINED_rebranded } from './rebranded/js/alert-outlined.js';
export const SVG_ANNOTATION_FILLED = 'ANNOTATION_FILLED';
import { default as ANNOTATION_FILLED_rebranded } from './rebranded/js/annotation-filled.js';
export const SVG_ANNOTATION_OUTLINED = 'ANNOTATION_OUTLINED';
import { default as ANNOTATION_OUTLINED_rebranded } from './rebranded/js/annotation-outlined.js';
export const SVG_APP_SWITCHER_OUTLINED = 'APP_SWITCHER_OUTLINED';
import { default as APP_SWITCHER_OUTLINED_rebranded } from './rebranded/js/app-switcher-outlined.js';
export const SVG_APP_SWITCHER_FILLED = 'APP_SWITCHER_FILLED';
import { default as APP_SWITCHER_FILLED_rebranded } from './rebranded/js/app-switcher-filled.js';
export const SVG_ARCHIVE_FILLED = 'ARCHIVE_FILLED';
import { default as ARCHIVE_FILLED_rebranded } from './rebranded/js/archive-filled.js';
export const SVG_ARCHIVE_OUTLINED = 'ARCHIVE_OUTLINED';
import { default as ARCHIVE_OUTLINED_rebranded } from './rebranded/js/archive-outlined.js';
export const SVG_ARROW_DOWN_FILLED = 'ARROW_DOWN_FILLED';
import { default as ARROW_DOWN_FILLED_rebranded } from './rebranded/js/arrow-down-filled.js';
export const SVG_ARROW_DOWN_OUTLINED = 'ARROW_DOWN_OUTLINED';
import { default as ARROW_DOWN_OUTLINED_rebranded } from './rebranded/js/arrow-down-outlined.js';
export const SVG_ARROW_LEFT_FILLED = 'ARROW_LEFT_FILLED';
import { default as ARROW_LEFT_FILLED_rebranded } from './rebranded/js/arrow-left-filled.js';
export const SVG_ARROW_LEFT_OUTLINED = 'ARROW_LEFT_OUTLINED';
import { default as ARROW_LEFT_OUTLINED_rebranded } from './rebranded/js/arrow-left-outlined.js';
export const SVG_ARROW_RIGHT_FILLED = 'ARROW_RIGHT_FILLED';
import { default as ARROW_RIGHT_FILLED_rebranded } from './rebranded/js/arrow-right-filled.js';
export const SVG_ARROW_RIGHT_OUTLINED = 'ARROW_RIGHT_OUTLINED';
import { default as ARROW_RIGHT_OUTLINED_rebranded } from './rebranded/js/arrow-right-outlined.js';
export const SVG_ARROW_UP_FILLED = 'ARROW_UP_FILLED';
import { default as ARROW_UP_FILLED_rebranded } from './rebranded/js/arrow-up-filled.js';
export const SVG_ASSISTANCE_OUTLINED = 'ASSISTANCE_OUTLINED';
import { default as ASSISTANCE_OUTLINED_rebranded } from './rebranded/js/assistance-outlined.js';
export const SVG_ASSISTANCE_FILLED = 'ASSISTANCE_FILLED';
import { default as ASSISTANCE_FILLED_rebranded } from './rebranded/js/assistance-filled.js';
export const SVG_ARROW_UP_OUTLINED = 'ARROW_UP_OUTLINED';
import { default as ARROW_UP_OUTLINED_rebranded } from './rebranded/js/arrow-up-outlined.js';
export const SVG_ASTERISK_FILLED = 'ASTERISK_FILLED';
import { default as ASTERISK_FILLED_rebranded } from './rebranded/js/asterisk-filled.js';
export const SVG_ASTERISK_OUTLINED = 'ASTERISK_OUTLINED';
import { default as ASTERISK_OUTLINED_rebranded } from './rebranded/js/asterisk-outlined.js';
export const SVG_ATTACHMENT_FILLED = 'ATTACHMENT_FILLED';
import { default as ATTACHMENT_FILLED_rebranded } from './rebranded/js/attachment-filled.js';
export const SVG_AUDIO_TEST_FILLED = 'AUDIO_TEST_FILLED';
import { default as AUDIO_TEST_FILLED_rebranded } from './rebranded/js/audio-test-filled.js';
export const SVG_ATTACHMENT_OUTLINED = 'ATTACHMENT_OUTLINED';
import { default as ATTACHMENT_OUTLINED_rebranded } from './rebranded/js/attachment-outlined.js';
export const SVG_AUDIO_TEST_OUTLINED = 'AUDIO_TEST_OUTLINED';
import { default as AUDIO_TEST_OUTLINED_rebranded } from './rebranded/js/audio-test-outlined.js';
export const SVG_BACKSPACE_FILLED = 'BACKSPACE_FILLED';
import { default as BACKSPACE_FILLED_rebranded } from './rebranded/js/backspace-filled.js';
export const SVG_BADGE_FILLED = 'BADGE_FILLED';
import { default as BADGE_FILLED_rebranded } from './rebranded/js/badge-filled.js';
export const SVG_BACKSPACE_OUTLINED = 'BACKSPACE_OUTLINED';
import { default as BACKSPACE_OUTLINED_rebranded } from './rebranded/js/backspace-outlined.js';
export const SVG_BADGE_OUTLINED = 'BADGE_OUTLINED';
import { default as BADGE_OUTLINED_rebranded } from './rebranded/js/badge-outlined.js';
export const SVG_BANK_CARD_FILLED = 'BANK_CARD_FILLED';
import { default as BANK_CARD_FILLED_rebranded } from './rebranded/js/bank-card-filled.js';
export const SVG_BANK_CARD_OUTLINED = 'BANK_CARD_OUTLINED';
import { default as BANK_CARD_OUTLINED_rebranded } from './rebranded/js/bank-card-outlined.js';
export const SVG_BATTERY_FULL_FILLED = 'BATTERY_FULL_FILLED';
import { default as BATTERY_FULL_FILLED_rebranded } from './rebranded/js/battery-full-filled.js';
export const SVG_BATTERY_FULL_OUTLINED = 'BATTERY_FULL_OUTLINED';
import { default as BATTERY_FULL_OUTLINED_rebranded } from './rebranded/js/battery-full-outlined.js';
export const SVG_BATTERY_LOW_FILLED = 'BATTERY_LOW_FILLED';
import { default as BATTERY_LOW_FILLED_rebranded } from './rebranded/js/battery-low-filled.js';
export const SVG_BATTERY_LOW_OUTLINED = 'BATTERY_LOW_OUTLINED';
import { default as BATTERY_LOW_OUTLINED_rebranded } from './rebranded/js/battery-low-outlined.js';
export const SVG_BATTERY_MID_FILLED = 'BATTERY_MID_FILLED';
import { default as BATTERY_MID_FILLED_rebranded } from './rebranded/js/battery-mid-filled.js';
export const SVG_BELL_OFF_FILLED = 'BELL_OFF_FILLED';
import { default as BELL_OFF_FILLED_rebranded } from './rebranded/js/bell-off-filled.js';
export const SVG_BELL_FILLED = 'BELL_FILLED';
import { default as BELL_FILLED_rebranded } from './rebranded/js/bell-filled.js';
export const SVG_BATTERY_MID_OUTLINED = 'BATTERY_MID_OUTLINED';
import { default as BATTERY_MID_OUTLINED_rebranded } from './rebranded/js/battery-mid-outlined.js';
export const SVG_BELL_OUTLINED = 'BELL_OUTLINED';
import { default as BELL_OUTLINED_rebranded } from './rebranded/js/bell-outlined.js';
export const SVG_BELL_OFF_OUTLINED = 'BELL_OFF_OUTLINED';
import { default as BELL_OFF_OUTLINED_rebranded } from './rebranded/js/bell-off-outlined.js';
export const SVG_BLOCK_FILLED = 'BLOCK_FILLED';
import { default as BLOCK_FILLED_rebranded } from './rebranded/js/block-filled.js';
export const SVG_BLOCK_OUTLINED = 'BLOCK_OUTLINED';
import { default as BLOCK_OUTLINED_rebranded } from './rebranded/js/block-outlined.js';
export const SVG_BLUETOOTH_CONNECTED_FILLED = 'BLUETOOTH_CONNECTED_FILLED';
import { default as BLUETOOTH_CONNECTED_FILLED_rebranded } from './rebranded/js/bluetooth-connected-filled.js';
export const SVG_BLUETOOTH_CONNECTED_OUTLINED = 'BLUETOOTH_CONNECTED_OUTLINED';
import { default as BLUETOOTH_CONNECTED_OUTLINED_rebranded } from './rebranded/js/bluetooth-connected-outlined.js';
export const SVG_BLUETOOTH_FILLED = 'BLUETOOTH_FILLED';
import { default as BLUETOOTH_FILLED_rebranded } from './rebranded/js/bluetooth-filled.js';
export const SVG_BLUETOOTH_OUTLINED = 'BLUETOOTH_OUTLINED';
import { default as BLUETOOTH_OUTLINED_rebranded } from './rebranded/js/bluetooth-outlined.js';
export const SVG_BOOK_OUTLINED = 'BOOK_OUTLINED';
import { default as BOOK_OUTLINED_rebranded } from './rebranded/js/book-outlined.js';
export const SVG_BOOK_FILLED = 'BOOK_FILLED';
import { default as BOOK_FILLED_rebranded } from './rebranded/js/book-filled.js';
export const SVG_BOOKMARK_FILLED = 'BOOKMARK_FILLED';
import { default as BOOKMARK_FILLED_rebranded } from './rebranded/js/bookmark-filled.js';
export const SVG_BOOKMARK_OUTLINED = 'BOOKMARK_OUTLINED';
import { default as BOOKMARK_OUTLINED_rebranded } from './rebranded/js/bookmark-outlined.js';
export const SVG_BREAKOUT_ROOM_FILLED = 'BREAKOUT_ROOM_FILLED';
import { default as BREAKOUT_ROOM_FILLED_rebranded } from './rebranded/js/breakout-room-filled.js';
export const SVG_BUG_FILLED = 'BUG_FILLED';
import { default as BUG_FILLED_rebranded } from './rebranded/js/bug-filled.js';
export const SVG_BREAKOUT_ROOM_OUTLINED = 'BREAKOUT_ROOM_OUTLINED';
import { default as BREAKOUT_ROOM_OUTLINED_rebranded } from './rebranded/js/breakout-room-outlined.js';
export const SVG_BUG_OUTLINED = 'BUG_OUTLINED';
import { default as BUG_OUTLINED_rebranded } from './rebranded/js/bug-outlined.js';
export const SVG_CABLE_HDMI_FILLED = 'CABLE_HDMI_FILLED';
import { default as CABLE_HDMI_FILLED_rebranded } from './rebranded/js/cable-hdmi-filled.js';
export const SVG_CABLE_HDMI_OUTLINED = 'CABLE_HDMI_OUTLINED';
import { default as CABLE_HDMI_OUTLINED_rebranded } from './rebranded/js/cable-hdmi-outlined.js';
export const SVG_CABLE_USB_FILLED = 'CABLE_USB_FILLED';
import { default as CABLE_USB_FILLED_rebranded } from './rebranded/js/cable-usb-filled.js';
export const SVG_CABLE_USB_OUTLINED = 'CABLE_USB_OUTLINED';
import { default as CABLE_USB_OUTLINED_rebranded } from './rebranded/js/cable-usb-outlined.js';
export const SVG_CALCULATOR_OUTLINED = 'CALCULATOR_OUTLINED';
import { default as CALCULATOR_OUTLINED_rebranded } from './rebranded/js/calculator-outlined.js';
export const SVG_CALENDAR_ADD_FILLED = 'CALENDAR_ADD_FILLED';
import { default as CALENDAR_ADD_FILLED_rebranded } from './rebranded/js/calendar-add-filled.js';
export const SVG_CALCULATOR_FILLED = 'CALCULATOR_FILLED';
import { default as CALCULATOR_FILLED_rebranded } from './rebranded/js/calculator-filled.js';
export const SVG_CALENDAR_EVENT_FILLED = 'CALENDAR_EVENT_FILLED';
import { default as CALENDAR_EVENT_FILLED_rebranded } from './rebranded/js/calendar-event-filled.js';
export const SVG_CALENDAR_ADD_OUTLINED = 'CALENDAR_ADD_OUTLINED';
import { default as CALENDAR_ADD_OUTLINED_rebranded } from './rebranded/js/calendar-add-outlined.js';
export const SVG_CALENDAR_EVENT_OUTLINED = 'CALENDAR_EVENT_OUTLINED';
import { default as CALENDAR_EVENT_OUTLINED_rebranded } from './rebranded/js/calendar-event-outlined.js';
export const SVG_CALENDAR_FILLED = 'CALENDAR_FILLED';
import { default as CALENDAR_FILLED_rebranded } from './rebranded/js/calendar-filled.js';
export const SVG_CALENDAR_MEETING_FILLED = 'CALENDAR_MEETING_FILLED';
import { default as CALENDAR_MEETING_FILLED_rebranded } from './rebranded/js/calendar-meeting-filled.js';
export const SVG_CALENDAR_OUTLINED = 'CALENDAR_OUTLINED';
import { default as CALENDAR_OUTLINED_rebranded } from './rebranded/js/calendar-outlined.js';
export const SVG_CALENDAR_PHONE_OUTLINED = 'CALENDAR_PHONE_OUTLINED';
import { default as CALENDAR_PHONE_OUTLINED_rebranded } from './rebranded/js/calendar-phone-outlined.js';
export const SVG_CALENDAR_PHONE_FILLED = 'CALENDAR_PHONE_FILLED';
import { default as CALENDAR_PHONE_FILLED_rebranded } from './rebranded/js/calendar-phone-filled.js';
export const SVG_CALENDAR_MEETING_OUTLINED = 'CALENDAR_MEETING_OUTLINED';
import { default as CALENDAR_MEETING_OUTLINED_rebranded } from './rebranded/js/calendar-meeting-outlined.js';
export const SVG_CALENDAR_PLAY_FILLED = 'CALENDAR_PLAY_FILLED';
import { default as CALENDAR_PLAY_FILLED_rebranded } from './rebranded/js/calendar-play-filled.js';
export const SVG_CALENDAR_PLAY_OUTLINED = 'CALENDAR_PLAY_OUTLINED';
import { default as CALENDAR_PLAY_OUTLINED_rebranded } from './rebranded/js/calendar-play-outlined.js';
export const SVG_CALENDAR_RECURRING_FILLED = 'CALENDAR_RECURRING_FILLED';
import { default as CALENDAR_RECURRING_FILLED_rebranded } from './rebranded/js/calendar-recurring-filled.js';
export const SVG_CALENDAR_SYNC_FILLED = 'CALENDAR_SYNC_FILLED';
import { default as CALENDAR_SYNC_FILLED_rebranded } from './rebranded/js/calendar-sync-filled.js';
export const SVG_CALENDAR_RECURRING_OUTLINED = 'CALENDAR_RECURRING_OUTLINED';
import { default as CALENDAR_RECURRING_OUTLINED_rebranded } from './rebranded/js/calendar-recurring-outlined.js';
export const SVG_CALENDAR_SYNC_OUTLINED = 'CALENDAR_SYNC_OUTLINED';
import { default as CALENDAR_SYNC_OUTLINED_rebranded } from './rebranded/js/calendar-sync-outlined.js';
export const SVG_CALL_MADE_FILLED = 'CALL_MADE_FILLED';
import { default as CALL_MADE_FILLED_rebranded } from './rebranded/js/call-made-filled.js';
export const SVG_CALL_MADE_OUTLINED = 'CALL_MADE_OUTLINED';
import { default as CALL_MADE_OUTLINED_rebranded } from './rebranded/js/call-made-outlined.js';
export const SVG_CALL_MERGE_FILLED = 'CALL_MERGE_FILLED';
import { default as CALL_MERGE_FILLED_rebranded } from './rebranded/js/call-merge-filled.js';
export const SVG_CALL_MISSED_FILLED = 'CALL_MISSED_FILLED';
import { default as CALL_MISSED_FILLED_rebranded } from './rebranded/js/call-missed-filled.js';
export const SVG_CALL_MERGE_OUTLINED = 'CALL_MERGE_OUTLINED';
import { default as CALL_MERGE_OUTLINED_rebranded } from './rebranded/js/call-merge-outlined.js';
export const SVG_CALL_MISSED_OUTLINED = 'CALL_MISSED_OUTLINED';
import { default as CALL_MISSED_OUTLINED_rebranded } from './rebranded/js/call-missed-outlined.js';
export const SVG_CALL_RECEIVED_FILLED = 'CALL_RECEIVED_FILLED';
import { default as CALL_RECEIVED_FILLED_rebranded } from './rebranded/js/call-received-filled.js';
export const SVG_CALL_RECEIVED_OUTLINED = 'CALL_RECEIVED_OUTLINED';
import { default as CALL_RECEIVED_OUTLINED_rebranded } from './rebranded/js/call-received-outlined.js';
export const SVG_CALL_SPLIT_FILLED = 'CALL_SPLIT_FILLED';
import { default as CALL_SPLIT_FILLED_rebranded } from './rebranded/js/call-split-filled.js';
export const SVG_CALL_SPLIT_OUTLINED = 'CALL_SPLIT_OUTLINED';
import { default as CALL_SPLIT_OUTLINED_rebranded } from './rebranded/js/call-split-outlined.js';
export const SVG_CAMERA_ADJUST_FILLED = 'CAMERA_ADJUST_FILLED';
import { default as CAMERA_ADJUST_FILLED_rebranded } from './rebranded/js/camera-adjust-filled.js';
export const SVG_CAMERA_AUTO_FILLED = 'CAMERA_AUTO_FILLED';
import { default as CAMERA_AUTO_FILLED_rebranded } from './rebranded/js/camera-auto-filled.js';
export const SVG_CAMERA_ADJUST_OUTLINED = 'CAMERA_ADJUST_OUTLINED';
import { default as CAMERA_ADJUST_OUTLINED_rebranded } from './rebranded/js/camera-adjust-outlined.js';
export const SVG_CAMERA_AUTO_OUTLINED = 'CAMERA_AUTO_OUTLINED';
import { default as CAMERA_AUTO_OUTLINED_rebranded } from './rebranded/js/camera-auto-outlined.js';
export const SVG_CAMERA_FILLED = 'CAMERA_FILLED';
import { default as CAMERA_FILLED_rebranded } from './rebranded/js/camera-filled.js';
export const SVG_CAMERA_FLIP_FILLED = 'CAMERA_FLIP_FILLED';
import { default as CAMERA_FLIP_FILLED_rebranded } from './rebranded/js/camera-flip-filled.js';
export const SVG_CAMERA_FLIP_OUTLINED = 'CAMERA_FLIP_OUTLINED';
import { default as CAMERA_FLIP_OUTLINED_rebranded } from './rebranded/js/camera-flip-outlined.js';
export const SVG_CAMERA_OUTLINED = 'CAMERA_OUTLINED';
import { default as CAMERA_OUTLINED_rebranded } from './rebranded/js/camera-outlined.js';
export const SVG_CAMERA_POSITION_BOTTOM_FILLED = 'CAMERA_POSITION_BOTTOM_FILLED';
import { default as CAMERA_POSITION_BOTTOM_FILLED_rebranded } from './rebranded/js/camera-position-bottom-filled.js';
export const SVG_CAMERA_POSITION_BOTTOM_OUTLINED = 'CAMERA_POSITION_BOTTOM_OUTLINED';
import { default as CAMERA_POSITION_BOTTOM_OUTLINED_rebranded } from './rebranded/js/camera-position-bottom-outlined.js';
export const SVG_CAMERA_POSITION_LEFT_FILLED = 'CAMERA_POSITION_LEFT_FILLED';
import { default as CAMERA_POSITION_LEFT_FILLED_rebranded } from './rebranded/js/camera-position-left-filled.js';
export const SVG_CAMERA_POSITION_LEFT_OUTLINED = 'CAMERA_POSITION_LEFT_OUTLINED';
import { default as CAMERA_POSITION_LEFT_OUTLINED_rebranded } from './rebranded/js/camera-position-left-outlined.js';
export const SVG_CAMERA_POSITION_RIGHT_FILLED = 'CAMERA_POSITION_RIGHT_FILLED';
import { default as CAMERA_POSITION_RIGHT_FILLED_rebranded } from './rebranded/js/camera-position-right-filled.js';
export const SVG_CAMERA_POSITION_RIGHT_OUTLINED = 'CAMERA_POSITION_RIGHT_OUTLINED';
import { default as CAMERA_POSITION_RIGHT_OUTLINED_rebranded } from './rebranded/js/camera-position-right-outlined.js';
export const SVG_CAMERA_POSITION_TOP_FILLED = 'CAMERA_POSITION_TOP_FILLED';
import { default as CAMERA_POSITION_TOP_FILLED_rebranded } from './rebranded/js/camera-position-top-filled.js';
export const SVG_CAMERA_PRESETS_FILLED = 'CAMERA_PRESETS_FILLED';
import { default as CAMERA_PRESETS_FILLED_rebranded } from './rebranded/js/camera-presets-filled.js';
export const SVG_CAMERA_POSITION_TOP_OUTLINED = 'CAMERA_POSITION_TOP_OUTLINED';
import { default as CAMERA_POSITION_TOP_OUTLINED_rebranded } from './rebranded/js/camera-position-top-outlined.js';
export const SVG_CAMERA_PRESETS_OUTLINED = 'CAMERA_PRESETS_OUTLINED';
import { default as CAMERA_PRESETS_OUTLINED_rebranded } from './rebranded/js/camera-presets-outlined.js';
export const SVG_CAMERA_ROOM_VIEW_OUTLINED = 'CAMERA_ROOM_VIEW_OUTLINED';
import { default as CAMERA_ROOM_VIEW_OUTLINED_rebranded } from './rebranded/js/camera-room-view-outlined.js';
export const SVG_CAMERA_ROOM_VIEW_FILLED = 'CAMERA_ROOM_VIEW_FILLED';
import { default as CAMERA_ROOM_VIEW_FILLED_rebranded } from './rebranded/js/camera-room-view-filled.js';
export const SVG_CAMERA_SHARE_FILLED = 'CAMERA_SHARE_FILLED';
import { default as CAMERA_SHARE_FILLED_rebranded } from './rebranded/js/camera-share-filled.js';
export const SVG_CAR_FILLED = 'CAR_FILLED';
import { default as CAR_FILLED_rebranded } from './rebranded/js/car-filled.js';
export const SVG_CAMERA_SHARE_OUTLINED = 'CAMERA_SHARE_OUTLINED';
import { default as CAMERA_SHARE_OUTLINED_rebranded } from './rebranded/js/camera-share-outlined.js';
export const SVG_CAR_OUTLINED = 'CAR_OUTLINED';
import { default as CAR_OUTLINED_rebranded } from './rebranded/js/car-outlined.js';
export const SVG_CARD_AMEX_FILLED = 'CARD_AMEX_FILLED';
import { default as CARD_AMEX_FILLED_rebranded } from './rebranded/js/card-amex-filled.js';
export const SVG_CARD_AMEX_OUTLINED = 'CARD_AMEX_OUTLINED';
import { default as CARD_AMEX_OUTLINED_rebranded } from './rebranded/js/card-amex-outlined.js';
export const SVG_CARD_DISCOVER_FILLED = 'CARD_DISCOVER_FILLED';
import { default as CARD_DISCOVER_FILLED_rebranded } from './rebranded/js/card-discover-filled.js';
export const SVG_CARD_MASTERCARD_FILLED = 'CARD_MASTERCARD_FILLED';
import { default as CARD_MASTERCARD_FILLED_rebranded } from './rebranded/js/card-mastercard-filled.js';
export const SVG_CARD_DISCOVER_OUTLINED = 'CARD_DISCOVER_OUTLINED';
import { default as CARD_DISCOVER_OUTLINED_rebranded } from './rebranded/js/card-discover-outlined.js';
export const SVG_CARD_VISA_FILLED = 'CARD_VISA_FILLED';
import { default as CARD_VISA_FILLED_rebranded } from './rebranded/js/card-visa-filled.js';
export const SVG_CARD_MASTERCARD_OUTLINED = 'CARD_MASTERCARD_OUTLINED';
import { default as CARD_MASTERCARD_OUTLINED_rebranded } from './rebranded/js/card-mastercard-outlined.js';
export const SVG_CARD_VISA_OUTLINED = 'CARD_VISA_OUTLINED';
import { default as CARD_VISA_OUTLINED_rebranded } from './rebranded/js/card-visa-outlined.js';
export const SVG_CASH_OUTLINED = 'CASH_OUTLINED';
import { default as CASH_OUTLINED_rebranded } from './rebranded/js/cash-outlined.js';
export const SVG_CASH_FILLED = 'CASH_FILLED';
import { default as CASH_FILLED_rebranded } from './rebranded/js/cash-filled.js';
export const SVG_CHECKMARK_CIRCLE_FILLED = 'CHECKMARK_CIRCLE_FILLED';
import { default as CHECKMARK_CIRCLE_FILLED_rebranded } from './rebranded/js/checkmark-circle-filled.js';
export const SVG_CHECKMARK_CIRCLE_OUTLINED = 'CHECKMARK_CIRCLE_OUTLINED';
import { default as CHECKMARK_CIRCLE_OUTLINED_rebranded } from './rebranded/js/checkmark-circle-outlined.js';
export const SVG_CHECKMARK_FILLED = 'CHECKMARK_FILLED';
import { default as CHECKMARK_FILLED_rebranded } from './rebranded/js/checkmark-filled.js';
export const SVG_CHECKMARK_OUTLINED = 'CHECKMARK_OUTLINED';
import { default as CHECKMARK_OUTLINED_rebranded } from './rebranded/js/checkmark-outlined.js';
export const SVG_CHEVRON_COMBO_FILLED = 'CHEVRON_COMBO_FILLED';
import { default as CHEVRON_COMBO_FILLED_rebranded } from './rebranded/js/chevron-combo-filled.js';
export const SVG_CHEVRON_COMBO_OUTLINED = 'CHEVRON_COMBO_OUTLINED';
import { default as CHEVRON_COMBO_OUTLINED_rebranded } from './rebranded/js/chevron-combo-outlined.js';
export const SVG_CHEVRON_DOWN_FILLED = 'CHEVRON_DOWN_FILLED';
import { default as CHEVRON_DOWN_FILLED_rebranded } from './rebranded/js/chevron-down-filled.js';
export const SVG_CHEVRON_DOWN_OUTLINED = 'CHEVRON_DOWN_OUTLINED';
import { default as CHEVRON_DOWN_OUTLINED_rebranded } from './rebranded/js/chevron-down-outlined.js';
export const SVG_CHEVRON_LEFT_FILLED = 'CHEVRON_LEFT_FILLED';
import { default as CHEVRON_LEFT_FILLED_rebranded } from './rebranded/js/chevron-left-filled.js';
export const SVG_CHEVRON_LEFT_OUTLINED = 'CHEVRON_LEFT_OUTLINED';
import { default as CHEVRON_LEFT_OUTLINED_rebranded } from './rebranded/js/chevron-left-outlined.js';
export const SVG_CHEVRON_RIGHT_FILLED = 'CHEVRON_RIGHT_FILLED';
import { default as CHEVRON_RIGHT_FILLED_rebranded } from './rebranded/js/chevron-right-filled.js';
export const SVG_CHEVRON_RIGHT_OUTLINED = 'CHEVRON_RIGHT_OUTLINED';
import { default as CHEVRON_RIGHT_OUTLINED_rebranded } from './rebranded/js/chevron-right-outlined.js';
export const SVG_CHEVRON_UP_FILLED = 'CHEVRON_UP_FILLED';
import { default as CHEVRON_UP_FILLED_rebranded } from './rebranded/js/chevron-up-filled.js';
export const SVG_CHEVRON_UP_OUTLINED = 'CHEVRON_UP_OUTLINED';
import { default as CHEVRON_UP_OUTLINED_rebranded } from './rebranded/js/chevron-up-outlined.js';
export const SVG_CLEAR_ALL_FILLED = 'CLEAR_ALL_FILLED';
import { default as CLEAR_ALL_FILLED_rebranded } from './rebranded/js/clear-all-filled.js';
export const SVG_CLEAR_ALL_OUTLINED = 'CLEAR_ALL_OUTLINED';
import { default as CLEAR_ALL_OUTLINED_rebranded } from './rebranded/js/clear-all-outlined.js';
export const SVG_CLIPBOARD_FILLED = 'CLIPBOARD_FILLED';
import { default as CLIPBOARD_FILLED_rebranded } from './rebranded/js/clipboard-filled.js';
export const SVG_CLIPBOARD_OUTLINED = 'CLIPBOARD_OUTLINED';
import { default as CLIPBOARD_OUTLINED_rebranded } from './rebranded/js/clipboard-outlined.js';
export const SVG_CLOCK_FILLED = 'CLOCK_FILLED';
import { default as CLOCK_FILLED_rebranded } from './rebranded/js/clock-filled.js';
export const SVG_CLOSE_CIRCLE_FILLED = 'CLOSE_CIRCLE_FILLED';
import { default as CLOSE_CIRCLE_FILLED_rebranded } from './rebranded/js/close-circle-filled.js';
export const SVG_CLOCK_OUTLINED = 'CLOCK_OUTLINED';
import { default as CLOCK_OUTLINED_rebranded } from './rebranded/js/clock-outlined.js';
export const SVG_CLOSE_CIRCLE_OUTLINED = 'CLOSE_CIRCLE_OUTLINED';
import { default as CLOSE_CIRCLE_OUTLINED_rebranded } from './rebranded/js/close-circle-outlined.js';
export const SVG_CLOSE_FILLED = 'CLOSE_FILLED';
import { default as CLOSE_FILLED_rebranded } from './rebranded/js/close-filled.js';
export const SVG_CLOUD_FILLED = 'CLOUD_FILLED';
import { default as CLOUD_FILLED_rebranded } from './rebranded/js/cloud-filled.js';
export const SVG_CLOUD_OFF_FILLED = 'CLOUD_OFF_FILLED';
import { default as CLOUD_OFF_FILLED_rebranded } from './rebranded/js/cloud-off-filled.js';
export const SVG_CLOSE_OUTLINED = 'CLOSE_OUTLINED';
import { default as CLOSE_OUTLINED_rebranded } from './rebranded/js/close-outlined.js';
export const SVG_CLOUD_OUTLINED = 'CLOUD_OUTLINED';
import { default as CLOUD_OUTLINED_rebranded } from './rebranded/js/cloud-outlined.js';
export const SVG_CLOUD_UPLOAD_FILLED = 'CLOUD_UPLOAD_FILLED';
import { default as CLOUD_UPLOAD_FILLED_rebranded } from './rebranded/js/cloud-upload-filled.js';
export const SVG_CLOUD_OFF_OUTLINED = 'CLOUD_OFF_OUTLINED';
import { default as CLOUD_OFF_OUTLINED_rebranded } from './rebranded/js/cloud-off-outlined.js';
export const SVG_CLOUD_UPLOAD_OUTLINED = 'CLOUD_UPLOAD_OUTLINED';
import { default as CLOUD_UPLOAD_OUTLINED_rebranded } from './rebranded/js/cloud-upload-outlined.js';
export const SVG_COBY_FILLED = 'COBY_FILLED';
import { default as COBY_FILLED_rebranded } from './rebranded/js/coby-filled.js';
export const SVG_COBY_OUTLINED = 'COBY_OUTLINED';
import { default as COBY_OUTLINED_rebranded } from './rebranded/js/coby-outlined.js';
export const SVG_CODE_FILLED = 'CODE_FILLED';
import { default as CODE_FILLED_rebranded } from './rebranded/js/code-filled.js';
export const SVG_CODE_OUTLINED = 'CODE_OUTLINED';
import { default as CODE_OUTLINED_rebranded } from './rebranded/js/code-outlined.js';
export const SVG_CONFERENCE_PHONE_FILLED = 'CONFERENCE_PHONE_FILLED';
import { default as CONFERENCE_PHONE_FILLED_rebranded } from './rebranded/js/conference-phone-filled.js';
export const SVG_CONFERENCE_PHONE_OUTLINED = 'CONFERENCE_PHONE_OUTLINED';
import { default as CONFERENCE_PHONE_OUTLINED_rebranded } from './rebranded/js/conference-phone-outlined.js';
export const SVG_CONTACT_ADDRESS_BOOK_FILLED = 'CONTACT_ADDRESS_BOOK_FILLED';
import { default as CONTACT_ADDRESS_BOOK_FILLED_rebranded } from './rebranded/js/contact-address-book-filled.js';
export const SVG_COPY_FILLED = 'COPY_FILLED';
import { default as COPY_FILLED_rebranded } from './rebranded/js/copy-filled.js';
export const SVG_CONTACT_ADDRESS_BOOK_OUTLINED = 'CONTACT_ADDRESS_BOOK_OUTLINED';
import { default as CONTACT_ADDRESS_BOOK_OUTLINED_rebranded } from './rebranded/js/contact-address-book-outlined.js';
export const SVG_COPY_OUTLINED = 'COPY_OUTLINED';
import { default as COPY_OUTLINED_rebranded } from './rebranded/js/copy-outlined.js';
export const SVG_CPU_FILLED = 'CPU_FILLED';
import { default as CPU_FILLED_rebranded } from './rebranded/js/cpu-filled.js';
export const SVG_CPU_OUTLINED = 'CPU_OUTLINED';
import { default as CPU_OUTLINED_rebranded } from './rebranded/js/cpu-outlined.js';
export const SVG_CREATE_GROUP_FILLED = 'CREATE_GROUP_FILLED';
import { default as CREATE_GROUP_FILLED_rebranded } from './rebranded/js/create-group-filled.js';
export const SVG_CREATE_GROUP_OUTLINED = 'CREATE_GROUP_OUTLINED';
import { default as CREATE_GROUP_OUTLINED_rebranded } from './rebranded/js/create-group-outlined.js';
export const SVG_CROWD_OUTLINED = 'CROWD_OUTLINED';
import { default as CROWD_OUTLINED_rebranded } from './rebranded/js/crowd-outlined.js';
export const SVG_CROWD_FILLED = 'CROWD_FILLED';
import { default as CROWD_FILLED_rebranded } from './rebranded/js/crowd-filled.js';
export const SVG_CTRL_ALT_DEL_FILLED = 'CTRL_ALT_DEL_FILLED';
import { default as CTRL_ALT_DEL_FILLED_rebranded } from './rebranded/js/ctrl-alt-del-filled.js';
export const SVG_CTRL_ALT_DEL_OUTLINED = 'CTRL_ALT_DEL_OUTLINED';
import { default as CTRL_ALT_DEL_OUTLINED_rebranded } from './rebranded/js/ctrl-alt-del-outlined.js';
export const SVG_CURRENCY_EUR_FILLED = 'CURRENCY_EUR_FILLED';
import { default as CURRENCY_EUR_FILLED_rebranded } from './rebranded/js/currency-eur-filled.js';
export const SVG_CURRENCY_EUR_OUTLINED = 'CURRENCY_EUR_OUTLINED';
import { default as CURRENCY_EUR_OUTLINED_rebranded } from './rebranded/js/currency-eur-outlined.js';
export const SVG_CURRENCY_JPY_FILLED = 'CURRENCY_JPY_FILLED';
import { default as CURRENCY_JPY_FILLED_rebranded } from './rebranded/js/currency-jpy-filled.js';
export const SVG_CURRENCY_JPY_OUTLINED = 'CURRENCY_JPY_OUTLINED';
import { default as CURRENCY_JPY_OUTLINED_rebranded } from './rebranded/js/currency-jpy-outlined.js';
export const SVG_CURRENCY_UKP_FILLED = 'CURRENCY_UKP_FILLED';
import { default as CURRENCY_UKP_FILLED_rebranded } from './rebranded/js/currency-ukp-filled.js';
export const SVG_CURRENCY_UKP_OUTLINED = 'CURRENCY_UKP_OUTLINED';
import { default as CURRENCY_UKP_OUTLINED_rebranded } from './rebranded/js/currency-ukp-outlined.js';
export const SVG_CURRENCY_USD_FILLED = 'CURRENCY_USD_FILLED';
import { default as CURRENCY_USD_FILLED_rebranded } from './rebranded/js/currency-usd-filled.js';
export const SVG_CURRENCY_USD_OUTLINED = 'CURRENCY_USD_OUTLINED';
import { default as CURRENCY_USD_OUTLINED_rebranded } from './rebranded/js/currency-usd-outlined.js';
export const SVG_CURSOR_DRAG_FILLED = 'CURSOR_DRAG_FILLED';
import { default as CURSOR_DRAG_FILLED_rebranded } from './rebranded/js/cursor-drag-filled.js';
export const SVG_CURSOR_DRAG_OUTLINED = 'CURSOR_DRAG_OUTLINED';
import { default as CURSOR_DRAG_OUTLINED_rebranded } from './rebranded/js/cursor-drag-outlined.js';
export const SVG_DASHBOARD_FILLED = 'DASHBOARD_FILLED';
import { default as DASHBOARD_FILLED_rebranded } from './rebranded/js/dashboard-filled.js';
export const SVG_DASHBOARD_OUTLINED = 'DASHBOARD_OUTLINED';
import { default as DASHBOARD_OUTLINED_rebranded } from './rebranded/js/dashboard-outlined.js';
export const SVG_DATA_FILLED = 'DATA_FILLED';
import { default as DATA_FILLED_rebranded } from './rebranded/js/data-filled.js';
export const SVG_DATA_MASKING_FILLED = 'DATA_MASKING_FILLED';
import { default as DATA_MASKING_FILLED_rebranded } from './rebranded/js/data-masking-filled.js';
export const SVG_DATA_OUTLINED = 'DATA_OUTLINED';
import { default as DATA_OUTLINED_rebranded } from './rebranded/js/data-outlined.js';
export const SVG_DATA_MASKING_OUTLINED = 'DATA_MASKING_OUTLINED';
import { default as DATA_MASKING_OUTLINED_rebranded } from './rebranded/js/data-masking-outlined.js';
export const SVG_DECISION_FILLED = 'DECISION_FILLED';
import { default as DECISION_FILLED_rebranded } from './rebranded/js/decision-filled.js';
export const SVG_DECISION_OUTLINED = 'DECISION_OUTLINED';
import { default as DECISION_OUTLINED_rebranded } from './rebranded/js/decision-outlined.js';
export const SVG_DESKTOP_FILLED = 'DESKTOP_FILLED';
import { default as DESKTOP_FILLED_rebranded } from './rebranded/js/desktop-filled.js';
export const SVG_DESKTOP_OUTLINED = 'DESKTOP_OUTLINED';
import { default as DESKTOP_OUTLINED_rebranded } from './rebranded/js/desktop-outlined.js';
export const SVG_DEVICES_FILLED = 'DEVICES_FILLED';
import { default as DEVICES_FILLED_rebranded } from './rebranded/js/devices-filled.js';
export const SVG_DEVICES_OUTLINED = 'DEVICES_OUTLINED';
import { default as DEVICES_OUTLINED_rebranded } from './rebranded/js/devices-outlined.js';
export const SVG_DIAL_PAD_FILLED = 'DIAL_PAD_FILLED';
import { default as DIAL_PAD_FILLED_rebranded } from './rebranded/js/dial-pad-filled.js';
export const SVG_DIAL_PAD_OUTLINED = 'DIAL_PAD_OUTLINED';
import { default as DIAL_PAD_OUTLINED_rebranded } from './rebranded/js/dial-pad-outlined.js';
export const SVG_DOUBLE_CHEVRON_LEFT_FILLED = 'DOUBLE_CHEVRON_LEFT_FILLED';
import { default as DOUBLE_CHEVRON_LEFT_FILLED_rebranded } from './rebranded/js/double-chevron-left-filled.js';
export const SVG_DOUBLE_CHEVRON_LEFT_OUTLINED = 'DOUBLE_CHEVRON_LEFT_OUTLINED';
import { default as DOUBLE_CHEVRON_LEFT_OUTLINED_rebranded } from './rebranded/js/double-chevron-left-outlined.js';
export const SVG_DOUBLE_CHEVRON_RIGHT_FILLED = 'DOUBLE_CHEVRON_RIGHT_FILLED';
import { default as DOUBLE_CHEVRON_RIGHT_FILLED_rebranded } from './rebranded/js/double-chevron-right-filled.js';
export const SVG_DOUBLE_CHEVRON_RIGHT_OUTLINED = 'DOUBLE_CHEVRON_RIGHT_OUTLINED';
import { default as DOUBLE_CHEVRON_RIGHT_OUTLINED_rebranded } from './rebranded/js/double-chevron-right-outlined.js';
export const SVG_DOWNLOAD_FILLED = 'DOWNLOAD_FILLED';
import { default as DOWNLOAD_FILLED_rebranded } from './rebranded/js/download-filled.js';
export const SVG_DOWNLOAD_DESKTOP_APP_OUTLINED = 'DOWNLOAD_DESKTOP_APP_OUTLINED';
import { default as DOWNLOAD_DESKTOP_APP_OUTLINED_rebranded } from './rebranded/js/download-desktop-app-outlined.js';
export const SVG_DOWNLOAD_OUTLINED = 'DOWNLOAD_OUTLINED';
import { default as DOWNLOAD_OUTLINED_rebranded } from './rebranded/js/download-outlined.js';
export const SVG_DOWNLOAD_MOBILE_APP_OUTLINED = 'DOWNLOAD_MOBILE_APP_OUTLINED';
import { default as DOWNLOAD_MOBILE_APP_OUTLINED_rebranded } from './rebranded/js/download-mobile-app-outlined.js';
export const SVG_DRAG_N_DROP_OUTLINED = 'DRAG_N_DROP_OUTLINED';
import { default as DRAG_N_DROP_OUTLINED_rebranded } from './rebranded/js/drag-n-drop-outlined.js';
export const SVG_DRAG_N_DROP_FILLED = 'DRAG_N_DROP_FILLED';
import { default as DRAG_N_DROP_FILLED_rebranded } from './rebranded/js/drag-n-drop-filled.js';
export const SVG_DRAWER_LEFT_FILLED = 'DRAWER_LEFT_FILLED';
import { default as DRAWER_LEFT_FILLED_rebranded } from './rebranded/js/drawer-left-filled.js';
export const SVG_DRAWER_LEFT_OUTLINED = 'DRAWER_LEFT_OUTLINED';
import { default as DRAWER_LEFT_OUTLINED_rebranded } from './rebranded/js/drawer-left-outlined.js';
export const SVG_DRAWER_RIGHT_FILLED = 'DRAWER_RIGHT_FILLED';
import { default as DRAWER_RIGHT_FILLED_rebranded } from './rebranded/js/drawer-right-filled.js';
export const SVG_DRAWER_RIGHT_OUTLINED = 'DRAWER_RIGHT_OUTLINED';
import { default as DRAWER_RIGHT_OUTLINED_rebranded } from './rebranded/js/drawer-right-outlined.js';
export const SVG_DUAL_DISPLAY_FILLED = 'DUAL_DISPLAY_FILLED';
import { default as DUAL_DISPLAY_FILLED_rebranded } from './rebranded/js/dual-display-filled.js';
export const SVG_DUAL_DISPLAY_OUTLINED = 'DUAL_DISPLAY_OUTLINED';
import { default as DUAL_DISPLAY_OUTLINED_rebranded } from './rebranded/js/dual-display-outlined.js';
export const SVG_DUMBELL_FILLED = 'DUMBELL_FILLED';
import { default as DUMBELL_FILLED_rebranded } from './rebranded/js/dumbell-filled.js';
export const SVG_ECHO_FILLED = 'ECHO_FILLED';
import { default as ECHO_FILLED_rebranded } from './rebranded/js/echo-filled.js';
export const SVG_DUMBELL_OUTLINED = 'DUMBELL_OUTLINED';
import { default as DUMBELL_OUTLINED_rebranded } from './rebranded/js/dumbell-outlined.js';
export const SVG_ECHO_OUTLINED = 'ECHO_OUTLINED';
import { default as ECHO_OUTLINED_rebranded } from './rebranded/js/echo-outlined.js';
export const SVG_EDIT_FILLED = 'EDIT_FILLED';
import { default as EDIT_FILLED_rebranded } from './rebranded/js/edit-filled.js';
export const SVG_EDIT_OUTLINED = 'EDIT_OUTLINED';
import { default as EDIT_OUTLINED_rebranded } from './rebranded/js/edit-outlined.js';
export const SVG_EDUCATION_FILLED = 'EDUCATION_FILLED';
import { default as EDUCATION_FILLED_rebranded } from './rebranded/js/education-filled.js';
export const SVG_EMAIL_FILLED = 'EMAIL_FILLED';
import { default as EMAIL_FILLED_rebranded } from './rebranded/js/email-filled.js';
export const SVG_EDUCATION_OUTLINED = 'EDUCATION_OUTLINED';
import { default as EDUCATION_OUTLINED_rebranded } from './rebranded/js/education-outlined.js';
export const SVG_EMAIL_OUTLINED = 'EMAIL_OUTLINED';
import { default as EMAIL_OUTLINED_rebranded } from './rebranded/js/email-outlined.js';
export const SVG_EMOJI_HAPPY_OUTLINED = 'EMOJI_HAPPY_OUTLINED';
import { default as EMOJI_HAPPY_OUTLINED_rebranded } from './rebranded/js/emoji-happy-outlined.js';
export const SVG_EMOJI_HAPPY_FILLED = 'EMOJI_HAPPY_FILLED';
import { default as EMOJI_HAPPY_FILLED_rebranded } from './rebranded/js/emoji-happy-filled.js';
export const SVG_EMOJI_SAD_FILLED = 'EMOJI_SAD_FILLED';
import { default as EMOJI_SAD_FILLED_rebranded } from './rebranded/js/emoji-sad-filled.js';
export const SVG_EMOJI_SAD_OUTLINED = 'EMOJI_SAD_OUTLINED';
import { default as EMOJI_SAD_OUTLINED_rebranded } from './rebranded/js/emoji-sad-outlined.js';
export const SVG_ENCRYPTION_FILLED = 'ENCRYPTION_FILLED';
import { default as ENCRYPTION_FILLED_rebranded } from './rebranded/js/encryption-filled.js';
export const SVG_ENCRYPTION_OUTLINED = 'ENCRYPTION_OUTLINED';
import { default as ENCRYPTION_OUTLINED_rebranded } from './rebranded/js/encryption-outlined.js';
export const SVG_ENTER_FILLED = 'ENTER_FILLED';
import { default as ENTER_FILLED_rebranded } from './rebranded/js/enter-filled.js';
export const SVG_ENTER_OUTLINED = 'ENTER_OUTLINED';
import { default as ENTER_OUTLINED_rebranded } from './rebranded/js/enter-outlined.js';
export const SVG_EXECUTABLE_FILLED = 'EXECUTABLE_FILLED';
import { default as EXECUTABLE_FILLED_rebranded } from './rebranded/js/executable-filled.js';
export const SVG_EXECUTABLE_OUTLINED = 'EXECUTABLE_OUTLINED';
import { default as EXECUTABLE_OUTLINED_rebranded } from './rebranded/js/executable-outlined.js';
export const SVG_EXTERNAL_LINK_FILLED = 'EXTERNAL_LINK_FILLED';
import { default as EXTERNAL_LINK_FILLED_rebranded } from './rebranded/js/external-link-filled.js';
export const SVG_FACTORY_BUILDING_FILLED = 'FACTORY_BUILDING_FILLED';
import { default as FACTORY_BUILDING_FILLED_rebranded } from './rebranded/js/factory-building-filled.js';
export const SVG_EXTERNAL_LINK_OUTLINED = 'EXTERNAL_LINK_OUTLINED';
import { default as EXTERNAL_LINK_OUTLINED_rebranded } from './rebranded/js/external-link-outlined.js';
export const SVG_FACTORY_BUILDING_OUTLINED = 'FACTORY_BUILDING_OUTLINED';
import { default as FACTORY_BUILDING_OUTLINED_rebranded } from './rebranded/js/factory-building-outlined.js';
export const SVG_FADE_OUT_FILLED = 'FADE_OUT_FILLED';
import { default as FADE_OUT_FILLED_rebranded } from './rebranded/js/fade-out-filled.js';
export const SVG_FADE_OUT_OUTLINED = 'FADE_OUT_OUTLINED';
import { default as FADE_OUT_OUTLINED_rebranded } from './rebranded/js/fade-out-outlined.js';
export const SVG_FAST_FORWARD_FILLED = 'FAST_FORWARD_FILLED';
import { default as FAST_FORWARD_FILLED_rebranded } from './rebranded/js/fast-forward-filled.js';
export const SVG_FAST_FORWARD_OUTLINED = 'FAST_FORWARD_OUTLINED';
import { default as FAST_FORWARD_OUTLINED_rebranded } from './rebranded/js/fast-forward-outlined.js';
export const SVG_FAX_FILLED = 'FAX_FILLED';
import { default as FAX_FILLED_rebranded } from './rebranded/js/fax-filled.js';
export const SVG_FAX_OUTLINED = 'FAX_OUTLINED';
import { default as FAX_OUTLINED_rebranded } from './rebranded/js/fax-outlined.js';
export const SVG_FILE_BROWSER_FILLED = 'FILE_BROWSER_FILLED';
import { default as FILE_BROWSER_FILLED_rebranded } from './rebranded/js/file-browser-filled.js';
export const SVG_FILE_BROWSER_OUTLINED = 'FILE_BROWSER_OUTLINED';
import { default as FILE_BROWSER_OUTLINED_rebranded } from './rebranded/js/file-browser-outlined.js';
export const SVG_FILE_CSV_FILLED = 'FILE_CSV_FILLED';
import { default as FILE_CSV_FILLED_rebranded } from './rebranded/js/file-csv-filled.js';
export const SVG_FILE_CODE_OUTLINED = 'FILE_CODE_OUTLINED';
import { default as FILE_CODE_OUTLINED_rebranded } from './rebranded/js/file-code-outlined.js';
export const SVG_FILE_CODE_FILLED = 'FILE_CODE_FILLED';
import { default as FILE_CODE_FILLED_rebranded } from './rebranded/js/file-code-filled.js';
export const SVG_FILE_CSV_OUTLINED = 'FILE_CSV_OUTLINED';
import { default as FILE_CSV_OUTLINED_rebranded } from './rebranded/js/file-csv-outlined.js';
export const SVG_FILE_FILLED = 'FILE_FILLED';
import { default as FILE_FILLED_rebranded } from './rebranded/js/file-filled.js';
export const SVG_FILE_LOG_FILLED = 'FILE_LOG_FILLED';
import { default as FILE_LOG_FILLED_rebranded } from './rebranded/js/file-log-filled.js';
export const SVG_FILE_LOG_OUTLINED = 'FILE_LOG_OUTLINED';
import { default as FILE_LOG_OUTLINED_rebranded } from './rebranded/js/file-log-outlined.js';
export const SVG_FILE_OUTLINED = 'FILE_OUTLINED';
import { default as FILE_OUTLINED_rebranded } from './rebranded/js/file-outlined.js';
export const SVG_FILE_PDF_FILLED = 'FILE_PDF_FILLED';
import { default as FILE_PDF_FILLED_rebranded } from './rebranded/js/file-pdf-filled.js';
export const SVG_FILE_PDF_OUTLINED = 'FILE_PDF_OUTLINED';
import { default as FILE_PDF_OUTLINED_rebranded } from './rebranded/js/file-pdf-outlined.js';
export const SVG_FILE_PRESENTATION_FILLED = 'FILE_PRESENTATION_FILLED';
import { default as FILE_PRESENTATION_FILLED_rebranded } from './rebranded/js/file-presentation-filled.js';
export const SVG_FILE_PRESENTATION_OUTLINED = 'FILE_PRESENTATION_OUTLINED';
import { default as FILE_PRESENTATION_OUTLINED_rebranded } from './rebranded/js/file-presentation-outlined.js';
export const SVG_FILE_SOUND_FILLED = 'FILE_SOUND_FILLED';
import { default as FILE_SOUND_FILLED_rebranded } from './rebranded/js/file-sound-filled.js';
export const SVG_FILE_SOUND_OUTLINED = 'FILE_SOUND_OUTLINED';
import { default as FILE_SOUND_OUTLINED_rebranded } from './rebranded/js/file-sound-outlined.js';
export const SVG_FILE_SPREADSHEET_FILLED = 'FILE_SPREADSHEET_FILLED';
import { default as FILE_SPREADSHEET_FILLED_rebranded } from './rebranded/js/file-spreadsheet-filled.js';
export const SVG_FILE_SPREADSHEET_OUTLINED = 'FILE_SPREADSHEET_OUTLINED';
import { default as FILE_SPREADSHEET_OUTLINED_rebranded } from './rebranded/js/file-spreadsheet-outlined.js';
export const SVG_FILE_TEXT_FILLED = 'FILE_TEXT_FILLED';
import { default as FILE_TEXT_FILLED_rebranded } from './rebranded/js/file-text-filled.js';
export const SVG_FILE_TEXT_OUTLINED = 'FILE_TEXT_OUTLINED';
import { default as FILE_TEXT_OUTLINED_rebranded } from './rebranded/js/file-text-outlined.js';
export const SVG_FILE_TRANSFER_FILLED = 'FILE_TRANSFER_FILLED';
import { default as FILE_TRANSFER_FILLED_rebranded } from './rebranded/js/file-transfer-filled.js';
export const SVG_FILE_TRANSFER_OUTLINED = 'FILE_TRANSFER_OUTLINED';
import { default as FILE_TRANSFER_OUTLINED_rebranded } from './rebranded/js/file-transfer-outlined.js';
export const SVG_FILE_VIDEO_FILLED = 'FILE_VIDEO_FILLED';
import { default as FILE_VIDEO_FILLED_rebranded } from './rebranded/js/file-video-filled.js';
export const SVG_FILE_VIDEO_OUTLINED = 'FILE_VIDEO_OUTLINED';
import { default as FILE_VIDEO_OUTLINED_rebranded } from './rebranded/js/file-video-outlined.js';
export const SVG_FILTER_FILLED = 'FILTER_FILLED';
import { default as FILTER_FILLED_rebranded } from './rebranded/js/filter-filled.js';
export const SVG_FILTER_OUTLINED = 'FILTER_OUTLINED';
import { default as FILTER_OUTLINED_rebranded } from './rebranded/js/filter-outlined.js';
export const SVG_FINE_ADJUSTMENT_FILLED = 'FINE_ADJUSTMENT_FILLED';
import { default as FINE_ADJUSTMENT_FILLED_rebranded } from './rebranded/js/fine-adjustment-filled.js';
export const SVG_FINE_ADJUSTMENT_OUTLINED = 'FINE_ADJUSTMENT_OUTLINED';
import { default as FINE_ADJUSTMENT_OUTLINED_rebranded } from './rebranded/js/fine-adjustment-outlined.js';
export const SVG_FINGERPRINT_FILLED = 'FINGERPRINT_FILLED';
import { default as FINGERPRINT_FILLED_rebranded } from './rebranded/js/fingerprint-filled.js';
export const SVG_FINGERPRINT_OUTLINED = 'FINGERPRINT_OUTLINED';
import { default as FINGERPRINT_OUTLINED_rebranded } from './rebranded/js/fingerprint-outlined.js';
export const SVG_FIT_HORIZONTALLY_FILLED = 'FIT_HORIZONTALLY_FILLED';
import { default as FIT_HORIZONTALLY_FILLED_rebranded } from './rebranded/js/fit-horizontally-filled.js';
export const SVG_FIT_VERTICALLY_FILLED = 'FIT_VERTICALLY_FILLED';
import { default as FIT_VERTICALLY_FILLED_rebranded } from './rebranded/js/fit-vertically-filled.js';
export const SVG_FIT_HORIZONTALLY_OUTLINED = 'FIT_HORIZONTALLY_OUTLINED';
import { default as FIT_HORIZONTALLY_OUTLINED_rebranded } from './rebranded/js/fit-horizontally-outlined.js';
export const SVG_FIT_VERTICALLY_OUTLINED = 'FIT_VERTICALLY_OUTLINED';
import { default as FIT_VERTICALLY_OUTLINED_rebranded } from './rebranded/js/fit-vertically-outlined.js';
export const SVG_FLASHLIGHT_OFF_FILLED = 'FLASHLIGHT_OFF_FILLED';
import { default as FLASHLIGHT_OFF_FILLED_rebranded } from './rebranded/js/flashlight-off-filled.js';
export const SVG_FLASHLIGHT_ON_FILLED = 'FLASHLIGHT_ON_FILLED';
import { default as FLASHLIGHT_ON_FILLED_rebranded } from './rebranded/js/flashlight-on-filled.js';
export const SVG_FLASHLIGHT_OFF_OUTLINED = 'FLASHLIGHT_OFF_OUTLINED';
import { default as FLASHLIGHT_OFF_OUTLINED_rebranded } from './rebranded/js/flashlight-off-outlined.js';
export const SVG_FLASHLIGHT_ON_OUTLINED = 'FLASHLIGHT_ON_OUTLINED';
import { default as FLASHLIGHT_ON_OUTLINED_rebranded } from './rebranded/js/flashlight-on-outlined.js';
export const SVG_FLOWCHART_FILLED = 'FLOWCHART_FILLED';
import { default as FLOWCHART_FILLED_rebranded } from './rebranded/js/flowchart-filled.js';
export const SVG_FLOWCHART_OUTLINED = 'FLOWCHART_OUTLINED';
import { default as FLOWCHART_OUTLINED_rebranded } from './rebranded/js/flowchart-outlined.js';
export const SVG_FOLDER_ADD_FILLED = 'FOLDER_ADD_FILLED';
import { default as FOLDER_ADD_FILLED_rebranded } from './rebranded/js/folder-add-filled.js';
export const SVG_FOLDER_ADD_OUTLINED = 'FOLDER_ADD_OUTLINED';
import { default as FOLDER_ADD_OUTLINED_rebranded } from './rebranded/js/folder-add-outlined.js';
export const SVG_FOLDER_ARCHIVE_FILLED = 'FOLDER_ARCHIVE_FILLED';
import { default as FOLDER_ARCHIVE_FILLED_rebranded } from './rebranded/js/folder-archive-filled.js';
export const SVG_FOLDER_ARCHIVE_OUTLINED = 'FOLDER_ARCHIVE_OUTLINED';
import { default as FOLDER_ARCHIVE_OUTLINED_rebranded } from './rebranded/js/folder-archive-outlined.js';
export const SVG_FOLDER_EMPTY_FILLED = 'FOLDER_EMPTY_FILLED';
import { default as FOLDER_EMPTY_FILLED_rebranded } from './rebranded/js/folder-empty-filled.js';
export const SVG_FOLDER_EMPTY_OUTLINED = 'FOLDER_EMPTY_OUTLINED';
import { default as FOLDER_EMPTY_OUTLINED_rebranded } from './rebranded/js/folder-empty-outlined.js';
export const SVG_FOLDER_FILLED = 'FOLDER_FILLED';
import { default as FOLDER_FILLED_rebranded } from './rebranded/js/folder-filled.js';
export const SVG_FOLDER_MOVE_TO_FILLED = 'FOLDER_MOVE_TO_FILLED';
import { default as FOLDER_MOVE_TO_FILLED_rebranded } from './rebranded/js/folder-move-to-filled.js';
export const SVG_FOLDER_MOVE_TO_OUTLINED = 'FOLDER_MOVE_TO_OUTLINED';
import { default as FOLDER_MOVE_TO_OUTLINED_rebranded } from './rebranded/js/folder-move-to-outlined.js';
export const SVG_FOLDER_OUTLINED = 'FOLDER_OUTLINED';
import { default as FOLDER_OUTLINED_rebranded } from './rebranded/js/folder-outlined.js';
export const SVG_FOLDER_REMOVE_FILLED = 'FOLDER_REMOVE_FILLED';
import { default as FOLDER_REMOVE_FILLED_rebranded } from './rebranded/js/folder-remove-filled.js';
export const SVG_FOLDER_REMOVE_FROM_FILLED = 'FOLDER_REMOVE_FROM_FILLED';
import { default as FOLDER_REMOVE_FROM_FILLED_rebranded } from './rebranded/js/folder-remove-from-filled.js';
export const SVG_FOLDER_REMOVE_FROM_OUTLINED = 'FOLDER_REMOVE_FROM_OUTLINED';
import { default as FOLDER_REMOVE_FROM_OUTLINED_rebranded } from './rebranded/js/folder-remove-from-outlined.js';
export const SVG_FOLDER_REMOVE_OUTLINED = 'FOLDER_REMOVE_OUTLINED';
import { default as FOLDER_REMOVE_OUTLINED_rebranded } from './rebranded/js/folder-remove-outlined.js';
export const SVG_FOLDER_UP_OUTLINED = 'FOLDER_UP_OUTLINED';
import { default as FOLDER_UP_OUTLINED_rebranded } from './rebranded/js/folder-up-outlined.js';
export const SVG_FOLDER_UP_FILLED = 'FOLDER_UP_FILLED';
import { default as FOLDER_UP_FILLED_rebranded } from './rebranded/js/folder-up-filled.js';
export const SVG_FONT_FILLED = 'FONT_FILLED';
import { default as FONT_FILLED_rebranded } from './rebranded/js/font-filled.js';
export const SVG_FONT_OUTLINED = 'FONT_OUTLINED';
import { default as FONT_OUTLINED_rebranded } from './rebranded/js/font-outlined.js';
export const SVG_FROM_CHANNEL_FILLED = 'FROM_CHANNEL_FILLED';
import { default as FROM_CHANNEL_FILLED_rebranded } from './rebranded/js/from-channel-filled.js';
export const SVG_FROM_CHANNEL_OUTLINED = 'FROM_CHANNEL_OUTLINED';
import { default as FROM_CHANNEL_OUTLINED_rebranded } from './rebranded/js/from-channel-outlined.js';
export const SVG_GIFT_OUTLINED = 'GIFT_OUTLINED';
import { default as GIFT_OUTLINED_rebranded } from './rebranded/js/gift-outlined.js';
export const SVG_GLOBAL_SESSION_LIST_FILLED = 'GLOBAL_SESSION_LIST_FILLED';
import { default as GLOBAL_SESSION_LIST_FILLED_rebranded } from './rebranded/js/global-session-list-filled.js';
export const SVG_GIFT_FILLED = 'GIFT_FILLED';
import { default as GIFT_FILLED_rebranded } from './rebranded/js/gift-filled.js';
export const SVG_GLOBAL_SESSION_LIST_OUTLINED = 'GLOBAL_SESSION_LIST_OUTLINED';
import { default as GLOBAL_SESSION_LIST_OUTLINED_rebranded } from './rebranded/js/global-session-list-outlined.js';
export const SVG_GLOBE_FILLED = 'GLOBE_FILLED';
import { default as GLOBE_FILLED_rebranded } from './rebranded/js/globe-filled.js';
export const SVG_GLOBE_OUTLINED = 'GLOBE_OUTLINED';
import { default as GLOBE_OUTLINED_rebranded } from './rebranded/js/globe-outlined.js';
export const SVG_HALF_STAR_FILLED = 'HALF_STAR_FILLED';
import { default as HALF_STAR_FILLED_rebranded } from './rebranded/js/half-star-filled.js';
export const SVG_HALF_STAR_OUTLINED = 'HALF_STAR_OUTLINED';
import { default as HALF_STAR_OUTLINED_rebranded } from './rebranded/js/half-star-outlined.js';
export const SVG_HAND_LOWER_FILLED = 'HAND_LOWER_FILLED';
import { default as HAND_LOWER_FILLED_rebranded } from './rebranded/js/hand-lower-filled.js';
export const SVG_HAND_LOWER_OUTLINED = 'HAND_LOWER_OUTLINED';
import { default as HAND_LOWER_OUTLINED_rebranded } from './rebranded/js/hand-lower-outlined.js';
export const SVG_HAND_RAISE_FILLED = 'HAND_RAISE_FILLED';
import { default as HAND_RAISE_FILLED_rebranded } from './rebranded/js/hand-raise-filled.js';
export const SVG_HAND_RAISE_OUTLINED = 'HAND_RAISE_OUTLINED';
import { default as HAND_RAISE_OUTLINED_rebranded } from './rebranded/js/hand-raise-outlined.js';
export const SVG_HARD_DRIVE_FILLED = 'HARD_DRIVE_FILLED';
import { default as HARD_DRIVE_FILLED_rebranded } from './rebranded/js/hard-drive-filled.js';
export const SVG_HASHTAG_FILLED = 'HASHTAG_FILLED';
import { default as HASHTAG_FILLED_rebranded } from './rebranded/js/hashtag-filled.js';
export const SVG_HARD_DRIVE_OUTLINED = 'HARD_DRIVE_OUTLINED';
import { default as HARD_DRIVE_OUTLINED_rebranded } from './rebranded/js/hard-drive-outlined.js';
export const SVG_HASHTAG_OUTLINED = 'HASHTAG_OUTLINED';
import { default as HASHTAG_OUTLINED_rebranded } from './rebranded/js/hashtag-outlined.js';
export const SVG_HEADPHONES_FILLED = 'HEADPHONES_FILLED';
import { default as HEADPHONES_FILLED_rebranded } from './rebranded/js/headphones-filled.js';
export const SVG_HEADPHONES_OUTLINED = 'HEADPHONES_OUTLINED';
import { default as HEADPHONES_OUTLINED_rebranded } from './rebranded/js/headphones-outlined.js';
export const SVG_HEALTHCARE_FILLED = 'HEALTHCARE_FILLED';
import { default as HEALTHCARE_FILLED_rebranded } from './rebranded/js/healthcare-filled.js';
export const SVG_HEALTHCARE_OUTLINED = 'HEALTHCARE_OUTLINED';
import { default as HEALTHCARE_OUTLINED_rebranded } from './rebranded/js/healthcare-outlined.js';
export const SVG_HEART_FILLED = 'HEART_FILLED';
import { default as HEART_FILLED_rebranded } from './rebranded/js/heart-filled.js';
export const SVG_HEART_OUTLINED = 'HEART_OUTLINED';
import { default as HEART_OUTLINED_rebranded } from './rebranded/js/heart-outlined.js';
export const SVG_HELP_CIRCLE_FILLED = 'HELP_CIRCLE_FILLED';
import { default as HELP_CIRCLE_FILLED_rebranded } from './rebranded/js/help-circle-filled.js';
export const SVG_HELP_CIRCLE_OUTLINED = 'HELP_CIRCLE_OUTLINED';
import { default as HELP_CIRCLE_OUTLINED_rebranded } from './rebranded/js/help-circle-outlined.js';
export const SVG_HELP_SQUARE_FILLED = 'HELP_SQUARE_FILLED';
import { default as HELP_SQUARE_FILLED_rebranded } from './rebranded/js/help-square-filled.js';
export const SVG_HELP_SQUARE_OUTLINED = 'HELP_SQUARE_OUTLINED';
import { default as HELP_SQUARE_OUTLINED_rebranded } from './rebranded/js/help-square-outlined.js';
export const SVG_HIGHLIGHTER_FILLED = 'HIGHLIGHTER_FILLED';
import { default as HIGHLIGHTER_FILLED_rebranded } from './rebranded/js/highlighter-filled.js';
export const SVG_HIGHLIGHTER_OUTLINED = 'HIGHLIGHTER_OUTLINED';
import { default as HIGHLIGHTER_OUTLINED_rebranded } from './rebranded/js/highlighter-outlined.js';
export const SVG_HISTORY_FILLED = 'HISTORY_FILLED';
import { default as HISTORY_FILLED_rebranded } from './rebranded/js/history-filled.js';
export const SVG_HISTORY_OUTLINED = 'HISTORY_OUTLINED';
import { default as HISTORY_OUTLINED_rebranded } from './rebranded/js/history-outlined.js';
export const SVG_HOME_FILLED = 'HOME_FILLED';
import { default as HOME_FILLED_rebranded } from './rebranded/js/home-filled.js';
export const SVG_HOUSE_FILLED = 'HOUSE_FILLED';
import { default as HOUSE_FILLED_rebranded } from './rebranded/js/house-filled.js';
export const SVG_HOUSE_OUTLINED = 'HOUSE_OUTLINED';
import { default as HOUSE_OUTLINED_rebranded } from './rebranded/js/house-outlined.js';
export const SVG_HOME_OUTLINED = 'HOME_OUTLINED';
import { default as HOME_OUTLINED_rebranded } from './rebranded/js/home-outlined.js';
export const SVG_ID_CARD_FILLED = 'ID_CARD_FILLED';
import { default as ID_CARD_FILLED_rebranded } from './rebranded/js/id-card-filled.js';
export const SVG_ID_CARD_OUTLINED = 'ID_CARD_OUTLINED';
import { default as ID_CARD_OUTLINED_rebranded } from './rebranded/js/id-card-outlined.js';
export const SVG_INBOX_FILLED = 'INBOX_FILLED';
import { default as INBOX_FILLED_rebranded } from './rebranded/js/inbox-filled.js';
export const SVG_INBOX_OUTLINED = 'INBOX_OUTLINED';
import { default as INBOX_OUTLINED_rebranded } from './rebranded/js/inbox-outlined.js';
export const SVG_INFINITY_FILLED = 'INFINITY_FILLED';
import { default as INFINITY_FILLED_rebranded } from './rebranded/js/infinity-filled.js';
export const SVG_INFINITY_OUTLINED = 'INFINITY_OUTLINED';
import { default as INFINITY_OUTLINED_rebranded } from './rebranded/js/infinity-outlined.js';
export const SVG_INFO_FILLED = 'INFO_FILLED';
import { default as INFO_FILLED_rebranded } from './rebranded/js/info-filled.js';
export const SVG_INFO_OUTLINED = 'INFO_OUTLINED';
import { default as INFO_OUTLINED_rebranded } from './rebranded/js/info-outlined.js';
export const SVG_INTEGRATIONS_FILLED = 'INTEGRATIONS_FILLED';
import { default as INTEGRATIONS_FILLED_rebranded } from './rebranded/js/integrations-filled.js';
export const SVG_INTEGRATIONS_OUTLINED = 'INTEGRATIONS_OUTLINED';
import { default as INTEGRATIONS_OUTLINED_rebranded } from './rebranded/js/integrations-outlined.js';
export const SVG_JOIN_FILLED = 'JOIN_FILLED';
import { default as JOIN_FILLED_rebranded } from './rebranded/js/join-filled.js';
export const SVG_JOIN_OUTLINED = 'JOIN_OUTLINED';
import { default as JOIN_OUTLINED_rebranded } from './rebranded/js/join-outlined.js';
export const SVG_KEY_FILLED = 'KEY_FILLED';
import { default as KEY_FILLED_rebranded } from './rebranded/js/key-filled.js';
export const SVG_KEY_OUTLINED = 'KEY_OUTLINED';
import { default as KEY_OUTLINED_rebranded } from './rebranded/js/key-outlined.js';
export const SVG_KEYBOARD_FILLED = 'KEYBOARD_FILLED';
import { default as KEYBOARD_FILLED_rebranded } from './rebranded/js/keyboard-filled.js';
export const SVG_KEYBOARD_OUTLINED = 'KEYBOARD_OUTLINED';
import { default as KEYBOARD_OUTLINED_rebranded } from './rebranded/js/keyboard-outlined.js';
export const SVG_LAB_FILLED = 'LAB_FILLED';
import { default as LAB_FILLED_rebranded } from './rebranded/js/lab-filled.js';
export const SVG_LAB_OUTLINED = 'LAB_OUTLINED';
import { default as LAB_OUTLINED_rebranded } from './rebranded/js/lab-outlined.js';
export const SVG_LANDLINE_FILLED = 'LANDLINE_FILLED';
import { default as LANDLINE_FILLED_rebranded } from './rebranded/js/landline-filled.js';
export const SVG_LANDLINE_OUTLINED = 'LANDLINE_OUTLINED';
import { default as LANDLINE_OUTLINED_rebranded } from './rebranded/js/landline-outlined.js';
export const SVG_LAUNCH_FILLED = 'LAUNCH_FILLED';
import { default as LAUNCH_FILLED_rebranded } from './rebranded/js/launch-filled.js';
export const SVG_LAUNCH_OUTLINED = 'LAUNCH_OUTLINED';
import { default as LAUNCH_OUTLINED_rebranded } from './rebranded/js/launch-outlined.js';
export const SVG_LEAVE_FILLED = 'LEAVE_FILLED';
import { default as LEAVE_FILLED_rebranded } from './rebranded/js/leave-filled.js';
export const SVG_LEAVE_OUTLINED = 'LEAVE_OUTLINED';
import { default as LEAVE_OUTLINED_rebranded } from './rebranded/js/leave-outlined.js';
export const SVG_LEGAL_FILLED = 'LEGAL_FILLED';
import { default as LEGAL_FILLED_rebranded } from './rebranded/js/legal-filled.js';
export const SVG_LEGAL_OUTLINED = 'LEGAL_OUTLINED';
import { default as LEGAL_OUTLINED_rebranded } from './rebranded/js/legal-outlined.js';
export const SVG_LIGHTBULB_OFF_FILLED = 'LIGHTBULB_OFF_FILLED';
import { default as LIGHTBULB_OFF_FILLED_rebranded } from './rebranded/js/lightbulb-off-filled.js';
export const SVG_LIGHTBULB_OFF_OUTLINED = 'LIGHTBULB_OFF_OUTLINED';
import { default as LIGHTBULB_OFF_OUTLINED_rebranded } from './rebranded/js/lightbulb-off-outlined.js';
export const SVG_LIGHTBULB_ON_FILLED = 'LIGHTBULB_ON_FILLED';
import { default as LIGHTBULB_ON_FILLED_rebranded } from './rebranded/js/lightbulb-on-filled.js';
export const SVG_LIGHTBULB_ON_OUTLINED = 'LIGHTBULB_ON_OUTLINED';
import { default as LIGHTBULB_ON_OUTLINED_rebranded } from './rebranded/js/lightbulb-on-outlined.js';
export const SVG_LIGHTNING_OUTLINED = 'LIGHTNING_OUTLINED';
import { default as LIGHTNING_OUTLINED_rebranded } from './rebranded/js/lightning-outlined.js';
export const SVG_LINK_FILLED = 'LINK_FILLED';
import { default as LINK_FILLED_rebranded } from './rebranded/js/link-filled.js';
export const SVG_LINK_OUTLINED = 'LINK_OUTLINED';
import { default as LINK_OUTLINED_rebranded } from './rebranded/js/link-outlined.js';
export const SVG_LIGHTNING_FILLED = 'LIGHTNING_FILLED';
import { default as LIGHTNING_FILLED_rebranded } from './rebranded/js/lightning-filled.js';
export const SVG_LIST_FILLED = 'LIST_FILLED';
import { default as LIST_FILLED_rebranded } from './rebranded/js/list-filled.js';
export const SVG_LIST_OUTLINED = 'LIST_OUTLINED';
import { default as LIST_OUTLINED_rebranded } from './rebranded/js/list-outlined.js';
export const SVG_LOCATION_PIN_FILLED = 'LOCATION_PIN_FILLED';
import { default as LOCATION_PIN_FILLED_rebranded } from './rebranded/js/location-pin-filled.js';
export const SVG_LOCATION_PIN_OUTLINED = 'LOCATION_PIN_OUTLINED';
import { default as LOCATION_PIN_OUTLINED_rebranded } from './rebranded/js/location-pin-outlined.js';
export const SVG_LOCKED_FILLED = 'LOCKED_FILLED';
import { default as LOCKED_FILLED_rebranded } from './rebranded/js/locked-filled.js';
export const SVG_LOCKED_OUTLINED = 'LOCKED_OUTLINED';
import { default as LOCKED_OUTLINED_rebranded } from './rebranded/js/locked-outlined.js';
export const SVG_LOUDSPEAKER_FILLED = 'LOUDSPEAKER_FILLED';
import { default as LOUDSPEAKER_FILLED_rebranded } from './rebranded/js/loudspeaker-filled.js';
export const SVG_LOUDSPEAKER_OUTLINED = 'LOUDSPEAKER_OUTLINED';
import { default as LOUDSPEAKER_OUTLINED_rebranded } from './rebranded/js/loudspeaker-outlined.js';
export const SVG_MAGIC_WAND_FILLED = 'MAGIC_WAND_FILLED';
import { default as MAGIC_WAND_FILLED_rebranded } from './rebranded/js/magic-wand-filled.js';
export const SVG_MAGIC_WAND_OUTLINED = 'MAGIC_WAND_OUTLINED';
import { default as MAGIC_WAND_OUTLINED_rebranded } from './rebranded/js/magic-wand-outlined.js';
export const SVG_MAIN_SWITCH_FILLED = 'MAIN_SWITCH_FILLED';
import { default as MAIN_SWITCH_FILLED_rebranded } from './rebranded/js/main-switch-filled.js';
export const SVG_MAIN_SWITCH_OUTLINED = 'MAIN_SWITCH_OUTLINED';
import { default as MAIN_SWITCH_OUTLINED_rebranded } from './rebranded/js/main-switch-outlined.js';
export const SVG_MANAGE_LICENSES_FILLED = 'MANAGE_LICENSES_FILLED';
import { default as MANAGE_LICENSES_FILLED_rebranded } from './rebranded/js/manage-licenses-filled.js';
export const SVG_MANAGE_LICENSES_OUTLINED = 'MANAGE_LICENSES_OUTLINED';
import { default as MANAGE_LICENSES_OUTLINED_rebranded } from './rebranded/js/manage-licenses-outlined.js';
export const SVG_MEETING_ENLARGE_FILLED = 'MEETING_ENLARGE_FILLED';
import { default as MEETING_ENLARGE_FILLED_rebranded } from './rebranded/js/meeting-enlarge-filled.js';
export const SVG_MEETING_MINIFY_FILLED = 'MEETING_MINIFY_FILLED';
import { default as MEETING_MINIFY_FILLED_rebranded } from './rebranded/js/meeting-minify-filled.js';
export const SVG_MEETING_ENLARGE_OUTLINED = 'MEETING_ENLARGE_OUTLINED';
import { default as MEETING_ENLARGE_OUTLINED_rebranded } from './rebranded/js/meeting-enlarge-outlined.js';
export const SVG_MEETING_MINIFY_OUTLINED = 'MEETING_MINIFY_OUTLINED';
import { default as MEETING_MINIFY_OUTLINED_rebranded } from './rebranded/js/meeting-minify-outlined.js';
export const SVG_MERGE_FILLED = 'MERGE_FILLED';
import { default as MERGE_FILLED_rebranded } from './rebranded/js/merge-filled.js';
export const SVG_MEMORY_FILLED = 'MEMORY_FILLED';
import { default as MEMORY_FILLED_rebranded } from './rebranded/js/memory-filled.js';
export const SVG_MEMORY_OUTLINED = 'MEMORY_OUTLINED';
import { default as MEMORY_OUTLINED_rebranded } from './rebranded/js/memory-outlined.js';
export const SVG_MERGE_OUTLINED = 'MERGE_OUTLINED';
import { default as MERGE_OUTLINED_rebranded } from './rebranded/js/merge-outlined.js';
export const SVG_MESSAGE_ADD_FILLED = 'MESSAGE_ADD_FILLED';
import { default as MESSAGE_ADD_FILLED_rebranded } from './rebranded/js/message-add-filled.js';
export const SVG_MESSAGE_CONVERSATION_FILLED = 'MESSAGE_CONVERSATION_FILLED';
import { default as MESSAGE_CONVERSATION_FILLED_rebranded } from './rebranded/js/message-conversation-filled.js';
export const SVG_MESSAGE_ADD_OUTLINED = 'MESSAGE_ADD_OUTLINED';
import { default as MESSAGE_ADD_OUTLINED_rebranded } from './rebranded/js/message-add-outlined.js';
export const SVG_MESSAGE_CONVERSATION_OUTLINED = 'MESSAGE_CONVERSATION_OUTLINED';
import { default as MESSAGE_CONVERSATION_OUTLINED_rebranded } from './rebranded/js/message-conversation-outlined.js';
export const SVG_MESSAGE_DELETE_FILLED = 'MESSAGE_DELETE_FILLED';
import { default as MESSAGE_DELETE_FILLED_rebranded } from './rebranded/js/message-delete-filled.js';
export const SVG_MESSAGE_DELETE_OUTLINED = 'MESSAGE_DELETE_OUTLINED';
import { default as MESSAGE_DELETE_OUTLINED_rebranded } from './rebranded/js/message-delete-outlined.js';
export const SVG_MESSAGE_DOTS_FILLED = 'MESSAGE_DOTS_FILLED';
import { default as MESSAGE_DOTS_FILLED_rebranded } from './rebranded/js/message-dots-filled.js';
export const SVG_MESSAGE_DOTS_OUTLINED = 'MESSAGE_DOTS_OUTLINED';
import { default as MESSAGE_DOTS_OUTLINED_rebranded } from './rebranded/js/message-dots-outlined.js';
export const SVG_MESSAGE_FEEDBACK_FILLED = 'MESSAGE_FEEDBACK_FILLED';
import { default as MESSAGE_FEEDBACK_FILLED_rebranded } from './rebranded/js/message-feedback-filled.js';
export const SVG_MESSAGE_FEEDBACK_OUTLINED = 'MESSAGE_FEEDBACK_OUTLINED';
import { default as MESSAGE_FEEDBACK_OUTLINED_rebranded } from './rebranded/js/message-feedback-outlined.js';
export const SVG_MESSAGE_FILLED = 'MESSAGE_FILLED';
import { default as MESSAGE_FILLED_rebranded } from './rebranded/js/message-filled.js';
export const SVG_MESSAGE_OUTLINED = 'MESSAGE_OUTLINED';
import { default as MESSAGE_OUTLINED_rebranded } from './rebranded/js/message-outlined.js';
export const SVG_MESSAGE_QUESTION_FILLED = 'MESSAGE_QUESTION_FILLED';
import { default as MESSAGE_QUESTION_FILLED_rebranded } from './rebranded/js/message-question-filled.js';
export const SVG_MESSAGE_QUESTION_OUTLINED = 'MESSAGE_QUESTION_OUTLINED';
import { default as MESSAGE_QUESTION_OUTLINED_rebranded } from './rebranded/js/message-question-outlined.js';
export const SVG_MESSAGE_TRANSFER_FILLED = 'MESSAGE_TRANSFER_FILLED';
import { default as MESSAGE_TRANSFER_FILLED_rebranded } from './rebranded/js/message-transfer-filled.js';
export const SVG_MESSAGE_WHISPER_FILLED = 'MESSAGE_WHISPER_FILLED';
import { default as MESSAGE_WHISPER_FILLED_rebranded } from './rebranded/js/message-whisper-filled.js';
export const SVG_MESSAGE_TRANSFER_OUTLINED = 'MESSAGE_TRANSFER_OUTLINED';
import { default as MESSAGE_TRANSFER_OUTLINED_rebranded } from './rebranded/js/message-transfer-outlined.js';
export const SVG_MESSAGE_WHISPER_OUTLINED = 'MESSAGE_WHISPER_OUTLINED';
import { default as MESSAGE_WHISPER_OUTLINED_rebranded } from './rebranded/js/message-whisper-outlined.js';
export const SVG_MICROPHONE_HARDMUTED_FILLED = 'MICROPHONE_HARDMUTED_FILLED';
import { default as MICROPHONE_HARDMUTED_FILLED_rebranded } from './rebranded/js/microphone-hardmuted-filled.js';
export const SVG_MICROPHONE_HARDMUTED_OUTLINED = 'MICROPHONE_HARDMUTED_OUTLINED';
import { default as MICROPHONE_HARDMUTED_OUTLINED_rebranded } from './rebranded/js/microphone-hardmuted-outlined.js';
export const SVG_MICROPHONE_OFF_OUTLINED = 'MICROPHONE_OFF_OUTLINED';
import { default as MICROPHONE_OFF_OUTLINED_rebranded } from './rebranded/js/microphone-off-outlined.js';
export const SVG_MICROPHONE_ON_FILLED = 'MICROPHONE_ON_FILLED';
import { default as MICROPHONE_ON_FILLED_rebranded } from './rebranded/js/microphone-on-filled.js';
export const SVG_MICROPHONE_OFF_FILLED = 'MICROPHONE_OFF_FILLED';
import { default as MICROPHONE_OFF_FILLED_rebranded } from './rebranded/js/microphone-off-filled.js';
export const SVG_MOBILE_SCAN_FILLED = 'MOBILE_SCAN_FILLED';
import { default as MOBILE_SCAN_FILLED_rebranded } from './rebranded/js/mobile-scan-filled.js';
export const SVG_MICROPHONE_ON_OUTLINED = 'MICROPHONE_ON_OUTLINED';
import { default as MICROPHONE_ON_OUTLINED_rebranded } from './rebranded/js/microphone-on-outlined.js';
export const SVG_MOBILE_SCAN_OUTLINED = 'MOBILE_SCAN_OUTLINED';
import { default as MOBILE_SCAN_OUTLINED_rebranded } from './rebranded/js/mobile-scan-outlined.js';
export const SVG_MOBILE_SUPPORT_FILLED = 'MOBILE_SUPPORT_FILLED';
import { default as MOBILE_SUPPORT_FILLED_rebranded } from './rebranded/js/mobile-support-filled.js';
export const SVG_MOBILE_SUPPORT_OUTLINED = 'MOBILE_SUPPORT_OUTLINED';
import { default as MOBILE_SUPPORT_OUTLINED_rebranded } from './rebranded/js/mobile-support-outlined.js';
export const SVG_MOON_FILLED = 'MOON_FILLED';
import { default as MOON_FILLED_rebranded } from './rebranded/js/moon-filled.js';
export const SVG_MORE_MENU_HAMBURGER_FILLED = 'MORE_MENU_HAMBURGER_FILLED';
import { default as MORE_MENU_HAMBURGER_FILLED_rebranded } from './rebranded/js/more-menu-hamburger-filled.js';
export const SVG_MOON_OUTLINED = 'MOON_OUTLINED';
import { default as MOON_OUTLINED_rebranded } from './rebranded/js/moon-outlined.js';
export const SVG_MORE_MENU_HORIZONTAL_FILLED = 'MORE_MENU_HORIZONTAL_FILLED';
import { default as MORE_MENU_HORIZONTAL_FILLED_rebranded } from './rebranded/js/more-menu-horizontal-filled.js';
export const SVG_MORE_MENU_HAMBURGER_OUTLINED = 'MORE_MENU_HAMBURGER_OUTLINED';
import { default as MORE_MENU_HAMBURGER_OUTLINED_rebranded } from './rebranded/js/more-menu-hamburger-outlined.js';
export const SVG_MORE_MENU_HORIZONTAL_OUTLINED = 'MORE_MENU_HORIZONTAL_OUTLINED';
import { default as MORE_MENU_HORIZONTAL_OUTLINED_rebranded } from './rebranded/js/more-menu-horizontal-outlined.js';
export const SVG_MORE_MENU_VERTICAL_FILLED = 'MORE_MENU_VERTICAL_FILLED';
import { default as MORE_MENU_VERTICAL_FILLED_rebranded } from './rebranded/js/more-menu-vertical-filled.js';
export const SVG_MORE_MENU_VERTICAL_OUTLINED = 'MORE_MENU_VERTICAL_OUTLINED';
import { default as MORE_MENU_VERTICAL_OUTLINED_rebranded } from './rebranded/js/more-menu-vertical-outlined.js';
export const SVG_MOUSE_FILLED = 'MOUSE_FILLED';
import { default as MOUSE_FILLED_rebranded } from './rebranded/js/mouse-filled.js';
export const SVG_MOUSE_OUTLINED = 'MOUSE_OUTLINED';
import { default as MOUSE_OUTLINED_rebranded } from './rebranded/js/mouse-outlined.js';
export const SVG_MUSIC_FILLED = 'MUSIC_FILLED';
import { default as MUSIC_FILLED_rebranded } from './rebranded/js/music-filled.js';
export const SVG_MUSIC_OUTLINED = 'MUSIC_OUTLINED';
import { default as MUSIC_OUTLINED_rebranded } from './rebranded/js/music-outlined.js';
export const SVG_NETWORK_FILLED = 'NETWORK_FILLED';
import { default as NETWORK_FILLED_rebranded } from './rebranded/js/network-filled.js';
export const SVG_NETWORK_OUTLINED = 'NETWORK_OUTLINED';
import { default as NETWORK_OUTLINED_rebranded } from './rebranded/js/network-outlined.js';
export const SVG_NOTE_FILLED = 'NOTE_FILLED';
import { default as NOTE_FILLED_rebranded } from './rebranded/js/note-filled.js';
export const SVG_NOTE_OUTLINED = 'NOTE_OUTLINED';
import { default as NOTE_OUTLINED_rebranded } from './rebranded/js/note-outlined.js';
export const SVG_NOTEPAD_OUTLINED = 'NOTEPAD_OUTLINED';
import { default as NOTEPAD_OUTLINED_rebranded } from './rebranded/js/notepad-outlined.js';
export const SVG_NOTEPAD_FILLED = 'NOTEPAD_FILLED';
import { default as NOTEPAD_FILLED_rebranded } from './rebranded/js/notepad-filled.js';
export const SVG_NOTIFICATIONS_ALERT_FILLED = 'NOTIFICATIONS_ALERT_FILLED';
import { default as NOTIFICATIONS_ALERT_FILLED_rebranded } from './rebranded/js/notifications-alert-filled.js';
export const SVG_NOTIFICATIONS_ALERT_OUTLINED = 'NOTIFICATIONS_ALERT_OUTLINED';
import { default as NOTIFICATIONS_ALERT_OUTLINED_rebranded } from './rebranded/js/notifications-alert-outlined.js';
export const SVG_NOTIFICATIONS_FILLED = 'NOTIFICATIONS_FILLED';
import { default as NOTIFICATIONS_FILLED_rebranded } from './rebranded/js/notifications-filled.js';
export const SVG_NOTIFICATIONS_OUTLINED = 'NOTIFICATIONS_OUTLINED';
import { default as NOTIFICATIONS_OUTLINED_rebranded } from './rebranded/js/notifications-outlined.js';
export const SVG_NPA_FILLED = 'NPA_FILLED';
import { default as NPA_FILLED_rebranded } from './rebranded/js/npa-filled.js';
export const SVG_NPA_OUTLINED = 'NPA_OUTLINED';
import { default as NPA_OUTLINED_rebranded } from './rebranded/js/npa-outlined.js';
export const SVG_NUMBERED_ARROW_FILLED = 'NUMBERED_ARROW_FILLED';
import { default as NUMBERED_ARROW_FILLED_rebranded } from './rebranded/js/numbered-arrow-filled.js';
export const SVG_NUMBERED_ARROW_OUTLINED = 'NUMBERED_ARROW_OUTLINED';
import { default as NUMBERED_ARROW_OUTLINED_rebranded } from './rebranded/js/numbered-arrow-outlined.js';
export const SVG_OFFICE_BUILDING_FILLED = 'OFFICE_BUILDING_FILLED';
import { default as OFFICE_BUILDING_FILLED_rebranded } from './rebranded/js/office-building-filled.js';
export const SVG_OFFICE_BUILDING_OUTLINED = 'OFFICE_BUILDING_OUTLINED';
import { default as OFFICE_BUILDING_OUTLINED_rebranded } from './rebranded/js/office-building-outlined.js';
export const SVG_ORDERED_LIST_FILLED = 'ORDERED_LIST_FILLED';
import { default as ORDERED_LIST_FILLED_rebranded } from './rebranded/js/ordered-list-filled.js';
export const SVG_ORDERED_LIST_OUTLINED = 'ORDERED_LIST_OUTLINED';
import { default as ORDERED_LIST_OUTLINED_rebranded } from './rebranded/js/ordered-list-outlined.js';
export const SVG_PAINT_FILLED = 'PAINT_FILLED';
import { default as PAINT_FILLED_rebranded } from './rebranded/js/paint-filled.js';
export const SVG_PAINT_OUTLINED = 'PAINT_OUTLINED';
import { default as PAINT_OUTLINED_rebranded } from './rebranded/js/paint-outlined.js';
export const SVG_PALETTE_FILLED = 'PALETTE_FILLED';
import { default as PALETTE_FILLED_rebranded } from './rebranded/js/palette-filled.js';
export const SVG_PALETTE_OUTLINED = 'PALETTE_OUTLINED';
import { default as PALETTE_OUTLINED_rebranded } from './rebranded/js/palette-outlined.js';
export const SVG_PAPERCLIP_FILLED = 'PAPERCLIP_FILLED';
import { default as PAPERCLIP_FILLED_rebranded } from './rebranded/js/paperclip-filled.js';
export const SVG_PAPERCLIP_OUTLINED = 'PAPERCLIP_OUTLINED';
import { default as PAPERCLIP_OUTLINED_rebranded } from './rebranded/js/paperclip-outlined.js';
export const SVG_PAUSE_CIRCLE_FILLED = 'PAUSE_CIRCLE_FILLED';
import { default as PAUSE_CIRCLE_FILLED_rebranded } from './rebranded/js/pause-circle-filled.js';
export const SVG_PAUSE_CIRCLE_OUTLINED = 'PAUSE_CIRCLE_OUTLINED';
import { default as PAUSE_CIRCLE_OUTLINED_rebranded } from './rebranded/js/pause-circle-outlined.js';
export const SVG_PAUSE_FILLED = 'PAUSE_FILLED';
import { default as PAUSE_FILLED_rebranded } from './rebranded/js/pause-filled.js';
export const SVG_PAUSE_OUTLINED = 'PAUSE_OUTLINED';
import { default as PAUSE_OUTLINED_rebranded } from './rebranded/js/pause-outlined.js';
export const SVG_PAYMENT_DUE_FILLED = 'PAYMENT_DUE_FILLED';
import { default as PAYMENT_DUE_FILLED_rebranded } from './rebranded/js/payment-due-filled.js';
export const SVG_PBX_FILLED = 'PBX_FILLED';
import { default as PBX_FILLED_rebranded } from './rebranded/js/pbx-filled.js';
export const SVG_PAYMENT_DUE_OUTLINED = 'PAYMENT_DUE_OUTLINED';
import { default as PAYMENT_DUE_OUTLINED_rebranded } from './rebranded/js/payment-due-outlined.js';
export const SVG_PBX_OUTLINED = 'PBX_OUTLINED';
import { default as PBX_OUTLINED_rebranded } from './rebranded/js/pbx-outlined.js';
export const SVG_PEOPLE_FILLED = 'PEOPLE_FILLED';
import { default as PEOPLE_FILLED_rebranded } from './rebranded/js/people-filled.js';
export const SVG_PERSON_ASSIGN_FILLED = 'PERSON_ASSIGN_FILLED';
import { default as PERSON_ASSIGN_FILLED_rebranded } from './rebranded/js/person-assign-filled.js';
export const SVG_PEOPLE_OUTLINED = 'PEOPLE_OUTLINED';
import { default as PEOPLE_OUTLINED_rebranded } from './rebranded/js/people-outlined.js';
export const SVG_PERSON_ASSIGN_OUTLINED = 'PERSON_ASSIGN_OUTLINED';
import { default as PERSON_ASSIGN_OUTLINED_rebranded } from './rebranded/js/person-assign-outlined.js';
export const SVG_PERSON_CHECKMARK_FILLED = 'PERSON_CHECKMARK_FILLED';
import { default as PERSON_CHECKMARK_FILLED_rebranded } from './rebranded/js/person-checkmark-filled.js';
export const SVG_PERSON_CHECKMARK_OUTLINED = 'PERSON_CHECKMARK_OUTLINED';
import { default as PERSON_CHECKMARK_OUTLINED_rebranded } from './rebranded/js/person-checkmark-outlined.js';
export const SVG_PERSON_FILLED = 'PERSON_FILLED';
import { default as PERSON_FILLED_rebranded } from './rebranded/js/person-filled.js';
export const SVG_PERSON_OUTLINED = 'PERSON_OUTLINED';
import { default as PERSON_OUTLINED_rebranded } from './rebranded/js/person-outlined.js';
export const SVG_PERSON_TRANSFER_FILLED = 'PERSON_TRANSFER_FILLED';
import { default as PERSON_TRANSFER_FILLED_rebranded } from './rebranded/js/person-transfer-filled.js';
export const SVG_PERSON_TRANSFER_OUTLINED = 'PERSON_TRANSFER_OUTLINED';
import { default as PERSON_TRANSFER_OUTLINED_rebranded } from './rebranded/js/person-transfer-outlined.js';
export const SVG_PHONE_CONNECTED_FILLED = 'PHONE_CONNECTED_FILLED';
import { default as PHONE_CONNECTED_FILLED_rebranded } from './rebranded/js/phone-connected-filled.js';
export const SVG_PHONE_ADD_OUTLINED = 'PHONE_ADD_OUTLINED';
import { default as PHONE_ADD_OUTLINED_rebranded } from './rebranded/js/phone-add-outlined.js';
export const SVG_PHONE_ADD_FILLED = 'PHONE_ADD_FILLED';
import { default as PHONE_ADD_FILLED_rebranded } from './rebranded/js/phone-add-filled.js';
export const SVG_PHONE_CONNECTED_OUTLINED = 'PHONE_CONNECTED_OUTLINED';
import { default as PHONE_CONNECTED_OUTLINED_rebranded } from './rebranded/js/phone-connected-outlined.js';
export const SVG_PHONE_FAILED_FILLED = 'PHONE_FAILED_FILLED';
import { default as PHONE_FAILED_FILLED_rebranded } from './rebranded/js/phone-failed-filled.js';
export const SVG_PHONE_FAILED_OUTLINED = 'PHONE_FAILED_OUTLINED';
import { default as PHONE_FAILED_OUTLINED_rebranded } from './rebranded/js/phone-failed-outlined.js';
export const SVG_PHONE_HANG_UP_FILLED = 'PHONE_HANG_UP_FILLED';
import { default as PHONE_HANG_UP_FILLED_rebranded } from './rebranded/js/phone-hang-up-filled.js';
export const SVG_PHONE_HANG_UP_OUTLINED = 'PHONE_HANG_UP_OUTLINED';
import { default as PHONE_HANG_UP_OUTLINED_rebranded } from './rebranded/js/phone-hang-up-outlined.js';
export const SVG_PHONE_INCOMING_FILLED = 'PHONE_INCOMING_FILLED';
import { default as PHONE_INCOMING_FILLED_rebranded } from './rebranded/js/phone-incoming-filled.js';
export const SVG_PHONE_INCOMING_OUTLINED = 'PHONE_INCOMING_OUTLINED';
import { default as PHONE_INCOMING_OUTLINED_rebranded } from './rebranded/js/phone-incoming-outlined.js';
export const SVG_PHONE_MESSAGE_OUTLINED = 'PHONE_MESSAGE_OUTLINED';
import { default as PHONE_MESSAGE_OUTLINED_rebranded } from './rebranded/js/phone-message-outlined.js';
export const SVG_PHONE_NUMBER_FILLED = 'PHONE_NUMBER_FILLED';
import { default as PHONE_NUMBER_FILLED_rebranded } from './rebranded/js/phone-number-filled.js';
export const SVG_PHONE_NUMBER_OUTLINED = 'PHONE_NUMBER_OUTLINED';
import { default as PHONE_NUMBER_OUTLINED_rebranded } from './rebranded/js/phone-number-outlined.js';
export const SVG_PHONE_MESSAGE_FILLED = 'PHONE_MESSAGE_FILLED';
import { default as PHONE_MESSAGE_FILLED_rebranded } from './rebranded/js/phone-message-filled.js';
export const SVG_PHONE_OFF_FILLED = 'PHONE_OFF_FILLED';
import { default as PHONE_OFF_FILLED_rebranded } from './rebranded/js/phone-off-filled.js';
export const SVG_PHONE_OFF_OUTLINED = 'PHONE_OFF_OUTLINED';
import { default as PHONE_OFF_OUTLINED_rebranded } from './rebranded/js/phone-off-outlined.js';
export const SVG_PHONE_OUTGOING_FILLED = 'PHONE_OUTGOING_FILLED';
import { default as PHONE_OUTGOING_FILLED_rebranded } from './rebranded/js/phone-outgoing-filled.js';
export const SVG_PHONE_OUTGOING_OUTLINED = 'PHONE_OUTGOING_OUTLINED';
import { default as PHONE_OUTGOING_OUTLINED_rebranded } from './rebranded/js/phone-outgoing-outlined.js';
export const SVG_PHONE_PARK_FILLED = 'PHONE_PARK_FILLED';
import { default as PHONE_PARK_FILLED_rebranded } from './rebranded/js/phone-park-filled.js';
export const SVG_PHONE_PARK_OUTLINED = 'PHONE_PARK_OUTLINED';
import { default as PHONE_PARK_OUTLINED_rebranded } from './rebranded/js/phone-park-outlined.js';
export const SVG_PHONE_PAUSE_FILLED = 'PHONE_PAUSE_FILLED';
import { default as PHONE_PAUSE_FILLED_rebranded } from './rebranded/js/phone-pause-filled.js';
export const SVG_PHONE_TRANSFER_FILLED = 'PHONE_TRANSFER_FILLED';
import { default as PHONE_TRANSFER_FILLED_rebranded } from './rebranded/js/phone-transfer-filled.js';
export const SVG_PHONE_PAUSE_OUTLINED = 'PHONE_PAUSE_OUTLINED';
import { default as PHONE_PAUSE_OUTLINED_rebranded } from './rebranded/js/phone-pause-outlined.js';
export const SVG_PHONE_TRANSFER_OUTLINED = 'PHONE_TRANSFER_OUTLINED';
import { default as PHONE_TRANSFER_OUTLINED_rebranded } from './rebranded/js/phone-transfer-outlined.js';
export const SVG_PICTURE_FILLED = 'PICTURE_FILLED';
import { default as PICTURE_FILLED_rebranded } from './rebranded/js/picture-filled.js';
export const SVG_PHONE_UP_OUTLINED = 'PHONE_UP_OUTLINED';
import { default as PHONE_UP_OUTLINED_rebranded } from './rebranded/js/phone-up-outlined.js';
export const SVG_PICTURE_OFF_FILLED = 'PICTURE_OFF_FILLED';
import { default as PICTURE_OFF_FILLED_rebranded } from './rebranded/js/picture-off-filled.js';
export const SVG_PHONE_UP_FILLED = 'PHONE_UP_FILLED';
import { default as PHONE_UP_FILLED_rebranded } from './rebranded/js/phone-up-filled.js';
export const SVG_PIE_CHART_OUTLINED = 'PIE_CHART_OUTLINED';
import { default as PIE_CHART_OUTLINED_rebranded } from './rebranded/js/pie-chart-outlined.js';
export const SVG_PICTURE_OUTLINED = 'PICTURE_OUTLINED';
import { default as PICTURE_OUTLINED_rebranded } from './rebranded/js/picture-outlined.js';
export const SVG_PIE_CHART_FILLED = 'PIE_CHART_FILLED';
import { default as PIE_CHART_FILLED_rebranded } from './rebranded/js/pie-chart-filled.js';
export const SVG_PICTURE_OFF_OUTLINED = 'PICTURE_OFF_OUTLINED';
import { default as PICTURE_OFF_OUTLINED_rebranded } from './rebranded/js/picture-off-outlined.js';
export const SVG_PIP_MAXIMIZE_FILLED = 'PIP_MAXIMIZE_FILLED';
import { default as PIP_MAXIMIZE_FILLED_rebranded } from './rebranded/js/pip-maximize-filled.js';
export const SVG_PIP_MAXIMIZE_OUTLINED = 'PIP_MAXIMIZE_OUTLINED';
import { default as PIP_MAXIMIZE_OUTLINED_rebranded } from './rebranded/js/pip-maximize-outlined.js';
export const SVG_PIP_MINIMIZE_OUTLINED = 'PIP_MINIMIZE_OUTLINED';
import { default as PIP_MINIMIZE_OUTLINED_rebranded } from './rebranded/js/pip-minimize-outlined.js';
export const SVG_PIP_MINIMIZE_FILLED = 'PIP_MINIMIZE_FILLED';
import { default as PIP_MINIMIZE_FILLED_rebranded } from './rebranded/js/pip-minimize-filled.js';
export const SVG_PLACEHOLDER_OUTLINED = 'PLACEHOLDER_OUTLINED';
import { default as PLACEHOLDER_OUTLINED_rebranded } from './rebranded/js/placeholder-outlined.js';
export const SVG_PLACEHOLDER_FILLED = 'PLACEHOLDER_FILLED';
import { default as PLACEHOLDER_FILLED_rebranded } from './rebranded/js/placeholder-filled.js';
export const SVG_PLAY_CIRCLE_FILLED = 'PLAY_CIRCLE_FILLED';
import { default as PLAY_CIRCLE_FILLED_rebranded } from './rebranded/js/play-circle-filled.js';
export const SVG_PLAY_FILLED = 'PLAY_FILLED';
import { default as PLAY_FILLED_rebranded } from './rebranded/js/play-filled.js';
export const SVG_PLAY_CIRCLE_OUTLINED = 'PLAY_CIRCLE_OUTLINED';
import { default as PLAY_CIRCLE_OUTLINED_rebranded } from './rebranded/js/play-circle-outlined.js';
export const SVG_PLAY_OUTLINED = 'PLAY_OUTLINED';
import { default as PLAY_OUTLINED_rebranded } from './rebranded/js/play-outlined.js';
export const SVG_POINTER_OFF_FILLED = 'POINTER_OFF_FILLED';
import { default as POINTER_OFF_FILLED_rebranded } from './rebranded/js/pointer-off-filled.js';
export const SVG_POINTER_OFF_OUTLINED = 'POINTER_OFF_OUTLINED';
import { default as POINTER_OFF_OUTLINED_rebranded } from './rebranded/js/pointer-off-outlined.js';
export const SVG_POINTER_WINDOWS_OFF_FILLED = 'POINTER_WINDOWS_OFF_FILLED';
import { default as POINTER_WINDOWS_OFF_FILLED_rebranded } from './rebranded/js/pointer-windows-off-filled.js';
export const SVG_POINTER_ON_FILLED = 'POINTER_ON_FILLED';
import { default as POINTER_ON_FILLED_rebranded } from './rebranded/js/pointer-on-filled.js';
export const SVG_POINTER_ON_OUTLINED = 'POINTER_ON_OUTLINED';
import { default as POINTER_ON_OUTLINED_rebranded } from './rebranded/js/pointer-on-outlined.js';
export const SVG_POINTER_WINDOWS_OFF_OUTLINED = 'POINTER_WINDOWS_OFF_OUTLINED';
import { default as POINTER_WINDOWS_OFF_OUTLINED_rebranded } from './rebranded/js/pointer-windows-off-outlined.js';
export const SVG_POINTER_WINDOWS_ON_FILLED = 'POINTER_WINDOWS_ON_FILLED';
import { default as POINTER_WINDOWS_ON_FILLED_rebranded } from './rebranded/js/pointer-windows-on-filled.js';
export const SVG_POLLS_FILLED = 'POLLS_FILLED';
import { default as POLLS_FILLED_rebranded } from './rebranded/js/polls-filled.js';
export const SVG_POINTER_WINDOWS_ON_OUTLINED = 'POINTER_WINDOWS_ON_OUTLINED';
import { default as POINTER_WINDOWS_ON_OUTLINED_rebranded } from './rebranded/js/pointer-windows-on-outlined.js';
export const SVG_POP_IN_FILLED = 'POP_IN_FILLED';
import { default as POP_IN_FILLED_rebranded } from './rebranded/js/pop-in-filled.js';
export const SVG_POLLS_OUTLINED = 'POLLS_OUTLINED';
import { default as POLLS_OUTLINED_rebranded } from './rebranded/js/polls-outlined.js';
export const SVG_POP_IN_OUTLINED = 'POP_IN_OUTLINED';
import { default as POP_IN_OUTLINED_rebranded } from './rebranded/js/pop-in-outlined.js';
export const SVG_POP_OUT_CAMERA_OUTLINED = 'POP_OUT_CAMERA_OUTLINED';
import { default as POP_OUT_CAMERA_OUTLINED_rebranded } from './rebranded/js/pop-out-camera-outlined.js';
export const SVG_POP_OUT_FILLED = 'POP_OUT_FILLED';
import { default as POP_OUT_FILLED_rebranded } from './rebranded/js/pop-out-filled.js';
export const SVG_POP_OUT_CAMERA_FILLED = 'POP_OUT_CAMERA_FILLED';
import { default as POP_OUT_CAMERA_FILLED_rebranded } from './rebranded/js/pop-out-camera-filled.js';
export const SVG_POP_OUT_OUTLINED = 'POP_OUT_OUTLINED';
import { default as POP_OUT_OUTLINED_rebranded } from './rebranded/js/pop-out-outlined.js';
export const SVG_POP_OUT_WINDOW_FILLED = 'POP_OUT_WINDOW_FILLED';
import { default as POP_OUT_WINDOW_FILLED_rebranded } from './rebranded/js/pop-out-window-filled.js';
export const SVG_POSITION_TV_BOTTOM_OUTLINED = 'POSITION_TV_BOTTOM_OUTLINED';
import { default as POSITION_TV_BOTTOM_OUTLINED_rebranded } from './rebranded/js/position-tv-bottom-outlined.js';
export const SVG_POP_OUT_WINDOW_OUTLINED = 'POP_OUT_WINDOW_OUTLINED';
import { default as POP_OUT_WINDOW_OUTLINED_rebranded } from './rebranded/js/pop-out-window-outlined.js';
export const SVG_POSITION_TV_BOTTOM_FILLED = 'POSITION_TV_BOTTOM_FILLED';
import { default as POSITION_TV_BOTTOM_FILLED_rebranded } from './rebranded/js/position-tv-bottom-filled.js';
export const SVG_POSITION_TV_LEFT_FILLED = 'POSITION_TV_LEFT_FILLED';
import { default as POSITION_TV_LEFT_FILLED_rebranded } from './rebranded/js/position-tv-left-filled.js';
export const SVG_POSITION_TV_LEFT_OUTLINED = 'POSITION_TV_LEFT_OUTLINED';
import { default as POSITION_TV_LEFT_OUTLINED_rebranded } from './rebranded/js/position-tv-left-outlined.js';
export const SVG_POSITION_TV_TOP_FILLED = 'POSITION_TV_TOP_FILLED';
import { default as POSITION_TV_TOP_FILLED_rebranded } from './rebranded/js/position-tv-top-filled.js';
export const SVG_POSITION_TV_RIGHT_FILLED = 'POSITION_TV_RIGHT_FILLED';
import { default as POSITION_TV_RIGHT_FILLED_rebranded } from './rebranded/js/position-tv-right-filled.js';
export const SVG_POSITION_TV_TOP_OUTLINED = 'POSITION_TV_TOP_OUTLINED';
import { default as POSITION_TV_TOP_OUTLINED_rebranded } from './rebranded/js/position-tv-top-outlined.js';
export const SVG_POSITION_TV_RIGHT_OUTLINED = 'POSITION_TV_RIGHT_OUTLINED';
import { default as POSITION_TV_RIGHT_OUTLINED_rebranded } from './rebranded/js/position-tv-right-outlined.js';
export const SVG_PRESENTATION_OUTLINED = 'PRESENTATION_OUTLINED';
import { default as PRESENTATION_OUTLINED_rebranded } from './rebranded/js/presentation-outlined.js';
export const SVG_PRESENTATION_FILLED = 'PRESENTATION_FILLED';
import { default as PRESENTATION_FILLED_rebranded } from './rebranded/js/presentation-filled.js';
export const SVG_PRIVATE_FILLED = 'PRIVATE_FILLED';
import { default as PRIVATE_FILLED_rebranded } from './rebranded/js/private-filled.js';
export const SVG_PRIVATE_OUTLINED = 'PRIVATE_OUTLINED';
import { default as PRIVATE_OUTLINED_rebranded } from './rebranded/js/private-outlined.js';
export const SVG_PUSHPIN_FILLED = 'PUSHPIN_FILLED';
import { default as PUSHPIN_FILLED_rebranded } from './rebranded/js/pushpin-filled.js';
export const SVG_QUESTION_OUTLINED = 'QUESTION_OUTLINED';
import { default as QUESTION_OUTLINED_rebranded } from './rebranded/js/question-outlined.js';
export const SVG_PUSHPIN_OUTLINED = 'PUSHPIN_OUTLINED';
import { default as PUSHPIN_OUTLINED_rebranded } from './rebranded/js/pushpin-outlined.js';
export const SVG_QUESTION_FILLED = 'QUESTION_FILLED';
import { default as QUESTION_FILLED_rebranded } from './rebranded/js/question-filled.js';
export const SVG_READER_FILLED = 'READER_FILLED';
import { default as READER_FILLED_rebranded } from './rebranded/js/reader-filled.js';
export const SVG_READER_OUTLINED = 'READER_OUTLINED';
import { default as READER_OUTLINED_rebranded } from './rebranded/js/reader-outlined.js';
export const SVG_RECORD_CIRCLE_FILLED = 'RECORD_CIRCLE_FILLED';
import { default as RECORD_CIRCLE_FILLED_rebranded } from './rebranded/js/record-circle-filled.js';
export const SVG_RECORD_CIRCLE_OUTLINED = 'RECORD_CIRCLE_OUTLINED';
import { default as RECORD_CIRCLE_OUTLINED_rebranded } from './rebranded/js/record-circle-outlined.js';
export const SVG_RECORDING_OUTLINED = 'RECORDING_OUTLINED';
import { default as RECORDING_OUTLINED_rebranded } from './rebranded/js/recording-outlined.js';
export const SVG_RECORDING_FILLED = 'RECORDING_FILLED';
import { default as RECORDING_FILLED_rebranded } from './rebranded/js/recording-filled.js';
export const SVG_RECORDING_TAPE_OUTLINED = 'RECORDING_TAPE_OUTLINED';
import { default as RECORDING_TAPE_OUTLINED_rebranded } from './rebranded/js/recording-tape-outlined.js';
export const SVG_RECORDING_TAPE_FILLED = 'RECORDING_TAPE_FILLED';
import { default as RECORDING_TAPE_FILLED_rebranded } from './rebranded/js/recording-tape-filled.js';
export const SVG_REDO_FILLED = 'REDO_FILLED';
import { default as REDO_FILLED_rebranded } from './rebranded/js/redo-filled.js';
export const SVG_REFRESH_FILLED = 'REFRESH_FILLED';
import { default as REFRESH_FILLED_rebranded } from './rebranded/js/refresh-filled.js';
export const SVG_REDO_OUTLINED = 'REDO_OUTLINED';
import { default as REDO_OUTLINED_rebranded } from './rebranded/js/redo-outlined.js';
export const SVG_REMOTE_SUPPORT_FILLED = 'REMOTE_SUPPORT_FILLED';
import { default as REMOTE_SUPPORT_FILLED_rebranded } from './rebranded/js/remote-support-filled.js';
export const SVG_REFRESH_OUTLINED = 'REFRESH_OUTLINED';
import { default as REFRESH_OUTLINED_rebranded } from './rebranded/js/refresh-outlined.js';
export const SVG_REMOTE_SUPPORT_OUTLINED = 'REMOTE_SUPPORT_OUTLINED';
import { default as REMOTE_SUPPORT_OUTLINED_rebranded } from './rebranded/js/remote-support-outlined.js';
export const SVG_REPLY_FILLED = 'REPLY_FILLED';
import { default as REPLY_FILLED_rebranded } from './rebranded/js/reply-filled.js';
export const SVG_REPORT_FILLED = 'REPORT_FILLED';
import { default as REPORT_FILLED_rebranded } from './rebranded/js/report-filled.js';
export const SVG_REPLY_OUTLINED = 'REPLY_OUTLINED';
import { default as REPLY_OUTLINED_rebranded } from './rebranded/js/reply-outlined.js';
export const SVG_REPORT_OUTLINED = 'REPORT_OUTLINED';
import { default as REPORT_OUTLINED_rebranded } from './rebranded/js/report-outlined.js';
export const SVG_RESTORE_OUTLINED = 'RESTORE_OUTLINED';
import { default as RESTORE_OUTLINED_rebranded } from './rebranded/js/restore-outlined.js';
export const SVG_RESTORE_FILLED = 'RESTORE_FILLED';
import { default as RESTORE_FILLED_rebranded } from './rebranded/js/restore-filled.js';
export const SVG_REWIND_FILLED = 'REWIND_FILLED';
import { default as REWIND_FILLED_rebranded } from './rebranded/js/rewind-filled.js';
export const SVG_REWIND_OUTLINED = 'REWIND_OUTLINED';
import { default as REWIND_OUTLINED_rebranded } from './rebranded/js/rewind-outlined.js';
export const SVG_ROOM_PHYSICAL_FILLED = 'ROOM_PHYSICAL_FILLED';
import { default as ROOM_PHYSICAL_FILLED_rebranded } from './rebranded/js/room-physical-filled.js';
export const SVG_ROOM_PHYSICAL_OUTLINED = 'ROOM_PHYSICAL_OUTLINED';
import { default as ROOM_PHYSICAL_OUTLINED_rebranded } from './rebranded/js/room-physical-outlined.js';
export const SVG_ROTATE_CCW_FILLED = 'ROTATE_CCW_FILLED';
import { default as ROTATE_CCW_FILLED_rebranded } from './rebranded/js/rotate-ccw-filled.js';
export const SVG_ROTATE_CW_FILLED = 'ROTATE_CW_FILLED';
import { default as ROTATE_CW_FILLED_rebranded } from './rebranded/js/rotate-cw-filled.js';
export const SVG_ROTATE_CCW_OUTLINED = 'ROTATE_CCW_OUTLINED';
import { default as ROTATE_CCW_OUTLINED_rebranded } from './rebranded/js/rotate-ccw-outlined.js';
export const SVG_ROTATE_CW_OUTLINED = 'ROTATE_CW_OUTLINED';
import { default as ROTATE_CW_OUTLINED_rebranded } from './rebranded/js/rotate-cw-outlined.js';
export const SVG_ROUTER_FILLED = 'ROUTER_FILLED';
import { default as ROUTER_FILLED_rebranded } from './rebranded/js/router-filled.js';
export const SVG_ROUTER_OUTLINED = 'ROUTER_OUTLINED';
import { default as ROUTER_OUTLINED_rebranded } from './rebranded/js/router-outlined.js';
export const SVG_SALES_QUOTE_FILLED = 'SALES_QUOTE_FILLED';
import { default as SALES_QUOTE_FILLED_rebranded } from './rebranded/js/sales-quote-filled.js';
export const SVG_SALES_QUOTE_OUTLINED = 'SALES_QUOTE_OUTLINED';
import { default as SALES_QUOTE_OUTLINED_rebranded } from './rebranded/js/sales-quote-outlined.js';
export const SVG_SAVE_FILLED = 'SAVE_FILLED';
import { default as SAVE_FILLED_rebranded } from './rebranded/js/save-filled.js';
export const SVG_SAVE_OUTLINED = 'SAVE_OUTLINED';
import { default as SAVE_OUTLINED_rebranded } from './rebranded/js/save-outlined.js';
export const SVG_SCREEN_ADD_FILLED = 'SCREEN_ADD_FILLED';
import { default as SCREEN_ADD_FILLED_rebranded } from './rebranded/js/screen-add-filled.js';
export const SVG_SCREEN_ADD_OUTLINED = 'SCREEN_ADD_OUTLINED';
import { default as SCREEN_ADD_OUTLINED_rebranded } from './rebranded/js/screen-add-outlined.js';
export const SVG_SCREEN_CAST_FILLED = 'SCREEN_CAST_FILLED';
import { default as SCREEN_CAST_FILLED_rebranded } from './rebranded/js/screen-cast-filled.js';
export const SVG_SCREEN_FILLED = 'SCREEN_FILLED';
import { default as SCREEN_FILLED_rebranded } from './rebranded/js/screen-filled.js';
export const SVG_SCREEN_CAST_OUTLINED = 'SCREEN_CAST_OUTLINED';
import { default as SCREEN_CAST_OUTLINED_rebranded } from './rebranded/js/screen-cast-outlined.js';
export const SVG_SCREEN_INFO_FILLED = 'SCREEN_INFO_FILLED';
import { default as SCREEN_INFO_FILLED_rebranded } from './rebranded/js/screen-info-filled.js';
export const SVG_SCREEN_LIGHTNING_FILLED = 'SCREEN_LIGHTNING_FILLED';
import { default as SCREEN_LIGHTNING_FILLED_rebranded } from './rebranded/js/screen-lightning-filled.js';
export const SVG_SCREEN_INFO_OUTLINED = 'SCREEN_INFO_OUTLINED';
import { default as SCREEN_INFO_OUTLINED_rebranded } from './rebranded/js/screen-info-outlined.js';
export const SVG_SCREEN_LIGHTNING_OUTLINED = 'SCREEN_LIGHTNING_OUTLINED';
import { default as SCREEN_LIGHTNING_OUTLINED_rebranded } from './rebranded/js/screen-lightning-outlined.js';
export const SVG_SCREEN_MIRRORING_FILLED = 'SCREEN_MIRRORING_FILLED';
import { default as SCREEN_MIRRORING_FILLED_rebranded } from './rebranded/js/screen-mirroring-filled.js';
export const SVG_SCREEN_MIRRORING_OUTLINED = 'SCREEN_MIRRORING_OUTLINED';
import { default as SCREEN_MIRRORING_OUTLINED_rebranded } from './rebranded/js/screen-mirroring-outlined.js';
export const SVG_SCREEN_OUTLINED = 'SCREEN_OUTLINED';
import { default as SCREEN_OUTLINED_rebranded } from './rebranded/js/screen-outlined.js';
export const SVG_SCREEN_PAUSE_OUTLINED = 'SCREEN_PAUSE_OUTLINED';
import { default as SCREEN_PAUSE_OUTLINED_rebranded } from './rebranded/js/screen-pause-outlined.js';
export const SVG_SCREEN_PLAY_OFF_FILLED = 'SCREEN_PLAY_OFF_FILLED';
import { default as SCREEN_PLAY_OFF_FILLED_rebranded } from './rebranded/js/screen-play-off-filled.js';
export const SVG_SCREEN_PLAY_ON_FILLED = 'SCREEN_PLAY_ON_FILLED';
import { default as SCREEN_PLAY_ON_FILLED_rebranded } from './rebranded/js/screen-play-on-filled.js';
export const SVG_SCREEN_PLAY_OFF_OUTLINED = 'SCREEN_PLAY_OFF_OUTLINED';
import { default as SCREEN_PLAY_OFF_OUTLINED_rebranded } from './rebranded/js/screen-play-off-outlined.js';
export const SVG_SCREEN_PLAY_ON_OUTLINED = 'SCREEN_PLAY_ON_OUTLINED';
import { default as SCREEN_PLAY_ON_OUTLINED_rebranded } from './rebranded/js/screen-play-on-outlined.js';
export const SVG_SCREEN_PAUSE_FILLED = 'SCREEN_PAUSE_FILLED';
import { default as SCREEN_PAUSE_FILLED_rebranded } from './rebranded/js/screen-pause-filled.js';
export const SVG_SCREEN_REBOOT_FILLED = 'SCREEN_REBOOT_FILLED';
import { default as SCREEN_REBOOT_FILLED_rebranded } from './rebranded/js/screen-reboot-filled.js';
export const SVG_SCREEN_SHARING_FILLED = 'SCREEN_SHARING_FILLED';
import { default as SCREEN_SHARING_FILLED_rebranded } from './rebranded/js/screen-sharing-filled.js';
export const SVG_SCREEN_SHARING_OUTLINED = 'SCREEN_SHARING_OUTLINED';
import { default as SCREEN_SHARING_OUTLINED_rebranded } from './rebranded/js/screen-sharing-outlined.js';
export const SVG_SCREEN_REBOOT_OUTLINED = 'SCREEN_REBOOT_OUTLINED';
import { default as SCREEN_REBOOT_OUTLINED_rebranded } from './rebranded/js/screen-reboot-outlined.js';
export const SVG_SCREEN_SLIDERS_FILLED = 'SCREEN_SLIDERS_FILLED';
import { default as SCREEN_SLIDERS_FILLED_rebranded } from './rebranded/js/screen-sliders-filled.js';
export const SVG_SCREEN_SLIDERS_OUTLINED = 'SCREEN_SLIDERS_OUTLINED';
import { default as SCREEN_SLIDERS_OUTLINED_rebranded } from './rebranded/js/screen-sliders-outlined.js';
export const SVG_SCREEN_SNAPSHOT_FILLED = 'SCREEN_SNAPSHOT_FILLED';
import { default as SCREEN_SNAPSHOT_FILLED_rebranded } from './rebranded/js/screen-snapshot-filled.js';
export const SVG_SCREEN_SNAPSHOT_OUTLINED = 'SCREEN_SNAPSHOT_OUTLINED';
import { default as SCREEN_SNAPSHOT_OUTLINED_rebranded } from './rebranded/js/screen-snapshot-outlined.js';
export const SVG_SCREEN_STOP_FILLED = 'SCREEN_STOP_FILLED';
import { default as SCREEN_STOP_FILLED_rebranded } from './rebranded/js/screen-stop-filled.js';
export const SVG_SCREEN_STOP_OUTLINED = 'SCREEN_STOP_OUTLINED';
import { default as SCREEN_STOP_OUTLINED_rebranded } from './rebranded/js/screen-stop-outlined.js';
export const SVG_SCREEN_VIEWING_OUTLINED = 'SCREEN_VIEWING_OUTLINED';
import { default as SCREEN_VIEWING_OUTLINED_rebranded } from './rebranded/js/screen-viewing-outlined.js';
export const SVG_SEARCH_FILLED = 'SEARCH_FILLED';
import { default as SEARCH_FILLED_rebranded } from './rebranded/js/search-filled.js';
export const SVG_SEARCH_OUTLINED = 'SEARCH_OUTLINED';
import { default as SEARCH_OUTLINED_rebranded } from './rebranded/js/search-outlined.js';
export const SVG_SEND_FILLED = 'SEND_FILLED';
import { default as SEND_FILLED_rebranded } from './rebranded/js/send-filled.js';
export const SVG_SCREEN_VIEWING_FILLED = 'SCREEN_VIEWING_FILLED';
import { default as SCREEN_VIEWING_FILLED_rebranded } from './rebranded/js/screen-viewing-filled.js';
export const SVG_SEND_OUTLINED = 'SEND_OUTLINED';
import { default as SEND_OUTLINED_rebranded } from './rebranded/js/send-outlined.js';
export const SVG_SERVER_FILLED = 'SERVER_FILLED';
import { default as SERVER_FILLED_rebranded } from './rebranded/js/server-filled.js';
export const SVG_SERVER_OUTLINED = 'SERVER_OUTLINED';
import { default as SERVER_OUTLINED_rebranded } from './rebranded/js/server-outlined.js';
export const SVG_SETTINGS_FILLED = 'SETTINGS_FILLED';
import { default as SETTINGS_FILLED_rebranded } from './rebranded/js/settings-filled.js';
export const SVG_SETTINGS_OUTLINED = 'SETTINGS_OUTLINED';
import { default as SETTINGS_OUTLINED_rebranded } from './rebranded/js/settings-outlined.js';
export const SVG_SHARE_ARROW_FILLED = 'SHARE_ARROW_FILLED';
import { default as SHARE_ARROW_FILLED_rebranded } from './rebranded/js/share-arrow-filled.js';
export const SVG_SHARE_ARROW_OUTLINED = 'SHARE_ARROW_OUTLINED';
import { default as SHARE_ARROW_OUTLINED_rebranded } from './rebranded/js/share-arrow-outlined.js';
export const SVG_SHARE_FILLED = 'SHARE_FILLED';
import { default as SHARE_FILLED_rebranded } from './rebranded/js/share-filled.js';
export const SVG_SHARE_OUTLINED = 'SHARE_OUTLINED';
import { default as SHARE_OUTLINED_rebranded } from './rebranded/js/share-outlined.js';
export const SVG_SHIELD_FILLED = 'SHIELD_FILLED';
import { default as SHIELD_FILLED_rebranded } from './rebranded/js/shield-filled.js';
export const SVG_SHIELD_OUTLINED = 'SHIELD_OUTLINED';
import { default as SHIELD_OUTLINED_rebranded } from './rebranded/js/shield-outlined.js';
export const SVG_SHOPPING_CART_FILLED = 'SHOPPING_CART_FILLED';
import { default as SHOPPING_CART_FILLED_rebranded } from './rebranded/js/shopping-cart-filled.js';
export const SVG_SHUFFLE_FILLED = 'SHUFFLE_FILLED';
import { default as SHUFFLE_FILLED_rebranded } from './rebranded/js/shuffle-filled.js';
export const SVG_SHOPPING_CART_OUTLINED = 'SHOPPING_CART_OUTLINED';
import { default as SHOPPING_CART_OUTLINED_rebranded } from './rebranded/js/shopping-cart-outlined.js';
export const SVG_SHUFFLE_OUTLINED = 'SHUFFLE_OUTLINED';
import { default as SHUFFLE_OUTLINED_rebranded } from './rebranded/js/shuffle-outlined.js';
export const SVG_SIGN_OUT_FILLED = 'SIGN_OUT_FILLED';
import { default as SIGN_OUT_FILLED_rebranded } from './rebranded/js/sign-out-filled.js';
export const SVG_SIGN_OUT_OUTLINED = 'SIGN_OUT_OUTLINED';
import { default as SIGN_OUT_OUTLINED_rebranded } from './rebranded/js/sign-out-outlined.js';
export const SVG_SKIP_NEXT_FILLED = 'SKIP_NEXT_FILLED';
import { default as SKIP_NEXT_FILLED_rebranded } from './rebranded/js/skip-next-filled.js';
export const SVG_SKIP_NEXT_OUTLINED = 'SKIP_NEXT_OUTLINED';
import { default as SKIP_NEXT_OUTLINED_rebranded } from './rebranded/js/skip-next-outlined.js';
export const SVG_SKIP_PREVIOUS_FILLED = 'SKIP_PREVIOUS_FILLED';
import { default as SKIP_PREVIOUS_FILLED_rebranded } from './rebranded/js/skip-previous-filled.js';
export const SVG_SMALL_ARROW_DOWN_FILLED = 'SMALL_ARROW_DOWN_FILLED';
import { default as SMALL_ARROW_DOWN_FILLED_rebranded } from './rebranded/js/small-arrow-down-filled.js';
export const SVG_SKIP_PREVIOUS_OUTLINED = 'SKIP_PREVIOUS_OUTLINED';
import { default as SKIP_PREVIOUS_OUTLINED_rebranded } from './rebranded/js/skip-previous-outlined.js';
export const SVG_SMALL_ARROW_LEFT_FILLED = 'SMALL_ARROW_LEFT_FILLED';
import { default as SMALL_ARROW_LEFT_FILLED_rebranded } from './rebranded/js/small-arrow-left-filled.js';
export const SVG_SMALL_ARROW_LEFT_OUTLINED = 'SMALL_ARROW_LEFT_OUTLINED';
import { default as SMALL_ARROW_LEFT_OUTLINED_rebranded } from './rebranded/js/small-arrow-left-outlined.js';
export const SVG_SMALL_ARROW_DOWN_OUTLINED = 'SMALL_ARROW_DOWN_OUTLINED';
import { default as SMALL_ARROW_DOWN_OUTLINED_rebranded } from './rebranded/js/small-arrow-down-outlined.js';
export const SVG_SMALL_ARROW_RIGHT_FILLED = 'SMALL_ARROW_RIGHT_FILLED';
import { default as SMALL_ARROW_RIGHT_FILLED_rebranded } from './rebranded/js/small-arrow-right-filled.js';
export const SVG_SMALL_ARROW_RIGHT_OUTLINED = 'SMALL_ARROW_RIGHT_OUTLINED';
import { default as SMALL_ARROW_RIGHT_OUTLINED_rebranded } from './rebranded/js/small-arrow-right-outlined.js';
export const SVG_SMALL_ARROW_UP_FILLED = 'SMALL_ARROW_UP_FILLED';
import { default as SMALL_ARROW_UP_FILLED_rebranded } from './rebranded/js/small-arrow-up-filled.js';
export const SVG_SMALL_ARROW_UP_OUTLINED = 'SMALL_ARROW_UP_OUTLINED';
import { default as SMALL_ARROW_UP_OUTLINED_rebranded } from './rebranded/js/small-arrow-up-outlined.js';
export const SVG_SMARTPHONE_OUTLINED = 'SMARTPHONE_OUTLINED';
import { default as SMARTPHONE_OUTLINED_rebranded } from './rebranded/js/smartphone-outlined.js';
export const SVG_SMARTPHONE_FILLED = 'SMARTPHONE_FILLED';
import { default as SMARTPHONE_FILLED_rebranded } from './rebranded/js/smartphone-filled.js';
export const SVG_SNOOZE_FILLED = 'SNOOZE_FILLED';
import { default as SNOOZE_FILLED_rebranded } from './rebranded/js/snooze-filled.js';
export const SVG_SNOOZE_OUTLINED = 'SNOOZE_OUTLINED';
import { default as SNOOZE_OUTLINED_rebranded } from './rebranded/js/snooze-outlined.js';
export const SVG_SPACES_FILLED = 'SPACES_FILLED';
import { default as SPACES_FILLED_rebranded } from './rebranded/js/spaces-filled.js';
export const SVG_SPEAKER_OFF_FILLED = 'SPEAKER_OFF_FILLED';
import { default as SPEAKER_OFF_FILLED_rebranded } from './rebranded/js/speaker-off-filled.js';
export const SVG_SPEAKER_OFF_OUTLINED = 'SPEAKER_OFF_OUTLINED';
import { default as SPEAKER_OFF_OUTLINED_rebranded } from './rebranded/js/speaker-off-outlined.js';
export const SVG_SPACES_OUTLINED = 'SPACES_OUTLINED';
import { default as SPACES_OUTLINED_rebranded } from './rebranded/js/spaces-outlined.js';
export const SVG_SPEAKER_ON_FILLED = 'SPEAKER_ON_FILLED';
import { default as SPEAKER_ON_FILLED_rebranded } from './rebranded/js/speaker-on-filled.js';
export const SVG_SPEAKER_ON_OUTLINED = 'SPEAKER_ON_OUTLINED';
import { default as SPEAKER_ON_OUTLINED_rebranded } from './rebranded/js/speaker-on-outlined.js';
export const SVG_SPEAKING_OUTLINED = 'SPEAKING_OUTLINED';
import { default as SPEAKING_OUTLINED_rebranded } from './rebranded/js/speaking-outlined.js';
export const SVG_SPEAKING_FILLED = 'SPEAKING_FILLED';
import { default as SPEAKING_FILLED_rebranded } from './rebranded/js/speaking-filled.js';
export const SVG_STAR_OUTLINED = 'STAR_OUTLINED';
import { default as STAR_OUTLINED_rebranded } from './rebranded/js/star-outlined.js';
export const SVG_STOP_FILLED = 'STOP_FILLED';
import { default as STOP_FILLED_rebranded } from './rebranded/js/stop-filled.js';
export const SVG_STOP_CIRCLE_FILLED = 'STOP_CIRCLE_FILLED';
import { default as STOP_CIRCLE_FILLED_rebranded } from './rebranded/js/stop-circle-filled.js';
export const SVG_STOP_OUTLINED = 'STOP_OUTLINED';
import { default as STOP_OUTLINED_rebranded } from './rebranded/js/stop-outlined.js';
export const SVG_STOP_CIRCLE_OUTLINED = 'STOP_CIRCLE_OUTLINED';
import { default as STOP_CIRCLE_OUTLINED_rebranded } from './rebranded/js/stop-circle-outlined.js';
export const SVG_STRETCH_EXIT_FULLSCREEN_FILLED = 'STRETCH_EXIT_FULLSCREEN_FILLED';
import { default as STRETCH_EXIT_FULLSCREEN_FILLED_rebranded } from './rebranded/js/stretch-exit-fullscreen-filled.js';
export const SVG_STRETCH_COLLAPSE_OUTLINED = 'STRETCH_COLLAPSE_OUTLINED';
import { default as STRETCH_COLLAPSE_OUTLINED_rebranded } from './rebranded/js/stretch-collapse-outlined.js';
export const SVG_STRETCH_EXIT_FULLSCREEN_OUTLINED = 'STRETCH_EXIT_FULLSCREEN_OUTLINED';
import { default as STRETCH_EXIT_FULLSCREEN_OUTLINED_rebranded } from './rebranded/js/stretch-exit-fullscreen-outlined.js';
export const SVG_STRETCH_COLLAPSE_FILLED = 'STRETCH_COLLAPSE_FILLED';
import { default as STRETCH_COLLAPSE_FILLED_rebranded } from './rebranded/js/stretch-collapse-filled.js';
export const SVG_STRETCH_EXPAND_FILLED = 'STRETCH_EXPAND_FILLED';
import { default as STRETCH_EXPAND_FILLED_rebranded } from './rebranded/js/stretch-expand-filled.js';
export const SVG_STRETCH_FULLSCREEN_OUTLINED = 'STRETCH_FULLSCREEN_OUTLINED';
import { default as STRETCH_FULLSCREEN_OUTLINED_rebranded } from './rebranded/js/stretch-fullscreen-outlined.js';
export const SVG_STRETCH_EXPAND_OUTLINED = 'STRETCH_EXPAND_OUTLINED';
import { default as STRETCH_EXPAND_OUTLINED_rebranded } from './rebranded/js/stretch-expand-outlined.js';
export const SVG_STRETCH_FULLSCREEN_FILLED = 'STRETCH_FULLSCREEN_FILLED';
import { default as STRETCH_FULLSCREEN_FILLED_rebranded } from './rebranded/js/stretch-fullscreen-filled.js';
export const SVG_SUBTRACT_FILLED = 'SUBTRACT_FILLED';
import { default as SUBTRACT_FILLED_rebranded } from './rebranded/js/subtract-filled.js';
export const SVG_SUBTRACT_OUTLINED = 'SUBTRACT_OUTLINED';
import { default as SUBTRACT_OUTLINED_rebranded } from './rebranded/js/subtract-outlined.js';
export const SVG_SUN_OUTLINED = 'SUN_OUTLINED';
import { default as SUN_OUTLINED_rebranded } from './rebranded/js/sun-outlined.js';
export const SVG_SUN_FILLED = 'SUN_FILLED';
import { default as SUN_FILLED_rebranded } from './rebranded/js/sun-filled.js';
export const SVG_SWAP_OUTLINED = 'SWAP_OUTLINED';
import { default as SWAP_OUTLINED_rebranded } from './rebranded/js/swap-outlined.js';
export const SVG_SWAP_FILLED = 'SWAP_FILLED';
import { default as SWAP_FILLED_rebranded } from './rebranded/js/swap-filled.js';
export const SVG_SYNC_FILLED = 'SYNC_FILLED';
import { default as SYNC_FILLED_rebranded } from './rebranded/js/sync-filled.js';
export const SVG_SYNCHRONIZED_FILLED = 'SYNCHRONIZED_FILLED';
import { default as SYNCHRONIZED_FILLED_rebranded } from './rebranded/js/synchronized-filled.js';
export const SVG_SYNC_OUTLINED = 'SYNC_OUTLINED';
import { default as SYNC_OUTLINED_rebranded } from './rebranded/js/sync-outlined.js';
export const SVG_SYNCHRONIZED_OUTLINED = 'SYNCHRONIZED_OUTLINED';
import { default as SYNCHRONIZED_OUTLINED_rebranded } from './rebranded/js/synchronized-outlined.js';
export const SVG_TAG_FILLED = 'TAG_FILLED';
import { default as TAG_FILLED_rebranded } from './rebranded/js/tag-filled.js';
export const SVG_TAX_EXEMPTION_OUTLINED = 'TAX_EXEMPTION_OUTLINED';
import { default as TAX_EXEMPTION_OUTLINED_rebranded } from './rebranded/js/tax-exemption-outlined.js';
export const SVG_TAG_OUTLINED = 'TAG_OUTLINED';
import { default as TAG_OUTLINED_rebranded } from './rebranded/js/tag-outlined.js';
export const SVG_TAX_EXEMPTION_FILLED = 'TAX_EXEMPTION_FILLED';
import { default as TAX_EXEMPTION_FILLED_rebranded } from './rebranded/js/tax-exemption-filled.js';
export const SVG_TEST_FILLED = 'TEST_FILLED';
import { default as TEST_FILLED_rebranded } from './rebranded/js/test-filled.js';
export const SVG_TEST_OUTLINED = 'TEST_OUTLINED';
import { default as TEST_OUTLINED_rebranded } from './rebranded/js/test-outlined.js';
export const SVG_TEXT_BOLD_FILLED = 'TEXT_BOLD_FILLED';
import { default as TEXT_BOLD_FILLED_rebranded } from './rebranded/js/text-bold-filled.js';
export const SVG_TEXT_FIELD_FILLED = 'TEXT_FIELD_FILLED';
import { default as TEXT_FIELD_FILLED_rebranded } from './rebranded/js/text-field-filled.js';
export const SVG_TEXT_BOLD_OUTLINED = 'TEXT_BOLD_OUTLINED';
import { default as TEXT_BOLD_OUTLINED_rebranded } from './rebranded/js/text-bold-outlined.js';
export const SVG_TEXT_FIELD_OUTLINED = 'TEXT_FIELD_OUTLINED';
import { default as TEXT_FIELD_OUTLINED_rebranded } from './rebranded/js/text-field-outlined.js';
export const SVG_TEXT_FILLED = 'TEXT_FILLED';
import { default as TEXT_FILLED_rebranded } from './rebranded/js/text-filled.js';
export const SVG_TEXT_ITALIC_FILLED = 'TEXT_ITALIC_FILLED';
import { default as TEXT_ITALIC_FILLED_rebranded } from './rebranded/js/text-italic-filled.js';
export const SVG_TEXT_STRIKETHROUGH_FILLED = 'TEXT_STRIKETHROUGH_FILLED';
import { default as TEXT_STRIKETHROUGH_FILLED_rebranded } from './rebranded/js/text-strikethrough-filled.js';
export const SVG_TEXT_ITALIC_OUTLINED = 'TEXT_ITALIC_OUTLINED';
import { default as TEXT_ITALIC_OUTLINED_rebranded } from './rebranded/js/text-italic-outlined.js';
export const SVG_TEXT_OUTLINED = 'TEXT_OUTLINED';
import { default as TEXT_OUTLINED_rebranded } from './rebranded/js/text-outlined.js';
export const SVG_TEXT_STRIKETHROUGH_OUTLINED = 'TEXT_STRIKETHROUGH_OUTLINED';
import { default as TEXT_STRIKETHROUGH_OUTLINED_rebranded } from './rebranded/js/text-strikethrough-outlined.js';
export const SVG_THEMES_FILLED = 'THEMES_FILLED';
import { default as THEMES_FILLED_rebranded } from './rebranded/js/themes-filled.js';
export const SVG_THUMBS_DOWN_OUTLINED = 'THUMBS_DOWN_OUTLINED';
import { default as THUMBS_DOWN_OUTLINED_rebranded } from './rebranded/js/thumbs-down-outlined.js';
export const SVG_THUMBS_DOWN_FILLED = 'THUMBS_DOWN_FILLED';
import { default as THUMBS_DOWN_FILLED_rebranded } from './rebranded/js/thumbs-down-filled.js';
export const SVG_THEMES_OUTLINED = 'THEMES_OUTLINED';
import { default as THEMES_OUTLINED_rebranded } from './rebranded/js/themes-outlined.js';
export const SVG_THUMBS_UP_FILLED = 'THUMBS_UP_FILLED';
import { default as THUMBS_UP_FILLED_rebranded } from './rebranded/js/thumbs-up-filled.js';
export const SVG_THUMBS_UP_OUTLINED = 'THUMBS_UP_OUTLINED';
import { default as THUMBS_UP_OUTLINED_rebranded } from './rebranded/js/thumbs-up-outlined.js';
export const SVG_TIME_LIMIT_FILLED = 'TIME_LIMIT_FILLED';
import { default as TIME_LIMIT_FILLED_rebranded } from './rebranded/js/time-limit-filled.js';
export const SVG_TICKET_FILLED = 'TICKET_FILLED';
import { default as TICKET_FILLED_rebranded } from './rebranded/js/ticket-filled.js';
export const SVG_TICKET_OUTLINED = 'TICKET_OUTLINED';
import { default as TICKET_OUTLINED_rebranded } from './rebranded/js/ticket-outlined.js';
export const SVG_TIME_LIMIT_OUTLINED = 'TIME_LIMIT_OUTLINED';
import { default as TIME_LIMIT_OUTLINED_rebranded } from './rebranded/js/time-limit-outlined.js';
export const SVG_TRASH_FILLED = 'TRASH_FILLED';
import { default as TRASH_FILLED_rebranded } from './rebranded/js/trash-filled.js';
export const SVG_TRENDING_OUTLINED = 'TRENDING_OUTLINED';
import { default as TRENDING_OUTLINED_rebranded } from './rebranded/js/trending-outlined.js';
export const SVG_TRENDING_FILLED = 'TRENDING_FILLED';
import { default as TRENDING_FILLED_rebranded } from './rebranded/js/trending-filled.js';
export const SVG_TRASH_OUTLINED = 'TRASH_OUTLINED';
import { default as TRASH_OUTLINED_rebranded } from './rebranded/js/trash-outlined.js';
export const SVG_UNDO_FILLED = 'UNDO_FILLED';
import { default as UNDO_FILLED_rebranded } from './rebranded/js/undo-filled.js';
export const SVG_UNDO_OUTLINED = 'UNDO_OUTLINED';
import { default as UNDO_OUTLINED_rebranded } from './rebranded/js/undo-outlined.js';
export const SVG_UNLOCKED_OUTLINED = 'UNLOCKED_OUTLINED';
import { default as UNLOCKED_OUTLINED_rebranded } from './rebranded/js/unlocked-outlined.js';
export const SVG_UNLOCKED_FILLED = 'UNLOCKED_FILLED';
import { default as UNLOCKED_FILLED_rebranded } from './rebranded/js/unlocked-filled.js';
export const SVG_UPLOAD_FILLED = 'UPLOAD_FILLED';
import { default as UPLOAD_FILLED_rebranded } from './rebranded/js/upload-filled.js';
export const SVG_VECTOR_FILLED = 'VECTOR_FILLED';
import { default as VECTOR_FILLED_rebranded } from './rebranded/js/vector-filled.js';
export const SVG_UPLOAD_OUTLINED = 'UPLOAD_OUTLINED';
import { default as UPLOAD_OUTLINED_rebranded } from './rebranded/js/upload-outlined.js';
export const SVG_VECTOR_OUTLINED = 'VECTOR_OUTLINED';
import { default as VECTOR_OUTLINED_rebranded } from './rebranded/js/vector-outlined.js';
export const SVG_VIEW_GRID_FILLED = 'VIEW_GRID_FILLED';
import { default as VIEW_GRID_FILLED_rebranded } from './rebranded/js/view-grid-filled.js';
export const SVG_VIEW_GRID_OUTLINED = 'VIEW_GRID_OUTLINED';
import { default as VIEW_GRID_OUTLINED_rebranded } from './rebranded/js/view-grid-outlined.js';
export const SVG_VIEW_SWITCH_CAMERAS_OUTLINED = 'VIEW_SWITCH_CAMERAS_OUTLINED';
import { default as VIEW_SWITCH_CAMERAS_OUTLINED_rebranded } from './rebranded/js/view-switch-cameras-outlined.js';
export const SVG_VIEW_SWITCH_CAMERAS_FILLED = 'VIEW_SWITCH_CAMERAS_FILLED';
import { default as VIEW_SWITCH_CAMERAS_FILLED_rebranded } from './rebranded/js/view-switch-cameras-filled.js';
export const SVG_VIEW_SWITCH_EVERYONE_OUTLINED = 'VIEW_SWITCH_EVERYONE_OUTLINED';
import { default as VIEW_SWITCH_EVERYONE_OUTLINED_rebranded } from './rebranded/js/view-switch-everyone-outlined.js';
export const SVG_VIEW_SWITCH_FILMSTRIP_FILLED = 'VIEW_SWITCH_FILMSTRIP_FILLED';
import { default as VIEW_SWITCH_FILMSTRIP_FILLED_rebranded } from './rebranded/js/view-switch-filmstrip-filled.js';
export const SVG_VIEW_SWITCH_EVERYONE_FILLED = 'VIEW_SWITCH_EVERYONE_FILLED';
import { default as VIEW_SWITCH_EVERYONE_FILLED_rebranded } from './rebranded/js/view-switch-everyone-filled.js';
export const SVG_VIEW_SWITCH_FILMSTRIP_OUTLINED = 'VIEW_SWITCH_FILMSTRIP_OUTLINED';
import { default as VIEW_SWITCH_FILMSTRIP_OUTLINED_rebranded } from './rebranded/js/view-switch-filmstrip-outlined.js';
export const SVG_VIEW_SWITCH_HIDE_ALL_FILLED = 'VIEW_SWITCH_HIDE_ALL_FILLED';
import { default as VIEW_SWITCH_HIDE_ALL_FILLED_rebranded } from './rebranded/js/view-switch-hide-all-filled.js';
export const SVG_VIEW_SWITCH_PORTRAIT_FILLED = 'VIEW_SWITCH_PORTRAIT_FILLED';
import { default as VIEW_SWITCH_PORTRAIT_FILLED_rebranded } from './rebranded/js/view-switch-portrait-filled.js';
export const SVG_VIEW_SWITCH_HIDE_ALL_OUTLINED = 'VIEW_SWITCH_HIDE_ALL_OUTLINED';
import { default as VIEW_SWITCH_HIDE_ALL_OUTLINED_rebranded } from './rebranded/js/view-switch-hide-all-outlined.js';
export const SVG_VIEWS_FILLED = 'VIEWS_FILLED';
import { default as VIEWS_FILLED_rebranded } from './rebranded/js/views-filled.js';
export const SVG_VIEW_SWITCH_PORTRAIT_OUTLINED = 'VIEW_SWITCH_PORTRAIT_OUTLINED';
import { default as VIEW_SWITCH_PORTRAIT_OUTLINED_rebranded } from './rebranded/js/view-switch-portrait-outlined.js';
export const SVG_VIEWS_OUTLINED = 'VIEWS_OUTLINED';
import { default as VIEWS_OUTLINED_rebranded } from './rebranded/js/views-outlined.js';
export const SVG_VIRTUAL_BACKGROUND_FILLED = 'VIRTUAL_BACKGROUND_FILLED';
import { default as VIRTUAL_BACKGROUND_FILLED_rebranded } from './rebranded/js/virtual-background-filled.js';
export const SVG_VISIBILITY_OFF_FILLED = 'VISIBILITY_OFF_FILLED';
import { default as VISIBILITY_OFF_FILLED_rebranded } from './rebranded/js/visibility-off-filled.js';
export const SVG_VIRTUAL_BACKGROUND_OUTLINED = 'VIRTUAL_BACKGROUND_OUTLINED';
import { default as VIRTUAL_BACKGROUND_OUTLINED_rebranded } from './rebranded/js/virtual-background-outlined.js';
export const SVG_VISIBILITY_ON_FILLED = 'VISIBILITY_ON_FILLED';
import { default as VISIBILITY_ON_FILLED_rebranded } from './rebranded/js/visibility-on-filled.js';
export const SVG_VISIBILITY_ON_OUTLINED = 'VISIBILITY_ON_OUTLINED';
import { default as VISIBILITY_ON_OUTLINED_rebranded } from './rebranded/js/visibility-on-outlined.js';
export const SVG_VOICEMAIL_OUTLINED = 'VOICEMAIL_OUTLINED';
import { default as VOICEMAIL_OUTLINED_rebranded } from './rebranded/js/voicemail-outlined.js';
export const SVG_VOICEMAIL_FILLED = 'VOICEMAIL_FILLED';
import { default as VOICEMAIL_FILLED_rebranded } from './rebranded/js/voicemail-filled.js';
export const SVG_VOICEMAIL_READ_FILLED = 'VOICEMAIL_READ_FILLED';
import { default as VOICEMAIL_READ_FILLED_rebranded } from './rebranded/js/voicemail-read-filled.js';
export const SVG_VISIBILITY_OFF_OUTLINED = 'VISIBILITY_OFF_OUTLINED';
import { default as VISIBILITY_OFF_OUTLINED_rebranded } from './rebranded/js/visibility-off-outlined.js';
export const SVG_VOICEMAIL_READ_OUTLINED = 'VOICEMAIL_READ_OUTLINED';
import { default as VOICEMAIL_READ_OUTLINED_rebranded } from './rebranded/js/voicemail-read-outlined.js';
export const SVG_VOICEMAIL_UNREAD_OUTLINED = 'VOICEMAIL_UNREAD_OUTLINED';
import { default as VOICEMAIL_UNREAD_OUTLINED_rebranded } from './rebranded/js/voicemail-unread-outlined.js';
export const SVG_VOICEMAIL_UNREAD_FILLED = 'VOICEMAIL_UNREAD_FILLED';
import { default as VOICEMAIL_UNREAD_FILLED_rebranded } from './rebranded/js/voicemail-unread-filled.js';
export const SVG_VOIP_OFF_FILLED = 'VOIP_OFF_FILLED';
import { default as VOIP_OFF_FILLED_rebranded } from './rebranded/js/voip-off-filled.js';
export const SVG_VOIP_FILLED = 'VOIP_FILLED';
import { default as VOIP_FILLED_rebranded } from './rebranded/js/voip-filled.js';
export const SVG_VOIP_OUTLINED = 'VOIP_OUTLINED';
import { default as VOIP_OUTLINED_rebranded } from './rebranded/js/voip-outlined.js';
export const SVG_WEB_BROWSER_FILLED = 'WEB_BROWSER_FILLED';
import { default as WEB_BROWSER_FILLED_rebranded } from './rebranded/js/web-browser-filled.js';
export const SVG_WEB_BROWSER_OUTLINED = 'WEB_BROWSER_OUTLINED';
import { default as WEB_BROWSER_OUTLINED_rebranded } from './rebranded/js/web-browser-outlined.js';
export const SVG_VOIP_OFF_OUTLINED = 'VOIP_OFF_OUTLINED';
import { default as VOIP_OFF_OUTLINED_rebranded } from './rebranded/js/voip-off-outlined.js';
export const SVG_WEBCAM_OFF_OUTLINED = 'WEBCAM_OFF_OUTLINED';
import { default as WEBCAM_OFF_OUTLINED_rebranded } from './rebranded/js/webcam-off-outlined.js';
export const SVG_WEBCAM_ON_FILLED = 'WEBCAM_ON_FILLED';
import { default as WEBCAM_ON_FILLED_rebranded } from './rebranded/js/webcam-on-filled.js';
export const SVG_WEBCAM_OFF_FILLED = 'WEBCAM_OFF_FILLED';
import { default as WEBCAM_OFF_FILLED_rebranded } from './rebranded/js/webcam-off-filled.js';
export const SVG_WHITEBOARD_FILLED = 'WHITEBOARD_FILLED';
import { default as WHITEBOARD_FILLED_rebranded } from './rebranded/js/whiteboard-filled.js';
export const SVG_WEBCAM_ON_OUTLINED = 'WEBCAM_ON_OUTLINED';
import { default as WEBCAM_ON_OUTLINED_rebranded } from './rebranded/js/webcam-on-outlined.js';
export const SVG_WHITEBOARD_OUTLINED = 'WHITEBOARD_OUTLINED';
import { default as WHITEBOARD_OUTLINED_rebranded } from './rebranded/js/whiteboard-outlined.js';
export const SVG_WIFI_OFF_OUTLINED = 'WIFI_OFF_OUTLINED';
import { default as WIFI_OFF_OUTLINED_rebranded } from './rebranded/js/wifi-off-outlined.js';
export const SVG_WIFI_FILLED = 'WIFI_FILLED';
import { default as WIFI_FILLED_rebranded } from './rebranded/js/wifi-filled.js';
export const SVG_WIFI_OFF_FILLED = 'WIFI_OFF_FILLED';
import { default as WIFI_OFF_FILLED_rebranded } from './rebranded/js/wifi-off-filled.js';
export const SVG_WIFI_OUTLINED = 'WIFI_OUTLINED';
import { default as WIFI_OUTLINED_rebranded } from './rebranded/js/wifi-outlined.js';
export const SVG_WRENCH_OUTLINED = 'WRENCH_OUTLINED';
import { default as WRENCH_OUTLINED_rebranded } from './rebranded/js/wrench-outlined.js';
export const SVG_WRENCH_FILLED = 'WRENCH_FILLED';
import { default as WRENCH_FILLED_rebranded } from './rebranded/js/wrench-filled.js';
export const SVG_ZIP_OUTLINED = 'ZIP_OUTLINED';
import { default as ZIP_OUTLINED_rebranded } from './rebranded/js/zip-outlined.js';
export const SVG_ZIP_FILLED = 'ZIP_FILLED';
import { default as ZIP_FILLED_rebranded } from './rebranded/js/zip-filled.js';
export const SVG_ZOOM_IN_FILLED = 'ZOOM_IN_FILLED';
import { default as ZOOM_IN_FILLED_rebranded } from './rebranded/js/zoom-in-filled.js';
export const SVG_ZOOM_IN_OUTLINED = 'ZOOM_IN_OUTLINED';
import { default as ZOOM_IN_OUTLINED_rebranded } from './rebranded/js/zoom-in-outlined.js';
export const SVG_ZOOM_OUT_FILLED = 'ZOOM_OUT_FILLED';
import { default as ZOOM_OUT_FILLED_rebranded } from './rebranded/js/zoom-out-filled.js';
export const SVG_ZOOM_OUT_OUTLINED = 'ZOOM_OUT_OUTLINED';
import { default as ZOOM_OUT_OUTLINED_rebranded } from './rebranded/js/zoom-out-outlined.js';
export const IconIds = {ACCESSIBILITY_rebranded,
ACTION_ITEM_ACTIVE_rebranded,
ACTION_ITEM_INACTIVE_rebranded,
ADD_ACTIVE_rebranded,
ADD_CIRCLE_ACTIVE_rebranded,
ADD_INACTIVE_rebranded,
ADD_CIRCLE_INACTIVE_rebranded,
ADD_PERSON_ACTIVE_rebranded,
ADD_PERSON_INACTIVE_rebranded,
ADD_rebranded,
ADDRESS_BOOK_CONTACTS_ACTIVE_rebranded,
ADDRESS_BOOK_CONTACTS_INACTIVE_rebranded,
ADDRESSES_ACTIVE_rebranded,
ADDRESSES_INACTIVE_rebranded,
ADJUST_CAMERA_rebranded,
ADJUST_CAMERA_INACTIVE_rebranded,
ADJUSTMENTS_ACTIVE_rebranded,
ADJUSTMENTS_rebranded,
ADMIN_ACTIVE_rebranded,
ADMIN_INACTIVE_rebranded,
ADOBE_rebranded,
ALERT_ACTIVE_rebranded,
ALERT_INACTIVE_rebranded,
AMEX_ACTIVE_rebranded,
AMEX_rebranded,
ANDROID_rebranded,
ANNOTATION_INACTIVE_rebranded,
APP_SWITCHER_rebranded,
APPLE_MONOCHROMATIC_rebranded,
ANNOTATION_ACTIVE_rebranded,
ARCHIVE_INACTIVE_rebranded,
ARCHIVE_ACTIVE_rebranded,
ARROW_DOWN_rebranded,
ARROW_LEFT_rebranded,
ARROW_RIGHT_rebranded,
ARROW_UP_rebranded,
ASSISTANCE_ACTIVE_rebranded,
ASSISTANCE_INACTIVE_rebranded,
AUDIO_OFF_20_PX_ACTIVE_rebranded,
AUDIO_OFF_20_PX_rebranded,
BACKSPACE_INACTIVE_rebranded,
BACKSPACE_rebranded,
BADGE_ACTIVE_rebranded,
BADGE_INACTIVE_rebranded,
BATTERY_FULL_ACTIVE_rebranded,
BATTERY_FULL_rebranded,
BATTERY_LOW_ACTIVE_rebranded,
BATTERY_LOW_rebranded,
BATTERY_MID_ACTIVE_rebranded,
BATTERY_MID_rebranded,
BELL_DISABLED_ACTIVE_rebranded,
BELL_ACTIVE_rebranded,
BLOCK_rebranded,
BELL_DISABLED_INACTIVE_rebranded,
BELL_INACTIVE_rebranded,
BLUETOOTH_rebranded,
BLUETOOTH_CONNECTED_rebranded,
BOLD_ACTIVE_rebranded,
BOLD_INACTIVE_rebranded,
BOOKMARK_ACTIVE_rebranded,
BOOKMARK_INACTIVE_rebranded,
BRAVE_rebranded,
BREAKOUT_ROOM_ACTIVE_rebranded,
BREAKOUT_ROOM_rebranded,
BRIGHTNESS_INACTIVE_rebranded,
BUG_ACTIVE_rebranded,
BRIGHTNESS_rebranded,
BUG_INACTIVE_rebranded,
BULB_ACTIVE_rebranded,
BULB_INACTIVE_rebranded,
BUSINESS_ACTIVE_rebranded,
BUSINESS_INACTIVE_rebranded,
CALCULATOR_ACTIVE_rebranded,
CALCULATOR_INACTIVE_rebranded,
CALENDAR_ACTIVE_rebranded,
CALENDAR_INACTIVE_rebranded,
CALL_FAILED_ACTIVE_rebranded,
CALL_FAILED_INACTIVE_rebranded,
CALL_MADE_rebranded,
CALL_ME_UP_ACTIVE_rebranded,
CALL_ME_UP_INACTIVE_rebranded,
CALL_MESSAGE_ACTIVE_rebranded,
CALL_MERGE_rebranded,
CALL_MESSAGE_INACTIVE_rebranded,
CALL_MISSED_rebranded,
CALL_ON_HOLD_ACTIVE_rebranded,
CALL_ON_HOLD_INACTIVE_rebranded,
CALL_PARK_ACTIVE_rebranded,
CALL_RECEIVED_rebranded,
CALL_PARK_INACTIVE_rebranded,
CALL_SPLIT_rebranded,
CALL_TRANSFER_ACTIVE_rebranded,
CALL_TRANSFER_INACTIVE_rebranded,
CAMERA_ACTIVE_rebranded,
CAMERA_AUTO_INACTIVE_rebranded,
CAMERA_FLIP_ACTIVE_rebranded,
CAMERA_FLIP_rebranded,
CAMERA_AUTO_rebranded,
CAMERA_INACTIVE_rebranded,
CAMERA_POSITION_BOTTOM_rebranded,
CAMERA_POSITION_LEFT_rebranded,
CAMERA_POSITION_RIGHT_rebranded,
CAMERA_POSITION_TOP_rebranded,
CAMERA_PRESETS_ACTIVE_rebranded,
CAMERA_PRESETS_INACTIVE_rebranded,
CAMERA_SHARE_ACTIVE_rebranded,
CAMERA_SHARE_rebranded,
CARD_ACTIVE_rebranded,
CARD_rebranded,
CART_ACTIVE_rebranded,
CART_INACTIVE_rebranded,
CASH_ACTIVE_rebranded,
CASH_rebranded,
CHAT_ACTIVE_rebranded,
CHAT_DOTS_ACTIVE_rebranded,
CHAT_DOTS_INACTIVE_rebranded,
CHAT_FEEDBACK_ACTIVE_rebranded,
CHAT_FEEDBACK_INACTIVE_rebranded,
CHAT_INACTIVE_rebranded,
CHAT_QUESTION_ACTIVE_rebranded,
CHAT_QUESTION_INACTIVE_rebranded,
CHECK_rebranded,
CHECKBOX_ACTIVE_rebranded,
CHECKBOX_ACTIVE_ANDROID_rebranded,
CHECKBOX_ANDROID_INDETERMINATE_rebranded,
CHECKBOX_ANDROID_rebranded,
CHECKBOX_CHECK_rebranded,
CHECKBOX_INDETERMINATE_rebranded,
CHECKBOX_rebranded,
CHECKBOX_LINE_rebranded,
CHECKMARK_CIRCLE_ACTIVE_rebranded,
CHEVRON_COMBO_rebranded,
CHECKMARK_CIRCLE_INACTIVE_rebranded,
CHEVRON_DOWN_20_PX_rebranded,
CHEVRON_DOWN_rebranded,
CHEVRON_LEFT_rebranded,
CHEVRON_LEFT_COLLAPSE_rebranded,
CHEVRON_RIGHT_EXPAND_rebranded,
CHEVRON_RIGHT_rebranded,
CHEVRON_UP_20_PX_rebranded,
CHEVRON_UP_rebranded,
CLEAR_ALL_rebranded,
CLIP_rebranded,
CLIPBOARD_ACTIVE_rebranded,
CLIPBOARD_INACTIVE_rebranded,
CLOSE_CIRCLE_ACTIVE_rebranded,
CLOCK_ACTIVE_rebranded,
CLOCK_INACTIVE_rebranded,
CLOSE_rebranded,
CLOSE_CIRCLE_INACTIVE_rebranded,
CLOUD_ACTIVE_rebranded,
CLOUD_OFF_ACTIVE_rebranded,
CLOUD_OFF_rebranded,
CLOUD_UPLOAD_ACTIVE_rebranded,
CLOUD_UPLOAD_INACTIVE_rebranded,
CLOUD_rebranded,
COBY_ACTIVE_rebranded,
COBY_INACTIVE_rebranded,
AD_rebranded,
AE_rebranded,
CODE_rebranded,
AG_rebranded,
AF_rebranded,
AL_rebranded,
AM_rebranded,
AN_rebranded,
AO_rebranded,
APPLE_rebranded,
AR_rebranded,
AT_rebranded,
AU_rebranded,
AW_rebranded,
AZ_rebranded,
BA_rebranded,
BD_rebranded,
BB_rebranded,
BE_rebranded,
BF_rebranded,
BG_rebranded,
BI_rebranded,
BH_rebranded,
BJ_rebranded,
BN_rebranded,
BO_rebranded,
BS_rebranded,
BR_rebranded,
BT_rebranded,
BV_rebranded,
BW_rebranded,
BY_rebranded,
BZ_rebranded,
CA_rebranded,
CD_rebranded,
CF_rebranded,
CG_rebranded,
CH_rebranded,
CI_rebranded,
CL_rebranded,
CM_rebranded,
CN_rebranded,
CO_rebranded,
CR_rebranded,
CU_rebranded,
CV_rebranded,
CONNECT_WISE_rebranded,
CW_rebranded,
CY_rebranded,
DE_rebranded,
DATTO_rebranded,
CZ_rebranded,
DJ_rebranded,
DM_rebranded,
DK_rebranded,
DO_rebranded,
DZ_rebranded,
EC_rebranded,
EG_rebranded,
EE_rebranded,
ER_rebranded,
ES_rebranded,
FACEBOOK_rebranded,
ET_rebranded,
FI_rebranded,
FILE_rebranded,
FJ_rebranded,
GA_rebranded,
FR_rebranded,
FM_rebranded,
GB_rebranded,
GD_rebranded,
GH_rebranded,
GE_rebranded,
GM_rebranded,
GN_rebranded,
GOOGLE_DRIVE_DOC_rebranded,
GOOGLE_CALENDAR_rebranded,
GOOGLE_DRIVE_DRAWINGS_rebranded,
GOOGLE_DRIVE_FOLDER_rebranded,
GOOGLE_DRIVE_SHEET_rebranded,
GOOGLE_DRIVE_SLIDE_rebranded,
GOOGLE_DRIVE_rebranded,
GOOGLE_GMAIL_rebranded,
GOOGLE_rebranded,
GOTO_ADMIN_BLACK_YELLOW_rebranded,
GOTO_ADMIN_PARTNER_APP_ICON_DARK_MODE_rebranded,
GOTO_ADMIN_PARTNER_FAVICON_DARK_MODE_rebranded,
GOTO_ADMIN_PARTNER_FAVICON_rebranded,
GOTO_ADMIN_WHITE_YELLOW_rebranded,
GOTO_ADMIN_PARTNER_APP_ICON_rebranded,
GOTO_APP_ICON_DARK_MODE_rebranded,
GOTO_APP_ICON_rebranded,
GOTO_BLACK_FAVICON_rebranded,
GOTO_BLACK_MONOCHROME_FAVICON_rebranded,
GOTO_BLACK_YELLOW_FAVICON_LEGACY_rebranded,
GOTO_BLACK_YELLOW_FAVICON_rebranded,
GOTO_BLACK_WHITE_rebranded,
GOTO_BLACK_YELLOW_rebranded,
GOTO_BLACK_rebranded,
GOTO_GIVES_BLACK_YELLOW_rebranded,
GOTO_GIVES_BLACK_rebranded,
GOTO_GIVES_GREY_rebranded,
GOTO_GIVES_WHITE_YELLOW_rebranded,
GOTO_GIVES_WHITE_rebranded,
GOTO_GREY_rebranded,
GOTO_INTEGRATIONS_APP_ICON_DARK_MODE_rebranded,
GOTO_INTEGRATIONS_APP_ICON_rebranded,
GOTO_MARK_rebranded,
GOTO_PARTNER_BLACK_YELLOW_rebranded,
GOTO_WHITE_FAVICON_rebranded,
GOTO_PARTNER_WHITE_YELLOW_rebranded,
GOTO_WHITE_MONOCHROME_FAVICON_rebranded,
GOTO_WHITE_YELLOW_FAVICON_DARK_MODE_rebranded,
GOTO_WHITE_rebranded,
GOTO_WHITE_YELLOW_rebranded,
GQ_rebranded,
GR_rebranded,
GRASSHOPPER_MARK_rebranded,
GTR_BLACK_HORIZONTAL_rebranded,
GT_rebranded,
GTR_BLACK_VERTICAL_rebranded,
GTR_BLACK_YELLOW_PURPLE_HORIZONTAL_rebranded,
GTR_BLACK_YELLOW_PURPLE_VERTICAL_rebranded,
GTR_DEFAULT_APP_ICON_DARK_MODE_rebranded,
GTR_DEFAULT_APP_ICON_rebranded,
GTR_FAVICON_DARK_MODE_rebranded,
GTR_FAVICON_LEGACY_rebranded,
GTR_FAVICON_rebranded,
GTR_GREY_HORIZONTAL_rebranded,
GTR_GREY_VERTICAL_rebranded,
GTR_PURPLE_APP_ICON_DARK_MODE_rebranded,
GTR_PURPLE_APP_ICON_rebranded,
GTR_WHITE_HORIZONTAL_rebranded,
GTR_WHITE_VERTICAL_rebranded,
GTR_WHITE_YELLOW_HORIZONTAL_rebranded,
GTR_WHITE_YELLOW_VERTICAL_rebranded,
GW_rebranded,
GY_rebranded,
HK_rebranded,
HR_rebranded,
HN_rebranded,
HT_rebranded,
HU_rebranded,
ID_rebranded,
IE_rebranded,
IL_rebranded,
IN_rebranded,
IQ_rebranded,
INSTAGRAM_rebranded,
IR_rebranded,
IS_rebranded,
IT_rebranded,
JM_rebranded,
JO_rebranded,
JP_rebranded,
KE_rebranded,
KG_rebranded,
KH_rebranded,
KI_rebranded,
KP_rebranded,
KR_rebranded,
KW_rebranded,
KM_rebranded,
KZ_rebranded,
LA_rebranded,
LB_rebranded,
LI_rebranded,
LC_rebranded,
LINKEDIN_rebranded,
LK_rebranded,
LP_BY_GO_TO_BLACK_HORIZONTAL_rebranded,
LP_BY_GO_TO_BLACK_RED_HORIZONTAL_rebranded,
LP_BY_GO_TO_BLACK_RED_VERTICAL_rebranded,
LP_BY_GO_TO_BLACK_VERTICAL_rebranded,
LP_BY_GO_TO_GREY_HORIZONTAL_rebranded,
LP_BY_GO_TO_GREY_VERTICAL_rebranded,
LP_BY_GO_TO_WHITE_HORIZONTAL_rebranded,
LP_BY_GO_TO_WHITE_RED_HORIZONTAL_rebranded,
LP_BY_GO_TO_WHITE_RED_VERTICAL_rebranded,
LP_BY_GO_TO_WHITE_VERTICAL_rebranded,
LR_rebranded,
LS_rebranded,
LU_rebranded,
LY_rebranded,
LT_rebranded,
LV_rebranded,
MA_rebranded,
MC_rebranded,
MD_rebranded,
ME_rebranded,
MG_rebranded,
MH_rebranded,
MICROSOFT_rebranded,
MICROSOFT_TEAMS_rebranded,
MIRO_rebranded,
MK_rebranded,
MM_rebranded,
ML_rebranded,
MN_rebranded,
MR_rebranded,
MT_rebranded,
MU_rebranded,
MV_rebranded,
MW_rebranded,
MX_rebranded,
MZ_rebranded,
MY_rebranded,
NA_rebranded,
NE_rebranded,
NG_rebranded,
NI_rebranded,
NL_rebranded,
NP_rebranded,
NO_rebranded,
NR_rebranded,
NZ_rebranded,
OFFICE_365_rebranded,
OM_rebranded,
OUTLOOK_rebranded,
PA_rebranded,
PE_rebranded,
PG_rebranded,
PH_rebranded,
PK_rebranded,
PL_rebranded,
PS_rebranded,
PT_rebranded,
PW_rebranded,
PY_rebranded,
QA_rebranded,
RO_rebranded,
RS_rebranded,
RU_rebranded,
RW_rebranded,
SB_rebranded,
SC_rebranded,
SA_rebranded,
SD_rebranded,
SE_rebranded,
SG_rebranded,
SI_rebranded,
SK_rebranded,
SL_rebranded,
SLACK_rebranded,
SN_rebranded,
SM_rebranded,
SO_rebranded,
SR_rebranded,
SS_rebranded,
ST_rebranded,
SV_rebranded,
SX_rebranded,
SY_rebranded,
SZ_rebranded,
TD_rebranded,
TH_rebranded,
TJ_rebranded,
TG_rebranded,
TL_rebranded,
TM_rebranded,
TN_rebranded,
TO_rebranded,
TV_rebranded,
TT_rebranded,
TR_rebranded,
TWITTER_rebranded,
TZ_rebranded,
UA_rebranded,
UG_rebranded,
US_rebranded,
UY_rebranded,
UZ_rebranded,
VA_rebranded,
VC_rebranded,
VE_rebranded,
VI_rebranded,
VN_rebranded,
VU_rebranded,
WS_rebranded,
YE_rebranded,
YOUTUBE_rebranded,
ZA_rebranded,
ZM_rebranded,
ZW_rebranded,
COMMUTER_MODE_ACTIVE_rebranded,
COMMUTER_MODE_rebranded,
CONFERENCE_PHONE_INACTIVE_rebranded,
CONFERENCE_PHONE_rebranded,
CONNECT_ACTIVE_rebranded,
CONNECT_INACTIVE_rebranded,
CONNECTED_VIA_PHONE_ACTIVE_rebranded,
CONNECTED_VIA_PHONE_INACTIVE_rebranded,
CONTINUE_20_PX_INACTIVE_rebranded,
CONTROLS_ACTIVE_rebranded,
CONTROLS_INACTIVE_rebranded,
CONVERSATION_ACTIVE_rebranded,
CONTINUE_20_PX_rebranded,
CONVERSATION_INACTIVE_rebranded,
COPY_ACTIVE_rebranded,
COPY_INACTIVE_rebranded,
CPU_ACTIVE_rebranded,
CPU_rebranded,
CREATE_CONVERSATION_ACTIVE_rebranded,
CREATE_CONVERSATION_INACTIVE_rebranded,
CREATE_GROUP_ACTIVE_rebranded,
CREATE_GROUP_INACTIVE_rebranded,
CROWD_ACTIVE_rebranded,
CROWD_INACTIVE_rebranded,
CTRL_ALT_DEL_ACTIVE_rebranded,
CTRL_ALT_DEL_INACTIVE_rebranded,
CVS_ACTIVE_rebranded,
CVS_INACTIVE_rebranded,
DARK_MODE_INACTIVE_rebranded,
DARK_MODE_rebranded,
DASHBOARD_ACTIVE_rebranded,
DASHBOARD_INACTIVE_rebranded,
DATA_MASKING_ACTIVE_rebranded,
DATA_MASKING_INACTIVE_rebranded,
DATA_rebranded,
DECISION_ACTIVE_rebranded,
DECISION_INACTIVE_rebranded,
DESKTOP_ACTIVE_rebranded,
DELETE_CONVERSATION_ACTIVE_rebranded,
DELETE_CONVERSATION_INACTIVE_rebranded,
DEVICES_ACTIVE_rebranded,
DESKTOP_rebranded,
DEVICES_INACTIVE_rebranded,
DIAL_IN_ACTIVE_rebranded,
DIAL_IN_INACTIVE_rebranded,
DIAL_OUT_ACTIVE_rebranded,
DIAL_OUT_INACTIVE_rebranded,
DIAL_PAD_rebranded,
DISCOVER_rebranded,
DISCOVER_ACTIVE_rebranded,
DOCUMENT_ACTIVE_rebranded,
DOCUMENT_INACTIVE_rebranded,
DOLBY_rebranded,
DOLLAR_ACTIVE_rebranded,
DOLLAR_rebranded,
DOWNLOAD_DESKTOP_APP_FILLED_rebranded,
DOWNLOAD_DESKTOP_APP_rebranded,
DOWNLOAD_MOBILE_APP_FILLED_rebranded,
DOWNLOAD_MOBILE_APP_rebranded,
DRAG_DROP_ACTIVE_rebranded,
DRAG_CURSOR_rebranded,
DRAG_DROP_rebranded,
DRAG_FREE_rebranded,
DOWNLOAD_rebranded,
DRAG_LINEAR_rebranded,
DRAWER_LEFT_ACTIVE_rebranded,
DRAWER_LEFT_INACTIVE_rebranded,
DRAWER_RIGHT_INACTIVE_rebranded,
DRIVE_ACTIVE_rebranded,
DRIVE_INACTIVE_rebranded,
DRAWER_RIGHT_ACTIVE_rebranded,
DUAL_DISPLAY_ACTIVE_rebranded,
ECHO_rebranded,
EDGE_rebranded,
DUAL_DISPLAY_rebranded,
EDIT_INACTIVE_rebranded,
EDIT_rebranded,
EDUCATION_ACTIVE_rebranded,
EDUCATION_INACTIVE_rebranded,
EMAIL_ACTIVE_rebranded,
EMAIL_INACTIVE_rebranded,
EMOJI_ACTIVE_rebranded,
EMOJI_SAD_ACTIVE_rebranded,
EMOJI_SAD_rebranded,
EMOJI_rebranded,
ENCRYPTION_ACTIVE_rebranded,
ENLARGE_MEETING_ACTIVE_rebranded,
ENCRYPTION_INACTIVE_rebranded,
ENLARGE_MEETING_rebranded,
ENTER_ACTIVE_rebranded,
ENTER_INACTIVE_rebranded,
EURO_ACTIVE_rebranded,
EURO_rebranded,
EVENT_INACTIVE_rebranded,
EVENT_ACTIVE_rebranded,
EVENT_PHONE_ACTIVE_rebranded,
EXECUTABLE_ACTIVE_rebranded,
EVENT_PHONE_INACTIVE_rebranded,
EXECUTABLE_INACTIVE_rebranded,
EXTERNAL_LINK_ACTIVE_rebranded,
EXTERNAL_LINK_rebranded,
FADE_OUT_rebranded,
FAST_FORWARD_ACTIVE_rebranded,
FAX_ACTIVE_rebranded,
FAST_FORWARD_INACTIVE_rebranded,
FAX_rebranded,
FILE_ACTIVE_rebranded,
FILE_BROWSER_ACTIVE_rebranded,
FILE_BROWSER_INACTIVE_rebranded,
FILE_CODE_ACTIVE_rebranded,
FILE_CODE_INACTIVE_rebranded,
FILE_INACTIVE_rebranded,
FILE_PDF_ACTIVE_rebranded,
FILE_PDF_INACTIVE_rebranded,
FILE_PRESENTATION_ACTIVE_rebranded,
FILE_PRESENTATION_INACTIVE_rebranded,
FILE_SOUND_ACTIVE_rebranded,
FILE_SOUND_INACTIVE_rebranded,
FILE_SPREADSHEET_INACTIVE_rebranded,
FILE_SPREADSHEET_ACTIVE_rebranded,
FILE_TRANSFER_ACTIVE_rebranded,
FILE_TRANSFER_INACTIVE_rebranded,
FILE_VIDEO_INACTIVE_rebranded,
FILE_VIDEO_ACTIVE_rebranded,
FILTER_ACTIVE_rebranded,
FILTER_INACTIVE_rebranded,
FINGERPRINT_rebranded,
FIT_HEIGHT_ACTIVE_rebranded,
FIT_HEIGHT_rebranded,
FIT_WIDTH_ACTIVE_rebranded,
FIREFOX_rebranded,
FIT_WIDTH_rebranded,
FITNESS_rebranded,
FLASLIGHT_OFF_ACTIVE_rebranded,
FLASLIGHT_OFF_INACTIVE_rebranded,
FLASLIGHT_ON_ACTIVE_rebranded,
FLASLIGHT_ON_INACTIVE_rebranded,
FLOWCHART_ACTIVE_rebranded,
FLOWCHART_rebranded,
FOLDER_ACTIVE_rebranded,
FOLDER_ARCHIVE_ACTIVE_rebranded,
FOLDER_ARCHIVE_INACTIVE_rebranded,
FOLDER_CREATE_ACTIVE_rebranded,
FOLDER_CREATE_INACTIVE_rebranded,
FOLDER_INACTIVE_rebranded,
FOLDER_UP_rebranded,
FONT_rebranded,
GEO_PIN_ACTIVE_rebranded,
GEO_PIN_INACTIVE_rebranded,
GIFT_ACTIVE_rebranded,
GIFT_rebranded,
GLOBAL_SESSION_LIST_ACTIVE_rebranded,
GLOBAL_SESSION_LIST_INACTIVE_rebranded,
GLOBE_ACTIVE_rebranded,
GLOBE_rebranded,
GOOGLE_MONOCHROMATIC_rebranded,
GOOGLE_CHROME_rebranded,
GOTO_rebranded,
GOTO_ASSIST_rebranded,
GRIP_20_PX_rebranded,
GTC_CONTACT_CENTER_PICTO_rebranded,
GTC_MEETING_PICTO_rebranded,
GTC_MESSAGING_PICTO_rebranded,
GTC_PHONE_MTG_BUNDLE_PICTO_rebranded,
GTC_ROOM_PICTO_rebranded,
GTC_VIRTUAL_EVENTS_PICTO_rebranded,
GTC_TRAINING_PICTO_rebranded,
GTC_VOICE_PICTO_rebranded,
GTC_WEBINAR_PICTO_rebranded,
GTR_CONVERSATIONAL_TICKETING_PICTO_rebranded,
GTR_DEVICE_MONITORING_PICTO_rebranded,
GTR_ENDPOINT_MANAGEMENT_PICTO_rebranded,
GTR_ENDPOINT_SECURITY_PICTO_rebranded,
GTR_FINGERPRINT_PICTO_rebranded,
GTR_HELP_DESK_PICTO_rebranded,
GTR_MOBILE_DEVICE_SUPPORT_PICTO_rebranded,
GTR_IT_AUTOMATION_PICTO_rebranded,
GTR_REMOTE_ACCESS_PICTO_rebranded,
GTR_REMOTE_SUPPORT_PICTO_rebranded,
GTR_VISUAL_ENGAGEMENT_PICTO_rebranded,
HAND_LOWER_rebranded,
HAMBURGER_MENU_rebranded,
HAND_RAISE_rebranded,
HARDPHONE_INACTIVE_rebranded,
HARDPHONE_rebranded,
HDMI_ACTIVE_rebranded,
HDMI_rebranded,
HEADPHONES_rebranded,
HEALTHCARE_ACTIVE_rebranded,
HEALTHCARE_INACTIVE_rebranded,
HEART_ACTIVE_rebranded,
HEART_INACTIVE_rebranded,
HELP_CIRCLE_ACTIVE_rebranded,
HELP_CIRCLE_INACTIVE_rebranded,
HELP_SQUARE_ACTIVE_rebranded,
HELP_SQUARE_INACTIVE_rebranded,
HELPDESK_ACTIVE_rebranded,
HELPDESK_rebranded,
HIGHLIGHTER_ACTIVE_rebranded,
HIGHLIGHTER_rebranded,
HISTORY_rebranded,
HOME_ACTIVE_rebranded,
HOME_INACTIVE_rebranded,
HOUSE_ACTIVE_rebranded,
HOUSE_INACTIVE_rebranded,
ID_CARD_ACTIVE_rebranded,
ID_CARD_rebranded,
INBOX_ACTIVE_rebranded,
INBOX_INACTIVE_rebranded,
INFINITY_rebranded,
INFO_ACTIVE_rebranded,
INTEGRATIONS_ACTIVE_rebranded,
INFO_INACTIVE_rebranded,
INTEGRATIONS_rebranded,
INTERNET_EXPLORER_rebranded,
ITALICS_INACTIVE_rebranded,
ITALICS_ACTIVE_rebranded,
KEY_ACTIVE_rebranded,
KEY_INACTIVE_rebranded,
KEYBOARD_ACTIVE_rebranded,
KEYBOARD_INACTIVE_rebranded,
LAB_ACTIVE_rebranded,
LAB_INACTIVE_rebranded,
LAUNCH_ACTIVE_rebranded,
LAUNCH_INACTIVE_rebranded,
LEAVE_ACTIVE_rebranded,
LEAVE_rebranded,
LEGAL_INACTIVE_rebranded,
LEGAL_ACTIVE_rebranded,
LINK_HORIZONTAL_ACTIVE_rebranded,
LINK_ACTIVE_rebranded,
LINK_HORIZONTAL_rebranded,
LINK_INACTIVE_rebranded,
LINUX_rebranded,
LIST_ACTIVE_rebranded,
LIST_INACTIVE_rebranded,
LISTEN_rebranded,
LOADER_rebranded,
LOCKED_ACTIVE_20_PX_rebranded,
LOCKED_ACTIVE_rebranded,
LOCKED_INACTIVE_20_PX_rebranded,
LOCKED_INACTIVE_rebranded,
LOG_ACTIVE_rebranded,
LOG_INACTIVE_rebranded,
LOGMEIN_rebranded,
LOUD_SPEAKER_ACTIVE_rebranded,
LOUD_SPEAKER_rebranded,
MAGIC_WAND_ACTIVE_rebranded,
MAGIC_WAND_INACTIVE_rebranded,
MAIN_SWITCH_ACTIVE_rebranded,
MANAGE_LICENSES_ACTIVE_rebranded,
MAIN_SWITCH_INACTIVE_rebranded,
MANAGE_LICENSES_INACTIVE_rebranded,
MANUFACTURING_ACTIVE_rebranded,
MANUFACTURING_INACTIVE_rebranded,
MASTER_ACTIVE_rebranded,
MASTER_rebranded,
MATERIALS_ACTIVE_rebranded,
MATERIALS_INACTIVE_rebranded,
MEET_NOW_ACTIVE_rebranded,
MEET_NOW_rebranded,
MEETING_JOIN_ACTIVE_rebranded,
MEETING_JOIN_INACTIVE_rebranded,
MEETING_SYNC_ACTIVE_rebranded,
MEETING_SYNC_rebranded,
MEETINGS_ACTIVE_rebranded,
MEETINGS_INACTIVE_rebranded,
MESSENGER_rebranded,
MERGE_rebranded,
MIC_ON_20_PX_rebranded,
MIC_OFF_20_PX_rebranded,
MICROPHONE_ACTIVE_rebranded,
MICROPHONE_INACTIVE_HARDMUTED_rebranded,
MICROPHONE_INACTIVE_rebranded,
MICROPHONE_OFF_ACTIVE_rebranded,
MICROPHONE_ON_HARDMUTED_rebranded,
MICROPHONE_ON_INACTIVE_rebranded,
MINIFY_MEETING_rebranded,
MINIFY_MEETING_ACTIVE_rebranded,
MOBILE_SUPPORT_ACTIVE_rebranded,
MOBILE_SUPPORT_rebranded,
MORE_HORIZONTAL_rebranded,
MORE_VERTICAL_MOBILE_ONLY_rebranded,
MOUSE_ACTIVE_rebranded,
MOUSE_INACTIVE_rebranded,
MUSIC_INACTIVE_rebranded,
MUSIC_rebranded,
NETWORK_ACTIVE_rebranded,
NETWORK_INACTIVE_rebranded,
NOTE_ACTIVE_rebranded,
NOTE_INACTIVE_rebranded,
NOTE_rebranded,
NOTEPAD_ACTIVE_rebranded,
NOTIFICATIONS_ALERT_INACTIVE_rebranded,
NOTIFICATIONS_ALERT_ACTIVE_rebranded,
NOTIFICATIONS_rebranded,
NOTEPAD_INACTIVE_rebranded,
NOTIFICATIONS_INACTIVE_rebranded,
NPA_ACTIVE_rebranded,
NPA_INACTIVE_rebranded,
NUMBERED_ARROW_INACTIVE_rebranded,
NUMBERED_ARROW_ACTIVE_rebranded,
OPEN_VOICE_rebranded,
OPERA_rebranded,
ORDERED_LIST_ACTIVE_rebranded,
ORDERED_LIST_INACTIVE_rebranded,
PAINT_INACTIVE_rebranded,
PAINT_ACTIVE_rebranded,
PALETTE_ACTIVE_rebranded,
PALETTE_INACTIVE_rebranded,
PAUSE_20_PX_INACTIVE_rebranded,
PAUSE_20_PX_rebranded,
PAUSE_ACTIVE_rebranded,
PAUSE_CIRCLE_ACTIVE_rebranded,
PAUSE_CIRCLE_INACTIVE_rebranded,
PAUSE_INACTIVE_rebranded,
PAYMENT_DUE_INACTIVE_rebranded,
PAYMENT_DUE_ACTIVE_rebranded,
PBX_INACTIVE_rebranded,
PBX_rebranded,
PEOPLE_INACTIVE_rebranded,
PEOPLE_ACTIVE_rebranded,
PERSON_ACTIVE_rebranded,
PERSON_CHECKMARK_ACTIVE_rebranded,
PERSON_CHECKMARK_INACTIVE_rebranded,
PERSON_INACTIVE_rebranded,
PERSON_TRANSFER_FROM_ACTIVE_rebranded,
PERSON_TRANSFER_FROM_INACTIVE_rebranded,
PERSON_TRANSFER_TO_ACTIVE_rebranded,
PHONE_DOWN_ACTIVE_rebranded,
PERSON_TRANSFER_TO_INACTIVE_rebranded,
PHONE_DOWN_INACTIVE_rebranded,
PHONE_NUMBER_ACTIVE_rebranded,
PHONE_UP_DISABLED_ACTIVE_rebranded,
PHONE_UP_ACTIVE_rebranded,
PHONE_NUMBER_INACTIVE_rebranded,
PHONE_UP_DISABLED_INACTIVE_rebranded,
PHONE_UP_INACTIVE_rebranded,
PICTURE_ACTIVE_rebranded,
PICTURE_DISABLED_ACTIVE_rebranded,
PICTURE_DISABLED_INACTIVE_rebranded,
PICTURE_INACTIVE_rebranded,
PIE_CHART_ACTIVE_rebranded,
PIE_CHART_INACTIVE_rebranded,
PIP_MAXIMIZE_INACTIVE_rebranded,
PIP_MINIMIZE_ACTIVE_rebranded,
PIP_MAXIMIZE_rebranded,
PIP_MINIMIZE_rebranded,
PLAY_ACTIVE_rebranded,
PLAY_INACTIVE_rebranded,
PLAY_PLAIN_ACTIVE_rebranded,
PLAY_PLAIN_INACTIVE_rebranded,
POINTER_OFF_ACTIVE_rebranded,
POINTER_OFF_INACTIVE_rebranded,
POINTER_ON_ACTIVE_rebranded,
POINTER_WINDOWS_OFF_ACTIVE_rebranded,
POINTER_ON_INACTIVE_rebranded,
POINTER_WINDOWS_OFF_INACTIVE_rebranded,
POINTER_WINDOWS_ON_ACTIVE_rebranded,
POINTER_WINDOWS_ON_INACTIVE_rebranded,
POINTER_rebranded,
POLLS_ACTIVE_rebranded,
POLLS_rebranded,
POP_IT_BACK_ACTIVE_rebranded,
POP_IT_BACK_rebranded,
POP_IT_OUT_ACTIVE_rebranded,
POP_IT_OUT_rebranded,
POP_OUT_CAMERA_ACTIVE_rebranded,
POP_OUT_CAMERA_rebranded,
POP_OUT_WINDOW_ACTIVE_rebranded,
POP_OUT_WINDOW_rebranded,
POSITION_TV_BOTTOM_ACTIVE_rebranded,
POSITION_TV_BOTTOM_rebranded,
POSITION_TV_LEFT_ACTIVE_rebranded,
POSITION_TV_LEFT_rebranded,
POSITION_TV_RIGHT_ACTIVE_rebranded,
POSITION_TV_RIGHT_rebranded,
POSITION_TV_TOP_ACTIVE_rebranded,
POUND_SIGN_rebranded,
POUND_ACTIVE_rebranded,
POSITION_TV_TOP_rebranded,
POUND_rebranded,
PRESENCE_AVAILABLE_rebranded,
PRESENCE_BUSY_ACTIVE_rebranded,
PRESENCE_BUSY_INACTIVE_rebranded,
PRESENCE_DND_rebranded,
PRESENCE_OFFLINE_rebranded,
PRESENTATION_ACTIVE_rebranded,
PRESENTATION_INACTIVE_rebranded,
PRIVATE_ACTIVE_rebranded,
PRIVATE_INACTIVE_rebranded,
PUSHPIN_ACTIVE_rebranded,
PUSHPIN_INACTIVE_rebranded,
QUESTION_rebranded,
RADIO_BUTTON_ANDROID_SELECTED_rebranded,
RADIO_BUTTON_ANDROID_UNSELECTED_rebranded,
RADIO_BUTTON_SELECTED_rebranded,
RADIO_BUTTON_UNSELECTED_rebranded,
READER_ACTIVE_rebranded,
READER_INACTIVE_rebranded,
RECORD_ACTIVE_rebranded,
RECORD_INACTIVE_rebranded,
RECORDING_INACTIVE_rebranded,
RECORDING_TAPE_INACTIVE_rebranded,
RECORDING_TAPE_rebranded,
RECURRING_ACTIVE_rebranded,
RECURRING_rebranded,
RECORDING_rebranded,
REDO_rebranded,
REMOTE_SUPPORT_ACTIVE_rebranded,
REFRESH_rebranded,
REMOTE_SUPPORT_rebranded,
REPLY_ACTIVE_rebranded,
REPLY_rebranded,
REPORT_rebranded,
RESIZE_HANDLE_rebranded,
RESTORE_ACTIVE_rebranded,
RESTORE_rebranded,
REWIND_ACTIVE_rebranded,
REWIND_INACTIVE_rebranded,
ROOM_PHYSICAL_rebranded,
ROOM_PHYSICAL_INACTIVE_rebranded,
ROOM_VIEW_rebranded,
ROTATE_CCW_ACTIVE_rebranded,
ROTATE_CCW_INACTIVE_rebranded,
ROTATE_CW_ACTIVE_rebranded,
ROTATE_CW_INACTIVE_rebranded,
ROUTER_ACTIVE_rebranded,
SAFARI_rebranded,
SALES_QUOTE_INACTIVE_rebranded,
ROUTER_INACTIVE_rebranded,
SALES_QUOTE_ACTIVE_rebranded,
SAVE_INACTIVE_rebranded,
SAVE_ACTIVE_rebranded,
SCREEN_ACTIVE_rebranded,
SCREEN_ADD_DEVICE_ACTIVE_rebranded,
SCREEN_INACTIVE_rebranded,
SCREEN_MIRRORING_LAPTOP_ACTIVE_rebranded,
SCREEN_ADD_DEVICE_INACTIVE_rebranded,
SCREEN_MIRRORING_LAPTOP_rebranded,
SCREEN_PAUSE_ACTIVE_rebranded,
SCREEN_PAUSE_INACTIVE_rebranded,
SCREEN_QUALITY_ACTIVE_rebranded,
SCREEN_QUALITY_INACTIVE_rebranded,
SCREEN_REBOOT_ACTIVE_rebranded,
SCREEN_REBOOT_INACTIVE_rebranded,
SCREEN_RUN_INACTIVE_rebranded,
SCREEN_RUN_ACTIVE_rebranded,
SCREEN_SHARING_rebranded,
SCREEN_SHARING_ACTIVE_rebranded,
SCREEN_SNAPSHOT_ACTIVE_rebranded,
SCREEN_SNAPSHOT_INACTIVE_rebranded,
SCREEN_STOP_REMOTE_ACTIVE_rebranded,
SCREEN_STOP_REMOTE_INACTIVE_rebranded,
SCREEN_SYSTEM_INFO_ACTIVE_rebranded,
SCREEN_SYSTEM_INFO_INACTIVE_rebranded,
SCREEN_UNATTENDED_INACTIVE_rebranded,
SCREEN_UNATTENDED_ACTIVE_rebranded,
SEARCH_ACTIVE_rebranded,
SEARCH_rebranded,
SEE_IT_rebranded,
SEND_LARGE_ACTIVE_rebranded,
SEND_LARGE_INACTIVE_rebranded,
SERVER_ACTIVE_rebranded,
SERVER_INACTIVE_rebranded,
SETTINGS_ACTIVE_rebranded,
SETTINGS_INACTIVE_rebranded,
SHARE_20_PX_INACTIVE_rebranded,
SHARE_20_PX_rebranded,
SHARE_ACTIVE_rebranded,
SHARE_ARROW_rebranded,
SHARE_rebranded,
SHIELD_ACTIVE_rebranded,
SHIELD_INACTIVE_rebranded,
SHUFFLE_rebranded,
SIGNAL_0_rebranded,
SIGNAL_2_rebranded,
SIGNAL_1_rebranded,
SIGNAL_3_rebranded,
SIGNAL_STRENGTH_1_rebranded,
SIGNAL_STRENGTH_2_rebranded,
SIGNAL_STRENGTH_0_rebranded,
SIGNAL_STRENGTH_3_rebranded,
SIGNAL_STRENGTH_4_rebranded,
SIGNOUT_ACTIVE_rebranded,
SIGNOUT_rebranded,
SKETCH_rebranded,
SKIP_NEXT_ACTIVE_rebranded,
SKIP_NEXT_INACTIVE_rebranded,
SKIP_PREVIOUS_INACTIVE_rebranded,
SKIP_PREVIOUS_ACTIVE_rebranded,
SLIDERS_ACTIVE_rebranded,
SLIDERS_INACTIVE_rebranded,
SMALL_ARROW_DOWN_INACTIVE_rebranded,
SMALL_ARROW_DOWN_rebranded,
SMALL_ARROW_LEFT_INACTIVE_rebranded,
SMALL_ARROW_LEFT_rebranded,
SMALL_ARROW_RIGHT_INACTIVE_rebranded,
SMALL_ARROW_RIGHT_rebranded,
SMALL_ARROW_UP_INACTIVE_rebranded,
SMALL_ARROW_UP_rebranded,
SMARTPHONE_ACTIVE_rebranded,
SMARTPHONE_rebranded,
SNOOZE_ACTIVE_rebranded,
SNOOZE_rebranded,
SPACES_ACTIVE_rebranded,
SPACES_INACTIVE_rebranded,
SPEAKER_20_PX_INACTIVE_rebranded,
SPEAKER_20_PX_rebranded,
SPEAKER_OFF_ACTIVE_rebranded,
SPEAKER_OFF_INACTIVE_rebranded,
SPEAKER_ON_ACTIVE_rebranded,
SPEAKER_ON_INACTIVE_rebranded,
SPEAKING_20_PX_rebranded,
SPEAKING_rebranded,
STAR_EMPTY_rebranded,
STAR_FILLED_rebranded,
STAR_HALF_FILLED_rebranded,
STAR_rebranded,
STOP_20_PX_INACTIVE_rebranded,
STOP_20_PX_rebranded,
STOP_ACTIVE_rebranded,
STOP_INACTIVE_rebranded,
STOP_PLAIN_ACTIVE_rebranded,
STOP_PLAIN_INACTIVE_rebranded,
STRETCHING_COLLAPSE_rebranded,
STRETCHING_EXIT_FULLSCREEN_rebranded,
STRETCHING_EXPAND_rebranded,
STRETCHING_FULLSCREEN_rebranded,
STRIKETHROUGH_ACTIVE_rebranded,
STRIKETHROUGH_INACTIVE_rebranded,
SUBTRACT_rebranded,
SYNC_rebranded,
SWAP_rebranded,
SYNCHRONIZED_rebranded,
TABLET_CHEVRON_rebranded,
TAG_ACTIVE_rebranded,
TAG_rebranded,
TAX_EXEMPTION_ACTIVE_rebranded,
TAX_EXEMPTION_INACTIVE_rebranded,
TEST_ACTIVE_rebranded,
TEST_INACTIVE_rebranded,
TEXT_FIELD_rebranded,
TEXT_INACTIVE_rebranded,
TEXT_rebranded,
THUMBS_DOWN_ACTIVE_rebranded,
THEMES_rebranded,
THUMBS_DOWN_INACTIVE_rebranded,
THUMBS_UP_INACTIVE_rebranded,
THUMBS_UP_ACTIVE_rebranded,
TIME_LIMITATION_rebranded,
TRANSFER_CONVERSATION_ACTIVE_rebranded,
TRANSFER_CONVERSATION_INACTIVE_rebranded,
TRASH_ACTIVE_rebranded,
TRASH_INACTIVE_rebranded,
TRENDING_rebranded,
UBUNTU_rebranded,
UNDO_rebranded,
UNLOCKED_ACTIVE_20_PX_rebranded,
UNLOCKED_ACTIVE_rebranded,
UNLOCKED_INACTIVE_rebranded,
UNLOCKED_INACTIVE_20_PX_rebranded,
UPLOAD_rebranded,
USB_C_ACTIVE_rebranded,
USB_C_rebranded,
VECTOR_rebranded,
VIEW_GRID_ACTIVE_rebranded,
VIEW_GRID_rebranded,
VIEW_SWITCH_ACTIVE_CAMERAS_INACTIVE_rebranded,
VIEW_SWITCH_ACTIVE_CAMERAS_rebranded,
VIEW_SWITCH_EVERYONE_INACTIVE_rebranded,
VIEW_SWITCH_EVERYONE_rebranded,
VIEW_SWITCH_FILMSTRIP_INACTIVE_rebranded,
VIEW_SWITCH_FILMSTRIP_rebranded,
VIEW_SWITCH_HIDEALL_INACTIVE_rebranded,
VIEW_SWITCH_HIDEALL_rebranded,
VIEW_SWITCH_PORTRAIT_ACTIVE_rebranded,
VIEW_SWITCH_PORTRAIT_INACTIVE_rebranded,
VIEWS_ACTIVE_rebranded,
VIMEO_rebranded,
VIEWS_INACTIVE_rebranded,
VIRTUAL_BACKGROUND_ACTIVE_rebranded,
VISA_ACTIVE_rebranded,
VIRTUAL_BACKGROUND_INACTIVE_rebranded,
VISA_rebranded,
VISIBILITY_DISABLED_ACTIVE_rebranded,
VISIBILITY_DISABLED_INACTIVE_rebranded,
VISIBILITY_ENABLED_ACTIVE_rebranded,
VISIBILITY_ENABLED_INACTIVE_rebranded,
VOICEMAIL_READ_rebranded,
VOICEMAIL_UNREAD_rebranded,
VOICEMAIL_rebranded,
VOIP_PAUSE_rebranded,
VOIP_rebranded,
WEB_rebranded,
WEB_ACTIVE_rebranded,
WEBCAM_OFF_ACTIVE_rebranded,
WEBCAM_OFF_INACTIVE_rebranded,
WEBCAM_ON_ACTIVE_rebranded,
WEBCAM_ON_INACTIVE_rebranded,
WHISPER_ACTIVE_rebranded,
WHISPER_rebranded,
WHITEBOARD_ACTIVE_rebranded,
WHITEBOARD_INACTIVE_rebranded,
WIFI_ACTIVE_rebranded,
WIFI_INACTIVE_rebranded,
WINDOWS_rebranded,
WRENCH_ACTIVE_rebranded,
WRENCH_INACTIVE_rebranded,
YUAN_ACTIVE_rebranded,
YUAN_rebranded,
ZIP_rebranded,
ZOOM_IN_ACTIVE_rebranded,
ZOOM_IN_INACTIVE_rebranded,
ZOOM_OUT_ACTIVE_rebranded,
ZOOM_OUT_INACTIVE_rebranded,
ACCESSIBILITY_FILLED_rebranded,
ACCESSIBILITY_OUTLINED_rebranded,
ACTION_ITEM_FILLED_rebranded,
ACTION_ITEM_OUTLINED_rebranded,
ADD_CIRCLE_OUTLINED_rebranded,
ADD_CIRCLE_FILLED_rebranded,
ADD_FILLED_rebranded,
ADD_OUTLINED_rebranded,
ADD_PERSON_FILLED_rebranded,
ADD_PERSON_OUTLINED_rebranded,
ADDRESS_BOOK_FILLED_rebranded,
ADMIN_FILLED_rebranded,
ADMIN_OUTLINED_rebranded,
ADDRESS_BOOK_OUTLINED_rebranded,
ALERT_FILLED_rebranded,
ALERT_OUTLINED_rebranded,
ANNOTATION_FILLED_rebranded,
ANNOTATION_OUTLINED_rebranded,
APP_SWITCHER_OUTLINED_rebranded,
APP_SWITCHER_FILLED_rebranded,
ARCHIVE_FILLED_rebranded,
ARCHIVE_OUTLINED_rebranded,
ARROW_DOWN_FILLED_rebranded,
ARROW_DOWN_OUTLINED_rebranded,
ARROW_LEFT_FILLED_rebranded,
ARROW_LEFT_OUTLINED_rebranded,
ARROW_RIGHT_FILLED_rebranded,
ARROW_RIGHT_OUTLINED_rebranded,
ARROW_UP_FILLED_rebranded,
ASSISTANCE_OUTLINED_rebranded,
ASSISTANCE_FILLED_rebranded,
ARROW_UP_OUTLINED_rebranded,
ASTERISK_FILLED_rebranded,
ASTERISK_OUTLINED_rebranded,
ATTACHMENT_FILLED_rebranded,
AUDIO_TEST_FILLED_rebranded,
ATTACHMENT_OUTLINED_rebranded,
AUDIO_TEST_OUTLINED_rebranded,
BACKSPACE_FILLED_rebranded,
BADGE_FILLED_rebranded,
BACKSPACE_OUTLINED_rebranded,
BADGE_OUTLINED_rebranded,
BANK_CARD_FILLED_rebranded,
BANK_CARD_OUTLINED_rebranded,
BATTERY_FULL_FILLED_rebranded,
BATTERY_FULL_OUTLINED_rebranded,
BATTERY_LOW_FILLED_rebranded,
BATTERY_LOW_OUTLINED_rebranded,
BATTERY_MID_FILLED_rebranded,
BELL_OFF_FILLED_rebranded,
BELL_FILLED_rebranded,
BATTERY_MID_OUTLINED_rebranded,
BELL_OUTLINED_rebranded,
BELL_OFF_OUTLINED_rebranded,
BLOCK_FILLED_rebranded,
BLOCK_OUTLINED_rebranded,
BLUETOOTH_CONNECTED_FILLED_rebranded,
BLUETOOTH_CONNECTED_OUTLINED_rebranded,
BLUETOOTH_FILLED_rebranded,
BLUETOOTH_OUTLINED_rebranded,
BOOK_OUTLINED_rebranded,
BOOK_FILLED_rebranded,
BOOKMARK_FILLED_rebranded,
BOOKMARK_OUTLINED_rebranded,
BREAKOUT_ROOM_FILLED_rebranded,
BUG_FILLED_rebranded,
BREAKOUT_ROOM_OUTLINED_rebranded,
BUG_OUTLINED_rebranded,
CABLE_HDMI_FILLED_rebranded,
CABLE_HDMI_OUTLINED_rebranded,
CABLE_USB_FILLED_rebranded,
CABLE_USB_OUTLINED_rebranded,
CALCULATOR_OUTLINED_rebranded,
CALENDAR_ADD_FILLED_rebranded,
CALCULATOR_FILLED_rebranded,
CALENDAR_EVENT_FILLED_rebranded,
CALENDAR_ADD_OUTLINED_rebranded,
CALENDAR_EVENT_OUTLINED_rebranded,
CALENDAR_FILLED_rebranded,
CALENDAR_MEETING_FILLED_rebranded,
CALENDAR_OUTLINED_rebranded,
CALENDAR_PHONE_OUTLINED_rebranded,
CALENDAR_PHONE_FILLED_rebranded,
CALENDAR_MEETING_OUTLINED_rebranded,
CALENDAR_PLAY_FILLED_rebranded,
CALENDAR_PLAY_OUTLINED_rebranded,
CALENDAR_RECURRING_FILLED_rebranded,
CALENDAR_SYNC_FILLED_rebranded,
CALENDAR_RECURRING_OUTLINED_rebranded,
CALENDAR_SYNC_OUTLINED_rebranded,
CALL_MADE_FILLED_rebranded,
CALL_MADE_OUTLINED_rebranded,
CALL_MERGE_FILLED_rebranded,
CALL_MISSED_FILLED_rebranded,
CALL_MERGE_OUTLINED_rebranded,
CALL_MISSED_OUTLINED_rebranded,
CALL_RECEIVED_FILLED_rebranded,
CALL_RECEIVED_OUTLINED_rebranded,
CALL_SPLIT_FILLED_rebranded,
CALL_SPLIT_OUTLINED_rebranded,
CAMERA_ADJUST_FILLED_rebranded,
CAMERA_AUTO_FILLED_rebranded,
CAMERA_ADJUST_OUTLINED_rebranded,
CAMERA_AUTO_OUTLINED_rebranded,
CAMERA_FILLED_rebranded,
CAMERA_FLIP_FILLED_rebranded,
CAMERA_FLIP_OUTLINED_rebranded,
CAMERA_OUTLINED_rebranded,
CAMERA_POSITION_BOTTOM_FILLED_rebranded,
CAMERA_POSITION_BOTTOM_OUTLINED_rebranded,
CAMERA_POSITION_LEFT_FILLED_rebranded,
CAMERA_POSITION_LEFT_OUTLINED_rebranded,
CAMERA_POSITION_RIGHT_FILLED_rebranded,
CAMERA_POSITION_RIGHT_OUTLINED_rebranded,
CAMERA_POSITION_TOP_FILLED_rebranded,
CAMERA_PRESETS_FILLED_rebranded,
CAMERA_POSITION_TOP_OUTLINED_rebranded,
CAMERA_PRESETS_OUTLINED_rebranded,
CAMERA_ROOM_VIEW_OUTLINED_rebranded,
CAMERA_ROOM_VIEW_FILLED_rebranded,
CAMERA_SHARE_FILLED_rebranded,
CAR_FILLED_rebranded,
CAMERA_SHARE_OUTLINED_rebranded,
CAR_OUTLINED_rebranded,
CARD_AMEX_FILLED_rebranded,
CARD_AMEX_OUTLINED_rebranded,
CARD_DISCOVER_FILLED_rebranded,
CARD_MASTERCARD_FILLED_rebranded,
CARD_DISCOVER_OUTLINED_rebranded,
CARD_VISA_FILLED_rebranded,
CARD_MASTERCARD_OUTLINED_rebranded,
CARD_VISA_OUTLINED_rebranded,
CASH_OUTLINED_rebranded,
CASH_FILLED_rebranded,
CHECKMARK_CIRCLE_FILLED_rebranded,
CHECKMARK_CIRCLE_OUTLINED_rebranded,
CHECKMARK_FILLED_rebranded,
CHECKMARK_OUTLINED_rebranded,
CHEVRON_COMBO_FILLED_rebranded,
CHEVRON_COMBO_OUTLINED_rebranded,
CHEVRON_DOWN_FILLED_rebranded,
CHEVRON_DOWN_OUTLINED_rebranded,
CHEVRON_LEFT_FILLED_rebranded,
CHEVRON_LEFT_OUTLINED_rebranded,
CHEVRON_RIGHT_FILLED_rebranded,
CHEVRON_RIGHT_OUTLINED_rebranded,
CHEVRON_UP_FILLED_rebranded,
CHEVRON_UP_OUTLINED_rebranded,
CLEAR_ALL_FILLED_rebranded,
CLEAR_ALL_OUTLINED_rebranded,
CLIPBOARD_FILLED_rebranded,
CLIPBOARD_OUTLINED_rebranded,
CLOCK_FILLED_rebranded,
CLOSE_CIRCLE_FILLED_rebranded,
CLOCK_OUTLINED_rebranded,
CLOSE_CIRCLE_OUTLINED_rebranded,
CLOSE_FILLED_rebranded,
CLOUD_FILLED_rebranded,
CLOUD_OFF_FILLED_rebranded,
CLOSE_OUTLINED_rebranded,
CLOUD_OUTLINED_rebranded,
CLOUD_UPLOAD_FILLED_rebranded,
CLOUD_OFF_OUTLINED_rebranded,
CLOUD_UPLOAD_OUTLINED_rebranded,
COBY_FILLED_rebranded,
COBY_OUTLINED_rebranded,
CODE_FILLED_rebranded,
CODE_OUTLINED_rebranded,
CONFERENCE_PHONE_FILLED_rebranded,
CONFERENCE_PHONE_OUTLINED_rebranded,
CONTACT_ADDRESS_BOOK_FILLED_rebranded,
COPY_FILLED_rebranded,
CONTACT_ADDRESS_BOOK_OUTLINED_rebranded,
COPY_OUTLINED_rebranded,
CPU_FILLED_rebranded,
CPU_OUTLINED_rebranded,
CREATE_GROUP_FILLED_rebranded,
CREATE_GROUP_OUTLINED_rebranded,
CROWD_OUTLINED_rebranded,
CROWD_FILLED_rebranded,
CTRL_ALT_DEL_FILLED_rebranded,
CTRL_ALT_DEL_OUTLINED_rebranded,
CURRENCY_EUR_FILLED_rebranded,
CURRENCY_EUR_OUTLINED_rebranded,
CURRENCY_JPY_FILLED_rebranded,
CURRENCY_JPY_OUTLINED_rebranded,
CURRENCY_UKP_FILLED_rebranded,
CURRENCY_UKP_OUTLINED_rebranded,
CURRENCY_USD_FILLED_rebranded,
CURRENCY_USD_OUTLINED_rebranded,
CURSOR_DRAG_FILLED_rebranded,
CURSOR_DRAG_OUTLINED_rebranded,
DASHBOARD_FILLED_rebranded,
DASHBOARD_OUTLINED_rebranded,
DATA_FILLED_rebranded,
DATA_MASKING_FILLED_rebranded,
DATA_OUTLINED_rebranded,
DATA_MASKING_OUTLINED_rebranded,
DECISION_FILLED_rebranded,
DECISION_OUTLINED_rebranded,
DESKTOP_FILLED_rebranded,
DESKTOP_OUTLINED_rebranded,
DEVICES_FILLED_rebranded,
DEVICES_OUTLINED_rebranded,
DIAL_PAD_FILLED_rebranded,
DIAL_PAD_OUTLINED_rebranded,
DOUBLE_CHEVRON_LEFT_FILLED_rebranded,
DOUBLE_CHEVRON_LEFT_OUTLINED_rebranded,
DOUBLE_CHEVRON_RIGHT_FILLED_rebranded,
DOUBLE_CHEVRON_RIGHT_OUTLINED_rebranded,
DOWNLOAD_FILLED_rebranded,
DOWNLOAD_DESKTOP_APP_OUTLINED_rebranded,
DOWNLOAD_OUTLINED_rebranded,
DOWNLOAD_MOBILE_APP_OUTLINED_rebranded,
DRAG_N_DROP_OUTLINED_rebranded,
DRAG_N_DROP_FILLED_rebranded,
DRAWER_LEFT_FILLED_rebranded,
DRAWER_LEFT_OUTLINED_rebranded,
DRAWER_RIGHT_FILLED_rebranded,
DRAWER_RIGHT_OUTLINED_rebranded,
DUAL_DISPLAY_FILLED_rebranded,
DUAL_DISPLAY_OUTLINED_rebranded,
DUMBELL_FILLED_rebranded,
ECHO_FILLED_rebranded,
DUMBELL_OUTLINED_rebranded,
ECHO_OUTLINED_rebranded,
EDIT_FILLED_rebranded,
EDIT_OUTLINED_rebranded,
EDUCATION_FILLED_rebranded,
EMAIL_FILLED_rebranded,
EDUCATION_OUTLINED_rebranded,
EMAIL_OUTLINED_rebranded,
EMOJI_HAPPY_OUTLINED_rebranded,
EMOJI_HAPPY_FILLED_rebranded,
EMOJI_SAD_FILLED_rebranded,
EMOJI_SAD_OUTLINED_rebranded,
ENCRYPTION_FILLED_rebranded,
ENCRYPTION_OUTLINED_rebranded,
ENTER_FILLED_rebranded,
ENTER_OUTLINED_rebranded,
EXECUTABLE_FILLED_rebranded,
EXECUTABLE_OUTLINED_rebranded,
EXTERNAL_LINK_FILLED_rebranded,
FACTORY_BUILDING_FILLED_rebranded,
EXTERNAL_LINK_OUTLINED_rebranded,
FACTORY_BUILDING_OUTLINED_rebranded,
FADE_OUT_FILLED_rebranded,
FADE_OUT_OUTLINED_rebranded,
FAST_FORWARD_FILLED_rebranded,
FAST_FORWARD_OUTLINED_rebranded,
FAX_FILLED_rebranded,
FAX_OUTLINED_rebranded,
FILE_BROWSER_FILLED_rebranded,
FILE_BROWSER_OUTLINED_rebranded,
FILE_CSV_FILLED_rebranded,
FILE_CODE_OUTLINED_rebranded,
FILE_CODE_FILLED_rebranded,
FILE_CSV_OUTLINED_rebranded,
FILE_FILLED_rebranded,
FILE_LOG_FILLED_rebranded,
FILE_LOG_OUTLINED_rebranded,
FILE_OUTLINED_rebranded,
FILE_PDF_FILLED_rebranded,
FILE_PDF_OUTLINED_rebranded,
FILE_PRESENTATION_FILLED_rebranded,
FILE_PRESENTATION_OUTLINED_rebranded,
FILE_SOUND_FILLED_rebranded,
FILE_SOUND_OUTLINED_rebranded,
FILE_SPREADSHEET_FILLED_rebranded,
FILE_SPREADSHEET_OUTLINED_rebranded,
FILE_TEXT_FILLED_rebranded,
FILE_TEXT_OUTLINED_rebranded,
FILE_TRANSFER_FILLED_rebranded,
FILE_TRANSFER_OUTLINED_rebranded,
FILE_VIDEO_FILLED_rebranded,
FILE_VIDEO_OUTLINED_rebranded,
FILTER_FILLED_rebranded,
FILTER_OUTLINED_rebranded,
FINE_ADJUSTMENT_FILLED_rebranded,
FINE_ADJUSTMENT_OUTLINED_rebranded,
FINGERPRINT_FILLED_rebranded,
FINGERPRINT_OUTLINED_rebranded,
FIT_HORIZONTALLY_FILLED_rebranded,
FIT_VERTICALLY_FILLED_rebranded,
FIT_HORIZONTALLY_OUTLINED_rebranded,
FIT_VERTICALLY_OUTLINED_rebranded,
FLASHLIGHT_OFF_FILLED_rebranded,
FLASHLIGHT_ON_FILLED_rebranded,
FLASHLIGHT_OFF_OUTLINED_rebranded,
FLASHLIGHT_ON_OUTLINED_rebranded,
FLOWCHART_FILLED_rebranded,
FLOWCHART_OUTLINED_rebranded,
FOLDER_ADD_FILLED_rebranded,
FOLDER_ADD_OUTLINED_rebranded,
FOLDER_ARCHIVE_FILLED_rebranded,
FOLDER_ARCHIVE_OUTLINED_rebranded,
FOLDER_EMPTY_FILLED_rebranded,
FOLDER_EMPTY_OUTLINED_rebranded,
FOLDER_FILLED_rebranded,
FOLDER_MOVE_TO_FILLED_rebranded,
FOLDER_MOVE_TO_OUTLINED_rebranded,
FOLDER_OUTLINED_rebranded,
FOLDER_REMOVE_FILLED_rebranded,
FOLDER_REMOVE_FROM_FILLED_rebranded,
FOLDER_REMOVE_FROM_OUTLINED_rebranded,
FOLDER_REMOVE_OUTLINED_rebranded,
FOLDER_UP_OUTLINED_rebranded,
FOLDER_UP_FILLED_rebranded,
FONT_FILLED_rebranded,
FONT_OUTLINED_rebranded,
FROM_CHANNEL_FILLED_rebranded,
FROM_CHANNEL_OUTLINED_rebranded,
GIFT_OUTLINED_rebranded,
GLOBAL_SESSION_LIST_FILLED_rebranded,
GIFT_FILLED_rebranded,
GLOBAL_SESSION_LIST_OUTLINED_rebranded,
GLOBE_FILLED_rebranded,
GLOBE_OUTLINED_rebranded,
HALF_STAR_FILLED_rebranded,
HALF_STAR_OUTLINED_rebranded,
HAND_LOWER_FILLED_rebranded,
HAND_LOWER_OUTLINED_rebranded,
HAND_RAISE_FILLED_rebranded,
HAND_RAISE_OUTLINED_rebranded,
HARD_DRIVE_FILLED_rebranded,
HASHTAG_FILLED_rebranded,
HARD_DRIVE_OUTLINED_rebranded,
HASHTAG_OUTLINED_rebranded,
HEADPHONES_FILLED_rebranded,
HEADPHONES_OUTLINED_rebranded,
HEALTHCARE_FILLED_rebranded,
HEALTHCARE_OUTLINED_rebranded,
HEART_FILLED_rebranded,
HEART_OUTLINED_rebranded,
HELP_CIRCLE_FILLED_rebranded,
HELP_CIRCLE_OUTLINED_rebranded,
HELP_SQUARE_FILLED_rebranded,
HELP_SQUARE_OUTLINED_rebranded,
HIGHLIGHTER_FILLED_rebranded,
HIGHLIGHTER_OUTLINED_rebranded,
HISTORY_FILLED_rebranded,
HISTORY_OUTLINED_rebranded,
HOME_FILLED_rebranded,
HOUSE_FILLED_rebranded,
HOUSE_OUTLINED_rebranded,
HOME_OUTLINED_rebranded,
ID_CARD_FILLED_rebranded,
ID_CARD_OUTLINED_rebranded,
INBOX_FILLED_rebranded,
INBOX_OUTLINED_rebranded,
INFINITY_FILLED_rebranded,
INFINITY_OUTLINED_rebranded,
INFO_FILLED_rebranded,
INFO_OUTLINED_rebranded,
INTEGRATIONS_FILLED_rebranded,
INTEGRATIONS_OUTLINED_rebranded,
JOIN_FILLED_rebranded,
JOIN_OUTLINED_rebranded,
KEY_FILLED_rebranded,
KEY_OUTLINED_rebranded,
KEYBOARD_FILLED_rebranded,
KEYBOARD_OUTLINED_rebranded,
LAB_FILLED_rebranded,
LAB_OUTLINED_rebranded,
LANDLINE_FILLED_rebranded,
LANDLINE_OUTLINED_rebranded,
LAUNCH_FILLED_rebranded,
LAUNCH_OUTLINED_rebranded,
LEAVE_FILLED_rebranded,
LEAVE_OUTLINED_rebranded,
LEGAL_FILLED_rebranded,
LEGAL_OUTLINED_rebranded,
LIGHTBULB_OFF_FILLED_rebranded,
LIGHTBULB_OFF_OUTLINED_rebranded,
LIGHTBULB_ON_FILLED_rebranded,
LIGHTBULB_ON_OUTLINED_rebranded,
LIGHTNING_OUTLINED_rebranded,
LINK_FILLED_rebranded,
LINK_OUTLINED_rebranded,
LIGHTNING_FILLED_rebranded,
LIST_FILLED_rebranded,
LIST_OUTLINED_rebranded,
LOCATION_PIN_FILLED_rebranded,
LOCATION_PIN_OUTLINED_rebranded,
LOCKED_FILLED_rebranded,
LOCKED_OUTLINED_rebranded,
LOUDSPEAKER_FILLED_rebranded,
LOUDSPEAKER_OUTLINED_rebranded,
MAGIC_WAND_FILLED_rebranded,
MAGIC_WAND_OUTLINED_rebranded,
MAIN_SWITCH_FILLED_rebranded,
MAIN_SWITCH_OUTLINED_rebranded,
MANAGE_LICENSES_FILLED_rebranded,
MANAGE_LICENSES_OUTLINED_rebranded,
MEETING_ENLARGE_FILLED_rebranded,
MEETING_MINIFY_FILLED_rebranded,
MEETING_ENLARGE_OUTLINED_rebranded,
MEETING_MINIFY_OUTLINED_rebranded,
MERGE_FILLED_rebranded,
MEMORY_FILLED_rebranded,
MEMORY_OUTLINED_rebranded,
MERGE_OUTLINED_rebranded,
MESSAGE_ADD_FILLED_rebranded,
MESSAGE_CONVERSATION_FILLED_rebranded,
MESSAGE_ADD_OUTLINED_rebranded,
MESSAGE_CONVERSATION_OUTLINED_rebranded,
MESSAGE_DELETE_FILLED_rebranded,
MESSAGE_DELETE_OUTLINED_rebranded,
MESSAGE_DOTS_FILLED_rebranded,
MESSAGE_DOTS_OUTLINED_rebranded,
MESSAGE_FEEDBACK_FILLED_rebranded,
MESSAGE_FEEDBACK_OUTLINED_rebranded,
MESSAGE_FILLED_rebranded,
MESSAGE_OUTLINED_rebranded,
MESSAGE_QUESTION_FILLED_rebranded,
MESSAGE_QUESTION_OUTLINED_rebranded,
MESSAGE_TRANSFER_FILLED_rebranded,
MESSAGE_WHISPER_FILLED_rebranded,
MESSAGE_TRANSFER_OUTLINED_rebranded,
MESSAGE_WHISPER_OUTLINED_rebranded,
MICROPHONE_HARDMUTED_FILLED_rebranded,
MICROPHONE_HARDMUTED_OUTLINED_rebranded,
MICROPHONE_OFF_OUTLINED_rebranded,
MICROPHONE_ON_FILLED_rebranded,
MICROPHONE_OFF_FILLED_rebranded,
MOBILE_SCAN_FILLED_rebranded,
MICROPHONE_ON_OUTLINED_rebranded,
MOBILE_SCAN_OUTLINED_rebranded,
MOBILE_SUPPORT_FILLED_rebranded,
MOBILE_SUPPORT_OUTLINED_rebranded,
MOON_FILLED_rebranded,
MORE_MENU_HAMBURGER_FILLED_rebranded,
MOON_OUTLINED_rebranded,
MORE_MENU_HORIZONTAL_FILLED_rebranded,
MORE_MENU_HAMBURGER_OUTLINED_rebranded,
MORE_MENU_HORIZONTAL_OUTLINED_rebranded,
MORE_MENU_VERTICAL_FILLED_rebranded,
MORE_MENU_VERTICAL_OUTLINED_rebranded,
MOUSE_FILLED_rebranded,
MOUSE_OUTLINED_rebranded,
MUSIC_FILLED_rebranded,
MUSIC_OUTLINED_rebranded,
NETWORK_FILLED_rebranded,
NETWORK_OUTLINED_rebranded,
NOTE_FILLED_rebranded,
NOTE_OUTLINED_rebranded,
NOTEPAD_OUTLINED_rebranded,
NOTEPAD_FILLED_rebranded,
NOTIFICATIONS_ALERT_FILLED_rebranded,
NOTIFICATIONS_ALERT_OUTLINED_rebranded,
NOTIFICATIONS_FILLED_rebranded,
NOTIFICATIONS_OUTLINED_rebranded,
NPA_FILLED_rebranded,
NPA_OUTLINED_rebranded,
NUMBERED_ARROW_FILLED_rebranded,
NUMBERED_ARROW_OUTLINED_rebranded,
OFFICE_BUILDING_FILLED_rebranded,
OFFICE_BUILDING_OUTLINED_rebranded,
ORDERED_LIST_FILLED_rebranded,
ORDERED_LIST_OUTLINED_rebranded,
PAINT_FILLED_rebranded,
PAINT_OUTLINED_rebranded,
PALETTE_FILLED_rebranded,
PALETTE_OUTLINED_rebranded,
PAPERCLIP_FILLED_rebranded,
PAPERCLIP_OUTLINED_rebranded,
PAUSE_CIRCLE_FILLED_rebranded,
PAUSE_CIRCLE_OUTLINED_rebranded,
PAUSE_FILLED_rebranded,
PAUSE_OUTLINED_rebranded,
PAYMENT_DUE_FILLED_rebranded,
PBX_FILLED_rebranded,
PAYMENT_DUE_OUTLINED_rebranded,
PBX_OUTLINED_rebranded,
PEOPLE_FILLED_rebranded,
PERSON_ASSIGN_FILLED_rebranded,
PEOPLE_OUTLINED_rebranded,
PERSON_ASSIGN_OUTLINED_rebranded,
PERSON_CHECKMARK_FILLED_rebranded,
PERSON_CHECKMARK_OUTLINED_rebranded,
PERSON_FILLED_rebranded,
PERSON_OUTLINED_rebranded,
PERSON_TRANSFER_FILLED_rebranded,
PERSON_TRANSFER_OUTLINED_rebranded,
PHONE_CONNECTED_FILLED_rebranded,
PHONE_ADD_OUTLINED_rebranded,
PHONE_ADD_FILLED_rebranded,
PHONE_CONNECTED_OUTLINED_rebranded,
PHONE_FAILED_FILLED_rebranded,
PHONE_FAILED_OUTLINED_rebranded,
PHONE_HANG_UP_FILLED_rebranded,
PHONE_HANG_UP_OUTLINED_rebranded,
PHONE_INCOMING_FILLED_rebranded,
PHONE_INCOMING_OUTLINED_rebranded,
PHONE_MESSAGE_OUTLINED_rebranded,
PHONE_NUMBER_FILLED_rebranded,
PHONE_NUMBER_OUTLINED_rebranded,
PHONE_MESSAGE_FILLED_rebranded,
PHONE_OFF_FILLED_rebranded,
PHONE_OFF_OUTLINED_rebranded,
PHONE_OUTGOING_FILLED_rebranded,
PHONE_OUTGOING_OUTLINED_rebranded,
PHONE_PARK_FILLED_rebranded,
PHONE_PARK_OUTLINED_rebranded,
PHONE_PAUSE_FILLED_rebranded,
PHONE_TRANSFER_FILLED_rebranded,
PHONE_PAUSE_OUTLINED_rebranded,
PHONE_TRANSFER_OUTLINED_rebranded,
PICTURE_FILLED_rebranded,
PHONE_UP_OUTLINED_rebranded,
PICTURE_OFF_FILLED_rebranded,
PHONE_UP_FILLED_rebranded,
PIE_CHART_OUTLINED_rebranded,
PICTURE_OUTLINED_rebranded,
PIE_CHART_FILLED_rebranded,
PICTURE_OFF_OUTLINED_rebranded,
PIP_MAXIMIZE_FILLED_rebranded,
PIP_MAXIMIZE_OUTLINED_rebranded,
PIP_MINIMIZE_OUTLINED_rebranded,
PIP_MINIMIZE_FILLED_rebranded,
PLACEHOLDER_OUTLINED_rebranded,
PLACEHOLDER_FILLED_rebranded,
PLAY_CIRCLE_FILLED_rebranded,
PLAY_FILLED_rebranded,
PLAY_CIRCLE_OUTLINED_rebranded,
PLAY_OUTLINED_rebranded,
POINTER_OFF_FILLED_rebranded,
POINTER_OFF_OUTLINED_rebranded,
POINTER_WINDOWS_OFF_FILLED_rebranded,
POINTER_ON_FILLED_rebranded,
POINTER_ON_OUTLINED_rebranded,
POINTER_WINDOWS_OFF_OUTLINED_rebranded,
POINTER_WINDOWS_ON_FILLED_rebranded,
POLLS_FILLED_rebranded,
POINTER_WINDOWS_ON_OUTLINED_rebranded,
POP_IN_FILLED_rebranded,
POLLS_OUTLINED_rebranded,
POP_IN_OUTLINED_rebranded,
POP_OUT_CAMERA_OUTLINED_rebranded,
POP_OUT_FILLED_rebranded,
POP_OUT_CAMERA_FILLED_rebranded,
POP_OUT_OUTLINED_rebranded,
POP_OUT_WINDOW_FILLED_rebranded,
POSITION_TV_BOTTOM_OUTLINED_rebranded,
POP_OUT_WINDOW_OUTLINED_rebranded,
POSITION_TV_BOTTOM_FILLED_rebranded,
POSITION_TV_LEFT_FILLED_rebranded,
POSITION_TV_LEFT_OUTLINED_rebranded,
POSITION_TV_TOP_FILLED_rebranded,
POSITION_TV_RIGHT_FILLED_rebranded,
POSITION_TV_TOP_OUTLINED_rebranded,
POSITION_TV_RIGHT_OUTLINED_rebranded,
PRESENTATION_OUTLINED_rebranded,
PRESENTATION_FILLED_rebranded,
PRIVATE_FILLED_rebranded,
PRIVATE_OUTLINED_rebranded,
PUSHPIN_FILLED_rebranded,
QUESTION_OUTLINED_rebranded,
PUSHPIN_OUTLINED_rebranded,
QUESTION_FILLED_rebranded,
READER_FILLED_rebranded,
READER_OUTLINED_rebranded,
RECORD_CIRCLE_FILLED_rebranded,
RECORD_CIRCLE_OUTLINED_rebranded,
RECORDING_OUTLINED_rebranded,
RECORDING_FILLED_rebranded,
RECORDING_TAPE_OUTLINED_rebranded,
RECORDING_TAPE_FILLED_rebranded,
REDO_FILLED_rebranded,
REFRESH_FILLED_rebranded,
REDO_OUTLINED_rebranded,
REMOTE_SUPPORT_FILLED_rebranded,
REFRESH_OUTLINED_rebranded,
REMOTE_SUPPORT_OUTLINED_rebranded,
REPLY_FILLED_rebranded,
REPORT_FILLED_rebranded,
REPLY_OUTLINED_rebranded,
REPORT_OUTLINED_rebranded,
RESTORE_OUTLINED_rebranded,
RESTORE_FILLED_rebranded,
REWIND_FILLED_rebranded,
REWIND_OUTLINED_rebranded,
ROOM_PHYSICAL_FILLED_rebranded,
ROOM_PHYSICAL_OUTLINED_rebranded,
ROTATE_CCW_FILLED_rebranded,
ROTATE_CW_FILLED_rebranded,
ROTATE_CCW_OUTLINED_rebranded,
ROTATE_CW_OUTLINED_rebranded,
ROUTER_FILLED_rebranded,
ROUTER_OUTLINED_rebranded,
SALES_QUOTE_FILLED_rebranded,
SALES_QUOTE_OUTLINED_rebranded,
SAVE_FILLED_rebranded,
SAVE_OUTLINED_rebranded,
SCREEN_ADD_FILLED_rebranded,
SCREEN_ADD_OUTLINED_rebranded,
SCREEN_CAST_FILLED_rebranded,
SCREEN_FILLED_rebranded,
SCREEN_CAST_OUTLINED_rebranded,
SCREEN_INFO_FILLED_rebranded,
SCREEN_LIGHTNING_FILLED_rebranded,
SCREEN_INFO_OUTLINED_rebranded,
SCREEN_LIGHTNING_OUTLINED_rebranded,
SCREEN_MIRRORING_FILLED_rebranded,
SCREEN_MIRRORING_OUTLINED_rebranded,
SCREEN_OUTLINED_rebranded,
SCREEN_PAUSE_OUTLINED_rebranded,
SCREEN_PLAY_OFF_FILLED_rebranded,
SCREEN_PLAY_ON_FILLED_rebranded,
SCREEN_PLAY_OFF_OUTLINED_rebranded,
SCREEN_PLAY_ON_OUTLINED_rebranded,
SCREEN_PAUSE_FILLED_rebranded,
SCREEN_REBOOT_FILLED_rebranded,
SCREEN_SHARING_FILLED_rebranded,
SCREEN_SHARING_OUTLINED_rebranded,
SCREEN_REBOOT_OUTLINED_rebranded,
SCREEN_SLIDERS_FILLED_rebranded,
SCREEN_SLIDERS_OUTLINED_rebranded,
SCREEN_SNAPSHOT_FILLED_rebranded,
SCREEN_SNAPSHOT_OUTLINED_rebranded,
SCREEN_STOP_FILLED_rebranded,
SCREEN_STOP_OUTLINED_rebranded,
SCREEN_VIEWING_OUTLINED_rebranded,
SEARCH_FILLED_rebranded,
SEARCH_OUTLINED_rebranded,
SEND_FILLED_rebranded,
SCREEN_VIEWING_FILLED_rebranded,
SEND_OUTLINED_rebranded,
SERVER_FILLED_rebranded,
SERVER_OUTLINED_rebranded,
SETTINGS_FILLED_rebranded,
SETTINGS_OUTLINED_rebranded,
SHARE_ARROW_FILLED_rebranded,
SHARE_ARROW_OUTLINED_rebranded,
SHARE_FILLED_rebranded,
SHARE_OUTLINED_rebranded,
SHIELD_FILLED_rebranded,
SHIELD_OUTLINED_rebranded,
SHOPPING_CART_FILLED_rebranded,
SHUFFLE_FILLED_rebranded,
SHOPPING_CART_OUTLINED_rebranded,
SHUFFLE_OUTLINED_rebranded,
SIGN_OUT_FILLED_rebranded,
SIGN_OUT_OUTLINED_rebranded,
SKIP_NEXT_FILLED_rebranded,
SKIP_NEXT_OUTLINED_rebranded,
SKIP_PREVIOUS_FILLED_rebranded,
SMALL_ARROW_DOWN_FILLED_rebranded,
SKIP_PREVIOUS_OUTLINED_rebranded,
SMALL_ARROW_LEFT_FILLED_rebranded,
SMALL_ARROW_LEFT_OUTLINED_rebranded,
SMALL_ARROW_DOWN_OUTLINED_rebranded,
SMALL_ARROW_RIGHT_FILLED_rebranded,
SMALL_ARROW_RIGHT_OUTLINED_rebranded,
SMALL_ARROW_UP_FILLED_rebranded,
SMALL_ARROW_UP_OUTLINED_rebranded,
SMARTPHONE_OUTLINED_rebranded,
SMARTPHONE_FILLED_rebranded,
SNOOZE_FILLED_rebranded,
SNOOZE_OUTLINED_rebranded,
SPACES_FILLED_rebranded,
SPEAKER_OFF_FILLED_rebranded,
SPEAKER_OFF_OUTLINED_rebranded,
SPACES_OUTLINED_rebranded,
SPEAKER_ON_FILLED_rebranded,
SPEAKER_ON_OUTLINED_rebranded,
SPEAKING_OUTLINED_rebranded,
SPEAKING_FILLED_rebranded,
STAR_OUTLINED_rebranded,
STOP_FILLED_rebranded,
STOP_CIRCLE_FILLED_rebranded,
STOP_OUTLINED_rebranded,
STOP_CIRCLE_OUTLINED_rebranded,
STRETCH_EXIT_FULLSCREEN_FILLED_rebranded,
STRETCH_COLLAPSE_OUTLINED_rebranded,
STRETCH_EXIT_FULLSCREEN_OUTLINED_rebranded,
STRETCH_COLLAPSE_FILLED_rebranded,
STRETCH_EXPAND_FILLED_rebranded,
STRETCH_FULLSCREEN_OUTLINED_rebranded,
STRETCH_EXPAND_OUTLINED_rebranded,
STRETCH_FULLSCREEN_FILLED_rebranded,
SUBTRACT_FILLED_rebranded,
SUBTRACT_OUTLINED_rebranded,
SUN_OUTLINED_rebranded,
SUN_FILLED_rebranded,
SWAP_OUTLINED_rebranded,
SWAP_FILLED_rebranded,
SYNC_FILLED_rebranded,
SYNCHRONIZED_FILLED_rebranded,
SYNC_OUTLINED_rebranded,
SYNCHRONIZED_OUTLINED_rebranded,
TAG_FILLED_rebranded,
TAX_EXEMPTION_OUTLINED_rebranded,
TAG_OUTLINED_rebranded,
TAX_EXEMPTION_FILLED_rebranded,
TEST_FILLED_rebranded,
TEST_OUTLINED_rebranded,
TEXT_BOLD_FILLED_rebranded,
TEXT_FIELD_FILLED_rebranded,
TEXT_BOLD_OUTLINED_rebranded,
TEXT_FIELD_OUTLINED_rebranded,
TEXT_FILLED_rebranded,
TEXT_ITALIC_FILLED_rebranded,
TEXT_STRIKETHROUGH_FILLED_rebranded,
TEXT_ITALIC_OUTLINED_rebranded,
TEXT_OUTLINED_rebranded,
TEXT_STRIKETHROUGH_OUTLINED_rebranded,
THEMES_FILLED_rebranded,
THUMBS_DOWN_OUTLINED_rebranded,
THUMBS_DOWN_FILLED_rebranded,
THEMES_OUTLINED_rebranded,
THUMBS_UP_FILLED_rebranded,
THUMBS_UP_OUTLINED_rebranded,
TIME_LIMIT_FILLED_rebranded,
TICKET_FILLED_rebranded,
TICKET_OUTLINED_rebranded,
TIME_LIMIT_OUTLINED_rebranded,
TRASH_FILLED_rebranded,
TRENDING_OUTLINED_rebranded,
TRENDING_FILLED_rebranded,
TRASH_OUTLINED_rebranded,
UNDO_FILLED_rebranded,
UNDO_OUTLINED_rebranded,
UNLOCKED_OUTLINED_rebranded,
UNLOCKED_FILLED_rebranded,
UPLOAD_FILLED_rebranded,
VECTOR_FILLED_rebranded,
UPLOAD_OUTLINED_rebranded,
VECTOR_OUTLINED_rebranded,
VIEW_GRID_FILLED_rebranded,
VIEW_GRID_OUTLINED_rebranded,
VIEW_SWITCH_CAMERAS_OUTLINED_rebranded,
VIEW_SWITCH_CAMERAS_FILLED_rebranded,
VIEW_SWITCH_EVERYONE_OUTLINED_rebranded,
VIEW_SWITCH_FILMSTRIP_FILLED_rebranded,
VIEW_SWITCH_EVERYONE_FILLED_rebranded,
VIEW_SWITCH_FILMSTRIP_OUTLINED_rebranded,
VIEW_SWITCH_HIDE_ALL_FILLED_rebranded,
VIEW_SWITCH_PORTRAIT_FILLED_rebranded,
VIEW_SWITCH_HIDE_ALL_OUTLINED_rebranded,
VIEWS_FILLED_rebranded,
VIEW_SWITCH_PORTRAIT_OUTLINED_rebranded,
VIEWS_OUTLINED_rebranded,
VIRTUAL_BACKGROUND_FILLED_rebranded,
VISIBILITY_OFF_FILLED_rebranded,
VIRTUAL_BACKGROUND_OUTLINED_rebranded,
VISIBILITY_ON_FILLED_rebranded,
VISIBILITY_ON_OUTLINED_rebranded,
VOICEMAIL_OUTLINED_rebranded,
VOICEMAIL_FILLED_rebranded,
VOICEMAIL_READ_FILLED_rebranded,
VISIBILITY_OFF_OUTLINED_rebranded,
VOICEMAIL_READ_OUTLINED_rebranded,
VOICEMAIL_UNREAD_OUTLINED_rebranded,
VOICEMAIL_UNREAD_FILLED_rebranded,
VOIP_OFF_FILLED_rebranded,
VOIP_FILLED_rebranded,
VOIP_OUTLINED_rebranded,
WEB_BROWSER_FILLED_rebranded,
WEB_BROWSER_OUTLINED_rebranded,
VOIP_OFF_OUTLINED_rebranded,
WEBCAM_OFF_OUTLINED_rebranded,
WEBCAM_ON_FILLED_rebranded,
WEBCAM_OFF_FILLED_rebranded,
WHITEBOARD_FILLED_rebranded,
WEBCAM_ON_OUTLINED_rebranded,
WHITEBOARD_OUTLINED_rebranded,
WIFI_OFF_OUTLINED_rebranded,
WIFI_FILLED_rebranded,
WIFI_OFF_FILLED_rebranded,
WIFI_OUTLINED_rebranded,
WRENCH_OUTLINED_rebranded,
WRENCH_FILLED_rebranded,
ZIP_OUTLINED_rebranded,
ZIP_FILLED_rebranded,
ZOOM_IN_FILLED_rebranded,
ZOOM_IN_OUTLINED_rebranded,
ZOOM_OUT_FILLED_rebranded,
ZOOM_OUT_OUTLINED_rebranded,
}